import { defineComponent as ne, computed as J, createElementBlock as A, openBlock as y, normalizeStyle as R, createElementVNode as l, normalizeClass as P, createBlock as _e, createCommentVNode as k, toDisplayString as m, createVNode as b, onMounted as we, nextTick as Tt, toRef as Hs, readonly as Xs, ref as C, customRef as Ks, unref as T, getCurrentScope as qs, onScopeDispose as eu, getCurrentInstance as Ll, watch as xe, watchEffect as tu, onBeforeUnmount as Aa, toRefs as at, Fragment as ge, renderList as ye, createTextVNode as G, inject as pl, Transition as wl, withCtx as Ta, withDirectives as ht, vShow as xa, resolveDynamicComponent as Cl, provide as iu, onUnmounted as _t, createStaticVNode as za, vModelSelect as hl, withKeys as ci, withModifiers as Pt, vModelText as vM, reactive as Ol, resolveComponent as Mu, mergeProps as nu, renderSlot as au, vModelDynamic as ru } from "vue";
import lu from "./assets/d015a0b184d88ae8.svg";
import ou from "./assets/a446f8b90ac74db1.svg";
import su from "./assets/1108776cc2eba282.png";
import uu from "./assets/3de85c98b721a4bb.png";
import cu from "./assets/f8b89b2dd96b8543.png";
import gu from "./assets/46a15a43beb00bc3.png";
import Nu from "./assets/7a3a0edf72ef5487.png";
import Iu from "./assets/6207d68103ba97c3.png";
import Du from "./assets/debb55faacb92e18.png";
import du from "./assets/1ca19338f2a43c19.png";
import ju from "./assets/da3404a98f13fc0a.png";
import yu from "./assets/de173bee08bf96b4.png";
import Au from "./assets/b086bdd2e6400463.png";
import Tu from "./assets/7b1831ce31bc2ac3.png";
import xu from "./assets/9987f3667484a537.png";
import zu from "./assets/6df200360f461323.png";
import fu from "./assets/0f890b84d3dbe1ea.png";
import mu from "./assets/78cfc10d4003eba8.png";
import Lu from "./assets/eb938c355681a53d.png";
import pu from "./assets/02e88ee127b765f7.png";
import wu from "./assets/fe1ead98be4d96a4.png";
import Cu from "./assets/f5d0d7969a3ec71d.png";
import hu from "./assets/ee0e9032174cf31f.png";
import Ou from "./assets/d0ecc7dabad2739c.png";
import Eu from "./assets/8de721b995d260dd.png";
import Su from "./assets/5649f5db1276ecff.png";
import ku from "./assets/a8b6fac4cdc60886.png";
import vu from "./assets/cd704b1d00d6c2bd.png";
import bu from "./assets/7f45e7db0423c216.png";
import Qu from "./assets/e5c93efbd3949b07.png";
import Uu from "./assets/e39d76bf6afa36a9.png";
import Yu from "./assets/1a670a057e5cf731.png";
import _u from "./assets/eded8ecd8a6db6af.png";
import Pu from "./assets/4bb0e9e856b13bf7.png";
import Ru from "./assets/c92599fe48968edc.png";
import Fu from "./assets/14648c6ca1311be3.png";
import Wu from "./assets/66e581596a528b62.png";
import Bu from "./assets/6d121129513157f7.png";
import Vu from "./assets/b88e9670bac3da50.png";
import Gu from "./assets/c969ccf648aa87da.png";
import Zu from "./assets/59d6d9d04e8dfaf4.png";
const $t = {
  brickRed: "#CF563F",
  chrome: "#F2F2F2",
  deepGreen: "#10A3B8",
  energyGreen: "#6ACCB6",
  fiestaYellow: "#F6CC1B",
  white: "#FFFFFF"
}, $u = {
  primary: "#6905F2",
  "primary-medium": "#7519F3",
  "primary-light": "#7F2AF4",
  secondary: "#00D4B5",
  usp: "#f5eefe",
  white: "#FFFFFF",
  black: "#000000",
  "dark-1": "#111111",
  "dark-2": "#444444",
  "purple-1": "#F5EEFE",
  "purple-2": "#E9DAFD",
  "purple-4": "#E4D2FD",
  "purple-8": "#7F2AF4",
  "purple-9": "#7519F3",
  "green-1": "#51B27E",
  "green-2": "#00B975",
  "green-3": "#D9F9F4",
  "grey-1": "#EEEEEE",
  "grey-2": "#F8F9FA",
  "grey-3": "#D9D9D9",
  "yellow-1": "#F5D000",
  "teal-100": "#ccfbf1",
  none: "transparent",
  accent: $t.chrome,
  positive: $t.energyGreen,
  negative: $t.brickRed,
  info: $t.deepGreen,
  warning: $t.fiestaYellow,
  "shadow-color": $t.chrome,
  cta: $t.energyGreen,
  "cta-text": $t.white
}, Ju = {
  default: { ...$u }
}, Rt = Ju.default;
Object.keys(Rt).map((t) => `bg-${t}`);
Object.keys(Rt).map((t) => `text-${t}`);
Object.keys(Rt).map((t) => `bg-${t}`);
Object.keys(Rt).map((t) => t);
const Hu = ["width", "height"], Xu = ["href"], ie = /* @__PURE__ */ ne({
  __name: "Icon",
  props: {
    icon: {
      type: String,
      required: !0
    },
    iconColor: {
      type: String
    },
    width: {
      type: [String, Number]
    },
    height: {
      type: [String, Number]
    },
    stroke: {
      type: String
    },
    opacity: {
      type: Number
    }
  },
  setup(t) {
    const e = t, i = J(() => {
      const a = {};
      return e.iconColor && (a.fill = Rt[e.iconColor] || e.iconColor), e.stroke && (a.stroke = Rt[e.stroke] || e.stroke), e.opacity !== void 0 && (a.opacity = e.opacity.toString()), a;
    }), M = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1", n = J(() => `${M ? new URL("data:image/svg+xml;base64,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", import.meta.url).href : ""}#${e.icon}`);
    return (a, r) => (y(), A("svg", {
      width: t.width ? typeof t.width == "number" ? `${t.width}px` : t.width : void 0,
      height: t.height ? typeof t.height == "number" ? `${t.height}px` : t.height : void 0,
      "aria-hidden": "true",
      focusable: "false",
      style: R(i.value)
    }, [
      l("use", { href: n.value }, null, 8, Xu)
    ], 12, Hu));
  }
}), Ku = ["id"], qu = { class: "flex flex-col items-center" }, ec = { class: "flex items-center" }, tc = {
  key: 1,
  class: "flex items-center justify-center ml-2"
}, Ke = /* @__PURE__ */ ne({
  __name: "Button",
  props: {
    id: {
      type: String
    },
    label: {
      type: String
    },
    showButtonSubText: {
      type: Boolean
    },
    color: {
      type: String
    },
    hoverColor: {
      type: String
    },
    textSize: {
      type: String
    },
    textColor: {
      type: String,
      default: "text-black"
    },
    iconBefore: {
      type: Boolean
    },
    iconAfter: {
      type: Boolean
    },
    iconColor: {
      type: String,
      default: "black"
    },
    width: {
      type: String
    },
    height: {
      type: String
    },
    link: {
      type: String
    },
    square: {
      type: Boolean
    },
    outline: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    loading: {
      type: Boolean
    }
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const i = t, M = e, n = () => {
      if (!(i.disabled || i.loading)) {
        if (i.link)
          return window.open(i.link, "_self");
        M("click");
      }
    }, a = J(() => [
      i.textColor,
      i.textSize,
      i.iconBefore ? "pl-1" : "",
      i.iconAfter ? "pr-1" : ""
    ]);
    return (r, o) => (y(), A("button", {
      id: t.id,
      class: P(["flex items-center justify-center p-2 max-w-full", [t.color, t.textColor, t.textSize, `hover:${t.hoverColor}`, `${t.square ? "" : "rounded-md"}`, `${t.outline ? "bg-transparent border border-black" : ""}`, `${t.disabled || t.loading ? "opacity-75 cursor-not-allowed" : "cursor-pointer"}`]]),
      style: R({ width: t.width, height: t.height }),
      onClick: n
    }, [
      l("div", qu, [
        t.iconBefore && !t.loading ? (y(), _e(ie, {
          key: 0,
          class: "cursor-pointer",
          icon: "refresh",
          "icon-color": t.iconColor,
          width: "17",
          height: "14"
        }, null, 8, ["icon-color"])) : k("", !0),
        l("span", ec, [
          l("div", {
            class: P(a.value)
          }, m(t.label), 3),
          t.iconAfter && !t.loading ? (y(), _e(ie, {
            key: 0,
            class: "cursor-pointer",
            icon: "arrow-right",
            "icon-color": t.iconColor,
            height: "13",
            width: "13"
          }, null, 8, ["icon-color"])) : k("", !0),
          t.loading ? (y(), A("div", tc, [
            (y(), A("svg", {
              class: P(["animate-spin h-5 w-5", t.textColor]),
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24"
            }, o[0] || (o[0] = [
              l("circle", {
                class: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                "stroke-width": "4"
              }, null, -1),
              l("path", {
                class: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              }, null, -1)
            ]), 2))
          ])) : k("", !0)
        ])
      ])
    ], 14, Ku));
  }
}), ic = ["id"], Mc = { class: "flex justify-center items-center px-16 py-6 w-full max-md:px-5 max-md:max-w-full" }, nc = { class: "flex flex-col max-w-full w-[776px]" }, ac = { class: "flex gap-2 justify-center self-center px-6 py-2 mt-2 rounded-md max-md:px-5 cursor-pointer" }, fh = /* @__PURE__ */ ne({
  __name: "GenericFooter",
  props: {
    id: String,
    title: String,
    description: String,
    btnText: String,
    btnLink: String,
    backgroundColor: String,
    btnIcon: String,
    btnColor: String,
    btnTextColor: String,
    textColor: String
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    return (i, M) => (y(), A("div", {
      id: t.id,
      class: P(["flex flex-col justify-center py-12 max-md:py-8 text-center"]),
      style: R({ backgroundColor: t.backgroundColor })
    }, [
      l("div", Mc, [
        l("div", nc, [
          l("div", {
            class: P([t.textColor, "text-h3 font-bold leading-8 max-md:max-w-full"])
          }, m(t.title), 3),
          l("div", {
            class: P([t.textColor, "text-body1 mt-2 leading-6 max-md:max-w-full"])
          }, m(t.description), 3),
          l("div", ac, [
            b(Ke, {
              color: t.btnColor,
              "hover-color": "bg-secondary hover:brightness-110",
              "text-size": "text-button-large",
              "text-color": t.btnTextColor,
              link: t.btnLink,
              label: t.btnText,
              "icon-after": t.btnIcon != "none",
              width: "",
              height: "52px",
              "icon-color": "dark-1",
              class: "cta-button px-4"
            }, null, 8, ["color", "text-color", "link", "label", "icon-after"])
          ])
        ])
      ])
    ], 12, ic));
  }
});
function fa(t) {
  return qs() ? (eu(t), !0) : !1;
}
function vi(t) {
  return typeof t == "function" ? t() : T(t);
}
const El = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const rc = Object.prototype.toString, lc = (t) => rc.call(t) === "[object Object]", Sl = () => {
}, Tr = /* @__PURE__ */ oc();
function oc() {
  var t, e;
  return El && ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function sc(t) {
  return Ll();
}
function uc(...t) {
  if (t.length !== 1)
    return Hs(...t);
  const e = t[0];
  return typeof e == "function" ? Xs(Ks(() => ({ get: e, set: Sl }))) : C(e);
}
function cc(t, e = !0, i) {
  sc() ? we(t, i) : e ? t() : Tt(t);
}
const ma = El ? window : void 0;
function gc(t) {
  var e;
  const i = vi(t);
  return (e = i == null ? void 0 : i.$el) != null ? e : i;
}
function kl(...t) {
  let e, i, M, n;
  if (typeof t[0] == "string" || Array.isArray(t[0]) ? ([i, M, n] = t, e = ma) : [e, i, M, n] = t, !e)
    return Sl;
  Array.isArray(i) || (i = [i]), Array.isArray(M) || (M = [M]);
  const a = [], r = () => {
    a.forEach((c) => c()), a.length = 0;
  }, o = (c, g, d, j) => (c.addEventListener(g, d, j), () => c.removeEventListener(g, d, j)), s = xe(
    () => [gc(e), vi(n)],
    ([c, g]) => {
      if (r(), !c)
        return;
      const d = lc(g) ? { ...g } : g;
      a.push(
        ...i.flatMap((j) => M.map((D) => o(c, j, D, d)))
      );
    },
    { immediate: !0, flush: "post" }
  ), u = () => {
    s(), r();
  };
  return fa(u), u;
}
function Nc() {
  const t = C(!1), e = Ll();
  return e && we(() => {
    t.value = !0;
  }, e), t;
}
function Ic(t) {
  const e = Nc();
  return J(() => (e.value, !!t()));
}
function Dc(t, e = {}) {
  const { window: i = ma } = e, M = Ic(() => i && "matchMedia" in i && typeof i.matchMedia == "function");
  let n;
  const a = C(!1), r = (u) => {
    a.value = u.matches;
  }, o = () => {
    n && ("removeEventListener" in n ? n.removeEventListener("change", r) : n.removeListener(r));
  }, s = tu(() => {
    M.value && (o(), n = i.matchMedia(vi(t)), "addEventListener" in n ? n.addEventListener("change", r) : n.addListener(r), a.value = n.matches);
  });
  return fa(() => {
    s(), o(), n = void 0;
  }), a;
}
function fn(t) {
  return typeof Window < "u" && t instanceof Window ? t.document.documentElement : typeof Document < "u" && t instanceof Document ? t.documentElement : t;
}
function vl(t) {
  const e = window.getComputedStyle(t);
  if (e.overflowX === "scroll" || e.overflowY === "scroll" || e.overflowX === "auto" && t.clientWidth < t.scrollWidth || e.overflowY === "auto" && t.clientHeight < t.scrollHeight)
    return !0;
  {
    const i = t.parentNode;
    return !i || i.tagName === "BODY" ? !1 : vl(i);
  }
}
function dc(t) {
  const e = t || window.event, i = e.target;
  return vl(i) ? !1 : e.touches.length > 1 ? !0 : (e.preventDefault && e.preventDefault(), !1);
}
const mn = /* @__PURE__ */ new WeakMap();
function jc(t, e = !1) {
  const i = C(e);
  let M = null, n = "";
  xe(uc(t), (o) => {
    const s = fn(vi(o));
    if (s) {
      const u = s;
      if (mn.get(u) || mn.set(u, u.style.overflow), u.style.overflow !== "hidden" && (n = u.style.overflow), u.style.overflow === "hidden")
        return i.value = !0;
      if (i.value)
        return u.style.overflow = "hidden";
    }
  }, {
    immediate: !0
  });
  const a = () => {
    const o = fn(vi(t));
    !o || i.value || (Tr && (M = kl(
      o,
      "touchmove",
      (s) => {
        dc(s);
      },
      { passive: !1 }
    )), o.style.overflow = "hidden", i.value = !0);
  }, r = () => {
    const o = fn(vi(t));
    !o || !i.value || (Tr && (M == null || M()), o.style.overflow = n, mn.delete(o), i.value = !1);
  };
  return fa(r), J({
    get() {
      return i.value;
    },
    set(o) {
      o ? a() : r();
    }
  });
}
function bl(t = {}) {
  const {
    window: e = ma,
    initialWidth: i = Number.POSITIVE_INFINITY,
    initialHeight: M = Number.POSITIVE_INFINITY,
    listenOrientation: n = !0,
    includeScrollbar: a = !0,
    type: r = "inner"
  } = t, o = C(i), s = C(M), u = () => {
    e && (r === "outer" ? (o.value = e.outerWidth, s.value = e.outerHeight) : a ? (o.value = e.innerWidth, s.value = e.innerHeight) : (o.value = e.document.documentElement.clientWidth, s.value = e.document.documentElement.clientHeight));
  };
  if (u(), cc(u), kl("resize", u, { passive: !0 }), n) {
    const c = Dc("(orientation: portrait)");
    xe(c, () => u());
  }
  return { width: o, height: s };
}
const yc = { class: "relative min-h-[200px]" }, Ac = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center bg-white z-10"
}, Tc = ["src", "alt", "width"], xc = /* @__PURE__ */ ne({
  __name: "Imagin",
  props: {
    id: {},
    make: {},
    modelFamily: {},
    modelRange: {},
    modelTrim: {},
    modelYear: {},
    modelDoors: {},
    modelPowerTrain: {},
    angle: {},
    paintId: {},
    width: {},
    position: {}
  },
  setup(t) {
    const e = t, i = J(() => {
      const o = new URLSearchParams({
        customer: "gb-carfinance247",
        zoomType: "fullscreen",
        margins: "0.03",
        make: e.make || "",
        modelFamily: e.modelFamily || "",
        modelRange: e.modelRange || "",
        modelYear: e.modelYear || "",
        modelTrim: e.modelTrim || "",
        bodySize: e.modelDoors || "",
        powerTrain: e.modelPowerTrain || "",
        angle: e.angle || "",
        paintId: e.paintId || "",
        width: e.width || "",
        position: e.position || "",
        fileType: "webp",
        // Hardcoded values (previously props)
        version: "5",
        surrounding: "studio",
        modelVariant: "ha",
        countryCode: "0",
        licensePlateType: "eu",
        rim: "0",
        interiorId: "000002",
        steering: "lhd",
        tailoring: "gray",
        aspectRatio: "1.6",
        transmission: "0"
      });
      return console.log("🔄 Imagin URL:", `https://cdn.imagin.studio/getImage?${o.toString()}`), `https://cdn.imagin.studio/getImage?${o.toString()}`;
    }), M = (o) => o ? o.endsWith("px") ? o.slice(0, -2) : o : "auto", n = J(() => M(e.width)), a = C(!0), r = () => {
      a.value = !1;
    };
    return we(() => {
      const o = document.createElement("link");
      o.rel = "preload", o.as = "image", o.href = i.value, document.head.appendChild(o);
    }), Aa(() => {
      const o = document.querySelector(`link[href="${i.value}"]`);
      o && document.head.removeChild(o);
    }), (o, s) => (y(), A("div", yc, [
      a.value ? (y(), A("div", Ac, s[0] || (s[0] = [
        l("svg", {
          class: "animate-spin h-12 w-12 text-gray-400",
          xmlns: "http://www.w3.org/2000/svg",
          fill: "none",
          viewBox: "0 0 24 24"
        }, [
          l("circle", {
            class: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            "stroke-width": "4"
          }),
          l("path", {
            class: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          })
        ], -1)
      ]))) : k("", !0),
      l("img", {
        src: i.value,
        alt: `${e.make} ${e.modelFamily}`,
        width: n.value,
        class: "px-4 relative",
        decoding: "async",
        fetchpriority: "high",
        loading: "eager",
        onLoad: r
      }, null, 40, Tc)
    ]));
  }
}), fe = (t, e) => {
  const i = t.__vccOpts || t;
  for (const [M, n] of e)
    i[M] = n;
  return i;
}, oM = /* @__PURE__ */ fe(xc, [["__scopeId", "data-v-81138975"]]), zc = ["id"], fc = { class: "text-h4 font-bold text-left w-full" }, mc = { class: "text-subtitle1 text-left w-full font-bold mt-1" }, Lc = { class: "flex gap-2 py-2 mt-4 text-l rounded-md" }, pc = ["title", "aria-label"], wc = { class: "justify-center max-w-full text-white w-[330px]" }, Cc = ["innerHTML"], hc = { class: "flex flex-col items-center w-full" }, Oc = {
  key: 1,
  style: { width: "100%", overflow: "hidden" },
  class: "md:p-0 p-4"
}, Ec = ["id"], Sc = { class: "text-h4 font-bold text-left w-full tracking-tight" }, kc = { class: "text-subtitle1 text-left w-full font-bold mt-1" }, vc = { class: "flex gap-2 py-2 mt-4 text-l grounded-md cursor-pointer" }, bc = ["title", "aria-label"], Qc = { class: "justify-center max-w-full text-white w-[330px]" }, Uc = ["innerHTML"], mh = /* @__PURE__ */ ne({
  __name: "CarConverter",
  props: {
    id: {
      type: String
    },
    header: {
      type: String
    },
    subHeader: {
      type: String
    },
    btnText: {
      type: String
    },
    btnColor: {
      type: String
    },
    backgroundColor: {
      type: String,
      default: "bg-purple-8"
    },
    bgHeight: {
      type: String
    },
    image: {
      type: String
    },
    arpText: {
      type: String
    }
  },
  setup(t) {
    const e = t, {
      id: i,
      header: M,
      subHeader: n,
      btnText: a,
      btnColor: r,
      backgroundColor: o,
      image: s,
      arpText: u
    } = at(e), { width: c } = bl(), g = J(() => c.value);
    return (d, j) => g.value >= 1024 ? (y(), A("div", {
      key: 0,
      id: T(i),
      class: P(["flex flex-col rounded-md text-white md:mt-4 lg:mt-0"])
    }, [
      l("div", {
        class: P([T(o), "pt-6 rounded-md px-6 py-2"]),
        style: { "padding-bottom": "75px" }
      }, [
        l("div", fc, m(T(M)), 1),
        l("div", mc, m(T(n)), 1),
        l("div", Lc, [
          l("a", {
            href: "https://apply.carfinance247.co.uk/",
            target: "_self",
            title: T(a),
            "aria-label": T(a),
            style: { "min-height": "44px" }
          }, [
            b(Ke, {
              color: T(r),
              style: { "min-height": "44px" },
              "text-size": "text-button-large",
              "text-color": "text-dark-1",
              "hover-color": "bg-secondary hover:brightness-110",
              label: T(a),
              "icon-after": !0,
              width: "188px",
              height: "52px",
              "icon-color": "dark-1"
            }, null, 8, ["color", "label"])
          ], 8, pc)
        ]),
        l("div", wc, [
          l("span", {
            class: "text-body2 text-white text-xs",
            innerHTML: T(u)
          }, null, 8, Cc)
        ])
      ], 2),
      l("div", hc, [
        b(oM, {
          make: "ford",
          "model-family": "fiesta",
          "model-range": "fiesta",
          "model-year": "2022",
          "model-trim": "",
          "model-power-train": "hybrid",
          "model-doors": "5",
          angle: "23",
          "paint-id": "pspc0386",
          width: "247",
          position: "top",
          height: "",
          style: { "margin-top": "-50px" }
        })
      ])
    ], 8, zc)) : (y(), A("div", Oc, [
      l("div", {
        id: T(i),
        class: P(["flex flex-col rounded-md text-white"])
      }, [
        l("div", {
          class: P([T(o), "pt-6 rounded-md px-6 py-12"])
        }, [
          l("div", Sc, m(T(M)), 1),
          l("div", kc, m(T(n)), 1),
          l("div", vc, [
            l("a", {
              href: "https://apply.carfinance247.co.uk/",
              target: "_self",
              title: T(a),
              "aria-label": T(a),
              style: { "min-height": "44px" }
            }, [
              b(Ke, {
                class: "max-w-[188px]",
                style: { "min-height": "44px" },
                color: T(r),
                "text-size": "text-button-large",
                "text-color": "text-dark-1",
                label: T(a),
                "icon-after": !0,
                width: "188px",
                height: "52px",
                "icon-color": "dark-1"
              }, null, 8, ["color", "label"])
            ], 8, bc)
          ]),
          l("div", Qc, [
            l("span", {
              class: "text-body2 text-white",
              innerHTML: T(u)
            }, null, 8, Uc)
          ])
        ], 2),
        l("div", {
          class: P(["flex flex-col w-full", `${g.value > 640 ? "items-end" : "items-center"}`])
        }, [
          b(oM, {
            make: "ford",
            "model-family": "fiesta",
            "model-range": "fiesta",
            "model-year": "2022",
            "model-trim": "",
            "model-power-train": "hybrid",
            "model-doors": "5",
            angle: "23",
            "paint-id": "pspc0386",
            width: "200",
            position: "top",
            style: R([{ "margin-top": "-70px" }, `${g.value > 640 ? "margin-right: 0px; margin-top: -40px;" : "margin-right: -250px; margin-top: -40px; margin-bottom: -30px"};`])
          }, null, 8, ["style"])
        ], 2)
      ], 8, Ec)
    ]));
  }
}), Yc = { class: "flex gap-x-1" }, _c = ["onClick"], Pc = { class: "text-subtitle2 flex items-center" }, Rc = ["id"], Fc = {
  key: 0,
  class: "col-span-2 hover:bg-purple-1 rounded-md"
}, Wc = ["href"], Bc = {
  key: 1,
  class: "min-w-[220px]"
}, Vc = { class: "p-4 text-overline uppercase tracking-widest" }, Gc = ["href"], Zc = ["href"], $c = {
  class: "text-subtitle2 flex items-center gap-x-2 cursor-pointer",
  href: "https://my.carfinance247.co.uk/",
  target: "_blank",
  rel: "noopener noreferrer"
}, Jc = /* @__PURE__ */ ne({
  __name: "DesktopMenu",
  props: {
    menu: {
      type: Array,
      required: !0
    }
  },
  setup(t) {
    const e = C([]), i = C(null), M = t, n = J(() => (o) => {
      if (!o) return "#";
      try {
        return new URL(o, window.location.origin).href;
      } catch {
        return o.startsWith("/") ? o : `/${o}`;
      }
    });
    function a(o, s, u) {
      var c;
      if (o.subMenu) {
        const g = document.getElementById(`dropdown-${s}`);
        if (g) {
          document.querySelectorAll(".dropdown").forEach((j) => {
            var D;
            j.id !== `dropdown-${s}` && (j.classList.add("invisible"), j.classList.add("opacity-0")), (D = j.parentElement) == null || D.classList.remove("bg-[#5E07D6]");
          }), document.querySelectorAll(".chevron").forEach((j) => {
            j.id !== `chevron-${s}` && (j.style.transform = "rotate(0deg)");
          }), g.classList.toggle("invisible"), g.classList.toggle("opacity-0"), (c = u.currentTarget) == null || c.classList.toggle("bg-[#5E07D6]");
          const d = document.getElementById(`chevron-${s}`);
          d && (d.style.transform = d.style.transform === "rotate(180deg)" ? "rotate(0deg)" : "rotate(180deg)");
        }
      }
    }
    const r = (o) => {
      i.value && !i.value.contains(o.target) && (document.querySelectorAll(".dropdown").forEach((s) => {
        var u;
        s.classList.add("invisible"), s.classList.add("opacity-0"), (u = s.parentElement) == null || u.classList.remove("bg-[#5E07D6]");
      }), document.querySelectorAll(".chevron").forEach((s) => {
        s.style.transform = "rotate(0deg)";
      }));
    };
    return we(() => {
      e.value = M.menu, document.addEventListener("click", r);
    }), Aa(() => {
      document.removeEventListener("click", r);
    }), (o, s) => (y(), A("nav", {
      ref_key: "desktopMenu",
      ref: i,
      class: P([
        "flex justify-between items-center gap-x-6 w-full animate text-white"
      ])
    }, [
      l("div", Yc, [
        (y(!0), A(ge, null, ye(e.value, (u, c) => (y(), A("div", {
          key: c,
          class: P(["flex items-center relative hover:bg-[#5E07D6] active:bg-[#5E07D6] rounded-md cursor-pointer", { "p-4 py-3": u.icon }]),
          onClick: (g) => u.icon ? a(u, c, g) : null
        }, [
          u.icon ? (y(), A(ge, { key: 0 }, [
            l("button", Pc, [
              G(m(u.name) + " ", 1),
              b(ie, {
                id: `chevron-${c}`,
                class: "ml-2 align-middle chevron",
                icon: "chevron-down",
                "icon-color": "white",
                height: "16",
                width: "16"
              }, null, 8, ["id"])
            ]),
            l("div", {
              id: `dropdown-${c}`,
              class: "dropdown absolute invisible opacity-0 bg-white top-9 z-50 text-dark-1 p-2 rounded-md transition-opacity duration-500 ease-in-out shadow-xl mt-4 -ml-6",
              style: { width: "max-content" }
            }, [
              l("ul", {
                class: P(["inline-grid gap-x-6 whitespace-nowrap min-w-[220px]", `grid-cols-${u.cols ? u.cols : 3}`])
              }, [
                (y(!0), A(ge, null, ye(u.subMenu, (g, d) => (y(), A(ge, null, [
                  g.link ? (y(), A("li", Fc, [
                    l("a", {
                      class: "inline-block p-4 w-full h-full text-subtitle2",
                      href: n.value(g.link)
                    }, m(g.name), 9, Wc)
                  ])) : (y(), A("li", Bc, [
                    l("ul", null, [
                      l("li", Vc, m(g.name), 1),
                      (y(!0), A(ge, null, ye(g.subMenu, (j, D) => (y(), A("li", {
                        key: D,
                        class: "hover:bg-purple-1 rounded-md"
                      }, [
                        l("a", {
                          class: "inline-block p-4 w-full h-full text-subtitle2",
                          href: n.value(j.link)
                        }, m(j.name), 9, Gc)
                      ]))), 128))
                    ])
                  ]))
                ], 64))), 256))
              ], 2)
            ], 8, Rc)
          ], 64)) : (y(), A("a", {
            key: 1,
            class: "p-4 py-3 bg-transparent text-subtitle2",
            href: n.value(u.link)
          }, m(u.name), 9, Zc))
        ], 10, _c))), 128))
      ]),
      l("a", $c, [
        b(ie, {
          class: "ml-2",
          icon: "account",
          "icon-color": "white",
          height: "24",
          width: "24"
        }),
        s[0] || (s[0] = G(" Sign In "))
      ])
    ], 512));
  }
}), Hc = /* @__PURE__ */ fe(Jc, [["__scopeId", "data-v-9273fc11"]]);
/*!
  * vue-router v4.5.1
  * (c) 2025 Eduardo San Martin Morote
  * @license MIT
  */
var xr;
(function(t) {
  t.pop = "pop", t.push = "push";
})(xr || (xr = {}));
var zr;
(function(t) {
  t.back = "back", t.forward = "forward", t.unknown = "";
})(zr || (zr = {}));
Symbol(process.env.NODE_ENV !== "production" ? "navigation failure" : "");
var fr;
(function(t) {
  t[t.aborted = 4] = "aborted", t[t.cancelled = 8] = "cancelled", t[t.duplicated = 16] = "duplicated";
})(fr || (fr = {}));
Symbol(process.env.NODE_ENV !== "production" ? "router view location matched" : "");
Symbol(process.env.NODE_ENV !== "production" ? "router view depth" : "");
Symbol(process.env.NODE_ENV !== "production" ? "router" : "");
const Xc = Symbol(process.env.NODE_ENV !== "production" ? "route location" : "");
Symbol(process.env.NODE_ENV !== "production" ? "router view location" : "");
function Kc(t) {
  return pl(Xc);
}
function La() {
  let t = !1;
  return window.location.pathname.indexOf("social-") > -1 && (t = !0), window.location.hostname.split(".")[0] === "social" && (t = !0), t;
}
const qc = { class: "w-full flex justify-end items-stretch" }, eg = { class: "text-xs" }, tg = { class: "w-full flex flex-col items-start" }, ig = {
  key: 0,
  class: "flex justify-start pb-4 fixed w-full bg-secondary",
  style: { "border-bottom": "1px solid rgba(17, 17, 17, .1)", width: "92%" }
}, Mg = ["onClick"], ng = {
  key: 0,
  class: "w-full mb-4",
  style: { height: "1px", "background-color": "#000", "border-color": "#111111", opacity: "0" }
}, ag = ["href"], rg = { class: "flex-grow cursor-pointer" }, lg = { key: 0 }, og = {
  key: 1,
  class: "hidden"
}, sg = ["aria-controls"], ug = ["href"], cg = ["id"], gg = ["href"], Ng = /* @__PURE__ */ ne({
  __name: "MobileMenu",
  props: {
    menu: {
      type: Array,
      required: !0
    },
    activeClass: {
      type: String,
      default: ""
    },
    headerRef: {
      type: Object
    }
  },
  emits: ["menu-active"],
  setup(t, { emit: e }) {
    const i = () => {
      window.open("https://my.carfinance247.co.uk/", "_blank", "noopener,noreferrer");
    };
    Kc();
    const M = C([]), n = jc(document.querySelector("body")), a = t, r = e, o = C(!1), s = C([]), u = C(!1);
    function c() {
      if (o.value = !o.value, a.headerRef) {
        const I = a.headerRef;
        I.style.maxHeight != "" && (I.style.maxHeight = "", I.style.height = "");
      }
    }
    function g(I) {
      let N = [];
      return I.subMenu && I.subMenu.forEach((x) => {
        x.icon && delete x.icon, N.push(x), N = N.concat(g(x));
      }), N;
    }
    function d(I, N) {
      if (N.level && N.level === 1 || !N.subMenu)
        return;
      u.value = !0, s.value = I;
      const x = g(N);
      x.length ? M.value = x : M.value = [], setTimeout(() => {
        u.value = !1;
      }, 500);
    }
    function j(I) {
      u.value = !0, M.value = I.level && I.level - 1 === 0 ? a.menu : s.value, setTimeout(() => {
        u.value = !1;
      }, 500);
    }
    const D = J(() => (I) => {
      if (!I) return "#";
      try {
        return new URL(I, window.location.origin).href;
      } catch {
        return I.startsWith("/") ? I : `/${I}`;
      }
    });
    return xe(o, (I) => {
      const N = I ? "hsl(var(--twc-secondary))" : "hsl(var(--twc-primary))";
      document.querySelector('meta[name="theme-color"]') && (document.querySelector('meta[name="theme-color"]').setAttribute("content", N), window.parent.postMessage(N, "*")), n.value = !!I, r("menu-active", I);
    }), we(() => {
      M.value = a.menu;
    }), (I, N) => (y(), A("div", qc, [
      l("div", {
        class: P(["flex flex-row gap-x-2 justify-center items-center text-subtitle2 h-16 px-2", o.value ? "text-dark animate" : "text-white"])
      }, [
        l("button", {
          class: "flex flex-col justify-center items-center px-2",
          onClick: i
        }, [
          b(ie, {
            title: "Sign In",
            class: "w-6 h-6 mb-1",
            icon: "account",
            "icon-color": o.value ? "black" : "white",
            height: "24",
            width: "24"
          }, null, 8, ["icon-color"]),
          N[1] || (N[1] = l("div", { class: "text-xs" }, " Sign In ", -1))
        ]),
        l("button", {
          class: "flex flex-col justify-center items-center px-2",
          onClick: c
        }, [
          b(ie, {
            class: "w-6 h-6 mb-1",
            icon: o.value ? "close" : "menu",
            "icon-color": o.value ? "black" : "white",
            height: "24",
            width: "24"
          }, null, 8, ["icon", "icon-color"]),
          l("div", eg, m(o.value ? "Close" : "Menu"), 1)
        ])
      ], 2),
      b(wl, { name: "fade" }, {
        default: Ta(() => {
          var x, f;
          return [
            ht(l("div", {
              class: P(["fixed inset-0 top-24 text-dark flex flex-col flex-start items-start px-4 gap-y-4 max-width:unset", t.activeClass]),
              style: { "overflow-y": "scroll" }
            }, [
              l("div", tg, [
                (x = M.value[0]) != null && x.parent ? (y(), A("div", ig, [
                  l("button", {
                    class: "flex items-center -ml-2 text-subtitle2",
                    onClick: N[0] || (N[0] = (L) => j(M.value[0]))
                  }, [
                    b(ie, {
                      title: "Back",
                      class: "mr-2",
                      icon: "chevron-left",
                      "icon-color": "black",
                      height: "24",
                      width: "24"
                    }),
                    G(" " + m(M.value[0].parent), 1)
                  ])
                ])) : k("", !0),
                l("div", {
                  class: P(["w-full pb-8", { "mb-12": (f = M.value[0]) == null ? void 0 : f.parent }])
                }, null, 2),
                (y(!0), A(ge, null, ye(M.value, (L, p) => (y(), A("div", {
                  key: p,
                  class: P(["w-full text-left flex justify-between text-h6 pb-8", { "flex-col": L.separator }]),
                  onClick: (h) => d(M.value, L)
                }, [
                  L.separator ? (y(), A("hr", ng)) : k("", !0),
                  L.link ? (y(), A("a", {
                    key: 1,
                    href: D.value(L.link),
                    style: { height: "32px" }
                  }, [
                    l("div", rg, m(L.name), 1)
                  ], 8, ag)) : (y(), A("div", {
                    key: 2,
                    class: P(["w-full flex justify-between items-center", { "cursor-pointer": L.level != 1 }]),
                    style: R(`height: ${L.level != 1 ? "32px" : ""}`)
                  }, [
                    l("div", {
                      class: P(["flex-grow w-full", { "text-overline uppercase tracking-widest text-dark-1": L.level == 1 }])
                    }, m(L.name), 3),
                    L.icon ? (y(), A("div", lg, [
                      b(ie, {
                        icon: "chevron-right",
                        "icon-color": o.value ? "black" : "white",
                        height: "32",
                        width: "32"
                      }, null, 8, ["icon-color"])
                    ])) : k("", !0),
                    L.subMenu ? (y(), A("ul", og, [
                      (y(!0), A(ge, null, ye(L.subMenu, (h, w) => (y(), A("li", { key: w }, [
                        h.subMenu ? (y(), A("button", {
                          key: 0,
                          type: "button",
                          "aria-expanded": "false",
                          "aria-controls": `sub-menu-${w}`
                        }, m(h.name), 9, sg)) : (y(), A("a", {
                          key: 1,
                          href: D.value(h.link)
                        }, m(h.name), 9, ug)),
                        h.subMenu ? (y(), A("ul", {
                          key: 2,
                          id: `sub-menu-${w}`
                        }, [
                          (y(!0), A(ge, null, ye(h.subMenu, (O, S) => (y(), A("li", { key: S }, [
                            l("a", {
                              href: D.value(O.link)
                            }, m(O.name), 9, gg)
                          ]))), 128))
                        ], 8, cg)) : k("", !0)
                      ]))), 128))
                    ])) : k("", !0)
                  ], 6))
                ], 10, Mg))), 128))
              ])
            ], 2), [
              [xa, o.value]
            ])
          ];
        }),
        _: 1
      })
    ]));
  }
}), Ig = /* @__PURE__ */ fe(Ng, [["__scopeId", "data-v-e12a5227"]]), Dg = {
  fetchMenu() {
    return new Promise((t, e) => {
      t([
        {
          name: "Car Finance",
          icon: !0,
          link: null,
          level: 0,
          cols: 4,
          subMenu: [
            {
              parent: "Back",
              name: "Car Finance",
              icon: !0,
              link: null,
              level: 1,
              subMenu: [
                {
                  parent: "Car Finance",
                  title: "How It Works",
                  name: "How It Works",
                  icon: !1,
                  link: "/how-it-works",
                  level: 2
                },
                {
                  parent: "Car Finance",
                  title: "HP Car Finance",
                  name: "HP Car Finance",
                  icon: !1,
                  link: "/hire-purchase",
                  level: 2
                },
                {
                  parent: "Car Finance",
                  title: "PCP Car Finance",
                  name: "PCP Car Finance",
                  icon: !1,
                  link: "/pcp-personal-contract-purchase",
                  level: 2
                },
                {
                  parent: "Car Finance",
                  title: "Value My Car",
                  name: "Value My Car",
                  icon: !1,
                  link: "/valuations",
                  level: 2
                },
                {
                  parent: "Car Finance",
                  title: "Bad Credit Car Finance",
                  name: "Bad Credit Car Finance",
                  icon: !1,
                  link: "/bad-credit-car-finance",
                  level: 2
                },
                {
                  parent: "Car Finance",
                  title: "No Deposit Car Finance",
                  name: "No Deposit Car Finance",
                  icon: !1,
                  link: "/no-deposit-car-finance",
                  level: 2
                },
                {
                  parent: "Car Finance",
                  title: "Refinance My Car",
                  name: "Refinance My Car",
                  icon: !1,
                  link: "/refinance-car-finance",
                  level: 2
                },
                {
                  parent: "Car Finance",
                  title: "Car Finance Explained",
                  name: "Car Finance Explained",
                  icon: !1,
                  link: "/car-finance-options-explained",
                  level: 2
                },
                {
                  parent: "Car Finance",
                  title: "Car Finance Locations",
                  name: "Car Finance Locations",
                  icon: !1,
                  link: "/locations",
                  level: 2
                }
              ]
            },
            {
              parent: "Back",
              name: "Finance by Vehicle Type",
              icon: !0,
              link: null,
              level: 1,
              separator: !0,
              subMenu: [
                {
                  parent: "Car Finance",
                  title: "Used Car Finance",
                  name: "Used Car Finance",
                  icon: !1,
                  link: "/used-car-finance",
                  level: 2
                },
                {
                  parent: "Car Finance",
                  title: "Electric Vehicle Finance",
                  name: "Electric Vehicle Finance",
                  icon: !1,
                  link: "/electric-car-finance",
                  level: 2
                },
                {
                  parent: "Car Finance",
                  title: "Van Finance",
                  name: "Van Finance",
                  icon: !1,
                  link: "/van-finance",
                  level: 2
                },
                {
                  parent: "Car Finance",
                  title: "Motorbike Finance",
                  name: "Motorbike Finance",
                  icon: !1,
                  link: "/motorbike-finance",
                  level: 2
                },
                {
                  parent: "Car Finance",
                  title: "Motorhome Finance",
                  name: "Motorhome Finance",
                  icon: !1,
                  link: "/motorhome-finance",
                  level: 2
                },
                {
                  parent: "Car Finance",
                  title: "Caravan Finance",
                  name: "Caravan Finance",
                  icon: !1,
                  link: "/caravan-finance",
                  level: 2
                }
              ]
            },
            {
              parent: "Back",
              name: "Car Finance by Make",
              icon: !0,
              link: null,
              level: 1,
              separator: !0,
              subMenu: [
                {
                  parent: "Car Finance",
                  title: "Audi Car Finance",
                  name: "Audi Car Finance",
                  icon: !1,
                  link: "/audi-car-finance",
                  level: 2
                },
                {
                  parent: "Car Finance",
                  title: "BMW Car Finance",
                  name: "BMW Car Finance",
                  icon: !1,
                  link: "/bmw-car-finance",
                  level: 2
                },
                {
                  parent: "Car Finance",
                  title: "Vauxhall Car Finance",
                  name: "Vauxhall Car Finance",
                  icon: !1,
                  link: "/vauxhall-car-finance",
                  level: 2
                },
                {
                  parent: "Car Finance",
                  title: "Ford Car Finance",
                  name: "Ford Car Finance",
                  icon: !1,
                  link: "/ford-car-finance",
                  level: 2
                },
                {
                  parent: "Car Finance",
                  title: "Nissan Car Finance",
                  name: "Nissan Car Finance",
                  icon: !1,
                  link: "/nissan-car-finance",
                  level: 2
                },
                {
                  parent: "Car Finance",
                  title: "Volkswagen Car Finance",
                  name: "Volkswagen Car Finance",
                  icon: !1,
                  link: "/volkswagen-car-finance",
                  level: 2
                }
              ]
            },
            {
              parent: "Back",
              name: "Locations",
              icon: !0,
              link: null,
              level: 1,
              separator: !0,
              subMenu: [
                {
                  parent: "Car Finance",
                  title: "All Locations",
                  name: "All Locations",
                  icon: !1,
                  link: "/locations",
                  level: 2
                },
                {
                  parent: "Car Finance",
                  title: "London",
                  name: "London",
                  icon: !1,
                  link: "/location/london",
                  level: 2
                },
                {
                  parent: "Car Finance",
                  title: "Birmingham",
                  name: "Birmingham",
                  icon: !1,
                  link: "/location/birmingham",
                  level: 2
                },
                {
                  parent: "Car Finance",
                  title: "Glasgow",
                  name: "Glasgow",
                  icon: !1,
                  link: "/location/glasgow",
                  level: 2
                },
                {
                  parent: "Car Finance",
                  title: "Manchester",
                  name: "Manchester",
                  icon: !1,
                  link: "/location/manchester",
                  level: 2
                },
                {
                  parent: "Car Finance",
                  title: "Nottingham",
                  name: "Nottingham",
                  icon: !1,
                  link: "/location/nottingham",
                  level: 2
                },
                {
                  parent: "Car Finance",
                  title: "Leeds",
                  name: "Leeds",
                  icon: !1,
                  link: "/location/leeds",
                  level: 2
                }
              ]
            }
          ]
        },
        {
          name: "Car Finance Calculator",
          icon: !1,
          link: "/car-finance-calculator",
          level: 0
        },
        {
          name: "Help & Guides",
          icon: !1,
          link: "/guides",
          level: 0
        },
        {
          name: "Company",
          icon: !0,
          link: null,
          level: 0,
          cols: 1,
          subMenu: [
            {
              parent: "Company",
              title: "Our Story",
              name: "Our Story",
              icon: !1,
              link: "/about",
              level: 1
            },
            {
              parent: "Company",
              title: "Customer Stories",
              name: "Customer Stories",
              icon: !1,
              link: "/customer-stories",
              level: 1
            },
            {
              parent: "Company",
              title: "Video Library",
              name: "Video Library",
              icon: !1,
              link: "/videos",
              level: 1
            },
            {
              parent: "Company",
              title: "Careers",
              name: "Careers",
              icon: !1,
              link: "/careers",
              level: 1
            },
            {
              parent: "Company",
              title: "Blog",
              name: "Blog",
              icon: !1,
              link: "/blog",
              level: 1
            },
            {
              parent: "Company",
              title: "Contact Us",
              name: "Contact Us",
              icon: !1,
              link: "/contact-us",
              level: 1
            },
            {
              parent: "Company",
              title: "Newsroom",
              name: "Newsroom",
              icon: !1,
              link: "/press",
              level: 1
            }
          ]
        }
      ]);
    });
  }
}, dg = { class: "flex items-center justify-between py-4 max-w-screen-lg mx-auto" }, jg = {
  href: "/",
  "aria-label": "Car Finance 247",
  class: "pr-8"
}, yg = /* @__PURE__ */ ne({
  __name: "Header",
  props: {
    id: String,
    activeClass: { type: String, default: "bg-secondary" },
    wrapperClass: String,
    bgClass: { type: String, default: "bg-transparent" }
  },
  setup(t) {
    const { width: e } = bl(), i = J(() => e.value), M = C(null), n = C(!1), a = C(null), r = (o) => {
      if (!o)
        n.value = o;
      else {
        if (a.value) {
          const s = a.value;
          s.style.maxHeight = "100vh", s.style.height = "100vh";
        }
        n.value = o;
      }
    };
    return we(async () => {
      try {
        M.value = await Dg.fetchMenu();
      } catch (o) {
        console.error("Failed to fetch menu:", o);
      }
    }), (o, s) => (y(), A("header", {
      ref_key: "header",
      ref: a,
      class: P([
        "z-50 w-full px-4",
        n.value ? `${t.activeClass} fixed top-0 left-0` : `${t.bgClass} absolute`,
        t.wrapperClass
      ])
    }, [
      l("div", dg, [
        l("a", jg, [
          b(ie, {
            icon: "logo",
            "icon-color": n.value ? "black" : "white",
            "aria-hidden": "true",
            class: "cursor-pointer",
            width: "71",
            height: "60"
          }, null, 8, ["icon-color"])
        ]),
        M.value ? (y(), _e(Cl(i.value > 1120 ? Hc : Ig), {
          key: 0,
          menu: M.value,
          headerRef: a.value,
          onMenuActive: r
        }, null, 40, ["menu", "headerRef"])) : k("", !0)
      ])
    ], 2));
  }
}), Lh = /* @__PURE__ */ fe(yg, [["__scopeId", "data-v-49766417"]]);
function vt(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Ql(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}
/*!
 * GSAP 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/
var st = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
}, Yi = {
  duration: 0.5,
  overwrite: !1,
  delay: 0
}, pa, Fe, me, Dt = 1e8, ze = 1 / Dt, Vn = Math.PI * 2, Ag = Vn / 4, Tg = 0, Ul = Math.sqrt, xg = Math.cos, zg = Math.sin, Pe = function(e) {
  return typeof e == "string";
}, he = function(e) {
  return typeof e == "function";
}, Ft = function(e) {
  return typeof e == "number";
}, wa = function(e) {
  return typeof e > "u";
}, Et = function(e) {
  return typeof e == "object";
}, et = function(e) {
  return e !== !1;
}, Ca = function() {
  return typeof window < "u";
}, hM = function(e) {
  return he(e) || Pe(e);
}, Yl = typeof ArrayBuffer == "function" && ArrayBuffer.isView || function() {
}, Je = Array.isArray, Gn = /(?:-?\.?\d|\.)+/gi, _l = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, Ei = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, Ln = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, Pl = /[+-]=-?[.\d]+/, Rl = /[^,'"\[\]\s]+/gi, fg = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, Le, wt, Zn, ha, ct = {}, VM = {}, Fl, Wl = function(e) {
  return (VM = _i(e, ct)) && nt;
}, Oa = function(e, i) {
  return console.warn("Invalid property", e, "set to", i, "Missing plugin? gsap.registerPlugin()");
}, sM = function(e, i) {
  return !i && console.warn(e);
}, Bl = function(e, i) {
  return e && (ct[e] = i) && VM && (VM[e] = i) || ct;
}, uM = function() {
  return 0;
}, mg = {
  suppressEvents: !0,
  isStart: !0,
  kill: !1
}, bM = {
  suppressEvents: !0,
  kill: !1
}, Lg = {
  suppressEvents: !0
}, Ea = {}, ei = [], $n = {}, Vl, rt = {}, pn = {}, mr = 30, QM = [], Sa = "", ka = function(e) {
  var i = e[0], M, n;
  if (Et(i) || he(i) || (e = [e]), !(M = (i._gsap || {}).harness)) {
    for (n = QM.length; n-- && !QM[n].targetTest(i); )
      ;
    M = QM[n];
  }
  for (n = e.length; n--; )
    e[n] && (e[n]._gsap || (e[n]._gsap = new Do(e[n], M))) || e.splice(n, 1);
  return e;
}, di = function(e) {
  return e._gsap || ka(dt(e))[0]._gsap;
}, Gl = function(e, i, M) {
  return (M = e[i]) && he(M) ? e[i]() : wa(M) && e.getAttribute && e.getAttribute(i) || M;
}, tt = function(e, i) {
  return (e = e.split(",")).forEach(i) || e;
}, ve = function(e) {
  return Math.round(e * 1e5) / 1e5 || 0;
}, Ue = function(e) {
  return Math.round(e * 1e7) / 1e7 || 0;
}, bi = function(e, i) {
  var M = i.charAt(0), n = parseFloat(i.substr(2));
  return e = parseFloat(e), M === "+" ? e + n : M === "-" ? e - n : M === "*" ? e * n : e / n;
}, pg = function(e, i) {
  for (var M = i.length, n = 0; e.indexOf(i[n]) < 0 && ++n < M; )
    ;
  return n < M;
}, GM = function() {
  var e = ei.length, i = ei.slice(0), M, n;
  for ($n = {}, ei.length = 0, M = 0; M < e; M++)
    n = i[M], n && n._lazy && (n.render(n._lazy[0], n._lazy[1], !0)._lazy = 0);
}, va = function(e) {
  return !!(e._initted || e._startAt || e.add);
}, Zl = function(e, i, M, n) {
  ei.length && !Fe && GM(), e.render(i, M, !!(Fe && i < 0 && va(e))), ei.length && !Fe && GM();
}, $l = function(e) {
  var i = parseFloat(e);
  return (i || i === 0) && (e + "").match(Rl).length < 2 ? i : Pe(e) ? e.trim() : e;
}, Jl = function(e) {
  return e;
}, gt = function(e, i) {
  for (var M in i)
    M in e || (e[M] = i[M]);
  return e;
}, wg = function(e) {
  return function(i, M) {
    for (var n in M)
      n in i || n === "duration" && e || n === "ease" || (i[n] = M[n]);
  };
}, _i = function(e, i) {
  for (var M in i)
    e[M] = i[M];
  return e;
}, Lr = function t(e, i) {
  for (var M in i)
    M !== "__proto__" && M !== "constructor" && M !== "prototype" && (e[M] = Et(i[M]) ? t(e[M] || (e[M] = {}), i[M]) : i[M]);
  return e;
}, ZM = function(e, i) {
  var M = {}, n;
  for (n in e)
    n in i || (M[n] = e[n]);
  return M;
}, aM = function(e) {
  var i = e.parent || Le, M = e.keyframes ? wg(Je(e.keyframes)) : gt;
  if (et(e.inherit))
    for (; i; )
      M(e, i.vars.defaults), i = i.parent || i._dp;
  return e;
}, Cg = function(e, i) {
  for (var M = e.length, n = M === i.length; n && M-- && e[M] === i[M]; )
    ;
  return M < 0;
}, Hl = function(e, i, M, n, a) {
  var r = e[n], o;
  if (a)
    for (o = i[a]; r && r[a] > o; )
      r = r._prev;
  return r ? (i._next = r._next, r._next = i) : (i._next = e[M], e[M] = i), i._next ? i._next._prev = i : e[n] = i, i._prev = r, i.parent = i._dp = e, i;
}, Mn = function(e, i, M, n) {
  M === void 0 && (M = "_first"), n === void 0 && (n = "_last");
  var a = i._prev, r = i._next;
  a ? a._next = r : e[M] === i && (e[M] = r), r ? r._prev = a : e[n] === i && (e[n] = a), i._next = i._prev = i.parent = null;
}, Mi = function(e, i) {
  e.parent && (!i || e.parent.autoRemoveChildren) && e.parent.remove && e.parent.remove(e), e._act = 0;
}, ji = function(e, i) {
  if (e && (!i || i._end > e._dur || i._start < 0))
    for (var M = e; M; )
      M._dirty = 1, M = M.parent;
  return e;
}, hg = function(e) {
  for (var i = e.parent; i && i.parent; )
    i._dirty = 1, i.totalDuration(), i = i.parent;
  return e;
}, Jn = function(e, i, M, n) {
  return e._startAt && (Fe ? e._startAt.revert(bM) : e.vars.immediateRender && !e.vars.autoRevert || e._startAt.render(i, !0, n));
}, Og = function t(e) {
  return !e || e._ts && t(e.parent);
}, pr = function(e) {
  return e._repeat ? Pi(e._tTime, e = e.duration() + e._rDelay) * e : 0;
}, Pi = function(e, i) {
  var M = Math.floor(e = Ue(e / i));
  return e && M === e ? M - 1 : M;
}, $M = function(e, i) {
  return (e - i._start) * i._ts + (i._ts >= 0 ? 0 : i._dirty ? i.totalDuration() : i._tDur);
}, nn = function(e) {
  return e._end = Ue(e._start + (e._tDur / Math.abs(e._ts || e._rts || ze) || 0));
}, an = function(e, i) {
  var M = e._dp;
  return M && M.smoothChildTiming && e._ts && (e._start = Ue(M._time - (e._ts > 0 ? i / e._ts : ((e._dirty ? e.totalDuration() : e._tDur) - i) / -e._ts)), nn(e), M._dirty || ji(M, e)), e;
}, Xl = function(e, i) {
  var M;
  if ((i._time || !i._dur && i._initted || i._start < e._time && (i._dur || !i.add)) && (M = $M(e.rawTime(), i), (!i._dur || jM(0, i.totalDuration(), M) - i._tTime > ze) && i.render(M, !0)), ji(e, i)._dp && e._initted && e._time >= e._dur && e._ts) {
    if (e._dur < e.duration())
      for (M = e; M._dp; )
        M.rawTime() >= 0 && M.totalTime(M._tTime), M = M._dp;
    e._zTime = -ze;
  }
}, Ct = function(e, i, M, n) {
  return i.parent && Mi(i), i._start = Ue((Ft(M) ? M : M || e !== Le ? It(e, M, i) : e._time) + i._delay), i._end = Ue(i._start + (i.totalDuration() / Math.abs(i.timeScale()) || 0)), Hl(e, i, "_first", "_last", e._sort ? "_start" : 0), Hn(i) || (e._recent = i), n || Xl(e, i), e._ts < 0 && an(e, e._tTime), e;
}, Kl = function(e, i) {
  return (ct.ScrollTrigger || Oa("scrollTrigger", i)) && ct.ScrollTrigger.create(i, e);
}, ql = function(e, i, M, n, a) {
  if (Qa(e, i, a), !e._initted)
    return 1;
  if (!M && e._pt && !Fe && (e._dur && e.vars.lazy !== !1 || !e._dur && e.vars.lazy) && Vl !== lt.frame)
    return ei.push(e), e._lazy = [a, n], 1;
}, Eg = function t(e) {
  var i = e.parent;
  return i && i._ts && i._initted && !i._lock && (i.rawTime() < 0 || t(i));
}, Hn = function(e) {
  var i = e.data;
  return i === "isFromStart" || i === "isStart";
}, Sg = function(e, i, M, n) {
  var a = e.ratio, r = i < 0 || !i && (!e._start && Eg(e) && !(!e._initted && Hn(e)) || (e._ts < 0 || e._dp._ts < 0) && !Hn(e)) ? 0 : 1, o = e._rDelay, s = 0, u, c, g;
  if (o && e._repeat && (s = jM(0, e._tDur, i), c = Pi(s, o), e._yoyo && c & 1 && (r = 1 - r), c !== Pi(e._tTime, o) && (a = 1 - r, e.vars.repeatRefresh && e._initted && e.invalidate())), r !== a || Fe || n || e._zTime === ze || !i && e._zTime) {
    if (!e._initted && ql(e, i, n, M, s))
      return;
    for (g = e._zTime, e._zTime = i || (M ? ze : 0), M || (M = i && !g), e.ratio = r, e._from && (r = 1 - r), e._time = 0, e._tTime = s, u = e._pt; u; )
      u.r(r, u.d), u = u._next;
    i < 0 && Jn(e, i, M, !0), e._onUpdate && !M && ot(e, "onUpdate"), s && e._repeat && !M && e.parent && ot(e, "onRepeat"), (i >= e._tDur || i < 0) && e.ratio === r && (r && Mi(e, 1), !M && !Fe && (ot(e, r ? "onComplete" : "onReverseComplete", !0), e._prom && e._prom()));
  } else e._zTime || (e._zTime = i);
}, kg = function(e, i, M) {
  var n;
  if (M > i)
    for (n = e._first; n && n._start <= M; ) {
      if (n.data === "isPause" && n._start > i)
        return n;
      n = n._next;
    }
  else
    for (n = e._last; n && n._start >= M; ) {
      if (n.data === "isPause" && n._start < i)
        return n;
      n = n._prev;
    }
}, Ri = function(e, i, M, n) {
  var a = e._repeat, r = Ue(i) || 0, o = e._tTime / e._tDur;
  return o && !n && (e._time *= r / e._dur), e._dur = r, e._tDur = a ? a < 0 ? 1e10 : Ue(r * (a + 1) + e._rDelay * a) : r, o > 0 && !n && an(e, e._tTime = e._tDur * o), e.parent && nn(e), M || ji(e.parent, e), e;
}, wr = function(e) {
  return e instanceof Xe ? ji(e) : Ri(e, e._dur);
}, vg = {
  _start: 0,
  endTime: uM,
  totalDuration: uM
}, It = function t(e, i, M) {
  var n = e.labels, a = e._recent || vg, r = e.duration() >= Dt ? a.endTime(!1) : e._dur, o, s, u;
  return Pe(i) && (isNaN(i) || i in n) ? (s = i.charAt(0), u = i.substr(-1) === "%", o = i.indexOf("="), s === "<" || s === ">" ? (o >= 0 && (i = i.replace(/=/, "")), (s === "<" ? a._start : a.endTime(a._repeat >= 0)) + (parseFloat(i.substr(1)) || 0) * (u ? (o < 0 ? a : M).totalDuration() / 100 : 1)) : o < 0 ? (i in n || (n[i] = r), n[i]) : (s = parseFloat(i.charAt(o - 1) + i.substr(o + 1)), u && M && (s = s / 100 * (Je(M) ? M[0] : M).totalDuration()), o > 1 ? t(e, i.substr(0, o - 1), M) + s : r + s)) : i == null ? r : +i;
}, rM = function(e, i, M) {
  var n = Ft(i[1]), a = (n ? 2 : 1) + (e < 2 ? 0 : 1), r = i[a], o, s;
  if (n && (r.duration = i[1]), r.parent = M, e) {
    for (o = r, s = M; s && !("immediateRender" in o); )
      o = s.vars.defaults || {}, s = et(s.vars.inherit) && s.parent;
    r.immediateRender = et(o.immediateRender), e < 2 ? r.runBackwards = 1 : r.startAt = i[a - 1];
  }
  return new Qe(i[0], r, i[a + 1]);
}, ai = function(e, i) {
  return e || e === 0 ? i(e) : i;
}, jM = function(e, i, M) {
  return M < e ? e : M > i ? i : M;
}, Ze = function(e, i) {
  return !Pe(e) || !(i = fg.exec(e)) ? "" : i[1];
}, bg = function(e, i, M) {
  return ai(M, function(n) {
    return jM(e, i, n);
  });
}, Xn = [].slice, eo = function(e, i) {
  return e && Et(e) && "length" in e && (!i && !e.length || e.length - 1 in e && Et(e[0])) && !e.nodeType && e !== wt;
}, Qg = function(e, i, M) {
  return M === void 0 && (M = []), e.forEach(function(n) {
    var a;
    return Pe(n) && !i || eo(n, 1) ? (a = M).push.apply(a, dt(n)) : M.push(n);
  }) || M;
}, dt = function(e, i, M) {
  return me && !i && me.selector ? me.selector(e) : Pe(e) && !M && (Zn || !Fi()) ? Xn.call((i || ha).querySelectorAll(e), 0) : Je(e) ? Qg(e, M) : eo(e) ? Xn.call(e, 0) : e ? [e] : [];
}, Kn = function(e) {
  return e = dt(e)[0] || sM("Invalid scope") || {}, function(i) {
    var M = e.current || e.nativeElement || e;
    return dt(i, M.querySelectorAll ? M : M === e ? sM("Invalid scope") || ha.createElement("div") : e);
  };
}, to = function(e) {
  return e.sort(function() {
    return 0.5 - Math.random();
  });
}, io = function(e) {
  if (he(e))
    return e;
  var i = Et(e) ? e : {
    each: e
  }, M = yi(i.ease), n = i.from || 0, a = parseFloat(i.base) || 0, r = {}, o = n > 0 && n < 1, s = isNaN(n) || o, u = i.axis, c = n, g = n;
  return Pe(n) ? c = g = {
    center: 0.5,
    edges: 0.5,
    end: 1
  }[n] || 0 : !o && s && (c = n[0], g = n[1]), function(d, j, D) {
    var I = (D || i).length, N = r[I], x, f, L, p, h, w, O, S, Y;
    if (!N) {
      if (Y = i.grid === "auto" ? 0 : (i.grid || [1, Dt])[1], !Y) {
        for (O = -Dt; O < (O = D[Y++].getBoundingClientRect().left) && Y < I; )
          ;
        Y < I && Y--;
      }
      for (N = r[I] = [], x = s ? Math.min(Y, I) * c - 0.5 : n % Y, f = Y === Dt ? 0 : s ? I * g / Y - 0.5 : n / Y | 0, O = 0, S = Dt, w = 0; w < I; w++)
        L = w % Y - x, p = f - (w / Y | 0), N[w] = h = u ? Math.abs(u === "y" ? p : L) : Ul(L * L + p * p), h > O && (O = h), h < S && (S = h);
      n === "random" && to(N), N.max = O - S, N.min = S, N.v = I = (parseFloat(i.amount) || parseFloat(i.each) * (Y > I ? I - 1 : u ? u === "y" ? I / Y : Y : Math.max(Y, I / Y)) || 0) * (n === "edges" ? -1 : 1), N.b = I < 0 ? a - I : a, N.u = Ze(i.amount || i.each) || 0, M = M && I < 0 ? go(M) : M;
    }
    return I = (N[d] - N.min) / N.max || 0, Ue(N.b + (M ? M(I) : I) * N.v) + N.u;
  };
}, qn = function(e) {
  var i = Math.pow(10, ((e + "").split(".")[1] || "").length);
  return function(M) {
    var n = Ue(Math.round(parseFloat(M) / e) * e * i);
    return (n - n % 1) / i + (Ft(M) ? 0 : Ze(M));
  };
}, Mo = function(e, i) {
  var M = Je(e), n, a;
  return !M && Et(e) && (n = M = e.radius || Dt, e.values ? (e = dt(e.values), (a = !Ft(e[0])) && (n *= n)) : e = qn(e.increment)), ai(i, M ? he(e) ? function(r) {
    return a = e(r), Math.abs(a - r) <= n ? a : r;
  } : function(r) {
    for (var o = parseFloat(a ? r.x : r), s = parseFloat(a ? r.y : 0), u = Dt, c = 0, g = e.length, d, j; g--; )
      a ? (d = e[g].x - o, j = e[g].y - s, d = d * d + j * j) : d = Math.abs(e[g] - o), d < u && (u = d, c = g);
    return c = !n || u <= n ? e[c] : r, a || c === r || Ft(r) ? c : c + Ze(r);
  } : qn(e));
}, no = function(e, i, M, n) {
  return ai(Je(e) ? !i : M === !0 ? !!(M = 0) : !n, function() {
    return Je(e) ? e[~~(Math.random() * e.length)] : (M = M || 1e-5) && (n = M < 1 ? Math.pow(10, (M + "").length - 2) : 1) && Math.floor(Math.round((e - M / 2 + Math.random() * (i - e + M * 0.99)) / M) * M * n) / n;
  });
}, Ug = function() {
  for (var e = arguments.length, i = new Array(e), M = 0; M < e; M++)
    i[M] = arguments[M];
  return function(n) {
    return i.reduce(function(a, r) {
      return r(a);
    }, n);
  };
}, Yg = function(e, i) {
  return function(M) {
    return e(parseFloat(M)) + (i || Ze(M));
  };
}, _g = function(e, i, M) {
  return ro(e, i, 0, 1, M);
}, ao = function(e, i, M) {
  return ai(M, function(n) {
    return e[~~i(n)];
  });
}, Pg = function t(e, i, M) {
  var n = i - e;
  return Je(e) ? ao(e, t(0, e.length), i) : ai(M, function(a) {
    return (n + (a - e) % n) % n + e;
  });
}, Rg = function t(e, i, M) {
  var n = i - e, a = n * 2;
  return Je(e) ? ao(e, t(0, e.length - 1), i) : ai(M, function(r) {
    return r = (a + (r - e) % a) % a || 0, e + (r > n ? a - r : r);
  });
}, cM = function(e) {
  for (var i = 0, M = "", n, a, r, o; ~(n = e.indexOf("random(", i)); )
    r = e.indexOf(")", n), o = e.charAt(n + 7) === "[", a = e.substr(n + 7, r - n - 7).match(o ? Rl : Gn), M += e.substr(i, n - i) + no(o ? a : +a[0], o ? 0 : +a[1], +a[2] || 1e-5), i = r + 1;
  return M + e.substr(i, e.length - i);
}, ro = function(e, i, M, n, a) {
  var r = i - e, o = n - M;
  return ai(a, function(s) {
    return M + ((s - e) / r * o || 0);
  });
}, Fg = function t(e, i, M, n) {
  var a = isNaN(e + i) ? 0 : function(j) {
    return (1 - j) * e + j * i;
  };
  if (!a) {
    var r = Pe(e), o = {}, s, u, c, g, d;
    if (M === !0 && (n = 1) && (M = null), r)
      e = {
        p: e
      }, i = {
        p: i
      };
    else if (Je(e) && !Je(i)) {
      for (c = [], g = e.length, d = g - 2, u = 1; u < g; u++)
        c.push(t(e[u - 1], e[u]));
      g--, a = function(D) {
        D *= g;
        var I = Math.min(d, ~~D);
        return c[I](D - I);
      }, M = i;
    } else n || (e = _i(Je(e) ? [] : {}, e));
    if (!c) {
      for (s in i)
        ba.call(o, e, s, "get", i[s]);
      a = function(D) {
        return _a(D, o) || (r ? e.p : e);
      };
    }
  }
  return ai(M, a);
}, Cr = function(e, i, M) {
  var n = e.labels, a = Dt, r, o, s;
  for (r in n)
    o = n[r] - i, o < 0 == !!M && o && a > (o = Math.abs(o)) && (s = r, a = o);
  return s;
}, ot = function(e, i, M) {
  var n = e.vars, a = n[i], r = me, o = e._ctx, s, u, c;
  if (a)
    return s = n[i + "Params"], u = n.callbackScope || e, M && ei.length && GM(), o && (me = o), c = s ? a.apply(u, s) : a.call(u), me = r, c;
}, MM = function(e) {
  return Mi(e), e.scrollTrigger && e.scrollTrigger.kill(!!Fe), e.progress() < 1 && ot(e, "onInterrupt"), e;
}, Si, lo = [], oo = function(e) {
  if (e)
    if (e = !e.name && e.default || e, Ca() || e.headless) {
      var i = e.name, M = he(e), n = i && !M && e.init ? function() {
        this._props = [];
      } : e, a = {
        init: uM,
        render: _a,
        add: ba,
        kill: nN,
        modifier: MN,
        rawVars: 0
      }, r = {
        targetTest: 0,
        get: 0,
        getSetter: Ya,
        aliases: {},
        register: 0
      };
      if (Fi(), e !== n) {
        if (rt[i])
          return;
        gt(n, gt(ZM(e, a), r)), _i(n.prototype, _i(a, ZM(e, r))), rt[n.prop = i] = n, e.targetTest && (QM.push(n), Ea[i] = 1), i = (i === "css" ? "CSS" : i.charAt(0).toUpperCase() + i.substr(1)) + "Plugin";
      }
      Bl(i, n), e.register && e.register(nt, n, it);
    } else
      lo.push(e);
}, Te = 255, nM = {
  aqua: [0, Te, Te],
  lime: [0, Te, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, Te],
  navy: [0, 0, 128],
  white: [Te, Te, Te],
  olive: [128, 128, 0],
  yellow: [Te, Te, 0],
  orange: [Te, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [Te, 0, 0],
  pink: [Te, 192, 203],
  cyan: [0, Te, Te],
  transparent: [Te, Te, Te, 0]
}, wn = function(e, i, M) {
  return e += e < 0 ? 1 : e > 1 ? -1 : 0, (e * 6 < 1 ? i + (M - i) * e * 6 : e < 0.5 ? M : e * 3 < 2 ? i + (M - i) * (2 / 3 - e) * 6 : i) * Te + 0.5 | 0;
}, so = function(e, i, M) {
  var n = e ? Ft(e) ? [e >> 16, e >> 8 & Te, e & Te] : 0 : nM.black, a, r, o, s, u, c, g, d, j, D;
  if (!n) {
    if (e.substr(-1) === "," && (e = e.substr(0, e.length - 1)), nM[e])
      n = nM[e];
    else if (e.charAt(0) === "#") {
      if (e.length < 6 && (a = e.charAt(1), r = e.charAt(2), o = e.charAt(3), e = "#" + a + a + r + r + o + o + (e.length === 5 ? e.charAt(4) + e.charAt(4) : "")), e.length === 9)
        return n = parseInt(e.substr(1, 6), 16), [n >> 16, n >> 8 & Te, n & Te, parseInt(e.substr(7), 16) / 255];
      e = parseInt(e.substr(1), 16), n = [e >> 16, e >> 8 & Te, e & Te];
    } else if (e.substr(0, 3) === "hsl") {
      if (n = D = e.match(Gn), !i)
        s = +n[0] % 360 / 360, u = +n[1] / 100, c = +n[2] / 100, r = c <= 0.5 ? c * (u + 1) : c + u - c * u, a = c * 2 - r, n.length > 3 && (n[3] *= 1), n[0] = wn(s + 1 / 3, a, r), n[1] = wn(s, a, r), n[2] = wn(s - 1 / 3, a, r);
      else if (~e.indexOf("="))
        return n = e.match(_l), M && n.length < 4 && (n[3] = 1), n;
    } else
      n = e.match(Gn) || nM.transparent;
    n = n.map(Number);
  }
  return i && !D && (a = n[0] / Te, r = n[1] / Te, o = n[2] / Te, g = Math.max(a, r, o), d = Math.min(a, r, o), c = (g + d) / 2, g === d ? s = u = 0 : (j = g - d, u = c > 0.5 ? j / (2 - g - d) : j / (g + d), s = g === a ? (r - o) / j + (r < o ? 6 : 0) : g === r ? (o - a) / j + 2 : (a - r) / j + 4, s *= 60), n[0] = ~~(s + 0.5), n[1] = ~~(u * 100 + 0.5), n[2] = ~~(c * 100 + 0.5)), M && n.length < 4 && (n[3] = 1), n;
}, uo = function(e) {
  var i = [], M = [], n = -1;
  return e.split(ti).forEach(function(a) {
    var r = a.match(Ei) || [];
    i.push.apply(i, r), M.push(n += r.length + 1);
  }), i.c = M, i;
}, hr = function(e, i, M) {
  var n = "", a = (e + n).match(ti), r = i ? "hsla(" : "rgba(", o = 0, s, u, c, g;
  if (!a)
    return e;
  if (a = a.map(function(d) {
    return (d = so(d, i, 1)) && r + (i ? d[0] + "," + d[1] + "%," + d[2] + "%," + d[3] : d.join(",")) + ")";
  }), M && (c = uo(e), s = M.c, s.join(n) !== c.c.join(n)))
    for (u = e.replace(ti, "1").split(Ei), g = u.length - 1; o < g; o++)
      n += u[o] + (~s.indexOf(o) ? a.shift() || r + "0,0,0,0)" : (c.length ? c : a.length ? a : M).shift());
  if (!u)
    for (u = e.split(ti), g = u.length - 1; o < g; o++)
      n += u[o] + a[o];
  return n + u[g];
}, ti = function() {
  var t = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", e;
  for (e in nM)
    t += "|" + e + "\\b";
  return new RegExp(t + ")", "gi");
}(), Wg = /hsl[a]?\(/, co = function(e) {
  var i = e.join(" "), M;
  if (ti.lastIndex = 0, ti.test(i))
    return M = Wg.test(i), e[1] = hr(e[1], M), e[0] = hr(e[0], M, uo(e[1])), !0;
}, gM, lt = function() {
  var t = Date.now, e = 500, i = 33, M = t(), n = M, a = 1e3 / 240, r = a, o = [], s, u, c, g, d, j, D = function I(N) {
    var x = t() - n, f = N === !0, L, p, h, w;
    if ((x > e || x < 0) && (M += x - i), n += x, h = n - M, L = h - r, (L > 0 || f) && (w = ++g.frame, d = h - g.time * 1e3, g.time = h = h / 1e3, r += L + (L >= a ? 4 : a - L), p = 1), f || (s = u(I)), p)
      for (j = 0; j < o.length; j++)
        o[j](h, d, w, N);
  };
  return g = {
    time: 0,
    frame: 0,
    tick: function() {
      D(!0);
    },
    deltaRatio: function(N) {
      return d / (1e3 / (N || 60));
    },
    wake: function() {
      Fl && (!Zn && Ca() && (wt = Zn = window, ha = wt.document || {}, ct.gsap = nt, (wt.gsapVersions || (wt.gsapVersions = [])).push(nt.version), Wl(VM || wt.GreenSockGlobals || !wt.gsap && wt || {}), lo.forEach(oo)), c = typeof requestAnimationFrame < "u" && requestAnimationFrame, s && g.sleep(), u = c || function(N) {
        return setTimeout(N, r - g.time * 1e3 + 1 | 0);
      }, gM = 1, D(2));
    },
    sleep: function() {
      (c ? cancelAnimationFrame : clearTimeout)(s), gM = 0, u = uM;
    },
    lagSmoothing: function(N, x) {
      e = N || 1 / 0, i = Math.min(x || 33, e);
    },
    fps: function(N) {
      a = 1e3 / (N || 240), r = g.time * 1e3 + a;
    },
    add: function(N, x, f) {
      var L = x ? function(p, h, w, O) {
        N(p, h, w, O), g.remove(L);
      } : N;
      return g.remove(N), o[f ? "unshift" : "push"](L), Fi(), L;
    },
    remove: function(N, x) {
      ~(x = o.indexOf(N)) && o.splice(x, 1) && j >= x && j--;
    },
    _listeners: o
  }, g;
}(), Fi = function() {
  return !gM && lt.wake();
}, de = {}, Bg = /^[\d.\-M][\d.\-,\s]/, Vg = /["']/g, Gg = function(e) {
  for (var i = {}, M = e.substr(1, e.length - 3).split(":"), n = M[0], a = 1, r = M.length, o, s, u; a < r; a++)
    s = M[a], o = a !== r - 1 ? s.lastIndexOf(",") : s.length, u = s.substr(0, o), i[n] = isNaN(u) ? u.replace(Vg, "").trim() : +u, n = s.substr(o + 1).trim();
  return i;
}, Zg = function(e) {
  var i = e.indexOf("(") + 1, M = e.indexOf(")"), n = e.indexOf("(", i);
  return e.substring(i, ~n && n < M ? e.indexOf(")", M + 1) : M);
}, $g = function(e) {
  var i = (e + "").split("("), M = de[i[0]];
  return M && i.length > 1 && M.config ? M.config.apply(null, ~e.indexOf("{") ? [Gg(i[1])] : Zg(e).split(",").map($l)) : de._CE && Bg.test(e) ? de._CE("", e) : M;
}, go = function(e) {
  return function(i) {
    return 1 - e(1 - i);
  };
}, No = function t(e, i) {
  for (var M = e._first, n; M; )
    M instanceof Xe ? t(M, i) : M.vars.yoyoEase && (!M._yoyo || !M._repeat) && M._yoyo !== i && (M.timeline ? t(M.timeline, i) : (n = M._ease, M._ease = M._yEase, M._yEase = n, M._yoyo = i)), M = M._next;
}, yi = function(e, i) {
  return e && (he(e) ? e : de[e] || $g(e)) || i;
}, zi = function(e, i, M, n) {
  M === void 0 && (M = function(s) {
    return 1 - i(1 - s);
  }), n === void 0 && (n = function(s) {
    return s < 0.5 ? i(s * 2) / 2 : 1 - i((1 - s) * 2) / 2;
  });
  var a = {
    easeIn: i,
    easeOut: M,
    easeInOut: n
  }, r;
  return tt(e, function(o) {
    de[o] = ct[o] = a, de[r = o.toLowerCase()] = M;
    for (var s in a)
      de[r + (s === "easeIn" ? ".in" : s === "easeOut" ? ".out" : ".inOut")] = de[o + "." + s] = a[s];
  }), a;
}, Io = function(e) {
  return function(i) {
    return i < 0.5 ? (1 - e(1 - i * 2)) / 2 : 0.5 + e((i - 0.5) * 2) / 2;
  };
}, Cn = function t(e, i, M) {
  var n = i >= 1 ? i : 1, a = (M || (e ? 0.3 : 0.45)) / (i < 1 ? i : 1), r = a / Vn * (Math.asin(1 / n) || 0), o = function(c) {
    return c === 1 ? 1 : n * Math.pow(2, -10 * c) * zg((c - r) * a) + 1;
  }, s = e === "out" ? o : e === "in" ? function(u) {
    return 1 - o(1 - u);
  } : Io(o);
  return a = Vn / a, s.config = function(u, c) {
    return t(e, u, c);
  }, s;
}, hn = function t(e, i) {
  i === void 0 && (i = 1.70158);
  var M = function(r) {
    return r ? --r * r * ((i + 1) * r + i) + 1 : 0;
  }, n = e === "out" ? M : e === "in" ? function(a) {
    return 1 - M(1 - a);
  } : Io(M);
  return n.config = function(a) {
    return t(e, a);
  }, n;
};
tt("Linear,Quad,Cubic,Quart,Quint,Strong", function(t, e) {
  var i = e < 5 ? e + 1 : e;
  zi(t + ",Power" + (i - 1), e ? function(M) {
    return Math.pow(M, i);
  } : function(M) {
    return M;
  }, function(M) {
    return 1 - Math.pow(1 - M, i);
  }, function(M) {
    return M < 0.5 ? Math.pow(M * 2, i) / 2 : 1 - Math.pow((1 - M) * 2, i) / 2;
  });
});
de.Linear.easeNone = de.none = de.Linear.easeIn;
zi("Elastic", Cn("in"), Cn("out"), Cn());
(function(t, e) {
  var i = 1 / e, M = 2 * i, n = 2.5 * i, a = function(o) {
    return o < i ? t * o * o : o < M ? t * Math.pow(o - 1.5 / e, 2) + 0.75 : o < n ? t * (o -= 2.25 / e) * o + 0.9375 : t * Math.pow(o - 2.625 / e, 2) + 0.984375;
  };
  zi("Bounce", function(r) {
    return 1 - a(1 - r);
  }, a);
})(7.5625, 2.75);
zi("Expo", function(t) {
  return Math.pow(2, 10 * (t - 1)) * t + t * t * t * t * t * t * (1 - t);
});
zi("Circ", function(t) {
  return -(Ul(1 - t * t) - 1);
});
zi("Sine", function(t) {
  return t === 1 ? 1 : -xg(t * Ag) + 1;
});
zi("Back", hn("in"), hn("out"), hn());
de.SteppedEase = de.steps = ct.SteppedEase = {
  config: function(e, i) {
    e === void 0 && (e = 1);
    var M = 1 / e, n = e + (i ? 0 : 1), a = i ? 1 : 0, r = 1 - ze;
    return function(o) {
      return ((n * jM(0, r, o) | 0) + a) * M;
    };
  }
};
Yi.ease = de["quad.out"];
tt("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(t) {
  return Sa += t + "," + t + "Params,";
});
var Do = function(e, i) {
  this.id = Tg++, e._gsap = this, this.target = e, this.harness = i, this.get = i ? i.get : Gl, this.set = i ? i.getSetter : Ya;
}, NM = /* @__PURE__ */ function() {
  function t(i) {
    this.vars = i, this._delay = +i.delay || 0, (this._repeat = i.repeat === 1 / 0 ? -2 : i.repeat || 0) && (this._rDelay = i.repeatDelay || 0, this._yoyo = !!i.yoyo || !!i.yoyoEase), this._ts = 1, Ri(this, +i.duration, 1, 1), this.data = i.data, me && (this._ctx = me, me.data.push(this)), gM || lt.wake();
  }
  var e = t.prototype;
  return e.delay = function(M) {
    return M || M === 0 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + M - this._delay), this._delay = M, this) : this._delay;
  }, e.duration = function(M) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? M + (M + this._rDelay) * this._repeat : M) : this.totalDuration() && this._dur;
  }, e.totalDuration = function(M) {
    return arguments.length ? (this._dirty = 0, Ri(this, this._repeat < 0 ? M : (M - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
  }, e.totalTime = function(M, n) {
    if (Fi(), !arguments.length)
      return this._tTime;
    var a = this._dp;
    if (a && a.smoothChildTiming && this._ts) {
      for (an(this, M), !a._dp || a.parent || Xl(a, this); a && a.parent; )
        a.parent._time !== a._start + (a._ts >= 0 ? a._tTime / a._ts : (a.totalDuration() - a._tTime) / -a._ts) && a.totalTime(a._tTime, !0), a = a.parent;
      !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && M < this._tDur || this._ts < 0 && M > 0 || !this._tDur && !M) && Ct(this._dp, this, this._start - this._delay);
    }
    return (this._tTime !== M || !this._dur && !n || this._initted && Math.abs(this._zTime) === ze || !M && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = M), Zl(this, M, n)), this;
  }, e.time = function(M, n) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), M + pr(this)) % (this._dur + this._rDelay) || (M ? this._dur : 0), n) : this._time;
  }, e.totalProgress = function(M, n) {
    return arguments.length ? this.totalTime(this.totalDuration() * M, n) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
  }, e.progress = function(M, n) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - M : M) + pr(this), n) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
  }, e.iteration = function(M, n) {
    var a = this.duration() + this._rDelay;
    return arguments.length ? this.totalTime(this._time + (M - 1) * a, n) : this._repeat ? Pi(this._tTime, a) + 1 : 1;
  }, e.timeScale = function(M, n) {
    if (!arguments.length)
      return this._rts === -ze ? 0 : this._rts;
    if (this._rts === M)
      return this;
    var a = this.parent && this._ts ? $M(this.parent._time, this) : this._tTime;
    return this._rts = +M || 0, this._ts = this._ps || M === -ze ? 0 : this._rts, this.totalTime(jM(-Math.abs(this._delay), this.totalDuration(), a), n !== !1), nn(this), hg(this);
  }, e.paused = function(M) {
    return arguments.length ? (this._ps !== M && (this._ps = M, M ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (Fi(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== ze && (this._tTime -= ze)))), this) : this._ps;
  }, e.startTime = function(M) {
    if (arguments.length) {
      this._start = M;
      var n = this.parent || this._dp;
      return n && (n._sort || !this.parent) && Ct(n, this, M - this._delay), this;
    }
    return this._start;
  }, e.endTime = function(M) {
    return this._start + (et(M) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  }, e.rawTime = function(M) {
    var n = this.parent || this._dp;
    return n ? M && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? $M(n.rawTime(M), this) : this._tTime : this._tTime;
  }, e.revert = function(M) {
    M === void 0 && (M = Lg);
    var n = Fe;
    return Fe = M, va(this) && (this.timeline && this.timeline.revert(M), this.totalTime(-0.01, M.suppressEvents)), this.data !== "nested" && M.kill !== !1 && this.kill(), Fe = n, this;
  }, e.globalTime = function(M) {
    for (var n = this, a = arguments.length ? M : n.rawTime(); n; )
      a = n._start + a / (Math.abs(n._ts) || 1), n = n._dp;
    return !this.parent && this._sat ? this._sat.globalTime(M) : a;
  }, e.repeat = function(M) {
    return arguments.length ? (this._repeat = M === 1 / 0 ? -2 : M, wr(this)) : this._repeat === -2 ? 1 / 0 : this._repeat;
  }, e.repeatDelay = function(M) {
    if (arguments.length) {
      var n = this._time;
      return this._rDelay = M, wr(this), n ? this.time(n) : this;
    }
    return this._rDelay;
  }, e.yoyo = function(M) {
    return arguments.length ? (this._yoyo = M, this) : this._yoyo;
  }, e.seek = function(M, n) {
    return this.totalTime(It(this, M), et(n));
  }, e.restart = function(M, n) {
    return this.play().totalTime(M ? -this._delay : 0, et(n)), this._dur || (this._zTime = -ze), this;
  }, e.play = function(M, n) {
    return M != null && this.seek(M, n), this.reversed(!1).paused(!1);
  }, e.reverse = function(M, n) {
    return M != null && this.seek(M || this.totalDuration(), n), this.reversed(!0).paused(!1);
  }, e.pause = function(M, n) {
    return M != null && this.seek(M, n), this.paused(!0);
  }, e.resume = function() {
    return this.paused(!1);
  }, e.reversed = function(M) {
    return arguments.length ? (!!M !== this.reversed() && this.timeScale(-this._rts || (M ? -ze : 0)), this) : this._rts < 0;
  }, e.invalidate = function() {
    return this._initted = this._act = 0, this._zTime = -ze, this;
  }, e.isActive = function() {
    var M = this.parent || this._dp, n = this._start, a;
    return !!(!M || this._ts && this._initted && M.isActive() && (a = M.rawTime(!0)) >= n && a < this.endTime(!0) - ze);
  }, e.eventCallback = function(M, n, a) {
    var r = this.vars;
    return arguments.length > 1 ? (n ? (r[M] = n, a && (r[M + "Params"] = a), M === "onUpdate" && (this._onUpdate = n)) : delete r[M], this) : r[M];
  }, e.then = function(M) {
    var n = this;
    return new Promise(function(a) {
      var r = he(M) ? M : Jl, o = function() {
        var u = n.then;
        n.then = null, he(r) && (r = r(n)) && (r.then || r === n) && (n.then = u), a(r), n.then = u;
      };
      n._initted && n.totalProgress() === 1 && n._ts >= 0 || !n._tTime && n._ts < 0 ? o() : n._prom = o;
    });
  }, e.kill = function() {
    MM(this);
  }, t;
}();
gt(NM.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: !1,
  parent: null,
  _initted: !1,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -ze,
  _prom: 0,
  _ps: !1,
  _rts: 1
});
var Xe = /* @__PURE__ */ function(t) {
  Ql(e, t);
  function e(M, n) {
    var a;
    return M === void 0 && (M = {}), a = t.call(this, M) || this, a.labels = {}, a.smoothChildTiming = !!M.smoothChildTiming, a.autoRemoveChildren = !!M.autoRemoveChildren, a._sort = et(M.sortChildren), Le && Ct(M.parent || Le, vt(a), n), M.reversed && a.reverse(), M.paused && a.paused(!0), M.scrollTrigger && Kl(vt(a), M.scrollTrigger), a;
  }
  var i = e.prototype;
  return i.to = function(n, a, r) {
    return rM(0, arguments, this), this;
  }, i.from = function(n, a, r) {
    return rM(1, arguments, this), this;
  }, i.fromTo = function(n, a, r, o) {
    return rM(2, arguments, this), this;
  }, i.set = function(n, a, r) {
    return a.duration = 0, a.parent = this, aM(a).repeatDelay || (a.repeat = 0), a.immediateRender = !!a.immediateRender, new Qe(n, a, It(this, r), 1), this;
  }, i.call = function(n, a, r) {
    return Ct(this, Qe.delayedCall(0, n, a), r);
  }, i.staggerTo = function(n, a, r, o, s, u, c) {
    return r.duration = a, r.stagger = r.stagger || o, r.onComplete = u, r.onCompleteParams = c, r.parent = this, new Qe(n, r, It(this, s)), this;
  }, i.staggerFrom = function(n, a, r, o, s, u, c) {
    return r.runBackwards = 1, aM(r).immediateRender = et(r.immediateRender), this.staggerTo(n, a, r, o, s, u, c);
  }, i.staggerFromTo = function(n, a, r, o, s, u, c, g) {
    return o.startAt = r, aM(o).immediateRender = et(o.immediateRender), this.staggerTo(n, a, o, s, u, c, g);
  }, i.render = function(n, a, r) {
    var o = this._time, s = this._dirty ? this.totalDuration() : this._tDur, u = this._dur, c = n <= 0 ? 0 : Ue(n), g = this._zTime < 0 != n < 0 && (this._initted || !u), d, j, D, I, N, x, f, L, p, h, w, O;
    if (this !== Le && c > s && n >= 0 && (c = s), c !== this._tTime || r || g) {
      if (o !== this._time && u && (c += this._time - o, n += this._time - o), d = c, p = this._start, L = this._ts, x = !L, g && (u || (o = this._zTime), (n || !a) && (this._zTime = n)), this._repeat) {
        if (w = this._yoyo, N = u + this._rDelay, this._repeat < -1 && n < 0)
          return this.totalTime(N * 100 + n, a, r);
        if (d = Ue(c % N), c === s ? (I = this._repeat, d = u) : (h = Ue(c / N), I = ~~h, I && I === h && (d = u, I--), d > u && (d = u)), h = Pi(this._tTime, N), !o && this._tTime && h !== I && this._tTime - h * N - this._dur <= 0 && (h = I), w && I & 1 && (d = u - d, O = 1), I !== h && !this._lock) {
          var S = w && h & 1, Y = S === (w && I & 1);
          if (I < h && (S = !S), o = S ? 0 : c % u ? u : c, this._lock = 1, this.render(o || (O ? 0 : Ue(I * N)), a, !u)._lock = 0, this._tTime = c, !a && this.parent && ot(this, "onRepeat"), this.vars.repeatRefresh && !O && (this.invalidate()._lock = 1), o && o !== this._time || x !== !this._ts || this.vars.onRepeat && !this.parent && !this._act)
            return this;
          if (u = this._dur, s = this._tDur, Y && (this._lock = 2, o = S ? u : -1e-4, this.render(o, !0), this.vars.repeatRefresh && !O && this.invalidate()), this._lock = 0, !this._ts && !x)
            return this;
          No(this, O);
        }
      }
      if (this._hasPause && !this._forcing && this._lock < 2 && (f = kg(this, Ue(o), Ue(d)), f && (c -= d - (d = f._start))), this._tTime = c, this._time = d, this._act = !L, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = n, o = 0), !o && c && !a && !h && (ot(this, "onStart"), this._tTime !== c))
        return this;
      if (d >= o && n >= 0)
        for (j = this._first; j; ) {
          if (D = j._next, (j._act || d >= j._start) && j._ts && f !== j) {
            if (j.parent !== this)
              return this.render(n, a, r);
            if (j.render(j._ts > 0 ? (d - j._start) * j._ts : (j._dirty ? j.totalDuration() : j._tDur) + (d - j._start) * j._ts, a, r), d !== this._time || !this._ts && !x) {
              f = 0, D && (c += this._zTime = -ze);
              break;
            }
          }
          j = D;
        }
      else {
        j = this._last;
        for (var H = n < 0 ? n : d; j; ) {
          if (D = j._prev, (j._act || H <= j._end) && j._ts && f !== j) {
            if (j.parent !== this)
              return this.render(n, a, r);
            if (j.render(j._ts > 0 ? (H - j._start) * j._ts : (j._dirty ? j.totalDuration() : j._tDur) + (H - j._start) * j._ts, a, r || Fe && va(j)), d !== this._time || !this._ts && !x) {
              f = 0, D && (c += this._zTime = H ? -ze : ze);
              break;
            }
          }
          j = D;
        }
      }
      if (f && !a && (this.pause(), f.render(d >= o ? 0 : -ze)._zTime = d >= o ? 1 : -1, this._ts))
        return this._start = p, nn(this), this.render(n, a, r);
      this._onUpdate && !a && ot(this, "onUpdate", !0), (c === s && this._tTime >= this.totalDuration() || !c && o) && (p === this._start || Math.abs(L) !== Math.abs(this._ts)) && (this._lock || ((n || !u) && (c === s && this._ts > 0 || !c && this._ts < 0) && Mi(this, 1), !a && !(n < 0 && !o) && (c || o || !s) && (ot(this, c === s && n >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(c < s && this.timeScale() > 0) && this._prom())));
    }
    return this;
  }, i.add = function(n, a) {
    var r = this;
    if (Ft(a) || (a = It(this, a, n)), !(n instanceof NM)) {
      if (Je(n))
        return n.forEach(function(o) {
          return r.add(o, a);
        }), this;
      if (Pe(n))
        return this.addLabel(n, a);
      if (he(n))
        n = Qe.delayedCall(0, n);
      else
        return this;
    }
    return this !== n ? Ct(this, n, a) : this;
  }, i.getChildren = function(n, a, r, o) {
    n === void 0 && (n = !0), a === void 0 && (a = !0), r === void 0 && (r = !0), o === void 0 && (o = -Dt);
    for (var s = [], u = this._first; u; )
      u._start >= o && (u instanceof Qe ? a && s.push(u) : (r && s.push(u), n && s.push.apply(s, u.getChildren(!0, a, r)))), u = u._next;
    return s;
  }, i.getById = function(n) {
    for (var a = this.getChildren(1, 1, 1), r = a.length; r--; )
      if (a[r].vars.id === n)
        return a[r];
  }, i.remove = function(n) {
    return Pe(n) ? this.removeLabel(n) : he(n) ? this.killTweensOf(n) : (n.parent === this && Mn(this, n), n === this._recent && (this._recent = this._last), ji(this));
  }, i.totalTime = function(n, a) {
    return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = Ue(lt.time - (this._ts > 0 ? n / this._ts : (this.totalDuration() - n) / -this._ts))), t.prototype.totalTime.call(this, n, a), this._forcing = 0, this) : this._tTime;
  }, i.addLabel = function(n, a) {
    return this.labels[n] = It(this, a), this;
  }, i.removeLabel = function(n) {
    return delete this.labels[n], this;
  }, i.addPause = function(n, a, r) {
    var o = Qe.delayedCall(0, a || uM, r);
    return o.data = "isPause", this._hasPause = 1, Ct(this, o, It(this, n));
  }, i.removePause = function(n) {
    var a = this._first;
    for (n = It(this, n); a; )
      a._start === n && a.data === "isPause" && Mi(a), a = a._next;
  }, i.killTweensOf = function(n, a, r) {
    for (var o = this.getTweensOf(n, r), s = o.length; s--; )
      Ht !== o[s] && o[s].kill(n, a);
    return this;
  }, i.getTweensOf = function(n, a) {
    for (var r = [], o = dt(n), s = this._first, u = Ft(a), c; s; )
      s instanceof Qe ? pg(s._targets, o) && (u ? (!Ht || s._initted && s._ts) && s.globalTime(0) <= a && s.globalTime(s.totalDuration()) > a : !a || s.isActive()) && r.push(s) : (c = s.getTweensOf(o, a)).length && r.push.apply(r, c), s = s._next;
    return r;
  }, i.tweenTo = function(n, a) {
    a = a || {};
    var r = this, o = It(r, n), s = a, u = s.startAt, c = s.onStart, g = s.onStartParams, d = s.immediateRender, j, D = Qe.to(r, gt({
      ease: a.ease || "none",
      lazy: !1,
      immediateRender: !1,
      time: o,
      overwrite: "auto",
      duration: a.duration || Math.abs((o - (u && "time" in u ? u.time : r._time)) / r.timeScale()) || ze,
      onStart: function() {
        if (r.pause(), !j) {
          var N = a.duration || Math.abs((o - (u && "time" in u ? u.time : r._time)) / r.timeScale());
          D._dur !== N && Ri(D, N, 0, 1).render(D._time, !0, !0), j = 1;
        }
        c && c.apply(D, g || []);
      }
    }, a));
    return d ? D.render(0) : D;
  }, i.tweenFromTo = function(n, a, r) {
    return this.tweenTo(a, gt({
      startAt: {
        time: It(this, n)
      }
    }, r));
  }, i.recent = function() {
    return this._recent;
  }, i.nextLabel = function(n) {
    return n === void 0 && (n = this._time), Cr(this, It(this, n));
  }, i.previousLabel = function(n) {
    return n === void 0 && (n = this._time), Cr(this, It(this, n), 1);
  }, i.currentLabel = function(n) {
    return arguments.length ? this.seek(n, !0) : this.previousLabel(this._time + ze);
  }, i.shiftChildren = function(n, a, r) {
    r === void 0 && (r = 0);
    for (var o = this._first, s = this.labels, u; o; )
      o._start >= r && (o._start += n, o._end += n), o = o._next;
    if (a)
      for (u in s)
        s[u] >= r && (s[u] += n);
    return ji(this);
  }, i.invalidate = function(n) {
    var a = this._first;
    for (this._lock = 0; a; )
      a.invalidate(n), a = a._next;
    return t.prototype.invalidate.call(this, n);
  }, i.clear = function(n) {
    n === void 0 && (n = !0);
    for (var a = this._first, r; a; )
      r = a._next, this.remove(a), a = r;
    return this._dp && (this._time = this._tTime = this._pTime = 0), n && (this.labels = {}), ji(this);
  }, i.totalDuration = function(n) {
    var a = 0, r = this, o = r._last, s = Dt, u, c, g;
    if (arguments.length)
      return r.timeScale((r._repeat < 0 ? r.duration() : r.totalDuration()) / (r.reversed() ? -n : n));
    if (r._dirty) {
      for (g = r.parent; o; )
        u = o._prev, o._dirty && o.totalDuration(), c = o._start, c > s && r._sort && o._ts && !r._lock ? (r._lock = 1, Ct(r, o, c - o._delay, 1)._lock = 0) : s = c, c < 0 && o._ts && (a -= c, (!g && !r._dp || g && g.smoothChildTiming) && (r._start += c / r._ts, r._time -= c, r._tTime -= c), r.shiftChildren(-c, !1, -1 / 0), s = 0), o._end > a && o._ts && (a = o._end), o = u;
      Ri(r, r === Le && r._time > a ? r._time : a, 1, 1), r._dirty = 0;
    }
    return r._tDur;
  }, e.updateRoot = function(n) {
    if (Le._ts && (Zl(Le, $M(n, Le)), Vl = lt.frame), lt.frame >= mr) {
      mr += st.autoSleep || 120;
      var a = Le._first;
      if ((!a || !a._ts) && st.autoSleep && lt._listeners.length < 2) {
        for (; a && !a._ts; )
          a = a._next;
        a || lt.sleep();
      }
    }
  }, e;
}(NM);
gt(Xe.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});
var Jg = function(e, i, M, n, a, r, o) {
  var s = new it(this._pt, e, i, 0, 1, zo, null, a), u = 0, c = 0, g, d, j, D, I, N, x, f;
  for (s.b = M, s.e = n, M += "", n += "", (x = ~n.indexOf("random(")) && (n = cM(n)), r && (f = [M, n], r(f, e, i), M = f[0], n = f[1]), d = M.match(Ln) || []; g = Ln.exec(n); )
    D = g[0], I = n.substring(u, g.index), j ? j = (j + 1) % 5 : I.substr(-5) === "rgba(" && (j = 1), D !== d[c++] && (N = parseFloat(d[c - 1]) || 0, s._pt = {
      _next: s._pt,
      p: I || c === 1 ? I : ",",
      //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
      s: N,
      c: D.charAt(1) === "=" ? bi(N, D) - N : parseFloat(D) - N,
      m: j && j < 4 ? Math.round : 0
    }, u = Ln.lastIndex);
  return s.c = u < n.length ? n.substring(u, n.length) : "", s.fp = o, (Pl.test(n) || x) && (s.e = 0), this._pt = s, s;
}, ba = function(e, i, M, n, a, r, o, s, u, c) {
  he(n) && (n = n(a || 0, e, r));
  var g = e[i], d = M !== "get" ? M : he(g) ? u ? e[i.indexOf("set") || !he(e["get" + i.substr(3)]) ? i : "get" + i.substr(3)](u) : e[i]() : g, j = he(g) ? u ? eN : To : Ua, D;
  if (Pe(n) && (~n.indexOf("random(") && (n = cM(n)), n.charAt(1) === "=" && (D = bi(d, n) + (Ze(d) || 0), (D || D === 0) && (n = D))), !c || d !== n || ea)
    return !isNaN(d * n) && n !== "" ? (D = new it(this._pt, e, i, +d || 0, n - (d || 0), typeof g == "boolean" ? iN : xo, 0, j), u && (D.fp = u), o && D.modifier(o, this, e), this._pt = D) : (!g && !(i in e) && Oa(i, n), Jg.call(this, e, i, d, n, j, s || st.stringFilter, u));
}, Hg = function(e, i, M, n, a) {
  if (he(e) && (e = lM(e, a, i, M, n)), !Et(e) || e.style && e.nodeType || Je(e) || Yl(e))
    return Pe(e) ? lM(e, a, i, M, n) : e;
  var r = {}, o;
  for (o in e)
    r[o] = lM(e[o], a, i, M, n);
  return r;
}, jo = function(e, i, M, n, a, r) {
  var o, s, u, c;
  if (rt[e] && (o = new rt[e]()).init(a, o.rawVars ? i[e] : Hg(i[e], n, a, r, M), M, n, r) !== !1 && (M._pt = s = new it(M._pt, a, e, 0, 1, o.render, o, 0, o.priority), M !== Si))
    for (u = M._ptLookup[M._targets.indexOf(a)], c = o._props.length; c--; )
      u[o._props[c]] = s;
  return o;
}, Ht, ea, Qa = function t(e, i, M) {
  var n = e.vars, a = n.ease, r = n.startAt, o = n.immediateRender, s = n.lazy, u = n.onUpdate, c = n.runBackwards, g = n.yoyoEase, d = n.keyframes, j = n.autoRevert, D = e._dur, I = e._startAt, N = e._targets, x = e.parent, f = x && x.data === "nested" ? x.vars.targets : N, L = e._overwrite === "auto" && !pa, p = e.timeline, h, w, O, S, Y, H, B, ae, te, q, le, Me, oe;
  if (p && (!d || !a) && (a = "none"), e._ease = yi(a, Yi.ease), e._yEase = g ? go(yi(g === !0 ? a : g, Yi.ease)) : 0, g && e._yoyo && !e._repeat && (g = e._yEase, e._yEase = e._ease, e._ease = g), e._from = !p && !!n.runBackwards, !p || d && !n.stagger) {
    if (ae = N[0] ? di(N[0]).harness : 0, Me = ae && n[ae.prop], h = ZM(n, Ea), I && (I._zTime < 0 && I.progress(1), i < 0 && c && o && !j ? I.render(-1, !0) : I.revert(c && D ? bM : mg), I._lazy = 0), r) {
      if (Mi(e._startAt = Qe.set(N, gt({
        data: "isStart",
        overwrite: !1,
        parent: x,
        immediateRender: !0,
        lazy: !I && et(s),
        startAt: null,
        delay: 0,
        onUpdate: u && function() {
          return ot(e, "onUpdate");
        },
        stagger: 0
      }, r))), e._startAt._dp = 0, e._startAt._sat = e, i < 0 && (Fe || !o && !j) && e._startAt.revert(bM), o && D && i <= 0 && M <= 0) {
        i && (e._zTime = i);
        return;
      }
    } else if (c && D && !I) {
      if (i && (o = !1), O = gt({
        overwrite: !1,
        data: "isFromStart",
        //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
        lazy: o && !I && et(s),
        immediateRender: o,
        //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
        stagger: 0,
        parent: x
        //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
      }, h), Me && (O[ae.prop] = Me), Mi(e._startAt = Qe.set(N, O)), e._startAt._dp = 0, e._startAt._sat = e, i < 0 && (Fe ? e._startAt.revert(bM) : e._startAt.render(-1, !0)), e._zTime = i, !o)
        t(e._startAt, ze, ze);
      else if (!i)
        return;
    }
    for (e._pt = e._ptCache = 0, s = D && et(s) || s && !D, w = 0; w < N.length; w++) {
      if (Y = N[w], B = Y._gsap || ka(N)[w]._gsap, e._ptLookup[w] = q = {}, $n[B.id] && ei.length && GM(), le = f === N ? w : f.indexOf(Y), ae && (te = new ae()).init(Y, Me || h, e, le, f) !== !1 && (e._pt = S = new it(e._pt, Y, te.name, 0, 1, te.render, te, 0, te.priority), te._props.forEach(function($) {
        q[$] = S;
      }), te.priority && (H = 1)), !ae || Me)
        for (O in h)
          rt[O] && (te = jo(O, h, e, le, Y, f)) ? te.priority && (H = 1) : q[O] = S = ba.call(e, Y, O, "get", h[O], le, f, 0, n.stringFilter);
      e._op && e._op[w] && e.kill(Y, e._op[w]), L && e._pt && (Ht = e, Le.killTweensOf(Y, q, e.globalTime(i)), oe = !e.parent, Ht = 0), e._pt && s && ($n[B.id] = 1);
    }
    H && fo(e), e._onInit && e._onInit(e);
  }
  e._onUpdate = u, e._initted = (!e._op || e._pt) && !oe, d && i <= 0 && p.render(Dt, !0, !0);
}, Xg = function(e, i, M, n, a, r, o, s) {
  var u = (e._pt && e._ptCache || (e._ptCache = {}))[i], c, g, d, j;
  if (!u)
    for (u = e._ptCache[i] = [], d = e._ptLookup, j = e._targets.length; j--; ) {
      if (c = d[j][i], c && c.d && c.d._pt)
        for (c = c.d._pt; c && c.p !== i && c.fp !== i; )
          c = c._next;
      if (!c)
        return ea = 1, e.vars[i] = "+=0", Qa(e, o), ea = 0, s ? sM(i + " not eligible for reset") : 1;
      u.push(c);
    }
  for (j = u.length; j--; )
    g = u[j], c = g._pt || g, c.s = (n || n === 0) && !a ? n : c.s + (n || 0) + r * c.c, c.c = M - c.s, g.e && (g.e = ve(M) + Ze(g.e)), g.b && (g.b = c.s + Ze(g.b));
}, Kg = function(e, i) {
  var M = e[0] ? di(e[0]).harness : 0, n = M && M.aliases, a, r, o, s;
  if (!n)
    return i;
  a = _i({}, i);
  for (r in n)
    if (r in a)
      for (s = n[r].split(","), o = s.length; o--; )
        a[s[o]] = a[r];
  return a;
}, qg = function(e, i, M, n) {
  var a = i.ease || n || "power1.inOut", r, o;
  if (Je(i))
    o = M[e] || (M[e] = []), i.forEach(function(s, u) {
      return o.push({
        t: u / (i.length - 1) * 100,
        v: s,
        e: a
      });
    });
  else
    for (r in i)
      o = M[r] || (M[r] = []), r === "ease" || o.push({
        t: parseFloat(e),
        v: i[r],
        e: a
      });
}, lM = function(e, i, M, n, a) {
  return he(e) ? e.call(i, M, n, a) : Pe(e) && ~e.indexOf("random(") ? cM(e) : e;
}, yo = Sa + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", Ao = {};
tt(yo + ",id,stagger,delay,duration,paused,scrollTrigger", function(t) {
  return Ao[t] = 1;
});
var Qe = /* @__PURE__ */ function(t) {
  Ql(e, t);
  function e(M, n, a, r) {
    var o;
    typeof n == "number" && (a.duration = n, n = a, a = null), o = t.call(this, r ? n : aM(n)) || this;
    var s = o.vars, u = s.duration, c = s.delay, g = s.immediateRender, d = s.stagger, j = s.overwrite, D = s.keyframes, I = s.defaults, N = s.scrollTrigger, x = s.yoyoEase, f = n.parent || Le, L = (Je(M) || Yl(M) ? Ft(M[0]) : "length" in n) ? [M] : dt(M), p, h, w, O, S, Y, H, B;
    if (o._targets = L.length ? ka(L) : sM("GSAP target " + M + " not found. https://gsap.com", !st.nullTargetWarn) || [], o._ptLookup = [], o._overwrite = j, D || d || hM(u) || hM(c)) {
      if (n = o.vars, p = o.timeline = new Xe({
        data: "nested",
        defaults: I || {},
        targets: f && f.data === "nested" ? f.vars.targets : L
      }), p.kill(), p.parent = p._dp = vt(o), p._start = 0, d || hM(u) || hM(c)) {
        if (O = L.length, H = d && io(d), Et(d))
          for (S in d)
            ~yo.indexOf(S) && (B || (B = {}), B[S] = d[S]);
        for (h = 0; h < O; h++)
          w = ZM(n, Ao), w.stagger = 0, x && (w.yoyoEase = x), B && _i(w, B), Y = L[h], w.duration = +lM(u, vt(o), h, Y, L), w.delay = (+lM(c, vt(o), h, Y, L) || 0) - o._delay, !d && O === 1 && w.delay && (o._delay = c = w.delay, o._start += c, w.delay = 0), p.to(Y, w, H ? H(h, Y, L) : 0), p._ease = de.none;
        p.duration() ? u = c = 0 : o.timeline = 0;
      } else if (D) {
        aM(gt(p.vars.defaults, {
          ease: "none"
        })), p._ease = yi(D.ease || n.ease || "none");
        var ae = 0, te, q, le;
        if (Je(D))
          D.forEach(function(Me) {
            return p.to(L, Me, ">");
          }), p.duration();
        else {
          w = {};
          for (S in D)
            S === "ease" || S === "easeEach" || qg(S, D[S], w, D.easeEach);
          for (S in w)
            for (te = w[S].sort(function(Me, oe) {
              return Me.t - oe.t;
            }), ae = 0, h = 0; h < te.length; h++)
              q = te[h], le = {
                ease: q.e,
                duration: (q.t - (h ? te[h - 1].t : 0)) / 100 * u
              }, le[S] = q.v, p.to(L, le, ae), ae += le.duration;
          p.duration() < u && p.to({}, {
            duration: u - p.duration()
          });
        }
      }
      u || o.duration(u = p.duration());
    } else
      o.timeline = 0;
    return j === !0 && !pa && (Ht = vt(o), Le.killTweensOf(L), Ht = 0), Ct(f, vt(o), a), n.reversed && o.reverse(), n.paused && o.paused(!0), (g || !u && !D && o._start === Ue(f._time) && et(g) && Og(vt(o)) && f.data !== "nested") && (o._tTime = -ze, o.render(Math.max(0, -c) || 0)), N && Kl(vt(o), N), o;
  }
  var i = e.prototype;
  return i.render = function(n, a, r) {
    var o = this._time, s = this._tDur, u = this._dur, c = n < 0, g = n > s - ze && !c ? s : n < ze ? 0 : n, d, j, D, I, N, x, f, L, p;
    if (!u)
      Sg(this, n, a, r);
    else if (g !== this._tTime || !n || r || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== c || this._lazy) {
      if (d = g, L = this.timeline, this._repeat) {
        if (I = u + this._rDelay, this._repeat < -1 && c)
          return this.totalTime(I * 100 + n, a, r);
        if (d = Ue(g % I), g === s ? (D = this._repeat, d = u) : (N = Ue(g / I), D = ~~N, D && D === N ? (d = u, D--) : d > u && (d = u)), x = this._yoyo && D & 1, x && (p = this._yEase, d = u - d), N = Pi(this._tTime, I), d === o && !r && this._initted && D === N)
          return this._tTime = g, this;
        D !== N && (L && this._yEase && No(L, x), this.vars.repeatRefresh && !x && !this._lock && d !== I && this._initted && (this._lock = r = 1, this.render(Ue(I * D), !0).invalidate()._lock = 0));
      }
      if (!this._initted) {
        if (ql(this, c ? n : d, r, a, g))
          return this._tTime = 0, this;
        if (o !== this._time && !(r && this.vars.repeatRefresh && D !== N))
          return this;
        if (u !== this._dur)
          return this.render(n, a, r);
      }
      if (this._tTime = g, this._time = d, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = f = (p || this._ease)(d / u), this._from && (this.ratio = f = 1 - f), !o && g && !a && !N && (ot(this, "onStart"), this._tTime !== g))
        return this;
      for (j = this._pt; j; )
        j.r(f, j.d), j = j._next;
      L && L.render(n < 0 ? n : L._dur * L._ease(d / this._dur), a, r) || this._startAt && (this._zTime = n), this._onUpdate && !a && (c && Jn(this, n, a, r), ot(this, "onUpdate")), this._repeat && D !== N && this.vars.onRepeat && !a && this.parent && ot(this, "onRepeat"), (g === this._tDur || !g) && this._tTime === g && (c && !this._onUpdate && Jn(this, n, !0, !0), (n || !u) && (g === this._tDur && this._ts > 0 || !g && this._ts < 0) && Mi(this, 1), !a && !(c && !o) && (g || o || x) && (ot(this, g === s ? "onComplete" : "onReverseComplete", !0), this._prom && !(g < s && this.timeScale() > 0) && this._prom()));
    }
    return this;
  }, i.targets = function() {
    return this._targets;
  }, i.invalidate = function(n) {
    return (!n || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(n), t.prototype.invalidate.call(this, n);
  }, i.resetTo = function(n, a, r, o, s) {
    gM || lt.wake(), this._ts || this.play();
    var u = Math.min(this._dur, (this._dp._time - this._start) * this._ts), c;
    return this._initted || Qa(this, u), c = this._ease(u / this._dur), Xg(this, n, a, r, o, c, u, s) ? this.resetTo(n, a, r, o, 1) : (an(this, 0), this.parent || Hl(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
  }, i.kill = function(n, a) {
    if (a === void 0 && (a = "all"), !n && (!a || a === "all"))
      return this._lazy = this._pt = 0, this.parent ? MM(this) : this.scrollTrigger && this.scrollTrigger.kill(!!Fe), this;
    if (this.timeline) {
      var r = this.timeline.totalDuration();
      return this.timeline.killTweensOf(n, a, Ht && Ht.vars.overwrite !== !0)._first || MM(this), this.parent && r !== this.timeline.totalDuration() && Ri(this, this._dur * this.timeline._tDur / r, 0, 1), this;
    }
    var o = this._targets, s = n ? dt(n) : o, u = this._ptLookup, c = this._pt, g, d, j, D, I, N, x;
    if ((!a || a === "all") && Cg(o, s))
      return a === "all" && (this._pt = 0), MM(this);
    for (g = this._op = this._op || [], a !== "all" && (Pe(a) && (I = {}, tt(a, function(f) {
      return I[f] = 1;
    }), a = I), a = Kg(o, a)), x = o.length; x--; )
      if (~s.indexOf(o[x])) {
        d = u[x], a === "all" ? (g[x] = a, D = d, j = {}) : (j = g[x] = g[x] || {}, D = a);
        for (I in D)
          N = d && d[I], N && ((!("kill" in N.d) || N.d.kill(I) === !0) && Mn(this, N, "_pt"), delete d[I]), j !== "all" && (j[I] = 1);
      }
    return this._initted && !this._pt && c && MM(this), this;
  }, e.to = function(n, a) {
    return new e(n, a, arguments[2]);
  }, e.from = function(n, a) {
    return rM(1, arguments);
  }, e.delayedCall = function(n, a, r, o) {
    return new e(a, 0, {
      immediateRender: !1,
      lazy: !1,
      overwrite: !1,
      delay: n,
      onComplete: a,
      onReverseComplete: a,
      onCompleteParams: r,
      onReverseCompleteParams: r,
      callbackScope: o
    });
  }, e.fromTo = function(n, a, r) {
    return rM(2, arguments);
  }, e.set = function(n, a) {
    return a.duration = 0, a.repeatDelay || (a.repeat = 0), new e(n, a);
  }, e.killTweensOf = function(n, a, r) {
    return Le.killTweensOf(n, a, r);
  }, e;
}(NM);
gt(Qe.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
});
tt("staggerTo,staggerFrom,staggerFromTo", function(t) {
  Qe[t] = function() {
    var e = new Xe(), i = Xn.call(arguments, 0);
    return i.splice(t === "staggerFromTo" ? 5 : 4, 0, 0), e[t].apply(e, i);
  };
});
var Ua = function(e, i, M) {
  return e[i] = M;
}, To = function(e, i, M) {
  return e[i](M);
}, eN = function(e, i, M, n) {
  return e[i](n.fp, M);
}, tN = function(e, i, M) {
  return e.setAttribute(i, M);
}, Ya = function(e, i) {
  return he(e[i]) ? To : wa(e[i]) && e.setAttribute ? tN : Ua;
}, xo = function(e, i) {
  return i.set(i.t, i.p, Math.round((i.s + i.c * e) * 1e6) / 1e6, i);
}, iN = function(e, i) {
  return i.set(i.t, i.p, !!(i.s + i.c * e), i);
}, zo = function(e, i) {
  var M = i._pt, n = "";
  if (!e && i.b)
    n = i.b;
  else if (e === 1 && i.e)
    n = i.e;
  else {
    for (; M; )
      n = M.p + (M.m ? M.m(M.s + M.c * e) : Math.round((M.s + M.c * e) * 1e4) / 1e4) + n, M = M._next;
    n += i.c;
  }
  i.set(i.t, i.p, n, i);
}, _a = function(e, i) {
  for (var M = i._pt; M; )
    M.r(e, M.d), M = M._next;
}, MN = function(e, i, M, n) {
  for (var a = this._pt, r; a; )
    r = a._next, a.p === n && a.modifier(e, i, M), a = r;
}, nN = function(e) {
  for (var i = this._pt, M, n; i; )
    n = i._next, i.p === e && !i.op || i.op === e ? Mn(this, i, "_pt") : i.dep || (M = 1), i = n;
  return !M;
}, aN = function(e, i, M, n) {
  n.mSet(e, i, n.m.call(n.tween, M, n.mt), n);
}, fo = function(e) {
  for (var i = e._pt, M, n, a, r; i; ) {
    for (M = i._next, n = a; n && n.pr > i.pr; )
      n = n._next;
    (i._prev = n ? n._prev : r) ? i._prev._next = i : a = i, (i._next = n) ? n._prev = i : r = i, i = M;
  }
  e._pt = a;
}, it = /* @__PURE__ */ function() {
  function t(i, M, n, a, r, o, s, u, c) {
    this.t = M, this.s = a, this.c = r, this.p = n, this.r = o || xo, this.d = s || this, this.set = u || Ua, this.pr = c || 0, this._next = i, i && (i._prev = this);
  }
  var e = t.prototype;
  return e.modifier = function(M, n, a) {
    this.mSet = this.mSet || this.set, this.set = aN, this.m = M, this.mt = a, this.tween = n;
  }, t;
}();
tt(Sa + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(t) {
  return Ea[t] = 1;
});
ct.TweenMax = ct.TweenLite = Qe;
ct.TimelineLite = ct.TimelineMax = Xe;
Le = new Xe({
  sortChildren: !1,
  defaults: Yi,
  autoRemoveChildren: !0,
  id: "root",
  smoothChildTiming: !0
});
st.stringFilter = co;
var Ai = [], UM = {}, rN = [], Or = 0, lN = 0, On = function(e) {
  return (UM[e] || rN).map(function(i) {
    return i();
  });
}, ta = function() {
  var e = Date.now(), i = [];
  e - Or > 2 && (On("matchMediaInit"), Ai.forEach(function(M) {
    var n = M.queries, a = M.conditions, r, o, s, u;
    for (o in n)
      r = wt.matchMedia(n[o]).matches, r && (s = 1), r !== a[o] && (a[o] = r, u = 1);
    u && (M.revert(), s && i.push(M));
  }), On("matchMediaRevert"), i.forEach(function(M) {
    return M.onMatch(M, function(n) {
      return M.add(null, n);
    });
  }), Or = e, On("matchMedia"));
}, mo = /* @__PURE__ */ function() {
  function t(i, M) {
    this.selector = M && Kn(M), this.data = [], this._r = [], this.isReverted = !1, this.id = lN++, i && this.add(i);
  }
  var e = t.prototype;
  return e.add = function(M, n, a) {
    he(M) && (a = n, n = M, M = he);
    var r = this, o = function() {
      var u = me, c = r.selector, g;
      return u && u !== r && u.data.push(r), a && (r.selector = Kn(a)), me = r, g = n.apply(r, arguments), he(g) && r._r.push(g), me = u, r.selector = c, r.isReverted = !1, g;
    };
    return r.last = o, M === he ? o(r, function(s) {
      return r.add(null, s);
    }) : M ? r[M] = o : o;
  }, e.ignore = function(M) {
    var n = me;
    me = null, M(this), me = n;
  }, e.getTweens = function() {
    var M = [];
    return this.data.forEach(function(n) {
      return n instanceof t ? M.push.apply(M, n.getTweens()) : n instanceof Qe && !(n.parent && n.parent.data === "nested") && M.push(n);
    }), M;
  }, e.clear = function() {
    this._r.length = this.data.length = 0;
  }, e.kill = function(M, n) {
    var a = this;
    if (M ? function() {
      for (var o = a.getTweens(), s = a.data.length, u; s--; )
        u = a.data[s], u.data === "isFlip" && (u.revert(), u.getChildren(!0, !0, !1).forEach(function(c) {
          return o.splice(o.indexOf(c), 1);
        }));
      for (o.map(function(c) {
        return {
          g: c._dur || c._delay || c._sat && !c._sat.vars.immediateRender ? c.globalTime(0) : -1 / 0,
          t: c
        };
      }).sort(function(c, g) {
        return g.g - c.g || -1 / 0;
      }).forEach(function(c) {
        return c.t.revert(M);
      }), s = a.data.length; s--; )
        u = a.data[s], u instanceof Xe ? u.data !== "nested" && (u.scrollTrigger && u.scrollTrigger.revert(), u.kill()) : !(u instanceof Qe) && u.revert && u.revert(M);
      a._r.forEach(function(c) {
        return c(M, a);
      }), a.isReverted = !0;
    }() : this.data.forEach(function(o) {
      return o.kill && o.kill();
    }), this.clear(), n)
      for (var r = Ai.length; r--; )
        Ai[r].id === this.id && Ai.splice(r, 1);
  }, e.revert = function(M) {
    this.kill(M || {});
  }, t;
}(), oN = /* @__PURE__ */ function() {
  function t(i) {
    this.contexts = [], this.scope = i, me && me.data.push(this);
  }
  var e = t.prototype;
  return e.add = function(M, n, a) {
    Et(M) || (M = {
      matches: M
    });
    var r = new mo(0, a || this.scope), o = r.conditions = {}, s, u, c;
    me && !r.selector && (r.selector = me.selector), this.contexts.push(r), n = r.add("onMatch", n), r.queries = M;
    for (u in M)
      u === "all" ? c = 1 : (s = wt.matchMedia(M[u]), s && (Ai.indexOf(r) < 0 && Ai.push(r), (o[u] = s.matches) && (c = 1), s.addListener ? s.addListener(ta) : s.addEventListener("change", ta)));
    return c && n(r, function(g) {
      return r.add(null, g);
    }), this;
  }, e.revert = function(M) {
    this.kill(M || {});
  }, e.kill = function(M) {
    this.contexts.forEach(function(n) {
      return n.kill(M, !0);
    });
  }, t;
}(), JM = {
  registerPlugin: function() {
    for (var e = arguments.length, i = new Array(e), M = 0; M < e; M++)
      i[M] = arguments[M];
    i.forEach(function(n) {
      return oo(n);
    });
  },
  timeline: function(e) {
    return new Xe(e);
  },
  getTweensOf: function(e, i) {
    return Le.getTweensOf(e, i);
  },
  getProperty: function(e, i, M, n) {
    Pe(e) && (e = dt(e)[0]);
    var a = di(e || {}).get, r = M ? Jl : $l;
    return M === "native" && (M = ""), e && (i ? r((rt[i] && rt[i].get || a)(e, i, M, n)) : function(o, s, u) {
      return r((rt[o] && rt[o].get || a)(e, o, s, u));
    });
  },
  quickSetter: function(e, i, M) {
    if (e = dt(e), e.length > 1) {
      var n = e.map(function(c) {
        return nt.quickSetter(c, i, M);
      }), a = n.length;
      return function(c) {
        for (var g = a; g--; )
          n[g](c);
      };
    }
    e = e[0] || {};
    var r = rt[i], o = di(e), s = o.harness && (o.harness.aliases || {})[i] || i, u = r ? function(c) {
      var g = new r();
      Si._pt = 0, g.init(e, M ? c + M : c, Si, 0, [e]), g.render(1, g), Si._pt && _a(1, Si);
    } : o.set(e, s);
    return r ? u : function(c) {
      return u(e, s, M ? c + M : c, o, 1);
    };
  },
  quickTo: function(e, i, M) {
    var n, a = nt.to(e, gt((n = {}, n[i] = "+=0.1", n.paused = !0, n.stagger = 0, n), M || {})), r = function(s, u, c) {
      return a.resetTo(i, s, u, c);
    };
    return r.tween = a, r;
  },
  isTweening: function(e) {
    return Le.getTweensOf(e, !0).length > 0;
  },
  defaults: function(e) {
    return e && e.ease && (e.ease = yi(e.ease, Yi.ease)), Lr(Yi, e || {});
  },
  config: function(e) {
    return Lr(st, e || {});
  },
  registerEffect: function(e) {
    var i = e.name, M = e.effect, n = e.plugins, a = e.defaults, r = e.extendTimeline;
    (n || "").split(",").forEach(function(o) {
      return o && !rt[o] && !ct[o] && sM(i + " effect requires " + o + " plugin.");
    }), pn[i] = function(o, s, u) {
      return M(dt(o), gt(s || {}, a), u);
    }, r && (Xe.prototype[i] = function(o, s, u) {
      return this.add(pn[i](o, Et(s) ? s : (u = s) && {}, this), u);
    });
  },
  registerEase: function(e, i) {
    de[e] = yi(i);
  },
  parseEase: function(e, i) {
    return arguments.length ? yi(e, i) : de;
  },
  getById: function(e) {
    return Le.getById(e);
  },
  exportRoot: function(e, i) {
    e === void 0 && (e = {});
    var M = new Xe(e), n, a;
    for (M.smoothChildTiming = et(e.smoothChildTiming), Le.remove(M), M._dp = 0, M._time = M._tTime = Le._time, n = Le._first; n; )
      a = n._next, (i || !(!n._dur && n instanceof Qe && n.vars.onComplete === n._targets[0])) && Ct(M, n, n._start - n._delay), n = a;
    return Ct(Le, M, 0), M;
  },
  context: function(e, i) {
    return e ? new mo(e, i) : me;
  },
  matchMedia: function(e) {
    return new oN(e);
  },
  matchMediaRefresh: function() {
    return Ai.forEach(function(e) {
      var i = e.conditions, M, n;
      for (n in i)
        i[n] && (i[n] = !1, M = 1);
      M && e.revert();
    }) || ta();
  },
  addEventListener: function(e, i) {
    var M = UM[e] || (UM[e] = []);
    ~M.indexOf(i) || M.push(i);
  },
  removeEventListener: function(e, i) {
    var M = UM[e], n = M && M.indexOf(i);
    n >= 0 && M.splice(n, 1);
  },
  utils: {
    wrap: Pg,
    wrapYoyo: Rg,
    distribute: io,
    random: no,
    snap: Mo,
    normalize: _g,
    getUnit: Ze,
    clamp: bg,
    splitColor: so,
    toArray: dt,
    selector: Kn,
    mapRange: ro,
    pipe: Ug,
    unitize: Yg,
    interpolate: Fg,
    shuffle: to
  },
  install: Wl,
  effects: pn,
  ticker: lt,
  updateRoot: Xe.updateRoot,
  plugins: rt,
  globalTimeline: Le,
  core: {
    PropTween: it,
    globals: Bl,
    Tween: Qe,
    Timeline: Xe,
    Animation: NM,
    getCache: di,
    _removeLinkedListItem: Mn,
    reverting: function() {
      return Fe;
    },
    context: function(e) {
      return e && me && (me.data.push(e), e._ctx = me), me;
    },
    suppressOverwrites: function(e) {
      return pa = e;
    }
  }
};
tt("to,from,fromTo,delayedCall,set,killTweensOf", function(t) {
  return JM[t] = Qe[t];
});
lt.add(Xe.updateRoot);
Si = JM.to({}, {
  duration: 0
});
var sN = function(e, i) {
  for (var M = e._pt; M && M.p !== i && M.op !== i && M.fp !== i; )
    M = M._next;
  return M;
}, uN = function(e, i) {
  var M = e._targets, n, a, r;
  for (n in i)
    for (a = M.length; a--; )
      r = e._ptLookup[a][n], r && (r = r.d) && (r._pt && (r = sN(r, n)), r && r.modifier && r.modifier(i[n], e, M[a], n));
}, En = function(e, i) {
  return {
    name: e,
    headless: 1,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function(n, a, r) {
      r._onInit = function(o) {
        var s, u;
        if (Pe(a) && (s = {}, tt(a, function(c) {
          return s[c] = 1;
        }), a = s), i) {
          s = {};
          for (u in a)
            s[u] = i(a[u]);
          a = s;
        }
        uN(o, a);
      };
    }
  };
}, nt = JM.registerPlugin({
  name: "attr",
  init: function(e, i, M, n, a) {
    var r, o, s;
    this.tween = M;
    for (r in i)
      s = e.getAttribute(r) || "", o = this.add(e, "setAttribute", (s || 0) + "", i[r], n, a, 0, 0, r), o.op = r, o.b = s, this._props.push(r);
  },
  render: function(e, i) {
    for (var M = i._pt; M; )
      Fe ? M.set(M.t, M.p, M.b, M) : M.r(e, M.d), M = M._next;
  }
}, {
  name: "endArray",
  headless: 1,
  init: function(e, i) {
    for (var M = i.length; M--; )
      this.add(e, M, e[M] || 0, i[M], 0, 0, 0, 0, 0, 1);
  }
}, En("roundProps", qn), En("modifiers"), En("snap", Mo)) || JM;
Qe.version = Xe.version = nt.version = "3.13.0";
Fl = 1;
Ca() && Fi();
de.Power0;
de.Power1;
de.Power2;
de.Power3;
de.Power4;
de.Linear;
de.Quad;
de.Cubic;
de.Quart;
de.Quint;
de.Strong;
de.Elastic;
de.Back;
de.SteppedEase;
de.Bounce;
de.Sine;
de.Expo;
de.Circ;
/*!
 * CSSPlugin 3.13.0
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/
var Er, Xt, Qi, Pa, Ii, Sr, Ra, cN = function() {
  return typeof window < "u";
}, Wt = {}, gi = 180 / Math.PI, Ui = Math.PI / 180, Li = Math.atan2, kr = 1e8, Fa = /([A-Z])/g, gN = /(left|right|width|margin|padding|x)/i, NN = /[\s,\(]\S/, Ot = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
}, ia = function(e, i) {
  return i.set(i.t, i.p, Math.round((i.s + i.c * e) * 1e4) / 1e4 + i.u, i);
}, IN = function(e, i) {
  return i.set(i.t, i.p, e === 1 ? i.e : Math.round((i.s + i.c * e) * 1e4) / 1e4 + i.u, i);
}, DN = function(e, i) {
  return i.set(i.t, i.p, e ? Math.round((i.s + i.c * e) * 1e4) / 1e4 + i.u : i.b, i);
}, dN = function(e, i) {
  var M = i.s + i.c * e;
  i.set(i.t, i.p, ~~(M + (M < 0 ? -0.5 : 0.5)) + i.u, i);
}, Lo = function(e, i) {
  return i.set(i.t, i.p, e ? i.e : i.b, i);
}, po = function(e, i) {
  return i.set(i.t, i.p, e !== 1 ? i.b : i.e, i);
}, jN = function(e, i, M) {
  return e.style[i] = M;
}, yN = function(e, i, M) {
  return e.style.setProperty(i, M);
}, AN = function(e, i, M) {
  return e._gsap[i] = M;
}, TN = function(e, i, M) {
  return e._gsap.scaleX = e._gsap.scaleY = M;
}, xN = function(e, i, M, n, a) {
  var r = e._gsap;
  r.scaleX = r.scaleY = M, r.renderTransform(a, r);
}, zN = function(e, i, M, n, a) {
  var r = e._gsap;
  r[i] = M, r.renderTransform(a, r);
}, pe = "transform", Mt = pe + "Origin", fN = function t(e, i) {
  var M = this, n = this.target, a = n.style, r = n._gsap;
  if (e in Wt && a) {
    if (this.tfm = this.tfm || {}, e !== "transform")
      e = Ot[e] || e, ~e.indexOf(",") ? e.split(",").forEach(function(o) {
        return M.tfm[o] = bt(n, o);
      }) : this.tfm[e] = r.x ? r[e] : bt(n, e), e === Mt && (this.tfm.zOrigin = r.zOrigin);
    else
      return Ot.transform.split(",").forEach(function(o) {
        return t.call(M, o, i);
      });
    if (this.props.indexOf(pe) >= 0)
      return;
    r.svg && (this.svgo = n.getAttribute("data-svg-origin"), this.props.push(Mt, i, "")), e = pe;
  }
  (a || i) && this.props.push(e, i, a[e]);
}, wo = function(e) {
  e.translate && (e.removeProperty("translate"), e.removeProperty("scale"), e.removeProperty("rotate"));
}, mN = function() {
  var e = this.props, i = this.target, M = i.style, n = i._gsap, a, r;
  for (a = 0; a < e.length; a += 3)
    e[a + 1] ? e[a + 1] === 2 ? i[e[a]](e[a + 2]) : i[e[a]] = e[a + 2] : e[a + 2] ? M[e[a]] = e[a + 2] : M.removeProperty(e[a].substr(0, 2) === "--" ? e[a] : e[a].replace(Fa, "-$1").toLowerCase());
  if (this.tfm) {
    for (r in this.tfm)
      n[r] = this.tfm[r];
    n.svg && (n.renderTransform(), i.setAttribute("data-svg-origin", this.svgo || "")), a = Ra(), (!a || !a.isStart) && !M[pe] && (wo(M), n.zOrigin && M[Mt] && (M[Mt] += " " + n.zOrigin + "px", n.zOrigin = 0, n.renderTransform()), n.uncache = 1);
  }
}, Co = function(e, i) {
  var M = {
    target: e,
    props: [],
    revert: mN,
    save: fN
  };
  return e._gsap || nt.core.getCache(e), i && e.style && e.nodeType && i.split(",").forEach(function(n) {
    return M.save(n);
  }), M;
}, ho, Ma = function(e, i) {
  var M = Xt.createElementNS ? Xt.createElementNS((i || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), e) : Xt.createElement(e);
  return M && M.style ? M : Xt.createElement(e);
}, jt = function t(e, i, M) {
  var n = getComputedStyle(e);
  return n[i] || n.getPropertyValue(i.replace(Fa, "-$1").toLowerCase()) || n.getPropertyValue(i) || !M && t(e, Wi(i) || i, 1) || "";
}, vr = "O,Moz,ms,Ms,Webkit".split(","), Wi = function(e, i, M) {
  var n = i || Ii, a = n.style, r = 5;
  if (e in a && !M)
    return e;
  for (e = e.charAt(0).toUpperCase() + e.substr(1); r-- && !(vr[r] + e in a); )
    ;
  return r < 0 ? null : (r === 3 ? "ms" : r >= 0 ? vr[r] : "") + e;
}, na = function() {
  cN() && window.document && (Er = window, Xt = Er.document, Qi = Xt.documentElement, Ii = Ma("div") || {
    style: {}
  }, Ma("div"), pe = Wi(pe), Mt = pe + "Origin", Ii.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", ho = !!Wi("perspective"), Ra = nt.core.reverting, Pa = 1);
}, br = function(e) {
  var i = e.ownerSVGElement, M = Ma("svg", i && i.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), n = e.cloneNode(!0), a;
  n.style.display = "block", M.appendChild(n), Qi.appendChild(M);
  try {
    a = n.getBBox();
  } catch {
  }
  return M.removeChild(n), Qi.removeChild(M), a;
}, Qr = function(e, i) {
  for (var M = i.length; M--; )
    if (e.hasAttribute(i[M]))
      return e.getAttribute(i[M]);
}, Oo = function(e) {
  var i, M;
  try {
    i = e.getBBox();
  } catch {
    i = br(e), M = 1;
  }
  return i && (i.width || i.height) || M || (i = br(e)), i && !i.width && !i.x && !i.y ? {
    x: +Qr(e, ["x", "cx", "x1"]) || 0,
    y: +Qr(e, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : i;
}, Eo = function(e) {
  return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && Oo(e));
}, Ti = function(e, i) {
  if (i) {
    var M = e.style, n;
    i in Wt && i !== Mt && (i = pe), M.removeProperty ? (n = i.substr(0, 2), (n === "ms" || i.substr(0, 6) === "webkit") && (i = "-" + i), M.removeProperty(n === "--" ? i : i.replace(Fa, "-$1").toLowerCase())) : M.removeAttribute(i);
  }
}, Kt = function(e, i, M, n, a, r) {
  var o = new it(e._pt, i, M, 0, 1, r ? po : Lo);
  return e._pt = o, o.b = n, o.e = a, e._props.push(M), o;
}, Ur = {
  deg: 1,
  rad: 1,
  turn: 1
}, LN = {
  grid: 1,
  flex: 1
}, ni = function t(e, i, M, n) {
  var a = parseFloat(M) || 0, r = (M + "").trim().substr((a + "").length) || "px", o = Ii.style, s = gN.test(i), u = e.tagName.toLowerCase() === "svg", c = (u ? "client" : "offset") + (s ? "Width" : "Height"), g = 100, d = n === "px", j = n === "%", D, I, N, x;
  if (n === r || !a || Ur[n] || Ur[r])
    return a;
  if (r !== "px" && !d && (a = t(e, i, M, "px")), x = e.getCTM && Eo(e), (j || r === "%") && (Wt[i] || ~i.indexOf("adius")))
    return D = x ? e.getBBox()[s ? "width" : "height"] : e[c], ve(j ? a / D * g : a / 100 * D);
  if (o[s ? "width" : "height"] = g + (d ? r : n), I = n !== "rem" && ~i.indexOf("adius") || n === "em" && e.appendChild && !u ? e : e.parentNode, x && (I = (e.ownerSVGElement || {}).parentNode), (!I || I === Xt || !I.appendChild) && (I = Xt.body), N = I._gsap, N && j && N.width && s && N.time === lt.time && !N.uncache)
    return ve(a / N.width * g);
  if (j && (i === "height" || i === "width")) {
    var f = e.style[i];
    e.style[i] = g + n, D = e[c], f ? e.style[i] = f : Ti(e, i);
  } else
    (j || r === "%") && !LN[jt(I, "display")] && (o.position = jt(e, "position")), I === e && (o.position = "static"), I.appendChild(Ii), D = Ii[c], I.removeChild(Ii), o.position = "absolute";
  return s && j && (N = di(I), N.time = lt.time, N.width = I[c]), ve(d ? D * a / g : D && a ? g / D * a : 0);
}, bt = function(e, i, M, n) {
  var a;
  return Pa || na(), i in Ot && i !== "transform" && (i = Ot[i], ~i.indexOf(",") && (i = i.split(",")[0])), Wt[i] && i !== "transform" ? (a = DM(e, n), a = i !== "transformOrigin" ? a[i] : a.svg ? a.origin : XM(jt(e, Mt)) + " " + a.zOrigin + "px") : (a = e.style[i], (!a || a === "auto" || n || ~(a + "").indexOf("calc(")) && (a = HM[i] && HM[i](e, i, M) || jt(e, i) || Gl(e, i) || (i === "opacity" ? 1 : 0))), M && !~(a + "").trim().indexOf(" ") ? ni(e, i, a, M) + M : a;
}, pN = function(e, i, M, n) {
  if (!M || M === "none") {
    var a = Wi(i, e, 1), r = a && jt(e, a, 1);
    r && r !== M ? (i = a, M = r) : i === "borderColor" && (M = jt(e, "borderTopColor"));
  }
  var o = new it(this._pt, e.style, i, 0, 1, zo), s = 0, u = 0, c, g, d, j, D, I, N, x, f, L, p, h;
  if (o.b = M, o.e = n, M += "", n += "", n.substring(0, 6) === "var(--" && (n = jt(e, n.substring(4, n.indexOf(")")))), n === "auto" && (I = e.style[i], e.style[i] = n, n = jt(e, i) || n, I ? e.style[i] = I : Ti(e, i)), c = [M, n], co(c), M = c[0], n = c[1], d = M.match(Ei) || [], h = n.match(Ei) || [], h.length) {
    for (; g = Ei.exec(n); )
      N = g[0], f = n.substring(s, g.index), D ? D = (D + 1) % 5 : (f.substr(-5) === "rgba(" || f.substr(-5) === "hsla(") && (D = 1), N !== (I = d[u++] || "") && (j = parseFloat(I) || 0, p = I.substr((j + "").length), N.charAt(1) === "=" && (N = bi(j, N) + p), x = parseFloat(N), L = N.substr((x + "").length), s = Ei.lastIndex - L.length, L || (L = L || st.units[i] || p, s === n.length && (n += L, o.e += L)), p !== L && (j = ni(e, i, I, L) || 0), o._pt = {
        _next: o._pt,
        p: f || u === 1 ? f : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: j,
        c: x - j,
        m: D && D < 4 || i === "zIndex" ? Math.round : 0
      });
    o.c = s < n.length ? n.substring(s, n.length) : "";
  } else
    o.r = i === "display" && n === "none" ? po : Lo;
  return Pl.test(n) && (o.e = 0), this._pt = o, o;
}, Yr = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
}, wN = function(e) {
  var i = e.split(" "), M = i[0], n = i[1] || "50%";
  return (M === "top" || M === "bottom" || n === "left" || n === "right") && (e = M, M = n, n = e), i[0] = Yr[M] || M, i[1] = Yr[n] || n, i.join(" ");
}, CN = function(e, i) {
  if (i.tween && i.tween._time === i.tween._dur) {
    var M = i.t, n = M.style, a = i.u, r = M._gsap, o, s, u;
    if (a === "all" || a === !0)
      n.cssText = "", s = 1;
    else
      for (a = a.split(","), u = a.length; --u > -1; )
        o = a[u], Wt[o] && (s = 1, o = o === "transformOrigin" ? Mt : pe), Ti(M, o);
    s && (Ti(M, pe), r && (r.svg && M.removeAttribute("transform"), n.scale = n.rotate = n.translate = "none", DM(M, 1), r.uncache = 1, wo(n)));
  }
}, HM = {
  clearProps: function(e, i, M, n, a) {
    if (a.data !== "isFromStart") {
      var r = e._pt = new it(e._pt, i, M, 0, 0, CN);
      return r.u = n, r.pr = -10, r.tween = a, e._props.push(M), 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://gsap.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */
}, IM = [1, 0, 0, 1, 0, 0], So = {}, ko = function(e) {
  return e === "matrix(1, 0, 0, 1, 0, 0)" || e === "none" || !e;
}, _r = function(e) {
  var i = jt(e, pe);
  return ko(i) ? IM : i.substr(7).match(_l).map(ve);
}, Wa = function(e, i) {
  var M = e._gsap || di(e), n = e.style, a = _r(e), r, o, s, u;
  return M.svg && e.getAttribute("transform") ? (s = e.transform.baseVal.consolidate().matrix, a = [s.a, s.b, s.c, s.d, s.e, s.f], a.join(",") === "1,0,0,1,0,0" ? IM : a) : (a === IM && !e.offsetParent && e !== Qi && !M.svg && (s = n.display, n.display = "block", r = e.parentNode, (!r || !e.offsetParent && !e.getBoundingClientRect().width) && (u = 1, o = e.nextElementSibling, Qi.appendChild(e)), a = _r(e), s ? n.display = s : Ti(e, "display"), u && (o ? r.insertBefore(e, o) : r ? r.appendChild(e) : Qi.removeChild(e))), i && a.length > 6 ? [a[0], a[1], a[4], a[5], a[12], a[13]] : a);
}, aa = function(e, i, M, n, a, r) {
  var o = e._gsap, s = a || Wa(e, !0), u = o.xOrigin || 0, c = o.yOrigin || 0, g = o.xOffset || 0, d = o.yOffset || 0, j = s[0], D = s[1], I = s[2], N = s[3], x = s[4], f = s[5], L = i.split(" "), p = parseFloat(L[0]) || 0, h = parseFloat(L[1]) || 0, w, O, S, Y;
  M ? s !== IM && (O = j * N - D * I) && (S = p * (N / O) + h * (-I / O) + (I * f - N * x) / O, Y = p * (-D / O) + h * (j / O) - (j * f - D * x) / O, p = S, h = Y) : (w = Oo(e), p = w.x + (~L[0].indexOf("%") ? p / 100 * w.width : p), h = w.y + (~(L[1] || L[0]).indexOf("%") ? h / 100 * w.height : h)), n || n !== !1 && o.smooth ? (x = p - u, f = h - c, o.xOffset = g + (x * j + f * I) - x, o.yOffset = d + (x * D + f * N) - f) : o.xOffset = o.yOffset = 0, o.xOrigin = p, o.yOrigin = h, o.smooth = !!n, o.origin = i, o.originIsAbsolute = !!M, e.style[Mt] = "0px 0px", r && (Kt(r, o, "xOrigin", u, p), Kt(r, o, "yOrigin", c, h), Kt(r, o, "xOffset", g, o.xOffset), Kt(r, o, "yOffset", d, o.yOffset)), e.setAttribute("data-svg-origin", p + " " + h);
}, DM = function(e, i) {
  var M = e._gsap || new Do(e);
  if ("x" in M && !i && !M.uncache)
    return M;
  var n = e.style, a = M.scaleX < 0, r = "px", o = "deg", s = getComputedStyle(e), u = jt(e, Mt) || "0", c, g, d, j, D, I, N, x, f, L, p, h, w, O, S, Y, H, B, ae, te, q, le, Me, oe, $, E, be, V, Q, F, Ne, se;
  return c = g = d = I = N = x = f = L = p = 0, j = D = 1, M.svg = !!(e.getCTM && Eo(e)), s.translate && ((s.translate !== "none" || s.scale !== "none" || s.rotate !== "none") && (n[pe] = (s.translate !== "none" ? "translate3d(" + (s.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (s.rotate !== "none" ? "rotate(" + s.rotate + ") " : "") + (s.scale !== "none" ? "scale(" + s.scale.split(" ").join(",") + ") " : "") + (s[pe] !== "none" ? s[pe] : "")), n.scale = n.rotate = n.translate = "none"), O = Wa(e, M.svg), M.svg && (M.uncache ? ($ = e.getBBox(), u = M.xOrigin - $.x + "px " + (M.yOrigin - $.y) + "px", oe = "") : oe = !i && e.getAttribute("data-svg-origin"), aa(e, oe || u, !!oe || M.originIsAbsolute, M.smooth !== !1, O)), h = M.xOrigin || 0, w = M.yOrigin || 0, O !== IM && (B = O[0], ae = O[1], te = O[2], q = O[3], c = le = O[4], g = Me = O[5], O.length === 6 ? (j = Math.sqrt(B * B + ae * ae), D = Math.sqrt(q * q + te * te), I = B || ae ? Li(ae, B) * gi : 0, f = te || q ? Li(te, q) * gi + I : 0, f && (D *= Math.abs(Math.cos(f * Ui))), M.svg && (c -= h - (h * B + w * te), g -= w - (h * ae + w * q))) : (se = O[6], F = O[7], be = O[8], V = O[9], Q = O[10], Ne = O[11], c = O[12], g = O[13], d = O[14], S = Li(se, Q), N = S * gi, S && (Y = Math.cos(-S), H = Math.sin(-S), oe = le * Y + be * H, $ = Me * Y + V * H, E = se * Y + Q * H, be = le * -H + be * Y, V = Me * -H + V * Y, Q = se * -H + Q * Y, Ne = F * -H + Ne * Y, le = oe, Me = $, se = E), S = Li(-te, Q), x = S * gi, S && (Y = Math.cos(-S), H = Math.sin(-S), oe = B * Y - be * H, $ = ae * Y - V * H, E = te * Y - Q * H, Ne = q * H + Ne * Y, B = oe, ae = $, te = E), S = Li(ae, B), I = S * gi, S && (Y = Math.cos(S), H = Math.sin(S), oe = B * Y + ae * H, $ = le * Y + Me * H, ae = ae * Y - B * H, Me = Me * Y - le * H, B = oe, le = $), N && Math.abs(N) + Math.abs(I) > 359.9 && (N = I = 0, x = 180 - x), j = ve(Math.sqrt(B * B + ae * ae + te * te)), D = ve(Math.sqrt(Me * Me + se * se)), S = Li(le, Me), f = Math.abs(S) > 2e-4 ? S * gi : 0, p = Ne ? 1 / (Ne < 0 ? -Ne : Ne) : 0), M.svg && (oe = e.getAttribute("transform"), M.forceCSS = e.setAttribute("transform", "") || !ko(jt(e, pe)), oe && e.setAttribute("transform", oe))), Math.abs(f) > 90 && Math.abs(f) < 270 && (a ? (j *= -1, f += I <= 0 ? 180 : -180, I += I <= 0 ? 180 : -180) : (D *= -1, f += f <= 0 ? 180 : -180)), i = i || M.uncache, M.x = c - ((M.xPercent = c && (!i && M.xPercent || (Math.round(e.offsetWidth / 2) === Math.round(-c) ? -50 : 0))) ? e.offsetWidth * M.xPercent / 100 : 0) + r, M.y = g - ((M.yPercent = g && (!i && M.yPercent || (Math.round(e.offsetHeight / 2) === Math.round(-g) ? -50 : 0))) ? e.offsetHeight * M.yPercent / 100 : 0) + r, M.z = d + r, M.scaleX = ve(j), M.scaleY = ve(D), M.rotation = ve(I) + o, M.rotationX = ve(N) + o, M.rotationY = ve(x) + o, M.skewX = f + o, M.skewY = L + o, M.transformPerspective = p + r, (M.zOrigin = parseFloat(u.split(" ")[2]) || !i && M.zOrigin || 0) && (n[Mt] = XM(u)), M.xOffset = M.yOffset = 0, M.force3D = st.force3D, M.renderTransform = M.svg ? ON : ho ? vo : hN, M.uncache = 0, M;
}, XM = function(e) {
  return (e = e.split(" "))[0] + " " + e[1];
}, Sn = function(e, i, M) {
  var n = Ze(i);
  return ve(parseFloat(i) + parseFloat(ni(e, "x", M + "px", n))) + n;
}, hN = function(e, i) {
  i.z = "0px", i.rotationY = i.rotationX = "0deg", i.force3D = 0, vo(e, i);
}, li = "0deg", eM = "0px", oi = ") ", vo = function(e, i) {
  var M = i || this, n = M.xPercent, a = M.yPercent, r = M.x, o = M.y, s = M.z, u = M.rotation, c = M.rotationY, g = M.rotationX, d = M.skewX, j = M.skewY, D = M.scaleX, I = M.scaleY, N = M.transformPerspective, x = M.force3D, f = M.target, L = M.zOrigin, p = "", h = x === "auto" && e && e !== 1 || x === !0;
  if (L && (g !== li || c !== li)) {
    var w = parseFloat(c) * Ui, O = Math.sin(w), S = Math.cos(w), Y;
    w = parseFloat(g) * Ui, Y = Math.cos(w), r = Sn(f, r, O * Y * -L), o = Sn(f, o, -Math.sin(w) * -L), s = Sn(f, s, S * Y * -L + L);
  }
  N !== eM && (p += "perspective(" + N + oi), (n || a) && (p += "translate(" + n + "%, " + a + "%) "), (h || r !== eM || o !== eM || s !== eM) && (p += s !== eM || h ? "translate3d(" + r + ", " + o + ", " + s + ") " : "translate(" + r + ", " + o + oi), u !== li && (p += "rotate(" + u + oi), c !== li && (p += "rotateY(" + c + oi), g !== li && (p += "rotateX(" + g + oi), (d !== li || j !== li) && (p += "skew(" + d + ", " + j + oi), (D !== 1 || I !== 1) && (p += "scale(" + D + ", " + I + oi), f.style[pe] = p || "translate(0, 0)";
}, ON = function(e, i) {
  var M = i || this, n = M.xPercent, a = M.yPercent, r = M.x, o = M.y, s = M.rotation, u = M.skewX, c = M.skewY, g = M.scaleX, d = M.scaleY, j = M.target, D = M.xOrigin, I = M.yOrigin, N = M.xOffset, x = M.yOffset, f = M.forceCSS, L = parseFloat(r), p = parseFloat(o), h, w, O, S, Y;
  s = parseFloat(s), u = parseFloat(u), c = parseFloat(c), c && (c = parseFloat(c), u += c, s += c), s || u ? (s *= Ui, u *= Ui, h = Math.cos(s) * g, w = Math.sin(s) * g, O = Math.sin(s - u) * -d, S = Math.cos(s - u) * d, u && (c *= Ui, Y = Math.tan(u - c), Y = Math.sqrt(1 + Y * Y), O *= Y, S *= Y, c && (Y = Math.tan(c), Y = Math.sqrt(1 + Y * Y), h *= Y, w *= Y)), h = ve(h), w = ve(w), O = ve(O), S = ve(S)) : (h = g, S = d, w = O = 0), (L && !~(r + "").indexOf("px") || p && !~(o + "").indexOf("px")) && (L = ni(j, "x", r, "px"), p = ni(j, "y", o, "px")), (D || I || N || x) && (L = ve(L + D - (D * h + I * O) + N), p = ve(p + I - (D * w + I * S) + x)), (n || a) && (Y = j.getBBox(), L = ve(L + n / 100 * Y.width), p = ve(p + a / 100 * Y.height)), Y = "matrix(" + h + "," + w + "," + O + "," + S + "," + L + "," + p + ")", j.setAttribute("transform", Y), f && (j.style[pe] = Y);
}, EN = function(e, i, M, n, a) {
  var r = 360, o = Pe(a), s = parseFloat(a) * (o && ~a.indexOf("rad") ? gi : 1), u = s - n, c = n + u + "deg", g, d;
  return o && (g = a.split("_")[1], g === "short" && (u %= r, u !== u % (r / 2) && (u += u < 0 ? r : -r)), g === "cw" && u < 0 ? u = (u + r * kr) % r - ~~(u / r) * r : g === "ccw" && u > 0 && (u = (u - r * kr) % r - ~~(u / r) * r)), e._pt = d = new it(e._pt, i, M, n, u, IN), d.e = c, d.u = "deg", e._props.push(M), d;
}, Pr = function(e, i) {
  for (var M in i)
    e[M] = i[M];
  return e;
}, SN = function(e, i, M) {
  var n = Pr({}, M._gsap), a = "perspective,force3D,transformOrigin,svgOrigin", r = M.style, o, s, u, c, g, d, j, D;
  n.svg ? (u = M.getAttribute("transform"), M.setAttribute("transform", ""), r[pe] = i, o = DM(M, 1), Ti(M, pe), M.setAttribute("transform", u)) : (u = getComputedStyle(M)[pe], r[pe] = i, o = DM(M, 1), r[pe] = u);
  for (s in Wt)
    u = n[s], c = o[s], u !== c && a.indexOf(s) < 0 && (j = Ze(u), D = Ze(c), g = j !== D ? ni(M, s, u, D) : parseFloat(u), d = parseFloat(c), e._pt = new it(e._pt, o, s, g, d - g, ia), e._pt.u = D || 0, e._props.push(s));
  Pr(o, n);
};
tt("padding,margin,Width,Radius", function(t, e) {
  var i = "Top", M = "Right", n = "Bottom", a = "Left", r = (e < 3 ? [i, M, n, a] : [i + a, i + M, n + M, n + a]).map(function(o) {
    return e < 2 ? t + o : "border" + o + t;
  });
  HM[e > 1 ? "border" + t : t] = function(o, s, u, c, g) {
    var d, j;
    if (arguments.length < 4)
      return d = r.map(function(D) {
        return bt(o, D, u);
      }), j = d.join(" "), j.split(d[0]).length === 5 ? d[0] : j;
    d = (c + "").split(" "), j = {}, r.forEach(function(D, I) {
      return j[D] = d[I] = d[I] || d[(I - 1) / 2 | 0];
    }), o.init(s, j, g);
  };
});
var bo = {
  name: "css",
  register: na,
  targetTest: function(e) {
    return e.style && e.nodeType;
  },
  init: function(e, i, M, n, a) {
    var r = this._props, o = e.style, s = M.vars.startAt, u, c, g, d, j, D, I, N, x, f, L, p, h, w, O, S;
    Pa || na(), this.styles = this.styles || Co(e), S = this.styles.props, this.tween = M;
    for (I in i)
      if (I !== "autoRound" && (c = i[I], !(rt[I] && jo(I, i, M, n, e, a)))) {
        if (j = typeof c, D = HM[I], j === "function" && (c = c.call(M, n, e, a), j = typeof c), j === "string" && ~c.indexOf("random(") && (c = cM(c)), D)
          D(this, e, I, c, M) && (O = 1);
        else if (I.substr(0, 2) === "--")
          u = (getComputedStyle(e).getPropertyValue(I) + "").trim(), c += "", ti.lastIndex = 0, ti.test(u) || (N = Ze(u), x = Ze(c)), x ? N !== x && (u = ni(e, I, u, x) + x) : N && (c += N), this.add(o, "setProperty", u, c, n, a, 0, 0, I), r.push(I), S.push(I, 0, o[I]);
        else if (j !== "undefined") {
          if (s && I in s ? (u = typeof s[I] == "function" ? s[I].call(M, n, e, a) : s[I], Pe(u) && ~u.indexOf("random(") && (u = cM(u)), Ze(u + "") || u === "auto" || (u += st.units[I] || Ze(bt(e, I)) || ""), (u + "").charAt(1) === "=" && (u = bt(e, I))) : u = bt(e, I), d = parseFloat(u), f = j === "string" && c.charAt(1) === "=" && c.substr(0, 2), f && (c = c.substr(2)), g = parseFloat(c), I in Ot && (I === "autoAlpha" && (d === 1 && bt(e, "visibility") === "hidden" && g && (d = 0), S.push("visibility", 0, o.visibility), Kt(this, o, "visibility", d ? "inherit" : "hidden", g ? "inherit" : "hidden", !g)), I !== "scale" && I !== "transform" && (I = Ot[I], ~I.indexOf(",") && (I = I.split(",")[0]))), L = I in Wt, L) {
            if (this.styles.save(I), j === "string" && c.substring(0, 6) === "var(--" && (c = jt(e, c.substring(4, c.indexOf(")"))), g = parseFloat(c)), p || (h = e._gsap, h.renderTransform && !i.parseTransform || DM(e, i.parseTransform), w = i.smoothOrigin !== !1 && h.smooth, p = this._pt = new it(this._pt, o, pe, 0, 1, h.renderTransform, h, 0, -1), p.dep = 1), I === "scale")
              this._pt = new it(this._pt, h, "scaleY", h.scaleY, (f ? bi(h.scaleY, f + g) : g) - h.scaleY || 0, ia), this._pt.u = 0, r.push("scaleY", I), I += "X";
            else if (I === "transformOrigin") {
              S.push(Mt, 0, o[Mt]), c = wN(c), h.svg ? aa(e, c, 0, w, 0, this) : (x = parseFloat(c.split(" ")[2]) || 0, x !== h.zOrigin && Kt(this, h, "zOrigin", h.zOrigin, x), Kt(this, o, I, XM(u), XM(c)));
              continue;
            } else if (I === "svgOrigin") {
              aa(e, c, 1, w, 0, this);
              continue;
            } else if (I in So) {
              EN(this, h, I, d, f ? bi(d, f + c) : c);
              continue;
            } else if (I === "smoothOrigin") {
              Kt(this, h, "smooth", h.smooth, c);
              continue;
            } else if (I === "force3D") {
              h[I] = c;
              continue;
            } else if (I === "transform") {
              SN(this, c, e);
              continue;
            }
          } else I in o || (I = Wi(I) || I);
          if (L || (g || g === 0) && (d || d === 0) && !NN.test(c) && I in o)
            N = (u + "").substr((d + "").length), g || (g = 0), x = Ze(c) || (I in st.units ? st.units[I] : N), N !== x && (d = ni(e, I, u, x)), this._pt = new it(this._pt, L ? h : o, I, d, (f ? bi(d, f + g) : g) - d, !L && (x === "px" || I === "zIndex") && i.autoRound !== !1 ? dN : ia), this._pt.u = x || 0, N !== x && x !== "%" && (this._pt.b = u, this._pt.r = DN);
          else if (I in o)
            pN.call(this, e, I, u, f ? f + c : c);
          else if (I in e)
            this.add(e, I, u || e[I], f ? f + c : c, n, a);
          else if (I !== "parseTransform") {
            Oa(I, c);
            continue;
          }
          L || (I in o ? S.push(I, 0, o[I]) : typeof e[I] == "function" ? S.push(I, 2, e[I]()) : S.push(I, 1, u || e[I])), r.push(I);
        }
      }
    O && fo(this);
  },
  render: function(e, i) {
    if (i.tween._time || !Ra())
      for (var M = i._pt; M; )
        M.r(e, M.d), M = M._next;
    else
      i.styles.revert();
  },
  get: bt,
  aliases: Ot,
  getSetter: function(e, i, M) {
    var n = Ot[i];
    return n && n.indexOf(",") < 0 && (i = n), i in Wt && i !== Mt && (e._gsap.x || bt(e, "x")) ? M && Sr === M ? i === "scale" ? TN : AN : (Sr = M || {}) && (i === "scale" ? xN : zN) : e.style && !wa(e.style[i]) ? jN : ~i.indexOf("-") ? yN : Ya(e, i);
  },
  core: {
    _removeProperty: Ti,
    _getMatrix: Wa
  }
};
nt.utils.checkPrefix = Wi;
nt.core.getStyleSaver = Co;
(function(t, e, i, M) {
  var n = tt(t + "," + e + "," + i, function(a) {
    Wt[a] = 1;
  });
  tt(e, function(a) {
    st.units[a] = "deg", So[a] = 1;
  }), Ot[n[13]] = t + "," + e, tt(M, function(a) {
    var r = a.split(":");
    Ot[r[1]] = n[r[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
tt("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(t) {
  st.units[t] = "px";
});
nt.registerPlugin(bo);
var YM = nt.registerPlugin(bo) || nt;
YM.core.Tween;
const kN = ["id"], vN = {
  key: 0,
  class: "trustpilot-widget-carousel"
}, bN = {
  id: "profile-link",
  target: "_blank",
  href: "https://uk.trustpilot.com/review/carfinance247.co.uk",
  rel: "noopener noreferrer"
}, QN = {
  id: "tp-widget-logo",
  class: "tp-widget-logo"
}, UN = { style: { position: "relative", height: "0", width: "100%", padding: "0", "padding-bottom": "24.6031746031746%" } }, YN = {
  id: "tp-widget-stars",
  class: "tp-widget-stars"
}, _N = { class: "tp-stars tp-stars--5" }, PN = { style: { position: "relative", height: "0", width: "100%", padding: "0", "padding-bottom": "18.326693227091635%" } }, RN = {
  id: "tp-widget-businessinfo",
  class: "tp-widget-businessinfo text-white"
}, FN = { class: "tp-widget-businessinfo__trustscore" }, WN = { id: "trust-score" }, BN = { class: "tp-widget-businessinfo__total" }, VN = { class: "bold-underline" }, GN = { id: "businessEntity-numberOfReviews-total" }, ZN = {
  key: 1,
  class: "trustpilot-widget-slider"
}, $N = {
  id: "tp-widget-wrapper",
  class: "tp-widget-wrapper visible",
  "aria-labelledby": "footer"
}, JN = {
  id: "wrapper-top",
  class: "wrapper-top"
}, HN = ["id"], XN = ["id", "title", "disabled", "onClick"], KN = { class: "" }, qN = { style: { position: "relative", height: "0", width: "100%", padding: "0", "padding-bottom": "100%" } }, eI = {
  id: "tp-widget-reviews-wrapper",
  class: "tp-widget-reviews-wrapper"
}, tI = ["aria-label"], iI = { class: "top-row" }, MI = { class: "tp-widget-stars" }, nI = { class: "tp-stars tp-stars--5" }, aI = { style: { position: "relative", height: "0", width: "100%", padding: "0", "padding-bottom": "18.326693227091635%" } }, rI = {
  key: 0,
  class: "tp-widget-review__source popover-activator"
}, lI = { class: "verification-label-wrapper" }, oI = { class: "verification-label" }, sI = { class: "label-icon" }, uI = { "aria-hidden": "true" }, cI = ["href", "aria-label"], gI = { class: "tp-widget-review-content" }, NI = { class: "header" }, II = { class: "text" }, DI = { class: "date-and-user-info-wrapper" }, dI = { class: "name secondary-text" }, jI = {
  class: "date secondary-text",
  lang: "en-GB"
}, yI = {
  id: "footer",
  class: "wrapper-bottom"
}, AI = {
  id: "tp-widget-profile-link",
  class: "tp-widget-profile-link",
  target: "_blank",
  href: "https://uk.trustpilot.com/review/carfinance247.co.uk"
}, TI = {
  id: "rating-long",
  class: "tp-widget-rating tp-widget-rating-long"
}, xI = { class: "bold-underline" }, zI = {
  id: "rating-short",
  class: "tp-widget-rating tp-widget-rating-short"
}, fI = { class: "bold-underline" }, mI = {
  id: "tp-widget-logo",
  class: "profile-url tp-widget-logo"
}, LI = { style: { position: "relative", height: "19.67px", width: "80px", padding: "0", "padding-bottom": "24.6031746031746%" } }, pI = {
  key: 2,
  class: "trustpilot-widget-mini"
}, wI = {
  id: "tp-widget-wrapper",
  class: "tp-widget-wrapper visible"
}, CI = {
  id: "profile-link",
  class: "tp-widget-profile-link",
  target: "_blank",
  href: "https://uk.trustpilot.com/review/carfinance247.co.uk",
  rel: "noopener noreferrer"
}, hI = {
  id: "tp-widget-logo",
  class: "tp-widget-logo",
  style: { margin: "0 0 8px" }
}, OI = { class: "" }, EI = { style: { position: "relative", height: "0", width: "100%", padding: "0", "padding-bottom": "24.6031746031746%" } }, SI = {
  id: "tp-widget-stars",
  class: "tp-widget-stars"
}, kI = { class: "tp-stars tp-stars--5" }, vI = { style: { position: "relative", height: "0", width: "100%", padding: "0", "padding-bottom": "18.326693227091635%" } }, bI = { class: "tp-widget-businessinfo__trustscore" }, QI = { id: "trust-score" }, UI = { class: "tp-widget-businessinfo__total" }, YI = { class: "bold-underline" }, _I = { id: "businessEntity-numberOfReviews-total" }, PI = {
  key: 3,
  class: "trustpilot-widget-toast"
}, RI = { class: "flex items-center justify-between" }, FI = { class: "mt-2" }, WI = { class: "text-body2 mt-1" }, BI = {
  target: "_blank",
  href: "https://uk.trustpilot.com/review/carfinance247.co.uk",
  class: "review-link bold-underline"
}, VI = {
  id: "tp-widget-reviews",
  class: "tp-widget-reviews"
}, GI = ["aria-label"], ZI = { class: "top-row" }, $I = { class: "tp-widget-stars" }, JI = { class: "tp-stars tp-stars--5" }, HI = { style: { position: "relative", height: "0", width: "100%", padding: "0", "padding-bottom": "18.326693227091635%" } }, XI = {
  key: 0,
  class: "tp-widget-review__source popover-activator"
}, KI = { class: "verification-label-wrapper" }, qI = { class: "verification-label" }, eD = { class: "label-icon" }, tD = { "aria-hidden": "true" }, iD = { style: { position: "relative", height: "0", width: "100%", padding: "0", "padding-bottom": "100%" } }, MD = ["href", "aria-label"], nD = { class: "tp-widget-review-content" }, aD = { class: "header" }, rD = { class: "text" }, lD = { class: "date-and-user-info-wrapper" }, oD = { class: "name secondary-text" }, sD = {
  class: "date secondary-text",
  lang: "en-GB"
}, Rr = "5193e43b00006400052dd669", uD = "carfinance247.co.uk", cD = 5 * 60 * 1e3, gD = 6e4, Fr = 1, OM = "trustpilotPollingStarted", ND = /* @__PURE__ */ ne({
  __name: "Trustpilot",
  props: {
    id: { type: String },
    widget: {
      type: String,
      validator: (t) => ["mini-carousel", "slider", "mini", "toast"].includes(t)
    },
    height: { type: String },
    width: { type: String },
    buttonUrl: { type: String, default: "https://apply.carfinance247.co.uk/" },
    darkIcon: { type: [Boolean, String], default: !1 }
  },
  setup(t) {
    const e = t, i = J(() => e.darkIcon || e.darkIcon === "true"), { widget: M } = at(e), n = C(!1), a = C(!1), r = C(!1), o = C(null), s = C(null), u = C(0), c = C(window.innerWidth), g = C(0), d = C(!1);
    let j = null;
    const D = Symbol("TrustpilotData"), I = pl(D, null), N = (I == null ? void 0 : I.reviews) || C([]), x = (I == null ? void 0 : I.dataLoaded) || C(!1), f = C(0);
    iu(D, { reviews: N, dataLoaded: x, totalWidth: f });
    const L = C(null), p = C(Rr), h = C(0), w = C(0), O = J(() => c.value <= 658 ? 1 : c.value <= 878 ? 2 : 3), S = J(() => Math.max(0, N.value.length - O.value)), Y = J(() => g.value === 0 ? 0 : (g.value - (O.value - 1) * 24) / O.value), H = J(() => `translateX(-${u.value * (Y.value + 24)}px)`), B = () => {
      e.buttonUrl && window.open(e.buttonUrl, "_self");
    }, ae = (K) => {
      r.value = !0, s.value && clearTimeout(s.value), s.value = setTimeout(() => {
        r.value = !1, s.value = null;
      }, 7e3);
    }, te = (K) => K === "prev" ? u.value === 0 : u.value >= S.value, q = (K) => K === "prev" ? u.value === 0 : u.value >= N.value.length - O.value, le = (K, X) => K.length > X ? K.slice(0, X) + "..." : K, Me = () => {
      if (!x.value) return 0;
      const K = Y.value, X = N.value.length;
      return X * K + (X - 1) * 24;
    };
    function oe(K) {
      const X = u.value + K * O.value;
      X >= 0 && X <= S.value ? u.value = X : X > S.value ? u.value = S.value : u.value = 0;
    }
    function $(K) {
      const X = new Date(K), Ae = Math.floor(((/* @__PURE__ */ new Date()).getTime() - X.getTime()) / (1e3 * 60));
      if (Ae < 1)
        return "Just now";
      if (Ae >= 1 && Ae < 60)
        return `${Ae} minute${Ae !== 1 ? "s" : ""} ago`;
      if (Ae < 24 * 60) {
        const mt = Math.floor(Ae / 60);
        return `${mt} hour${mt !== 1 ? "s" : ""} ago`;
      } else {
        const mt = Math.floor(Ae / 1440), Gt = Math.floor(Ae % (24 * 60) / 60);
        return `${mt} day${mt !== 1 ? "s" : ""} ${Gt} hour${Gt !== 1 ? "s" : ""} ago`;
      }
    }
    const E = async () => {
      try {
        const [K, X] = await Promise.all([
          fetch(`https://apim.247dev.io/api/apply/v1/trustpilot/${Rr}/reviews`, {
            method: "GET"
          }),
          fetch(`https://apim.247dev.io/api/apply/v1/trustpilot/find?name=${uD}`, {
            method: "GET"
          })
        ]);
        if (!K.ok || !X.ok)
          throw new Error("One or more API calls failed");
        const [De, Ae] = await Promise.all([
          K.json(),
          X.json()
        ]);
        return {
          reviews: De.reviews,
          businessUnitId: Ae.id,
          trustScore: Number.parseFloat(Ae.score.trustScore),
          totalReviews: Ae.numberOfReviews.total
        };
      } catch (K) {
        throw console.error("Error in fetchTrustpilotData:", K), K;
      }
    }, be = () => {
      n.value || sessionStorage.getItem(OM) === "true" || (sessionStorage.setItem(OM, "true"), n.value = !0, d.value = !1, V(), j = setInterval(V, gD));
    }, V = async () => {
      try {
        const K = await E();
        Re(K), sessionStorage.setItem("trustpilotData", JSON.stringify({ data: K, timestamp: Date.now() }));
      } catch (K) {
        console.error("Error polling Trustpilot data:", K);
      }
    }, Q = async () => {
      const K = Date.now(), X = sessionStorage.getItem("trustpilotData"), De = sessionStorage.getItem("isFetchingTrustpilot");
      if (X) {
        const Ae = JSON.parse(X);
        if (K - Ae.timestamp < cD) {
          Re(Ae.data), F();
          return;
        }
      }
      if (De) {
        await Ne(), F();
        return;
      }
      sessionStorage.setItem("isFetchingTrustpilot", "true");
      try {
        const Ae = await E();
        Re(Ae), sessionStorage.setItem("trustpilotData", JSON.stringify({ data: Ae, timestamp: K })), F();
      } catch (Ae) {
        console.error("Error fetching Trustpilot data:", Ae);
      } finally {
        sessionStorage.removeItem("isFetchingTrustpilot");
      }
    }, F = () => {
      n.value || setTimeout(() => {
        be();
      }, 5e3);
    }, Ne = () => new Promise((K) => {
      const X = setInterval(() => {
        const De = sessionStorage.getItem("trustpilotData");
        if (De) {
          clearInterval(X);
          const Ae = JSON.parse(De);
          Re(Ae.data), K();
        }
      }, 100);
    }), se = (K) => {
      YM.set(K, { y: "100%" });
    }, Nt = (K, X) => {
      YM.to(K, {
        y: "0%",
        duration: 1.5,
        ease: "power2.out",
        onComplete: X
      });
    }, je = (K, X) => {
      YM.to(K, {
        y: "100%",
        duration: 1.5,
        ease: "power2.in",
        onComplete: X
      });
    }, We = () => {
      r.value = !1;
    }, Re = (K) => {
      N.value = K.reviews || [], p.value = K.businessUnitId, h.value;
      const X = w.value;
      if (h.value = K.trustScore, w.value = K.totalReviews, !x.value)
        x.value = !0;
      else {
        const De = K.totalReviews - X;
        De > 0 && n.value && De >= Fr && ae();
      }
      L.value = K;
    }, Be = () => {
      c.value = window.innerWidth, Ie(), Tt(() => {
        f.value = Me();
      });
    }, Ie = () => {
      const K = document.querySelector(".tp-widget-reviews-wrapper");
      K && (g.value = K.clientWidth);
    };
    return xe(w, (K, X) => {
      if (!d.value) {
        d.value = !0;
        return;
      }
      const De = K - X;
      n.value && De >= Fr && ae();
    }), xe(() => {
      var K;
      return (K = L.value) == null ? void 0 : K.totalReviews;
    }, (K) => {
      K !== void 0 && (w.value = K);
    }), xe(O, () => {
      u.value = 0;
    }), xe([N, c, x, O], () => {
      x.value && Tt(() => {
        f.value = Me();
      });
    }), we(async () => {
      sessionStorage.removeItem(OM), !x.value && (a.value = window.innerWidth < 768, c.value = window.innerWidth, window.addEventListener("resize", Be), await Q(), Tt(() => {
        Ie(), f.value = Me();
      }));
    }), _t(() => {
      window.removeEventListener("resize", Be), s.value && clearTimeout(s.value), j !== null && clearInterval(j), sessionStorage.removeItem(OM), n.value = !1;
    }), (K, X) => (y(), A("div", {
      id: t.id,
      class: "w-full"
    }, [
      T(M) === "mini-carousel" ? (y(), A("div", vN, [
        l("a", bN, [
          l("div", QN, [
            l("div", UN, [
              b(ie, {
                id: "trustpilot-light",
                style: { position: "absolute", height: "100%", width: "100%", left: "0", top: "0" },
                icon: i.value ? "trustpilot-dark-logo" : "trustpilot-light-logo",
                width: "110",
                height: "27.06"
              }, null, 8, ["icon"])
            ])
          ]),
          l("div", YN, [
            l("div", _N, [
              l("div", PN, [
                b(ie, {
                  id: "stars-1",
                  style: { position: "absolute", height: "100%", width: "100%", left: "0", top: "0" },
                  icon: "trustpilot-stars",
                  "icon-color": "primary",
                  width: "106",
                  height: "20"
                })
              ])
            ])
          ]),
          l("div", RN, [
            l("div", FN, [
              X[0] || (X[0] = l("span", { id: "trust-score-text" }, "TrustScore ", -1)),
              l("strong", WN, m(h.value.toFixed(1)), 1),
              X[1] || (X[1] = l("span", { class: "divider" }, "|", -1))
            ]),
            l("div", BN, [
              l("span", VN, [
                l("strong", GN, m(w.value.toLocaleString()) + " reviews", 1)
              ])
            ])
          ])
        ])
      ])) : k("", !0),
      T(M) === "slider" ? (y(), A("div", ZN, [
        l("div", $N, [
          l("div", JN, [
            (y(), A(ge, null, ye(["prev", "next"], (De) => l("div", {
              key: De,
              id: `review-arrow-${De === "prev" ? "left" : "right"}`,
              class: P([
                `tp-widget-review-${De}`,
                `icon-angle-${De}`,
                { "display-none": te(De) }
              ]),
              "aria-hidden": "true"
            }, [
              X[2] || (X[2] = l("div", { class: "arrow" }, "   ", -1)),
              l("button", {
                id: `tp-widget-${De}-button`,
                class: "svg-slider-arrow",
                title: De === "prev" ? "Previous" : "Next",
                tabindex: "-1",
                disabled: q(De),
                onClick: (Ae) => oe(De === "prev" ? -1 : 1)
              }, [
                l("div", KN, [
                  l("div", qN, [
                    b(ie, {
                      icon: "arrow-slider-circle",
                      width: "24",
                      height: "24",
                      alt: "arrow slider circle"
                    })
                  ])
                ])
              ], 8, XN)
            ], 10, HN)), 64)),
            l("div", eI, [
              l("div", {
                id: "tp-widget-reviews",
                class: "tp-widget-reviews",
                style: R({ transform: H.value, width: `${f.value}px` })
              }, [
                (y(!0), A(ge, null, ye(T(N), (De, Ae) => (y(), A("div", {
                  key: De.id || Ae,
                  class: "tp-widget-review",
                  style: R({ width: `${Y.value}px`, minWidth: `${Y.value}px` }),
                  "aria-label": De.title
                }, [
                  l("div", iI, [
                    l("div", MI, [
                      l("div", nI, [
                        l("div", aI, [
                          b(ie, {
                            id: "stars-2",
                            style: { position: "absolute", height: "100%", width: "100%", left: "0", top: "0" },
                            icon: "trustpilot-stars",
                            "icon-color": "white",
                            width: "106",
                            height: "20"
                          })
                        ])
                      ])
                    ]),
                    De.isVerified ? (y(), A("div", rI, [
                      l("div", lI, [
                        l("div", oI, [
                          l("div", sI, [
                            l("div", uI, [
                              b(ie, {
                                icon: "verified-tick",
                                width: "14",
                                height: "14",
                                alt: "Verified review"
                              })
                            ]),
                            X[3] || (X[3] = za('<div class="tp-widget-review__source__information" data-v-7dafb843><div class="tp-widget-review__source__arrow" data-v-7dafb843></div><div class="information-title" data-v-7dafb843> Verified review </div><div class="information-text" data-v-7dafb843><a href="https://support.trustpilot.com/hc/articles/223402468#verified-reviews-2" target="_blank" rel="noopener noreferrer" data-v-7dafb843>Learn more about verified reviews and review types</a></div></div>', 1))
                          ]),
                          X[4] || (X[4] = l("div", { class: "label-text" }, " Verified ", -1))
                        ])
                      ])
                    ])) : k("", !0)
                  ]),
                  l("a", {
                    href: `https://uk.trustpilot.com/reviews/${De.id}`,
                    rel: "nofollow",
                    target: "_blank",
                    class: "tp-widget-review-link",
                    "aria-label": `Read full review: ${De.title}`
                  }, [
                    l("div", gI, [
                      l("div", NI, m(De.title), 1),
                      l("div", II, m(le(De.text, 85)), 1),
                      l("div", DI, [
                        l("div", dI, m(De.consumer.displayName) + ",", 1),
                        l("div", jI, m($(De.createdAt)), 1)
                      ])
                    ])
                  ], 8, cI)
                ], 12, tI))), 128))
              ], 4)
            ])
          ]),
          l("div", yI, [
            l("a", AI, [
              l("div", TI, [
                X[5] || (X[5] = G(" Rated ")),
                l("strong", null, m(h.value.toFixed(1)), 1),
                X[6] || (X[6] = G(" / 5 based on ")),
                l("span", xI, m(w.value.toLocaleString()) + " reviews", 1),
                X[7] || (X[7] = G(". "))
              ]),
              l("span", zI, [
                X[8] || (X[8] = G(" Rated ")),
                l("strong", null, m(h.value.toFixed(1)), 1),
                X[9] || (X[9] = G(" / 5 • ")),
                l("span", fI, m(w.value.toLocaleString()) + " reviews", 1)
              ]),
              X[10] || (X[10] = l("div", { class: "tp-widget-reviews-filter-label-wrapper" }, [
                l("span", {
                  id: "tp-widget-reviews-filter-label",
                  class: "tp-widget-reviews-filter-label",
                  style: { "padding-left": "3px" }
                }, " Showing our 5 star reviews "),
                l("span", {
                  id: "tp-widget-reviews-filter-dot",
                  class: "tp-widget-reviews-filter-dot"
                }, ".")
              ], -1)),
              l("span", mI, [
                l("div", null, [
                  l("div", LI, [
                    b(ie, {
                      id: "trustpilot-dark",
                      icon: "trustpilot-dark-logo",
                      width: "80",
                      height: "19.67",
                      style: { position: "absolute", height: "100%", width: "100%", left: "0", top: "0" }
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ])) : k("", !0),
      T(M) === "mini" ? (y(), A("div", pI, [
        l("div", wI, [
          l("a", CI, [
            l("span", hI, [
              l("div", OI, [
                l("div", EI, [
                  b(ie, {
                    id: "trustpilot-light",
                    icon: i.value ? "trustpilot-dark-logo" : "trustpilot-light-logo",
                    width: "100%",
                    height: "100%",
                    style: { position: "absolute", left: "0", top: "0" }
                  }, null, 8, ["icon"])
                ])
              ])
            ]),
            l("div", SI, [
              l("div", kI, [
                l("div", vI, [
                  b(ie, {
                    id: "stars-3",
                    style: { position: "absolute", height: "100%", width: "100%", left: "0", top: "0" },
                    icon: "trustpilot-stars",
                    "icon-color": "primary",
                    width: "106",
                    height: "20"
                  })
                ])
              ])
            ]),
            l("div", {
              id: "tp-widget-businessinfo",
              class: P(["tp-widget-businessinfo", `${i.value ? "text-dark-1" : "text-white"}`])
            }, [
              l("span", bI, [
                X[11] || (X[11] = l("span", { id: "trust-score-text" }, "TrustScore ", -1)),
                l("strong", QI, m(h.value.toFixed(1)), 1),
                X[12] || (X[12] = l("span", { class: "divider" }, "|", -1))
              ]),
              l("span", UI, [
                l("span", YI, [
                  l("strong", _I, m(w.value.toLocaleString()), 1),
                  X[13] || (X[13] = l("span", null, " reviews", -1))
                ])
              ])
            ], 2)
          ])
        ])
      ])) : k("", !0),
      T(M) === "toast" ? (y(), A("div", PI, [
        b(wl, {
          onBeforeEnter: se,
          onEnter: Nt,
          onLeave: je
        }, {
          default: Ta(() => [
            r.value ? (y(), A("div", {
              key: 0,
              ref_key: "notificationRef",
              ref: o,
              class: "fixed bottom-0 left-0 right-0 bg-white rounded-t-lg p-4 z-50 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1),_0_-2px_4px_-1px_rgba(0,0,0,0.06)]"
            }, [
              l("div", RI, [
                X[14] || (X[14] = l("div", { class: "flex items-center space-x-2" }, [
                  l("div", { class: "text-h5" }, " We've received a new 5-star review! ")
                ], -1)),
                l("button", {
                  class: "text-gray-500 hover:text-gray-700",
                  onClick: We
                }, [
                  b(ie, {
                    icon: "close-notification",
                    width: "20",
                    height: "20",
                    alt: "close notification"
                  })
                ])
              ]),
              l("div", FI, [
                l("div", WI, [
                  X[15] || (X[15] = G(" We now have ")),
                  l("a", BI, m(w.value.toLocaleString()), 1),
                  X[16] || (X[16] = G(" reviews on Trustpilot. "))
                ])
              ]),
              l("div", VI, [
                T(N).length > 0 ? (y(), A("div", {
                  key: 0,
                  class: "tp-widget-review mt-2",
                  style: { width: "100%", "min-width": "100%" },
                  "aria-label": T(N)[0].title
                }, [
                  l("div", ZI, [
                    l("div", $I, [
                      l("div", JI, [
                        l("div", HI, [
                          b(ie, {
                            id: "stars-4",
                            style: { position: "absolute", height: "100%", width: "100%", left: "0", top: "0" },
                            icon: "trustpilot-stars",
                            "icon-color": "white",
                            width: "106",
                            height: "20"
                          })
                        ])
                      ])
                    ]),
                    T(N)[0].isVerified ? (y(), A("div", XI, [
                      l("div", KI, [
                        l("div", qI, [
                          l("div", eD, [
                            l("div", tD, [
                              l("div", iD, [
                                b(ie, {
                                  icon: "verified-tick",
                                  width: "14",
                                  height: "14",
                                  alt: "Verified review"
                                })
                              ])
                            ]),
                            X[17] || (X[17] = l("div", { class: "tp-widget-review__source__information" }, [
                              l("div", { class: "tp-widget-review__source__arrow" }),
                              l("div", { class: "information-title" }, " Verified review "),
                              l("div", { class: "information-text" }, [
                                l("a", {
                                  href: "https://support.trustpilot.com/hc/articles/223402468#verified-reviews-2",
                                  target: "_blank",
                                  rel: "noopener noreferrer"
                                }, "Learn more about verified reviews and review types")
                              ])
                            ], -1))
                          ]),
                          X[18] || (X[18] = l("div", { class: "label-text" }, " Verified ", -1))
                        ])
                      ])
                    ])) : k("", !0)
                  ]),
                  l("a", {
                    href: `https://uk.trustpilot.com/reviews/${T(N)[0].id}`,
                    rel: "nofollow",
                    target: "_blank",
                    class: "tp-widget-review-link",
                    "aria-label": `Read full review: ${T(N)[0].title}`
                  }, [
                    l("div", nD, [
                      l("div", aD, m(T(N)[0].title), 1),
                      l("div", rD, m(le(T(N)[0].text, 85)), 1),
                      l("div", lD, [
                        l("div", oD, m(T(N)[0].consumer.displayName) + ",", 1),
                        l("div", sD, m($(T(N)[0].createdAt)), 1)
                      ])
                    ])
                  ], 8, MD)
                ], 8, GI)) : k("", !0)
              ]),
              b(Ke, {
                class: "justify-center items-center self-center mt-2",
                color: "bg-secondary",
                "text-size": "text-button-large",
                "text-color": "text-dark-1",
                label: "Get my quote",
                "icon-after": !0,
                width: "100%",
                height: "44px",
                "icon-color": "dark-1",
                "aria-label": "Get my quote",
                onClick: B
              })
            ], 512)) : k("", !0)
          ]),
          _: 1
        })
      ])) : k("", !0)
    ], 8, kN));
  }
}), rn = /* @__PURE__ */ fe(ND, [["__scopeId", "data-v-7dafb843"]]), ID = { class: "bg-dark-1 p-4 lg:p-6 text-white text-sm" }, DD = { class: "max-w-screen-lg mx-auto" }, dD = { class: "w-full lg:w-1/3 flex flex-col items-left lg:items-start" }, jD = { class: "mx-auto flex flex-wrap justify-center lg:justify-between lg:mt-6" }, yD = { class: "w-full grid grid-cols-2 max-md:grid-cols-1 gap-y-2" }, AD = { class: "grid grid-cols-2 gap-y-2" }, TD = ["href"], xD = { class: "grid grid-cols-2 gap-y-2" }, zD = ["href"], fD = { class: "flex flex-wrap justify-between mt-8" }, mD = { class: "w-full lg:w-2/3" }, LD = { class: "flex flex-wrap gap-4" }, pD = ["href", "aria-label"], wD = { class: "flex flex-wrap gap-4 max-md:grid grid-cols-2" }, CD = ["href", "target", "rel", "aria-label"], hD = /* @__PURE__ */ ne({
  __name: "Footer",
  setup(t) {
    const e = C([
      { href: "/car-finance-calculator", text: "Car Finance Calculator" },
      { href: "/about", text: "About Us" },
      { href: "/how-it-works", text: "How It Works" },
      { href: "https://jobs.carfinance247.co.uk/", text: "Careers" },
      { href: "/guides", text: "Help & Guides" },
      { href: "/press", text: "Press Office" },
      { href: "https://dealer.carfinance247.co.uk/", text: "Dealer's Portal" },
      { href: "/contact-us", text: "Contact Us" }
    ]), i = C([
      { href: "/location/glasgow", text: "Glasgow Car Finance" },
      { href: "/location/birmingham", text: "Birmingham Car Finance" },
      { href: "/location/nottingham", text: "Nottingham Car Finance" },
      { href: "/location/manchester", text: "Manchester Car Finance" },
      { href: "/location/london", text: "London Car Finance" },
      { href: "/location/leeds", text: "Leeds Car Finance" },
      { href: "/location/luton", text: "Luton Car Finance" },
      { href: "/location/leicester", text: "Leicester Car Finance" }
    ]), M = C([
      { href: "https://twitter.com/CarFinance247", icon: "twitter", alt: "Twitter" },
      { href: "https://www.linkedin.com/company/car-finance-247", icon: "linkedin", alt: "LinkedIn" },
      { href: "https://www.youtube.com/channel/UCREA9FCb-iWyR88aiIxVHkQ", icon: "youtube", alt: "YouTube" },
      { href: "https://www.tiktok.com/@carfinance_247?", icon: "tiktok", alt: "TikTok" },
      { href: "https://www.facebook.com/carfinance247", icon: "facebook", alt: "Facebook" },
      { href: "https://www.instagram.com/carfinance247", icon: "instagram", alt: "Instagram" }
    ]), n = C([
      { href: "/sitemap", text: "Sitemap" },
      { href: "/terms-and-conditions", text: "Terms & Conditions" },
      { href: "/privacy-policy", text: "Privacy Policy" },
      { href: "/cookie-policy", text: "Cookie Policy" },
      { href: "/acceptable-use-policy", text: "Acceptable Use Policy" },
      { href: "/complaints-procedure", text: "Complaints Procedure" },
      { href: "/modern-slavery-act", text: "Anti-Slavery and Human Trafficking" },
      { href: "https://www.247money.com/", text: "247 Money", external: !0 }
    ]);
    return (a, r) => (y(), A("footer", ID, [
      l("div", DD, [
        l("div", dD, [
          b(rn, {
            id: "footer",
            widget: "mini"
          })
        ]),
        l("div", jD, [
          r[0] || (r[0] = l("div", { class: "w-full lg:w-1/3 mb-4 lg:mb-0" }, [
            l("span", { class: "font-bold" }, "Car Finance 247 Ltd,"),
            l("p", null, [
              G("Universal Square,"),
              l("br"),
              G("Devonshire Street North,"),
              l("br"),
              G("Manchester,"),
              l("br"),
              G("M12 6JH")
            ])
          ], -1)),
          l("div", yD, [
            l("div", AD, [
              (y(!0), A(ge, null, ye(e.value, (o, s) => (y(), A("a", {
                key: s,
                href: o.href,
                target: "_self",
                class: "underline hover:text-gray-300 hover:no-underline"
              }, m(o.text), 9, TD))), 128))
            ]),
            l("div", xD, [
              (y(!0), A(ge, null, ye(i.value, (o, s) => (y(), A("a", {
                key: s,
                href: o.href,
                target: "_self",
                class: "underline hover:text-gray-300 hover:no-underline"
              }, m(o.text), 9, zD))), 128))
            ])
          ])
        ]),
        l("div", fD, [
          r[2] || (r[2] = za('<div class="w-full lg:w-1/3 mb-6 lg:mb-0" data-v-ca7b58d8><h3 class="text-subtitle2 mb-4" data-v-ca7b58d8> Get The App </h3><div class="flex gap-4" data-v-ca7b58d8><a href="https://apps.apple.com/gb/app/carfinance-247/id1161743286" target="_self" data-v-ca7b58d8><img src="' + lu + '" alt="App Store" width="135" height="40" loading="lazy" data-v-ca7b58d8></a><a href="https://play.google.com/store/apps/details?id=uk.co.carfinance247.customerapp&amp;hl=en_GB" target="_self" data-v-ca7b58d8><img src="' + ou + '" alt="Play Store" width="135" height="40" loading="lazy" data-v-ca7b58d8></a></div></div>', 1)),
          l("div", mD, [
            r[1] || (r[1] = l("h3", { class: "text-subtitle2 mb-4" }, " Follow Us ", -1)),
            l("div", LD, [
              (y(!0), A(ge, null, ye(M.value, (o) => (y(), A("a", {
                key: o.alt,
                href: o.href,
                target: "_self",
                class: "flex items-center justify-center w-10 h-10 hover:opacity-80",
                "aria-label": o.alt
              }, [
                b(ie, {
                  icon: o.icon,
                  width: "20px",
                  height: "20px",
                  alt: o.alt,
                  "icon-color": "white"
                }, null, 8, ["icon", "alt"])
              ], 8, pD))), 128))
            ])
          ])
        ]),
        r[3] || (r[3] = l("hr", { class: "border-t border-gray-700 my-8" }, null, -1)),
        l("div", wD, [
          (y(!0), A(ge, null, ye(n.value, (o) => (y(), A("a", {
            key: o.href,
            href: o.href,
            target: o.external ? "_blank" : "_self",
            rel: o.external ? "noopener noreferrer" : "",
            class: "underline hover:text-gray-300 hover:no-underline",
            "aria-label": o.text
          }, m(o.text), 9, CD))), 128))
        ]),
        r[4] || (r[4] = l("div", { class: "mt-8 space-y-4" }, [
          l("p", null, "* The UK's largest online car finance broker by unique users to the website. Based on Similar Web data - 1,488,248 to Car Finance 247 vs. 654,703 for nearest competitor. January to June 2024."),
          l("p", null, "Car Finance 247 is a trading name of Car Finance 247 Limited. Registered office: Universal Square, Devonshire Street North, Manchester, M12 6JH. Registered in England. (Registration Number 06035525)."),
          l("p", null, "Car Finance 247 is authorised and regulated by the Financial Conduct Authority for insurance distribution and credit broking (Firm Reference Number: 653019). Car Finance 247 is registered with the ICO (Registration Number Z1897658)."),
          l("p", null, "Finance is subject to status and is only available to UK residents aged 18 and over. Written quotations are available on request."),
          l("p", null, "This site uses cookies so that we can provide you with the best user experience. By continuing to use the site you are consenting for cookies to be used. Further information on cookies and how you can disable them is available on our cookie policy.")
        ], -1))
      ])
    ]));
  }
}), ph = /* @__PURE__ */ fe(hD, [["__scopeId", "data-v-ca7b58d8"]]), OD = {
  key: 0,
  class: "absolute",
  style: { top: "17px", left: "20px" }
}, ED = ["id", "inputmode", "value", "placeholder", "maxlength"], Ba = /* @__PURE__ */ ne({
  __name: "Input",
  props: {
    id: String,
    width: String,
    height: String,
    backgroundColor: String,
    value: String,
    border: Boolean,
    placeholder: String,
    type: { type: String },
    showPoundSign: { type: Boolean },
    icon: { type: String },
    inputClass: { type: String },
    max: { type: Number },
    inputmode: {
      type: String,
      default: "decimal"
    }
  },
  emits: ["update:value"],
  setup(t, { emit: e }) {
    var d;
    const i = t, M = C(((d = i.value) == null ? void 0 : d.replace(/,/g, "")) || ""), n = e, a = J(() => {
      if (i.type === "number") {
        const j = Number.parseFloat(M.value);
        return Number.isNaN(j) ? "" : j.toLocaleString();
      }
      return M.value ?? "";
    }), r = (j) => {
      const I = j.target.value.replace(/,/g, ""), N = i.max ? I.slice(0, i.max) : I;
      M.value = N, n("update:value", N);
    };
    xe(() => i.value, (j) => {
      M.value = (j == null ? void 0 : j.replace(/,/g, "")) || "";
    });
    const { backgroundColor: o, border: s } = at(i), u = J(() => ({ [o.value]: !0 })), c = J(() => ({
      width: i.width,
      maxWidth: i.width,
      height: i.height,
      ...s.value && { border: "2px solid black" }
    })), g = (j) => {
      if (i.type === "number" && !["Backspace", "Tab", "Enter", "End", "Home", "ArrowLeft", "ArrowRight", "Delete", "."].includes(j.key) && (j.key < "0" || j.key > "9") && j.preventDefault(), i.type === "reg") {
        const D = /^[a-zA-Z0-9\s]$/.test(j.key), I = ["Backspace", "Tab", "Enter", "End", "Home", "ArrowLeft", "ArrowRight", "Delete"].includes(j.key);
        !D && !I && j.preventDefault();
      }
    };
    return (j, D) => (y(), A("div", {
      class: P(["relative flex", [t.showPoundSign && "justify-center"]])
    }, [
      t.showPoundSign ? (y(), A("div", OD, [
        b(ie, {
          icon: t.icon,
          width: "18",
          height: "34"
        }, null, 8, ["icon"])
      ])) : k("", !0),
      l("input", {
        id: t.id,
        type: "text",
        inputmode: i.inputmode,
        style: R(c.value),
        class: P([u.value, "w-full"]),
        value: a.value,
        placeholder: i.placeholder,
        backgroundColor: "bg-white",
        maxlength: i.max,
        onInput: r,
        onKeypress: g
      }, null, 46, ED)
    ], 2));
  }
}), Bi = {
  "bad-credit-rate": {
    from: 9.9,
    representative: 23.9
  },
  "prime-rate": {
    from: 8.9,
    representative: 10.9
  },
  "refinance-rate": {
    from: 9.9,
    representative: 15.9
  },
  "van-rate": {
    from: 9.9,
    representative: 15.9
  },
  "van-prime-rate": {
    from: 9.9,
    representative: 13.9
  },
  "premiere-247-rate": {
    from: 8.9,
    representative: 10.9
  },
  "caravan-rate": {
    from: 16.9,
    representative: 19.9
  },
  default: {
    from: 9.9,
    representative: 19.9
  }
}, SD = { class: "flex flex-col text-center items-center max-w-full" }, kD = ["id"], vD = { class: "justify-center items-center mt-2 max-w-full" }, bD = { class: "flex gap-2 justify-center py-2 max-w-full" }, QD = { class: "justify-center max-w-full text-center text-white w-[350px]" }, UD = ["innerHTML"], YD = /* @__PURE__ */ ne({
  __name: "MonthlyBudget",
  props: {
    id: {
      type: String
    },
    footer: {
      type: String
    },
    btnText: {
      type: String
    },
    placeholder: {
      type: String
    },
    showButtonSubText: {
      type: Boolean
    },
    aprType: String,
    linkQuery: String
  },
  setup(t) {
    const e = t, i = C(""), M = () => {
      const o = La() ? "social" : "apply", s = i.value ? `monthlyBudget=${i.value}` : "", u = "option=monthly", c = e.linkQuery ? `${e.linkQuery}` : "", g = [s, u, c].filter(Boolean).join("&");
      window.location.href = `https://${o}.carfinance247.co.uk${g ? `?${g}` : ""}`;
    }, { placeholder: n } = at(e), a = J(() => {
      var s;
      if (!e.aprType || e.aprType === "none")
        return (s = e.footer) == null ? void 0 : s.replace(/<br\/?>/gi, "");
      if (window.APR_RATES !== void 0) {
        const u = window.APR_RATES[e.aprType] || window.APR_RATES.default;
        return `Rates from ${u.from}% APR. Representative ${u.representative}% APR.<br>Car Finance 247 Limited is a credit broker, not a lender.`;
      }
      const o = Bi[e.aprType] || Bi.default;
      return `Rates from ${o.from}% APR. Representative APR ${o.representative}%.<br>Car Finance 247 Limited is a credit broker, not a lender.`;
    }), r = (o) => {
      o.key === "." && o.preventDefault();
    };
    return (o, s) => (y(), A("div", SD, [
      l("div", {
        id: t.id,
        class: "mt-4 text-xl font-bold tracking-normal text-center text-white"
      }, s[1] || (s[1] = [
        l("p", { class: "text-h6 text-white" }, " My monthly budget is ", -1)
      ]), 8, kD),
      l("div", vD, [
        b(Ba, {
          id: "monthly-budget",
          value: i.value,
          "onUpdate:value": s[0] || (s[0] = (u) => i.value = u),
          type: "number",
          class: "responsive-width",
          height: "4rem",
          "background-color": "bg-white",
          placeholder: T(n),
          "show-pound-sign": !0,
          currency: "£",
          "aria-label": "Enter your monthly budget",
          icon: "pound",
          max: 5,
          onKeypress: r
        }, null, 8, ["value", "placeholder"])
      ]),
      l("div", bD, [
        b(Ke, {
          class: "monthly-budget-button",
          color: "bg-secondary",
          "hover-color": "bg-secondary hover:brightness-110",
          "text-size": "text-button-large",
          "text-color": "text-dark-1",
          label: t.btnText,
          "icon-after": !0,
          width: "330px",
          height: "4rem",
          "icon-color": "dark-1",
          "aria-label": "Get my quote",
          "show-button-sub-text": t.showButtonSubText,
          onClick: M
        }, null, 8, ["label", "show-button-sub-text"])
      ]),
      l("div", QD, [
        l("span", {
          "data-nosnippet": "",
          class: "text-body2 text-white",
          innerHTML: a.value
        }, null, 8, UD)
      ])
    ]));
  }
}), _D = ["id", "src", "alt", "width", "height"], Ce = {
  __name: "Image",
  props: {
    id: {
      type: String,
      default: ""
    },
    imageName: {
      type: String,
      required: !0
    },
    imageAlt: {
      type: String
    },
    width: String,
    height: String,
    objectFit: String
  },
  setup(t) {
    const e = t, {
      imageName: i,
      imageAlt: M,
      width: n,
      height: a,
      objectFit: r
    } = at(e), o = C(window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"), s = J(() => {
      const c = i.value.split("?")[0], g = c.endsWith(".png") || c.endsWith(".jpg"), d = c.includes("cloudinary.com"), j = c.includes("imagin.studio");
      return d || j ? i.value : c.includes("http") && !d && !j ? c : o.value && !g ? new URL((/* @__PURE__ */ Object.assign({ "../assets/images/5star.png": su, "../assets/images/BadCreditScoreTable.png": uu, "../assets/images/Bold.png": cu, "../assets/images/CFPlantTrees.png": gu, "../assets/images/CarInMountains.png": Nu, "../assets/images/Efficient.png": Iu, "../assets/images/FordFocus.png": Du, "../assets/images/GregandKaren.png": du, "../assets/images/Passionate.png": ju, "../assets/images/PhoneDuo.png": yu, "../assets/images/RegandLouis.png": Au, "../assets/images/RegandLouisNew.png": Tu, "../assets/images/Resilient.png": xu, "../assets/images/VehicleSearch.png": zu, "../assets/images/car.png": fu, "../assets/images/card-1.png": mu, "../assets/images/card-2.png": Lu, "../assets/images/card-3.png": pu, "../assets/images/card-full-1-mobile.png": wu, "../assets/images/card-full-1.png": Cu, "../assets/images/card-full-2-mobile.png": hu, "../assets/images/card-full-2.png": Ou, "../assets/images/card-full-3-mobile.png": Eu, "../assets/images/card-full-3.png": Su, "../assets/images/clearScore.png": ku, "../assets/images/compareTheMarket.png": vu, "../assets/images/creditKarma.png": bu, "../assets/images/experian.png": Qu, "../assets/images/logo.png": Uu, "../assets/images/louis.png": Yu, "../assets/images/paula.png": _u, "../assets/images/paula_img.png": Pu, "../assets/images/second_img.png": Ru, "../assets/images/step1.png": Fu, "../assets/images/step2.png": Wu, "../assets/images/step3.png": Bu, "../assets/images/third_img.png": Vu, "../assets/images/trustpilot-dark.png": Gu, "../assets/images/trustpilot-light.png": Zu }))[`../assets/images/${c}.png`], import.meta.url).href : g ? `${c}/100vw/webp_q` : `${c}`;
    }), u = J(() => M.value ? M.value : i.value.split(".")[0].replace(/[-_]/g, " "));
    return (c, g) => (y(), A("img", {
      id: t.id,
      src: s.value,
      alt: u.value,
      width: T(n) || !T(a) && "100%",
      height: T(a) ? T(a) : void 0,
      style: R({ "object-fit": T(r) && T(r) != "" ? T(r) : "", height: T(a), width: T(n) }),
      loading: "lazy"
    }, null, 12, _D));
  }
}, PD = { class: "background" }, RD = { class: "text-center" }, FD = { class: "text-h1 text-white mt-12 max-md:leading-[55px]" }, WD = {
  key: 0,
  class: "flex flex-wrap justify-center my-2 max-w-screen-lg md:gap-2"
}, BD = ["innerHTML"], VD = {
  key: 0,
  style: { width: "354px", "z-index": "5" }
}, GD = {
  key: 1,
  style: { width: "354px", "z-index": "5" },
  class: "flex flex-col items-center"
}, wh = /* @__PURE__ */ ne({
  __name: "HeroBanner",
  props: {
    header: {
      type: String
    },
    showTickMessage: {
      type: Boolean
    },
    tickItem1: String,
    tickItem2: String,
    tickItem3: String,
    budgetFooter: String,
    budgetPlaceholder: String,
    budgetBtnText: String,
    bgHeight: {
      type: String
    },
    wrapperClass: {
      type: String
    },
    showButtonSubText: {
      type: Boolean
    },
    imaginMake: {
      type: String
    },
    imaginModelFamily: {
      type: String
    },
    imaginModelTrim: {
      type: String
    },
    imaginModelRange: {
      type: String
    },
    imaginModelYear: {
      type: String
    },
    imaginModelPowerTrain: {
      type: String
    },
    imaginModelDoors: {
      type: String
    },
    imaginAngle: {
      type: String
    },
    imaginPaintId: {
      type: String
    },
    imaginWidth: {
      type: String
    },
    imaginPosition: {
      type: String
    },
    overrideCurrentImage: {
      type: String
    },
    carImage: {
      type: String
    },
    carImageAlt: {
      type: String
    },
    carImageWidth: {
      type: String
    },
    carImageHeight: {
      type: String
    },
    aprType: String,
    linkQuery: String
  },
  setup(t) {
    const e = t, {
      header: i,
      showTickMessage: M,
      budgetFooter: n,
      budgetPlaceholder: a,
      budgetBtnText: r,
      bgHeight: o,
      wrapperClass: s,
      imaginMake: u,
      imaginModelFamily: c,
      imaginAngle: g,
      imaginPaintId: d,
      imaginWidth: j,
      imaginModelDoors: D,
      imaginModelTrim: I,
      imaginPosition: N,
      overrideCurrentImage: x,
      carImage: f,
      carImageWidth: L,
      carImageHeight: p,
      imaginModelPowerTrain: h
    } = at(e), w = J(() => [e.tickItem1, e.tickItem2, e.tickItem3].filter((O) => O && O.trim() !== ""));
    return we(() => {
      document.querySelector(":root").style.setProperty("--cf247-herobanner-padding-bottom", "60px");
    }), (O, S) => (y(), A("div", {
      class: P(T(s))
    }, [
      l("div", PD, [
        S[0] || (S[0] = l("div", { class: "small-circle" }, null, -1)),
        S[1] || (S[1] = l("div", { class: "medium-circle" }, null, -1)),
        l("main", {
          class: "header-text-content flex flex-col items-center self-stretch px-16 max-md:px-5 top-0 left-0 w-full pt-20",
          style: R({ height: T(o), paddingBottom: "140px" })
        }, [
          l("section", RD, [
            l("h1", FD, m(T(i)), 1),
            T(M) && w.value.length ? (y(), A("ul", WD, [
              (y(!0), A(ge, null, ye(w.value, (Y, H) => (y(), A("li", {
                key: H,
                class: "flex gap-2 py-0.5 px-2 max-md:py-2"
              }, [
                b(ie, {
                  icon: "tick-circle",
                  stroke: "black",
                  width: "20",
                  height: "20",
                  "icon-color": "secondary"
                }),
                l("span", {
                  class: "text-body1 text-white text-left tick-item",
                  innerHTML: Y
                }, null, 8, BD)
              ]))), 128))
            ])) : k("", !0),
            b(YD, {
              footer: T(n),
              "btn-text": T(r),
              placeholder: T(a),
              "show-button-sub-text": t.showButtonSubText,
              "apr-type": t.aprType,
              "link-query": t.linkQuery
            }, null, 8, ["footer", "btn-text", "placeholder", "show-button-sub-text", "apr-type", "link-query"]),
            b(rn, {
              widget: "mini-carousel",
              class: "mt-4"
            })
          ])
        ], 4)
      ]),
      l("div", {
        class: "flex justify-center max-w-full absolute w-full",
        style: R(`bottom: ${T(x) == "true" ? "-80px" : "-40px"};`)
      }, [
        T(x) == "true" ? (y(), A("div", VD, [
          b(oM, {
            make: T(u),
            "model-family": T(c),
            "model-range": t.imaginModelRange,
            "model-year": t.imaginModelYear,
            "model-trim": T(I),
            "model-power-train": T(h),
            "model-doors": T(D),
            angle: T(g),
            "paint-id": T(d),
            width: T(j),
            position: T(N),
            height: "221px"
          }, null, 8, ["make", "model-family", "model-range", "model-year", "model-trim", "model-power-train", "model-doors", "angle", "paint-id", "width", "position"])
        ])) : (y(), A("div", GD, [
          b(Ce, {
            "image-name": T(f),
            "image-alt": t.carImageAlt,
            width: T(L),
            height: T(p)
          }, null, 8, ["image-name", "image-alt", "width", "height"])
        ]))
      ], 4)
    ], 2));
  }
}), ZD = { class: "relative flex justify-center select-wrapper" }, $D = ["id", "disabled"], JD = {
  disabled: "",
  value: "none"
}, HD = ["value", "selected"], XD = /* @__PURE__ */ ne({
  __name: "SelectInput",
  props: {
    id: String,
    value: String,
    placeholder: String,
    options: Array,
    disabled: Boolean,
    placeholderColor: {
      type: String,
      default: "#757575"
      // Changed default color
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const i = t, M = C(i.value), n = e, a = (r) => {
      const o = r.target;
      M.value = o.value, n("update:modelValue", o.value);
    };
    return we(() => {
      M.value = i.value;
      const r = document.getElementById(i.id);
      r.addEventListener("change", function() {
        this.value === "" ? this.style.color = i.placeholderColor : this.style.color = "black";
      }), r.style.color = i.placeholderColor;
    }), (r, o) => (y(), A("div", ZD, [
      ht(l("select", {
        id: t.id,
        "onUpdate:modelValue": o[0] || (o[0] = (s) => M.value = s),
        class: "input w-full select",
        onChange: a,
        disabled: t.disabled
      }, [
        l("option", JD, m(t.placeholder), 1),
        (y(!0), A(ge, null, ye(t.options, (s, u) => (y(), A("option", {
          key: u,
          value: s.value,
          selected: s.value === M.value
        }, m(s.label), 9, HD))), 128))
      ], 40, $D), [
        [hl, M.value]
      ])
    ]));
  }
}), si = /* @__PURE__ */ fe(XD, [["__scopeId", "data-v-9df7143d"]]), KD = ["id"], qD = { class: "flex flex-col" }, ed = /* @__PURE__ */ ne({
  __name: "Card",
  props: {
    id: {
      type: String
    },
    title: {
      type: String
    },
    description: {
      type: String
    },
    textSize: {
      type: String
    },
    textColor: {
      type: String
    },
    icon: {
      type: String
    },
    iconColor: {
      type: String
    },
    btnColor: {
      type: String
    },
    width: {
      type: String
    },
    height: {
      type: String
    },
    enterReg: {
      type: Boolean,
      default: !1
    },
    buttonTitle: {
      type: String
    },
    placeholder: {
      type: String
    },
    showPoundSign: {
      type: Boolean
    },
    buttonUrl: {
      type: String
    },
    btnWidth: {
      type: String
    },
    btnHeight: {
      type: String
    },
    inputWidth: {
      type: String,
      default: ""
    },
    cardType: {
      type: String
    }
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const i = t, M = e, n = J(() => i.btnWidth), a = J(() => i.inputWidth), r = () => {
      i.buttonUrl ? window.open(i.buttonUrl, "_self") : M("click");
    };
    return (o, s) => (y(), A("div", {
      id: t.id,
      class: P(["relative flex flex-col justify-between h-full p-2 pt-6 pb-6 md:p-6 mx-auto w-full rounded-md md:px-0", [t.cardType === "half-image" ? "text-left" : "text-center"]])
    }, [
      i.icon ? (y(), _e(ie, {
        key: 0,
        class: "self-center w-10 aspect-[1.11]",
        icon: i.icon,
        "icon-color": t.iconColor,
        width: "17",
        height: "17"
      }, null, 8, ["icon", "icon-color"])) : k("", !0),
      l("section", null, [
        l("header", qD, [
          l("span", {
            class: P(["font-bold", t.cardType === "half-image" ? "card-title-half-image text-dark-1" : "card-title-full-image text-white"])
          }, m(t.title), 3),
          l("p", {
            class: P(["mb-4 mt-1", t.cardType === "half-image" ? "card-description-half-image text-dark-1" : "card-description-full-image text-white"])
          }, m(t.description), 3)
        ])
      ]),
      l("div", {
        class: P(["flex justify-center w-full", [t.cardType === "half-image" ? "text-left" : "text-center"]])
      }, [
        t.enterReg ? (y(), A("div", {
          key: 1,
          class: P(["flex flex-col w-full", t.cardType === "half-image" ? "mobile-center-half-image" : "mobile-center-full-image"])
        }, [
          b(Ba, {
            id: "vehicleRegistration",
            class: P(["pb-2 w-full", t.cardType === "half-image" ? "mobile-center-half-image" : "mobile-center-full-image"]),
            width: a.value,
            height: "52px",
            "background-color": "bg-yellow-1",
            placeholder: t.placeholder,
            border: !1,
            "show-pound-sign": t.showPoundSign
          }, null, 8, ["class", "width", "placeholder", "show-pound-sign"]),
          b(Ke, {
            class: P(["flex gap-2 justify-center gap-6", t.cardType === "half-image" ? "mobile-self-center-half-image" : "mobile-self-center-full-image"]),
            color: t.btnColor,
            "hover-color": "bg-secondary hover:brightness-110",
            "text-size": "text-subtitle1",
            "text-color": t.textColor,
            label: t.buttonTitle,
            "icon-after": !0,
            width: n.value,
            height: t.btnHeight,
            "icon-color": "dark-1",
            "aria-label": t.buttonTitle,
            onClick: r
          }, null, 8, ["class", "color", "text-color", "label", "width", "height", "aria-label"])
        ], 2)) : (y(), A("div", {
          key: 0,
          class: P(["text-h5 flex w-full", t.cardType === "half-image" ? "mobile-center-half-image" : "mobile-center-full-image"])
        }, [
          b(Ke, {
            class: "flex gap-2 justify-center gap-6",
            "hover-color": "bg-secondary hover:brightness-110",
            color: t.btnColor,
            "text-size": "text-button-large",
            "text-color": t.textColor,
            label: t.buttonTitle,
            "icon-after": !0,
            width: n.value,
            height: t.btnHeight,
            "icon-color": "dark-1",
            "aria-label": t.buttonTitle,
            onClick: r
          }, null, 8, ["color", "text-color", "label", "width", "height", "aria-label"])
        ], 2))
      ], 2)
    ], 10, KD));
  }
}), Wr = /* @__PURE__ */ fe(ed, [["__scopeId", "data-v-9f0d0e20"]]), td = {
  id: "card-trio-container",
  class: "justify-center w-full"
}, id = { class: "flex gap-2 justify-center items-center py-6 px-4 lg:py-12" }, Md = {
  key: 0,
  class: "flex flex-wrap md:gap-12 gap-4 sm:gap-8 max-w-screen-lg max-md:max-w-full justify-center"
}, nd = { class: "flex flex-col text-center w-full max-md:max-w-full" }, ad = { class: "flex flex-col justify-center text-center" }, rd = { class: "text-center text-h2 w-full" }, ld = { class: "w-full h-full relative" }, od = ["id"], sd = {
  key: 1,
  class: "flex flex-wrap md:gap-12 gap-4 sm:gap-8 max-w-screen-lg max-md:max-w-full justify-center"
}, ud = { class: "flex flex-col text-center w-full max-md:max-w-full" }, cd = { class: "flex flex-col justify-center text-center" }, gd = { class: "text-center text-h2 w-full" }, Nd = ["id"], Id = /* @__PURE__ */ ne({
  __name: "CardTrio",
  props: {
    title: { type: String },
    titleCard1: { type: String },
    descriptionCard1: { type: String },
    iconCard1: { type: String },
    buttonTitleCard1: { type: String },
    titleCard2: { type: String },
    descriptionCard2: { type: String },
    iconCard2: { type: String },
    buttonTitleCard2: { type: String },
    titleCard3: { type: String },
    descriptionCard3: { type: String },
    iconCard3: { type: String },
    buttonTitleCard3: { type: String },
    buttonUrl1: { type: String },
    buttonUrl2: { type: String },
    buttonUrl3: { type: String },
    imageCard1: { type: String },
    mobileImageCard1: { type: String },
    imageCard2: { type: String },
    mobileImageCard2: { type: String },
    imageCard3: { type: String },
    mobileImageCard3: { type: String },
    cardType: { type: String }
  },
  setup(t) {
    const e = t, i = C(!1), M = () => {
      i.value = window.innerWidth < 768;
    };
    we(() => {
      M(), window.addEventListener("resize", M);
    }), _t(() => {
      window.removeEventListener("resize", M);
    });
    const n = J(() => [
      {
        id: "card1",
        title: e.titleCard1,
        description: e.descriptionCard1,
        icon: e.iconCard1,
        buttonTitle: e.buttonTitleCard1,
        buttonUrl: e.buttonUrl1,
        image: i.value ? e.mobileImageCard1 : e.imageCard1,
        enterReg: !1
      },
      {
        id: "card2",
        title: e.titleCard2,
        description: e.descriptionCard2,
        icon: e.iconCard2,
        buttonTitle: e.buttonTitleCard2,
        buttonUrl: e.buttonUrl2,
        image: i.value ? e.mobileImageCard2 : e.imageCard2,
        reverseOnMobile: !0,
        enterReg: !1
      },
      {
        id: "card3",
        title: e.titleCard3,
        description: e.descriptionCard3,
        icon: e.iconCard3,
        buttonTitle: e.buttonTitleCard3,
        buttonUrl: e.buttonUrl3,
        image: i.value ? e.mobileImageCard3 : e.imageCard3,
        enterReg: !1
      }
    ]), a = (r) => {
      switch (r) {
        case 0:
          return "190px";
        case 1:
          return "168px";
        case 2:
          return "260px";
        default:
          return "100%";
      }
    };
    return (r, o) => (y(), A("div", td, [
      l("div", id, [
        t.cardType === "full-image" ? (y(), A("div", Md, [
          l("section", nd, [
            l("header", ad, [
              l("h2", rd, m(t.title), 1)
            ])
          ]),
          (y(!0), A(ge, null, ye(n.value, (s, u) => (y(), A("div", {
            key: u,
            class: P([["card-container", `card-${u + 1}`], "relative flex flex-col w-full max-w-screen-full xs:max-w-screen-xs md:max-w-screen-md lg:max-w-screen-lg"])
          }, [
            l("div", ld, [
              b(Ce, {
                "image-name": s.image,
                class: "w-full rounded-md custom-object-fit"
              }, null, 8, ["image-name"]),
              o[0] || (o[0] = l("div", { class: "gradient-overlay" }, null, -1))
            ]),
            l("div", {
              class: P(["absolute inset-0 flex items-center p-4 lg:p-8 mobile-card-alignment", { "justify-start": u !== 1, "justify-end": u === 1 }])
            }, [
              l("div", {
                id: s.id,
                class: "flex flex-col w-full max-w-md card-content"
              }, [
                b(Wr, {
                  title: s.title,
                  description: s.description,
                  "button-title": s.buttonTitle,
                  "button-url": s.buttonUrl,
                  "enter-reg": s.enterReg,
                  "btn-width": a(u),
                  "input-width": a(u),
                  "btn-height": "52px",
                  "btn-color": "bg-secondary",
                  "text-color": "text-dark-1",
                  "show-pound-sign": !1,
                  placeholder: "ENTER REG",
                  "card-type": t.cardType
                }, null, 8, ["title", "description", "button-title", "button-url", "enter-reg", "btn-width", "input-width", "card-type"])
              ], 8, od)
            ], 2)
          ], 2))), 128))
        ])) : t.cardType === "half-image" ? (y(), A("div", sd, [
          l("section", ud, [
            l("header", cd, [
              l("h2", gd, m(t.title), 1)
            ])
          ]),
          (y(!0), A(ge, null, ye(n.value, (s, u) => (y(), A("div", {
            key: u,
            class: "flex flex-col md:flex-row max-md:flex-wrap text-center max-w-screen-full xs:max-w-screen-xs md:max-w-screen-md lg:max-w-screen-lg"
          }, [
            l("div", {
              class: P([
                "flex flex-col md:order-2 max-md:w-full",
                s.reverseOnMobile ? "md:order-1" : "md:order-2"
              ])
            }, [
              b(Ce, {
                "image-name": s.image,
                height: "619px",
                width: "491px",
                class: "card-image object-contain w-full rounded-md tablet:w-[419px] tablet:h-[304.82px] small-tablet:object-cover small-tablet:h-full"
              }, null, 8, ["image-name"])
            ], 2),
            l("div", {
              class: P([
                "md:flex-1 min-w-[240px] max-md:max-w-full content-center",
                s.reverseOnMobile ? "md:order-2" : "md:order-1"
              ])
            }, [
              l("div", {
                id: s.id,
                class: "flex flex-col w-full text-neutral-900 md:px-8"
              }, [
                b(Wr, {
                  title: s.title,
                  description: s.description,
                  icon: s.icon,
                  "icon-color": "secondary",
                  "button-title": s.buttonTitle,
                  "button-url": s.buttonUrl,
                  "enter-reg": s.enterReg,
                  "btn-width": a(u),
                  "input-width": a(u),
                  "btn-height": "52px",
                  "btn-color": "bg-secondary",
                  "text-color": "text-dark-1",
                  "show-pound-sign": !1,
                  placeholder: "ENTER REG",
                  "card-type": t.cardType
                }, null, 8, ["title", "description", "icon", "button-title", "button-url", "enter-reg", "btn-width", "input-width", "card-type"])
              ], 8, Nd)
            ], 2)
          ]))), 128))
        ])) : k("", !0)
      ])
    ]));
  }
}), Ch = /* @__PURE__ */ fe(Id, [["__scopeId", "data-v-8c2db3cc"]]), Dd = ["id"], dd = {
  key: 0,
  class: "flex md:flex-row flex-col gap-4 pb-4"
}, jd = { class: "flex flex-col" }, yd = { class: "text-h6" }, Ad = ["innerHTML"], Td = {
  key: 1,
  class: "flex gap-x-4 justify-start items-center"
}, xd = { class: "flex flex-col" }, zd = ["innerHTML"], fd = /* @__PURE__ */ ne({
  name: "IconListComponent",
  __name: "IconList",
  props: {
    id: {
      type: String
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "simple"
    },
    icon: {
      type: String,
      default: ""
    },
    iconFill: {
      type: String,
      default: ""
    },
    iconStroke: {
      type: String,
      default: "none"
    },
    iconWidth: {
      type: String,
      default: "28"
    },
    iconHeight: {
      type: String,
      default: "28"
    }
  },
  setup(t) {
    return (e, i) => (y(), A("div", {
      id: t.id,
      class: "icon-list max-w-screen-sm py-2"
    }, [
      t.type == "detailed" ? (y(), A("div", dd, [
        l("div", null, [
          b(ie, {
            icon: t.icon,
            "icon-color": t.iconFill,
            stroke: t.iconStroke,
            width: t.iconWidth,
            height: t.iconHeight
          }, null, 8, ["icon", "icon-color", "stroke", "width", "height"])
        ]),
        l("div", jd, [
          l("div", yd, m(t.title), 1),
          l("p", {
            class: "text-lg",
            innerHTML: t.description
          }, null, 8, Ad)
        ])
      ])) : (y(), A("div", Td, [
        l("div", null, [
          b(ie, {
            class: "pt-1",
            icon: t.icon,
            "icon-color": t.iconFill,
            stroke: t.iconStroke,
            width: t.iconWidth,
            height: t.iconHeight
          }, null, 8, ["icon", "icon-color", "stroke", "width", "height"])
        ]),
        l("div", xd, [
          l("div", {
            class: "text",
            innerHTML: t.title
          }, null, 8, zd)
        ])
      ]))
    ], 8, Dd));
  }
}), kn = /* @__PURE__ */ fe(fd, [["__scopeId", "data-v-1b8565a9"]]), md = { class: "flex flex-col justify-center items-start w-full max-w-screen-sm max-md:px-4" }, Ld = { class: "text-left text-h2 mb-8 w-full" }, pd = { class: "flex flex-col items-start gap-y-4 w-full" }, wd = /* @__PURE__ */ ne({
  __name: "WhyCF247",
  props: {
    title: {
      type: String
    },
    backgroundColor: {
      type: String
    },
    title1: {
      type: String
    },
    description1: {
      type: String
    },
    icon1: { type: String },
    iconFill1: { type: String },
    iconStroke1: { type: String },
    title2: {
      type: String
    },
    description2: {
      type: String
    },
    icon2: { type: String },
    iconFill2: { type: String },
    iconStroke2: { type: String },
    title3: {
      type: String
    },
    description3: {
      type: String
    },
    icon3: { type: String },
    iconFill3: { type: String },
    iconStroke3: { type: String }
  },
  setup(t) {
    const e = t, {
      title: i,
      title1: M,
      title2: n,
      title3: a,
      description1: r,
      description2: o,
      description3: s,
      icon1: u,
      iconFill1: c,
      iconStroke1: g,
      icon2: d,
      iconFill2: j,
      iconStroke2: D,
      icon3: I,
      iconFill3: N,
      iconStroke3: x
    } = at(e);
    return (f, L) => (y(), A("div", {
      class: "flex justify-center py-8 md:py-12",
      style: R({ backgroundColor: t.backgroundColor })
    }, [
      l("div", md, [
        l("div", Ld, [
          l("h2", null, m(T(i)), 1)
        ]),
        l("div", pd, [
          b(kn, {
            type: "detailed",
            title: T(M),
            description: T(r),
            icon: T(u),
            "icon-fill": T(c),
            "icon-stroke": T(g),
            "icon-width": "28",
            "icon-height": "28"
          }, null, 8, ["title", "description", "icon", "icon-fill", "icon-stroke"]),
          b(kn, {
            type: "detailed",
            title: T(n),
            description: T(o),
            icon: T(d),
            "icon-fill": T(j),
            "icon-stroke": T(D),
            "icon-width": "28",
            "icon-height": "28"
          }, null, 8, ["title", "description", "icon", "icon-fill", "icon-stroke"]),
          b(kn, {
            type: "detailed",
            title: T(a),
            description: T(s),
            icon: T(I),
            "icon-fill": T(N),
            "icon-stroke": T(x),
            "icon-width": "28",
            "icon-height": "28"
          }, null, 8, ["title", "description", "icon", "icon-fill", "icon-stroke"])
        ])
      ])
    ], 4));
  }
}), hh = /* @__PURE__ */ fe(wd, [["__scopeId", "data-v-bd9c569f"]]), Cd = { class: "flex flex-col max-w-full w-[975px]" }, hd = { class: "self-center text-center max-w-[776px] w-[776px] max-md:max-w-full" }, Od = { class: "text-h2 text-dark" }, Ed = { class: "flex gap-4 justify-center self-stretch tracking-normal max-md:flex-wrap" }, Sd = { class: "flex w-full items-center" }, Oh = /* @__PURE__ */ ne({
  __name: "TrustPilotContainer",
  props: {
    showTitle: {
      type: String
    },
    widgetType: {
      type: String
    },
    backgroundColor: {
      type: String
    }
  },
  setup(t) {
    const e = C(0), i = C("Rated 'Excellent' by our customers"), M = () => {
      var a;
      const n = sessionStorage.getItem("trustpilotData") || "{}";
      try {
        const r = JSON.parse(n), o = (a = r == null ? void 0 : r.data) == null ? void 0 : a.totalReviews;
        if (typeof o == "number" && !Number.isNaN(o))
          return e.value = Math.floor(o / 1e3) * 1e3, i.value = `Rated 'Excellent' with more than ${e.value.toLocaleString()} reviews`, !0;
      } catch (r) {
        console.error("Error parsing trustpilot data:", r);
      }
      return !1;
    };
    return we(() => {
      const n = setInterval(() => {
        M() && clearInterval(n);
      }, 1e3);
      setTimeout(() => clearInterval(n), 1e4);
    }), (n, a) => (y(), A("div", {
      class: "flex justify-center items-center md:pt-12 pt-8 pb-7 max-md:px-5",
      style: R({ backgroundColor: t.backgroundColor })
    }, [
      l("section", Cd, [
        l("div", hd, [
          l("h2", Od, m(i.value), 1)
        ]),
        l("div", {
          class: P(["flex flex-col justify-center items-center px-4 max-w-[975px] pt-6 max-md:max-w-full", t.showTitle === "true" ? "pt-10" : ""])
        }, [
          l("div", Ed, [
            l("div", Sd, [
              b(rn, {
                widget: t.widgetType,
                height: "240px",
                width: "100%"
              }, null, 8, ["widget"])
            ])
          ])
        ], 2)
      ])
    ], 4));
  }
}), kd = { class: "flex flex-col self-stretch max-w-screen-lg w-full" }, vd = { class: "flex justify-center text-center my-2 max-md:max-w-full" }, bd = { class: "text-h5 text-dark max-md:px-4" }, Qd = { class: "flex justify-center items-center w-full max-md:max-w-full" }, Ud = { class: "flex flex-wrap justify-center items-center gap-x-4 gap-y-0 md:gap-8" }, Eh = /* @__PURE__ */ ne({
  __name: "ThirdPartyPartners",
  props: {
    title: {
      type: String
    },
    clearScore: {
      type: String
    },
    compareTheMarket: {
      type: String
    },
    experian: {
      type: String
    },
    creditKarma: {
      type: String
    },
    backgroundColor: {
      type: String
    }
  },
  setup(t) {
    const e = t, i = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1", M = C([
      {
        logo: i ? "clearScore" : "/dA/6678400dc8/fileAsset/clearScore.png",
        alt: "ClearScore"
      },
      {
        logo: i ? "compareTheMarket" : "/dA/b0032fb627/fileAsset/compareTheMarket.png",
        alt: "Compare the Market"
      },
      {
        logo: i ? "experian" : "/dA/b3944ca70f/fileAsset/experian.png",
        alt: "Experian"
      },
      {
        logo: i ? "creditKarma" : "/dA/6f16e7bbd8/fileAsset/creditKarma.png",
        alt: "Credit Karma"
      }
    ]);
    return we(() => {
      e.clearScore === "false" && (M.value = M.value.filter((n) => !n.logo.includes("clearScore"))), e.compareTheMarket === "false" && (M.value = M.value.filter((n) => !n.logo.includes("compareTheMarket"))), e.experian === "false" && (M.value = M.value.filter((n) => !n.logo.includes("experian"))), e.creditKarma === "false" && (M.value = M.value.filter((n) => !n.logo.includes("creditKarma")));
    }), (n, a) => (y(), A("div", {
      class: "flex justify-center items-center py-8 md:py-12",
      style: R({ backgroundColor: t.backgroundColor })
    }, [
      l("section", kd, [
        l("div", vd, [
          l("h2", bd, m(t.title), 1)
        ]),
        l("div", Qd, [
          l("div", Ud, [
            (y(!0), A(ge, null, ye(M.value, (r) => (y(), A("div", {
              key: r.logo,
              class: "shrink-0 max-w-full w-[160px] py-2"
            }, [
              b(Ce, {
                "image-name": r.logo,
                "image-alt": r.alt,
                width: "160",
                height: "54"
              }, null, 8, ["image-name", "image-alt"])
            ]))), 128))
          ])
        ])
      ])
    ], 4));
  }
}), Yd = ["id"], _d = { class: "justify-center items-center self-start p-1 w-5 h-5" }, Pd = { class: "text-body1 mt-1 leading-6" }, vn = /* @__PURE__ */ ne({
  __name: "SortFinanceSteps",
  props: {
    id: {
      type: String
    },
    title: {
      type: String
    },
    description: {
      type: String
    },
    textSize: {
      type: String
    },
    textColor: {
      type: String
    },
    icon: {
      type: String
    },
    iconColor: {
      type: String
    },
    width: {
      type: String
    },
    height: {
      type: String
    }
  },
  setup(t) {
    const e = t;
    return (i, M) => (y(), A("div", {
      id: t.id,
      class: "flex gap-4 self-stretch"
    }, [
      l("div", _d, [
        b(ie, {
          class: "self-center w-10 aspect-[1.11]",
          icon: t.icon,
          "icon-color": t.iconColor || void 0,
          width: t.width,
          height: t.height
        }, null, 8, ["icon", "icon-color", "width", "height"])
      ]),
      l("div", {
        class: P(["flex flex-col flex-1 px-5", t.textColor])
      }, [
        l("div", {
          class: P(["text-h6 font-bold tracking-normal", t.textSize])
        }, m(e.title), 3),
        l("div", Pd, m(e.description), 1)
      ], 2)
    ], 8, Yd));
  }
}), Rd = {
  id: "sort-finance-container",
  class: "relative w-full bg-purple-9"
}, Fd = ["src"], Wd = { class: "flex flex-col justify-center self-stretch py-12 relative z-10" }, Bd = { class: "flex justify-center items-center px-4 w-full max-md:px-5 max-md:max-w-full" }, Vd = { class: "flex flex-col max-w-full w-[975px]" }, Gd = { class: "mx-6 leading-8 text-center max-md:mr-2.5 max-md:max-w-full" }, Zd = { class: "text-h4 text-white" }, $d = { class: "justify-center mt-12 max-w-[975px] max-md:max-w-full" }, Jd = { class: "flex justify-between gap-4 max-md:flex-col max-md:gap-0" }, Hd = { class: "flex flex-col w-full md:w-6/12" }, Xd = { class: "flex flex-col self-stretch max-w-[975px] max-md:mt-10 max-md:max-w-full" }, Kd = { class: "flex gap-4 max-md:flex-wrap text-white" }, qd = { class: "flex gap-4 mt-6 max-md:flex-wrap text-white" }, ej = { class: "flex gap-4 mt-6 max-md:flex-wrap text-white" }, tj = { class: "flex gap-2 justify-left mt-6 px-2 py-2 max-md:justify-center" }, ij = { class: "py-1 px-2 max-w-full max-md:w-full max-md:justify-center" }, Mj = { class: "text-body2 w-[330px] text-white max-md:text-center" }, nj = { class: "flex flex-col justify-center w-full md:w-6/12" }, Sh = /* @__PURE__ */ ne({
  __name: "SortFinance",
  props: {
    title: {
      type: String
    },
    footerText: {
      type: String
    },
    image: {
      type: String
    },
    imageAlt: {
      type: String
    }
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const i = C(!1), M = J(() => new URL("data:image/svg+xml,%3csvg%20width='1513'%20height='652'%20viewBox='0%200%201513%20652'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_1441_13756)'%3e%3crect%20width='1513'%20height='651'%20transform='translate(0%200.0461426)'%20fill='%237519F3'/%3e%3cpath%20opacity='0.2'%20d='M1363%20156.546C1363%20653.327%20960.503%201056.05%20464%201056.05C-32.5035%201056.05%20-435%20653.327%20-435%20156.546C-435%20-340.235%20-32.5035%20-742.954%20464%20-742.954C960.503%20-742.954%201363%20-340.235%201363%20156.546Z'%20stroke='white'%20stroke-width='2'/%3e%3cpath%20opacity='0.2'%20d='M997%20156.546C997%20451.191%20758.367%20690.046%20464%20690.046C169.633%20690.046%20-69%20451.191%20-69%20156.546C-69%20-138.099%20169.633%20-376.954%20464%20-376.954C758.367%20-376.954%20997%20-138.099%20997%20156.546Z'%20stroke='white'%20stroke-width='2'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_1441_13756'%3e%3crect%20width='1513'%20height='651'%20fill='white'%20transform='translate(0%200.0461426)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", import.meta.url).href), n = () => {
      i.value = window.innerWidth <= 768;
    };
    we(() => {
      window.addEventListener("resize", n);
    }), _t(() => {
      window.removeEventListener("resize", n);
    });
    const a = e;
    return (r, o) => (y(), A("div", Rd, [
      i.value ? k("", !0) : (y(), A("img", {
        key: 0,
        src: M.value,
        alt: "Background",
        class: "w-full h-full object-fill absolute inset-0"
      }, null, 8, Fd)),
      l("div", Wd, [
        l("div", Bd, [
          l("div", Vd, [
            l("div", Gd, [
              l("span", Zd, m(t.title), 1)
            ]),
            l("div", $d, [
              l("div", Jd, [
                l("div", Hd, [
                  l("div", Xd, [
                    l("div", Kd, [
                      b(vn, {
                        title: "Unlock your personalised quote",
                        description: "Get a free quote online and a decision in minutes. We’ll look to find you the best available deal from our wide panel of lenders to beat any quote you've found elsewhere.",
                        "text-size": "text-card-large",
                        "text-color": "text-white",
                        icon: "Number1Ball",
                        "icon-color": "secondary",
                        width: "383.5px",
                        height: "72px"
                      })
                    ]),
                    l("div", qd, [
                      b(vn, {
                        title: "Discover your dream ride",
                        description: "Once approved, choose a car with confidence from any reputable dealer. And don’t forget to check out our car search – it’s home to over 100,000 cars sold by verified dealers.",
                        "text-size": "text-card-large",
                        "text-color": "text-white",
                        icon: "Number2Ball",
                        "icon-color": "secondary",
                        width: "383.5px",
                        height: "72px"
                      })
                    ]),
                    l("div", ej, [
                      b(vn, {
                        title: "Seal the deal and hit the road",
                        description: "Once you've found a car, we’ll sort the paperwork for you, chase the lender, and make sure the dealer is kept in the loop. Then all you need to do is eSign on the dotted line & you're good to go!",
                        "text-size": "text-card-large",
                        "text-color": "text-white",
                        icon: "Number3Ball",
                        "icon-color": "secondary",
                        width: "383.5px",
                        height: "72px"
                      })
                    ]),
                    l("div", tj, [
                      b(Ke, {
                        color: "bg-secondary",
                        "text-size": "text-button-large",
                        "text-color": "text-dark-1",
                        label: "Get my quote",
                        "icon-after": !0,
                        width: "188px",
                        height: "44px",
                        "icon-color": "dark-1",
                        onClick: o[0] || (o[0] = () => a("click"))
                      })
                    ]),
                    l("div", ij, [
                      l("div", Mj, m(t.footerText), 1)
                    ])
                  ])
                ]),
                l("div", nj, [
                  b(Ce, {
                    "image-name": t.image,
                    "image-alt": t.imageAlt,
                    width: "438",
                    height: "455"
                  }, null, 8, ["image-name", "image-alt"])
                ])
              ])
            ])
          ])
        ])
      ])
    ]));
  }
}), aj = ["id"], rj = ["aria-expanded", "aria-controls"], lj = ["innerHTML"], oj = { class: "flex justify-center py-4 whitespace-nowrap align-middle" }, sj = ["innerHTML"], uj = /* @__PURE__ */ ne({
  __name: "FAQ",
  props: {
    id: {
      type: String
    },
    title: {
      type: String
    },
    description: {
      type: String
    },
    iconColor: {
      type: String
    }
  },
  setup(t) {
    const e = C(!1), i = (M) => {
      M.preventDefault();
      const n = M.currentTarget;
      n && n.classList.toggle("rounded-b-md"), e.value = !e.value;
    };
    return we(() => {
      document.querySelectorAll(".faq-description a").forEach((M) => {
        const n = M;
        n.style.color = "hsl(var(--twc-primary))", n.style.cursor = "pointer", n.style.textDecoration = "underline", n.style.textDecorationColor = "#e9dafd", n.style.fontWeight = "700";
      });
    }), (M, n) => (y(), A("article", {
      id: t.id,
      class: "flex flex-col items-center max-w-screen-sm w-full"
    }, [
      l("button", {
        class: "flex gap-4 px-4 bg-purple-2 cursor-pointer w-full max-md:flex-wrap rounded-t-md rounded-b-md",
        onKeydown: n[0] || (n[0] = ci(Pt((a) => i(a), ["prevent"]), ["space"])),
        onClick: n[1] || (n[1] = (a) => i(a)),
        "aria-expanded": e.value,
        "aria-controls": t.id
      }, [
        l("h3", {
          class: "text-h5 flex-1 my-auto py-4 font-bold tracking-normal text-dark-1 max-md:max-w-full text-left",
          innerHTML: t.title
        }, null, 8, lj),
        l("div", oj, [
          b(ie, {
            class: "self-center aspect-[1.11]",
            icon: e.value ? "minus" : "plus",
            "icon-color": t.iconColor,
            width: "33",
            height: "33"
          }, null, 8, ["icon", "icon-color"])
        ])
      ], 40, rj),
      ht(l("p", {
        class: "faq-description text-lg justify-center p-4 w-full leading-relaxed bg-purple-1 text-dark-1 max-md:max-w-full rounded-b-md",
        innerHTML: t.description
      }, null, 8, sj), [
        [xa, e.value]
      ])
    ], 8, aj));
  }
}), cj = /* @__PURE__ */ fe(uj, [["__scopeId", "data-v-ff0a73c5"]]), gj = ["id"], Nj = /* @__PURE__ */ ne({
  __name: "Background",
  props: {
    id: {
      type: String
    },
    height: {
      type: String
    }
  },
  setup(t) {
    const e = t, {
      height: i
    } = at(e);
    return (M, n) => (y(), A("div", {
      id: t.id,
      class: "background",
      style: R({ height: T(i) })
    }, n[0] || (n[0] = [
      l("div", { class: "small-circle" }, null, -1),
      l("div", { class: "medium-circle" }, null, -1)
    ]), 12, gj));
  }
}), Ij = /* @__PURE__ */ fe(Nj, [["__scopeId", "data-v-18e6f45c"]]), Dj = {
  key: 0,
  class: "w-full py-12 px-4 max-md:py-8 flex justify-center"
}, dj = { class: "relative" }, jj = {
  style: { "z-index": "3" },
  class: "flex flex-col items-center justify-center self-stretch px-20 py-12 max-md:py-8 max-md:px-5 absolute top-0 left-0 w-full h-full"
}, yj = { class: "text-h2 leading-8 text-white max-md:max-w-full text-center" }, Aj = { class: "justify-center py-2 max-w-full text-center text-white w-[776px]" }, Tj = { class: "text-body1 text-white" }, xj = { class: "flex gap-2 justify-center py-2 max-w-full" }, zj = {
  key: 0,
  class: "justify-center py-2 max-w-full text-center text-white w-[350px]"
}, fj = ["innerHTML"], kh = /* @__PURE__ */ ne({
  __name: "QuoteFooter",
  props: {
    title: {
      type: String
    },
    subTitle: {
      type: String
    },
    height: {
      type: String,
      default: "334px"
    },
    btnText: {
      type: String
    },
    btnLink: {
      type: String,
      default: "https://apply.carfinance247.co.uk/"
    },
    btnSocialLink: {
      type: String,
      default: "https://social.carfinance247.co.uk/"
    },
    checkIsSocialPage: {
      type: String,
      default: "false"
    },
    footerText: {
      type: String
    },
    showDisclaimer: {
      type: String,
      default: "true"
    },
    showButtonSubText: {
      type: String,
      default: "true"
    },
    aprType: String
  },
  setup(t) {
    const e = t, i = J(() => e.checkIsSocialPage && e.checkIsSocialPage == "true" && La() ? e.btnSocialLink : e.btnLink), M = J(() => {
      var a;
      return !e.aprType || e.aprType === "none" ? (a = e.footerText) == null ? void 0 : a.replace(/<br\/?>/gi, "") : window.APR_RATES !== void 0 ? `Representative ${(window.APR_RATES[e.aprType] || window.APR_RATES.default).representative}% APR.<br>Car Finance 247 Limited is a credit broker, not a lender.` : `Representative APR ${(Bi[e.aprType] || Bi.default).representative}%.<br>Car Finance 247 Limited is a credit broker, not a lender.`;
    });
    return (n, a) => (y(), A("div", null, [
      t.showDisclaimer == "true" ? (y(), A("div", Dj, a[0] || (a[0] = [
        l("section", null, [
          l("div", { class: "text-sm text-left max-w-screen-lg" }, [
            l("h3", null, [
              G(" We look to find the "),
              l("strong", null, "best rate from our panel of lenders"),
              G(" and will offer you the best deal that you're eligible for. We will be paid a commission for providing our services and this commission may be a fixed amount or a percentage of the amount borrowed. The interest rate you pay is directly linked to the amount you are borrowing and your individual credit status. ")
            ])
          ])
        ], -1)
      ]))) : k("", !0),
      l("div", dj, [
        b(Ij, { height: t.height }, null, 8, ["height"]),
        l("section", jj, [
          l("h3", yj, m(t.title), 1),
          l("div", Aj, [
            l("h3", Tj, m(t.subTitle), 1)
          ]),
          l("div", xj, [
            b(Ke, {
              color: "bg-secondary",
              "hover-color": "bg-secondary hover:brightness-110",
              "text-size": "text-button-large",
              "text-color": "text-dark-1",
              label: t.btnText,
              "icon-after": !0,
              width: "239px",
              height: t.showButtonSubText == "true" ? "65px" : "52px",
              "icon-color": "dark-1",
              link: i.value,
              "show-button-sub-text": t.showButtonSubText == "true"
            }, null, 8, ["label", "height", "link", "show-button-sub-text"])
          ]),
          M.value != "" ? (y(), A("div", zj, [
            l("h3", {
              class: "text-sm text-white",
              innerHTML: M.value
            }, null, 8, fj)
          ])) : k("", !0)
        ])
      ])
    ]));
  }
}), mj = ["id"], Lj = { class: "w-full flex justify-center" }, pj = /* @__PURE__ */ ne({
  __name: "InfoCard",
  props: {
    id: {
      type: String
    },
    title: {
      type: String
    },
    description: {
      type: String
    },
    width: {
      type: String
    },
    textSize: {
      type: String
    },
    textColor: {
      type: String
    },
    textWeight: {
      type: String
    },
    textMargin: {
      type: String
    },
    descriptionSize: {
      type: String
    },
    descriptionColor: {
      type: String
    },
    descriptionWeight: {
      type: String
    },
    descriptionMargin: {
      type: String
    },
    icon: {
      type: String
    },
    iconColor: {
      type: String
    },
    strokeColor: {
      type: String
    },
    iconWidth: {
      type: String
    },
    iconHeight: {
      type: String
    },
    iconBackground: {
      type: String
    },
    iconBackgroundRounded: {
      type: Boolean
    },
    wrapperClass: {
      type: String
    },
    showBorder: {
      type: [Boolean, String]
    },
    borderWidth: {
      type: String
    },
    borderColor: {
      type: String
    },
    link: {
      type: String
    },
    roundedClass: String
  },
  setup(t) {
    const e = t, i = () => {
      e.link && window.open(e.link, "_self");
    }, M = J(() => e.showBorder == !0 || e.showBorder == "true"), { id: n, title: a, description: r, textSize: o, textColor: s, textWeight: u, descriptionSize: c, descriptionColor: g, descriptionWeight: d, icon: j, iconColor: D, iconBackground: I, iconBackgroundRounded: N, wrapperClass: x, borderWidth: f, borderColor: L, roundedClass: p, link: h } = at(e);
    return (w, O) => (y(), A("section", {
      id: T(n),
      class: P([[T(x) ? T(x) : "p-4", { "cursor-pointer": T(h) }, `${M.value ? "border" : "border-none"} ${T(p)}`], "w-full h-full flex flex-col justify-between"]),
      style: R({ width: t.width, borderWidth: T(f), borderColor: T(L) }),
      onClick: O[0] || (O[0] = (S) => i())
    }, [
      l("div", Lj, [
        l("div", {
          style: R({ "background-color": T(I) ? T(Rt)[T(I)] : "" }),
          class: P([T(N) ? "rounded-full" : "", T(I) ? "p-2" : ""])
        }, [
          b(ie, {
            icon: T(j),
            "icon-color": T(D) || void 0,
            class: "inline-svg",
            width: t.iconWidth || "32",
            height: t.iconHeight || "32",
            stroke: t.strokeColor || void 0
          }, null, 8, ["icon", "icon-color", "width", "height", "stroke"])
        ], 6)
      ]),
      l("div", {
        class: P(["text-center w-full h-full", t.textMargin ? "mt-" + t.textMargin : "mt-4"])
      }, [
        l("span", {
          class: P([T(o), T(s), T(u)])
        }, m(T(a)), 3)
      ], 2),
      T(r) ? (y(), A("div", {
        key: 0,
        class: P(["text-center w-full h-full", t.descriptionMargin ? "mt-" + t.descriptionMargin : "mt-4"])
      }, [
        l("span", {
          class: P(["text-body1 mt-1 leading-6", [T(c), T(g), T(d)]])
        }, m(T(r)), 3)
      ], 2)) : k("", !0)
    ], 14, mj));
  }
}), vh = /* @__PURE__ */ fe(pj, [["__scopeId", "data-v-e560f211"]]), wj = { class: "text-h5 leading-4" }, Cj = { class: "mt-2 leading-4" }, hj = { class: "text-base" }, Oj = { class: "flex !justify-start !py-0 gap-x-4 mt-4" }, Ej = { class: "flex flex-col gap-1 tracking-normal mt-1" }, Sj = { class: "text-caption" }, kj = ["innerHTML"], vj = { class: "leading-[133%] text-caption" }, bj = { class: "text-h5" }, Qj = {
  key: 0,
  class: "mt-2 leading-4"
}, Uj = { class: "text-body1" }, Yj = {
  key: 0,
  class: "flex gap-2 py-2.5 mt-4 text-center"
}, _j = ["href"], Pj = {
  key: 1,
  class: "text-subtitle1 text-primary cursor-pointer"
}, Rj = { class: "my-auto cursor-pointer" }, bn = /* @__PURE__ */ ne({
  name: "ImageWidgetComponent",
  __name: "ImageWidget",
  props: {
    id: String,
    title: String,
    description: String,
    textSize: String,
    textColor: String,
    image: String,
    width: String,
    height: String,
    authorImage: String,
    authorName: String,
    blogDate: String,
    imageAlt: String,
    iconColor: String,
    showReadMore: String,
    link: String,
    showOuterRadius: Boolean,
    showOuterBorder: Boolean,
    showOuterShadow: Boolean,
    showOuterBackgroundColor: Boolean,
    showImageRadius: Boolean,
    topImageObjectFit: String,
    showDescription: String,
    mobileWithoutDescMinHeight: String,
    showReadMoreText: String,
    contentClassName: String,
    wholeCardClickable: String,
    type: String
  },
  setup(t) {
    const e = t, {
      title: i,
      description: M,
      image: n,
      width: a,
      height: r,
      iconColor: o,
      authorImage: s,
      authorName: u,
      blogDate: c,
      imageAlt: g,
      link: d,
      showOuterRadius: j,
      showOuterBorder: D,
      showOuterShadow: I,
      showOuterBackgroundColor: N,
      showImageRadius: x,
      topImageObjectFit: f,
      showDescription: L,
      showReadMore: p,
      showReadMoreText: h,
      contentClassName: w,
      wholeCardClickable: O,
      type: S
    } = at(e), Y = J(() => e.wholeCardClickable ? "a" : "div");
    return (H, B) => (y(), _e(Cl(Y.value), {
      id: t.id,
      href: T(d),
      class: P(["flex flex-col justify-start w-full h-full max-w-[480px]", { "rounded-md": T(j), "border border-gray-200": T(D), "shadow-md": T(I), "bg-white": T(N), "cursor-pointer": T(O) }])
    }, {
      default: Ta(() => [
        l("div", {
          class: "flex overflow-hidden justify-center w-full",
          style: R(`height: ${T(r)}px;  ` + (T(x) ? " border-top-left-radius: 0.375rem; border-top-right-radius: 0.375rem; " : " "))
        }, [
          b(Ce, {
            "image-name": T(n),
            "image-alt": T(g),
            style: R(`object-fit: ${T(f)}; object-position: center; height: ${T(r)};width: 100%;`),
            height: T(r),
            width: T(a)
          }, null, 8, ["image-name", "image-alt", "style", "height", "width"])
        ], 4),
        T(S) == "blog-author" ? (y(), A("div", {
          key: 0,
          class: P(`flex flex-1 flex-col justify-between p-4 w-full min-h-[215px] ${T(w) != "" ? T(w) : ""}`)
        }, [
          l("section", null, [
            l("div", {
              class: P(["tracking-normal", t.textSize])
            }, [
              l("span", wj, m(T(i)), 1)
            ], 2),
            l("div", Cj, [
              l("p", hj, m(T(M)), 1)
            ])
          ]),
          l("div", Oj, [
            b(Ce, {
              style: { "border-radius": "50%", width: "40px", height: "40px" },
              "image-name": T(s),
              "image-alt": T(u),
              width: "40",
              height: "40"
            }, null, 8, ["image-name", "image-alt"]),
            l("div", Ej, [
              l("span", Sj, [
                B[0] || (B[0] = G("Written by ")),
                l("span", { innerHTML: T(u) }, null, 8, kj)
              ]),
              l("span", vj, "Posted " + m(T(c)), 1)
            ])
          ])
        ], 2)) : (y(), A("div", {
          key: 1,
          class: P(`flex flex-1 flex-col justify-between p-4 w-full ${T(w) != "" ? T(w) : ""}`)
        }, [
          l("section", null, [
            l("div", {
              class: P(["tracking-normal", t.textSize])
            }, [
              l("span", bj, m(T(i)), 1)
            ], 2),
            T(L) ? (y(), A("div", Qj, [
              l("p", Uj, m(T(M)), 1)
            ])) : k("", !0)
          ]),
          T(p) ? (y(), A("div", Yj, [
            !T(O) || T(O) == "false" ? (y(), A("a", {
              key: 0,
              class: "text-subtitle1 text-primary cursor-pointer",
              href: T(d),
              target: "_blank"
            }, m(T(h) ? T(h) : "Read more"), 9, _j)) : (y(), A("span", Pj, m(T(h) ? T(h) : "Read more"), 1)),
            l("div", Rj, [
              b(ie, {
                icon: "arrow-right",
                "icon-color": T(o),
                width: "13",
                height: "13"
              }, null, 8, ["icon-color"])
            ])
          ])) : k("", !0)
        ], 2))
      ]),
      _: 1
    }, 8, ["id", "href", "class"]));
  }
}), Fj = { class: "flex flex-col w-full" }, Wj = {
  key: 0,
  class: "text-h2 text-dark-1 w-full text-left leading-relaxed pb-8 md:pb-8"
}, Bj = ["innerHTML"], Vj = {
  key: 0,
  class: "justify-center",
  style: { paddingTop: "", paddingBottom: "3rem" }
}, Gj = ["innerHTML"], bh = /* @__PURE__ */ ne({
  __name: "PageComponent",
  props: {
    title: {
      type: String
    },
    content: {
      type: String
    },
    backgroundColor: {
      type: String
    },
    aprComponent: {
      type: String
    },
    aprType: String
  },
  setup(t) {
    const e = t, i = C(e.title || ""), M = C(e.content || ""), n = C(e.backgroundColor || ""), a = C(e.aprComponent || "false"), r = C(null), o = C(null), s = J(() => window.innerWidth <= 768), u = J(() => a.value && a.value && s.value ? "text-body2" : "text-lg"), c = J(() => a.value && a.value == "true" ? window.APR_TEXT !== void 0 ? window.APR_TEXT[e.aprType] || window.APR_TEXT.default : e.aprType == "bad-credit-rate" ? "Rates from <b>9.9% APR</b>. Representative Example <b>23.9% APR</b>. Hire Purchase (HP) Example: Borrow <b>£10,000</b> over 5 years with a £0 deposit. Representative APR <b>23.9%</b> fixed rate. Monthly payment: <b>£274.05</b>. Total cost of credit: <b>£6,442.98</b>. Total amount repayable: <b>£16,442.98</b>." : e.aprType == "prime-rate" ? "Rates from <b>8.9%</b> APR. Representative Example <b>10.9%</b> APR. Personal Contract Purchase (PCP) Example: Car price <b>£27,500.00</b>, Term 4 years, Deposit <b>£2,750.00</b>, Total amount of credit <b>£24,750.00</b>, Representative APR <b>10.9%</b> fixed rate, Monthly payment <b>£392.47</b>, Total cost of credit <b>£8,291.09</b>, Total amount payable <b>£35,791.09</b>, Optional final payment <b>£14,595.00</b>, Annual mileage <b>8,000pa</b>." : e.aprType == "refinance-rate" ? "Rates from <b>9.9% APR</b>. Representative Example <b>15.9% APR</b>. Hire Purchase (HP) Example: Borrow <b>£11,500</b> over 5 years with a £0 deposit. Representative APR <b>15.9%</b> fixed rate. Monthly payment: <b>£272.66</b>. Total cost of credit: <b>£4,859.64</b>. Total amount repayable: <b>£16,359.64</b>. Car Finance 247 Limited is a credit broker not a lender." : e.aprType == "van-rate" ? "Rates from <b>9.9% APR</b>. Representative Example <b>15.9% APR</b>. Hire Purchase (HP) Example: Borrow <b>£10,000</b> over 5 years with a £0 deposit. Representative APR <b>15.9%</b> fixed rate. Monthly payment: <b>£237.10</b>. Total cost of credit: <b>£4,225.77</b>. Total amount repayable: <b>£14,225.77</b>. Car Finance 247 Limited is a credit broker not a lender." : e.aprType == "van-prime-rate" ? "Representative example: borrowing <b>£12,000</b> over 5 years with a representative APR of <b>13.9%</b>, an annual interest rate of <b>13.9%</b> (Fixed) and a deposit of <b>£0.00</b>, the amount payable would be <b>£273.56</b> per month, with a total cost of credit of <b>£4,413.89</b> and a total amount payable of <b>£16,413.89</b>." : e.aprType == "premiere-247-rate" ? "" : e.aprType == "caravan-rate" ? "Rates from <b>16.9%</b> APR. Representative Example <b>19.9%</b> APR. Hire Purchase (HP) Example: Borrow <b>£10,000</b> over 5 years with a £0 deposit. Representative APR <b>19.9%</b> fixed rate. Monthly payment: <b>£255.50</b>. Total cost of credit: <b>£5,329.80</b>. Total amount repayable: <b>£15,329.80</b>. Car Finance 247 Limited is a credit broker not a lender." : "Rates from <b>9.9%</b> APR. Representative Example <b>19.9%</b> APR. Hire Purchase (HP) Example: Borrow <b>£10,000</b> over 5 years with a £0 deposit. Representative APR <b>19.9%</b> fixed rate. Monthly payment: <b>£255.50</b>. Total cost of credit: <b>£5,329.80</b>. Total amount repayable: <b>£15,329.80</b>. Car Finance 247 Limited is a credit broker not a lender." : "");
    return we(() => {
      var d;
      const g = (d = r.value) == null ? void 0 : d.querySelectorAll("table");
      g && g.length && o.value && (o.value.style.overflowX = "auto");
    }), (g, d) => i.value || M.value ? (y(), A("div", {
      key: 0,
      ref_key: "pageComponent",
      ref: r,
      class: P(["flex flex-col justify-center items-center self-stretch page-component py-8 md:py-12 xs:px-4 xxs:px-4 xxxs:px-4", a.value == "true" ? "md:py-8" : ""]),
      style: R({ backgroundColor: n.value })
    }, [
      l("div", {
        class: P(["flex justify-center items-center w-full", a.value == "true" ? "max-w-screen-lg" : "max-w-screen-sm"])
      }, [
        l("section", {
          ref_key: "section",
          ref: o
        }, [
          l("div", Fj, [
            i.value ? (y(), A("div", Wj, [
              l("h2", null, m(i.value), 1)
            ])) : k("", !0),
            a.value == "true" ? (y(), A("p", {
              key: 1,
              "data-nosnippet": "",
              class: "max-w-screen-lg text-sm text-center",
              style: { "padding-top": "1rem" },
              innerHTML: c.value
            }, null, 8, Bj)) : (y(), A(ge, { key: 2 }, [
              M.value ? (y(), A("div", Vj, [
                l("div", {
                  class: P(["justify-center text-left leading-relaxed w-full max-md:text-lg", u.value]),
                  innerHTML: M.value
                }, null, 10, Gj)
              ])) : k("", !0)
            ], 64))
          ])
        ], 512)
      ], 2)
    ], 6)) : k("", !0);
  }
}), Zj = ["id"], $j = { class: "flex justify-center items-center px-16 py-2.5 mt-4 text-primary whitespace-nowrap" }, Jj = { class: "flex gap-1" }, Hj = ["href"], Qh = /* @__PURE__ */ ne({
  __name: "HelpandAdviceBox",
  props: {
    id: {
      type: String
    },
    title: {
      type: String
    },
    description: {
      type: String
    },
    textSize: {
      type: String
    },
    textColor: {
      type: String
    },
    numberofArticles: {
      type: String
    },
    link: {
      type: String
    }
  },
  setup(t) {
    const e = t, {
      title: i,
      description: M,
      textSize: n,
      textColor: a
    } = at(e);
    return (r, o) => (y(), A("div", {
      id: t.id,
      class: "flex flex-col justify-center self-stretch p-6 text-base font-bold text-center bg-white rounded-md border border-solid shadow-sm border-neutral-100 max-w-[376px] text-dark-1"
    }, [
      l("div", {
        class: P(["text-h5 tracking-tight", [T(a)]])
      }, m(T(i)), 3),
      l("div", {
        class: P(["text-body2 mt-1 leading-[137.5%]", [T(a), T(n)]])
      }, m(T(M)), 3),
      l("div", $j, [
        l("div", Jj, [
          l("a", {
            class: "text-subtitle1 cursor-pointer",
            href: t.link
          }, [
            l("div", null, m(t.numberofArticles), 1)
          ], 8, Hj)
        ])
      ])
    ], 8, Zj));
  }
}), Xj = ["id"], Kj = { class: "flex flex-col w-full" }, qj = ["innerHTML"], ey = ["innerHTML"], ty = { class: "my-auto text-2xl text-center whitespace-wrap" }, Uh = /* @__PURE__ */ ne({
  __name: "RowIcon",
  props: {
    id: {
      type: String
    },
    title: {
      type: String
    },
    description: {
      type: String
    },
    textSize: {
      type: String
    },
    textColor: {
      type: String
    },
    icon: {
      type: String
    },
    iconColor: {
      type: String
    }
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const i = e, M = () => {
      i("click");
    };
    return (n, a) => (y(), A("div", {
      id: t.id,
      class: P(["flex gap-6 py-2 cursor-pointer", [t.textColor]]),
      onClick: Pt(M, ["stop"])
    }, [
      l("div", Kj, [
        l("div", {
          class: P(["text-h6 font-bold tracking-normal w-full whitespace-wrap", t.textSize]),
          innerHTML: t.title
        }, null, 10, qj),
        l("div", {
          class: "text-body2 mt-1 leading-6 w-full description whitespace-wrap text-ellipsis",
          innerHTML: t.description
        }, null, 8, ey)
      ]),
      l("div", ty, [
        b(ie, {
          icon: t.icon,
          "icon-color": t.iconColor || void 0,
          width: "24",
          height: "24"
        }, null, 8, ["icon", "icon-color"])
      ])
    ], 10, Xj));
  }
}), iy = ["id"], My = ["placeholder"], ny = /* @__PURE__ */ ne({
  __name: "SearchBar",
  props: {
    id: {
      type: String
    },
    description: {
      type: String
    },
    icon: {
      type: String
    },
    iconColor: {
      type: String
    },
    textColor: {
      type: String
    }
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const i = e, M = C(""), n = (a) => {
      a.preventDefault(), i("click", M.value);
    };
    return (a, r) => (y(), A("form", {
      id: t.id,
      class: P(["flex gap-2 justify-between items-center px-4 py-3 bg-white rounded-md shadow-md search-wrapper", t.textColor]),
      onSubmit: Pt(n, ["stop"])
    }, [
      ht(l("input", {
        id: "search-bar",
        "onUpdate:modelValue": r[0] || (r[0] = (o) => M.value = o),
        type: "text",
        class: "w-full text-body1 text-left text-base leading-6",
        style: { "padding-left": "0px", "text-transform": "none" },
        placeholder: t.description,
        "aria-label": "Search"
      }, null, 8, My), [
        [vM, M.value]
      ]),
      l("button", {
        class: "cursor-pointer",
        type: "submit",
        onClick: Pt(n, ["stop"])
      }, [
        b(ie, {
          icon: t.icon,
          "icon-color": t.iconColor || void 0,
          width: "32",
          height: "32"
        }, null, 8, ["icon", "icon-color"])
      ])
    ], 42, iy));
  }
}), Yh = /* @__PURE__ */ fe(ny, [["__scopeId", "data-v-dbcedec0"]]), ay = ["id"], ry = { class: "flex justify-center items-center w-full max-md:px-5 max-md:max-w-full" }, ly = {
  key: 0,
  class: "text-h1 max-md:max-w-full"
}, oy = {
  key: 1,
  class: "text-h2 mt-6 max-md:max-w-full"
}, _h = /* @__PURE__ */ ne({
  __name: "SolidHeader",
  props: {
    id: {
      type: String
    },
    title: {
      type: String
    },
    description: {
      type: String
    },
    textSize: {
      type: String
    },
    textColor: {
      type: String
    },
    backgroundColor: {
      type: String
    }
  },
  setup(t) {
    const e = t;
    return (i, M) => (y(), A("div", {
      id: t.id,
      class: P([e.backgroundColor, "flex flex-col justify-center py-12 text-center"])
    }, [
      l("div", ry, [
        l("div", {
          class: P(["flex flex-col max-w-full w-[776px]", t.textColor])
        }, [
          t.title ? (y(), A("h1", ly, m(t.title), 1)) : k("", !0),
          t.description ? (y(), A("h2", oy, m(t.description), 1)) : k("", !0)
        ], 2)
      ])
    ], 10, ay));
  }
}), sy = ["id"], uy = { class: "text-base mt-1 leading-6" }, cy = ["href"], gy = { class: "flex justify-center items-center px-px py-0.5 my-auto text-lg" }, Ny = ["href"], Iy = { class: "flex justify-center items-center p-0.5 my-auto text-lg whitespace-nowrap" }, Dy = ["href"], dy = { class: "flex justify-center items-center p-0.5 my-auto text-lg whitespace-nowrap" }, Ph = /* @__PURE__ */ ne({
  __name: "ContactCard",
  props: {
    id: {
      type: String
    },
    title: {
      type: String
    },
    description: {
      type: String
    },
    textSize: {
      type: String
    },
    textColor: {
      type: String
    },
    iconColor: {
      type: String
    },
    contactEmail: {
      type: String
    },
    contactPhone: {
      type: String
    },
    contactLink: {
      type: String
    }
  },
  setup(t) {
    return (e, i) => (y(), A("div", {
      id: t.id,
      class: "flex flex-col h-full p-6 text-center bg-white rounded-md border border-solid shadow-sm border-zinc-100 min-h-[170px] md:px-4"
    }, [
      l("div", {
        class: P(["text-h4 font-bold tracking-tight", [t.textSize, t.textColor]])
      }, m(t.title), 3),
      l("div", uy, m(t.description), 1),
      t.contactLink ? (y(), A("a", {
        key: 0,
        class: "flex gap-2 justify-center items-center px-14 py-2.5 mt-4 whitespace-nowrap cursor-pointer",
        href: t.contactLink
      }, [
        l("div", gy, [
          b(ie, {
            icon: "arrow-right",
            "icon-color": t.iconColor,
            width: "16",
            height: "13"
          }, null, 8, ["icon-color"])
        ]),
        l("div", {
          class: P(["text-base font-bold", `text-${t.iconColor}`])
        }, " Customer Care Form ", 2)
      ], 8, cy)) : k("", !0),
      t.contactEmail ? (y(), A("a", {
        key: 1,
        class: "flex gap-2 justify-center items-center py-2.5 cursor-pointer",
        href: `mailto:${t.contactEmail}`
      }, [
        l("div", Iy, [
          b(ie, {
            icon: "email",
            "icon-color": t.iconColor,
            width: "16",
            height: "13"
          }, null, 8, ["icon-color"])
        ]),
        l("div", {
          class: P(["text-base font-bold", `text-${t.iconColor}`])
        }, m(t.contactEmail), 3)
      ], 8, Ny)) : k("", !0),
      t.contactPhone ? (y(), A("a", {
        key: 2,
        class: "flex gap-2 justify-center items-center py-2.5 cursor-pointer",
        href: `tel:${t.contactPhone}`
      }, [
        l("div", dy, [
          b(ie, {
            icon: "phone",
            "icon-color": t.iconColor,
            width: "15",
            height: "14"
          }, null, 8, ["icon-color"])
        ]),
        l("div", {
          class: P(["text-base font-bold", `text-${t.iconColor}`])
        }, m(t.contactPhone), 3)
      ], 8, Dy)) : k("", !0)
    ], 8, sy));
  }
}), jy = { key: 0 }, yy = ["id"], Ay = { class: "text-subtitle1" }, Ty = { class: "flex gap-1 mt-1 tracking-normal" }, xy = ["innerHTML"], zy = { key: 1 }, fy = ["id"], my = {
  class: "text-subtitle1",
  style: { "line-height": "1.3" }
}, Ly = { class: "flex flex-col gap-1 tracking-normal mt-1" }, py = {
  key: 0,
  class: "text-caption"
}, wy = ["innerHTML"], Cy = {
  key: 1,
  class: "leading-[133%] text-caption"
}, hy = { key: 2 }, Oy = ["id"], Ey = { class: "text-caption-link" }, Sy = { class: "flex gap-1 tracking-normal" }, ky = ["innerHTML"], vy = { key: 3 }, by = ["id"], Qy = { class: "flex justify-start items-start w-full max-md:px-5 max-md:max-w-full sm:px-0 xs:px-0 xxs:px-0" }, Uy = {
  key: 0,
  class: "flex pb-2 items-start max-w-[975px] max-md:max-w-full md:pb-1 sm:pb-1"
}, Yy = {
  key: 1,
  class: "flex pb-4 items-start max-w-[975px] max-md:max-w-full md:pb-1 sm:pb-1"
}, _y = { class: "flex items-center max-w-[975px] max-md:max-w-full lg:mt-6 md:mt-6" }, Py = { class: "text-caption font-bold flex place-content-between w-full" }, Ry = { class: "leading-[133%] text-caption" }, Fy = { key: 4 }, Wy = { class: "flex flex-col rounded-md md:flex-row overflow-hidden justify-between items-center bg-white shadow-md" }, By = { class: "w-full md:w-1/2 flex-shrink-0 self-stretch" }, Vy = { class: "flex flex-col w-full md:w-1/2 flex-shrink-0 justify-center p-6 md:px-6" }, Gy = { class: "leading-9" }, Zy = ["innerHTML"], $y = ["href"], qe = /* @__PURE__ */ ne({
  name: "ImageTextComponent",
  __name: "ImageText",
  props: {
    id: String,
    type: String,
    title: String,
    description: String,
    image: String,
    imageAlt: String,
    width: String,
    height: String,
    textSize: String,
    textColor: String,
    backgroundColor: String,
    quote: String,
    starImage: String,
    url: String,
    authorName: String,
    blogDate: String,
    trustpilotLink: String,
    objectFit: String
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const i = e, M = t, n = J(() => M.image && typeof M.image == "string" ? M.image.replace(
      "https://prod-carfinance247.dotcmscloud.com",
      "https://carfinance-prod-2310.dotcms.cloud"
    ) : M.image), a = () => {
      if (M.trustpilotLink)
        return window.open(M.trustpilotLink, "_blank");
      i("click");
    }, {
      title: r,
      description: o,
      width: s,
      height: u,
      image: c,
      textSize: g,
      textColor: d,
      type: j,
      backgroundColor: D,
      objectFit: I
    } = at(M);
    return (N, x) => (y(), A(ge, null, [
      T(j) === "default" ? (y(), A("div", jy, [
        l("div", {
          id: t.id,
          class: "flex justify-center items-center"
        }, [
          b(Ce, {
            "image-name": n.value,
            "image-alt": t.imageAlt,
            width: T(s),
            height: T(u),
            objectFit: T(I)
          }, null, 8, ["image-name", "image-alt", "width", "height", "objectFit"]),
          l("div", {
            class: P(["flex flex-col flex-1 px-5 py-2", [T(g), T(d)]])
          }, [
            l("div", Ay, m(T(r)), 1),
            l("div", Ty, [
              l("div", {
                class: "leading-[133%]",
                innerHTML: T(o)
              }, null, 8, xy)
            ])
          ], 2)
        ], 8, yy)
      ])) : k("", !0),
      T(j) === "blog-author" ? (y(), A("div", zy, [
        l("div", {
          id: t.id,
          class: "flex justify-center items-start"
        }, [
          b(Ce, {
            class: "rounded-md",
            "image-name": n.value,
            "image-alt": t.imageAlt,
            width: T(s),
            height: T(u),
            objectFit: T(I)
          }, null, 8, ["image-name", "image-alt", "width", "height", "objectFit"]),
          l("div", {
            class: P(["flex flex-col flex-1 px-4", [T(g), T(d)]])
          }, [
            l("div", my, m(T(r)), 1),
            l("div", Ly, [
              t.authorName && t.authorName != "" ? (y(), A("span", py, [
                x[0] || (x[0] = G("Written by ")),
                l("span", { innerHTML: t.authorName }, null, 8, wy)
              ])) : k("", !0),
              t.blogDate && t.blogDate != "" ? (y(), A("span", Cy, m(t.blogDate), 1)) : k("", !0)
            ])
          ], 2)
        ], 8, fy)
      ])) : k("", !0),
      T(j) === "page-review" ? (y(), A("div", hy, [
        l("div", {
          id: t.id,
          class: "flex justify-center items-center"
        }, [
          b(Ce, {
            class: "rounded-full",
            "image-name": n.value,
            "image-alt": t.imageAlt,
            width: T(s),
            height: T(u),
            objectFit: T(I)
          }, null, 8, ["image-name", "image-alt", "width", "height", "objectFit"]),
          l("div", {
            class: P(["flex flex-col flex-1 px-4 py-2", [T(g), T(d)]])
          }, [
            l("div", null, [
              x[1] || (x[1] = l("span", { class: "text-caption" }, "Page last reviewed by ", -1)),
              l("span", Ey, m(T(r)), 1)
            ]),
            l("div", Sy, [
              x[2] || (x[2] = l("span", { class: "leading-[133%] text-caption" }, "Posted ", -1)),
              l("span", {
                class: "leading-[133%] text-caption",
                innerHTML: T(o)
              }, null, 8, ky)
            ])
          ], 2)
        ], 8, Oy)
      ])) : k("", !0),
      T(j) === "trustpilot" ? (y(), A("div", vy, [
        l("div", {
          id: t.id,
          class: "flex flex-col justify-start self-stretch"
        }, [
          l("div", Qy, [
            l("div", {
              class: "flex flex-col max-w-full w-[975px]",
              style: R({ backgroundColor: T(D) })
            }, [
              t.starImage && t.starImage != "" ? (y(), A("div", Uy, [
                b(ie, {
                  id: "stars-image-text",
                  style: { height: "20px", width: "107px" },
                  icon: "trustpilot-stars",
                  "icon-color": "white",
                  width: "107",
                  height: "20"
                })
              ])) : k("", !0),
              t.quote !== void 0 ? (y(), A("div", Yy, [
                l("q", {
                  class: P(["text-h6 mt-2", [T(d)]]),
                  style: { "text-align": "left" }
                }, m(t.quote), 3)
              ])) : k("", !0),
              l("div", _y, [
                T(c) ? (y(), _e(Ce, {
                  key: 0,
                  class: "w-10 h-10 rounded-full",
                  "image-name": n.value,
                  "image-alt": t.imageAlt,
                  width: T(s),
                  height: T(u),
                  objectFit: T(I)
                }, null, 8, ["image-name", "image-alt", "width", "height", "objectFit"])) : k("", !0),
                l("div", {
                  class: P([[T(d), { "ml-3": T(c) }], "flex flex-col items-start w-full"])
                }, [
                  l("span", Py, [
                    G(m(T(r)) + " ", 1),
                    t.starImage && t.starImage.length > 0 ? (y(), A("div", {
                      key: 0,
                      class: "cursor-pointer",
                      onClick: a
                    }, [
                      b(ie, {
                        id: "trustpilot-dark",
                        icon: "trustpilot-dark-logo",
                        width: "80",
                        height: "19.67"
                      })
                    ])) : k("", !0)
                  ]),
                  l("span", Ry, m(T(o)), 1)
                ], 2)
              ])
            ], 4)
          ])
        ], 8, by)
      ])) : k("", !0),
      T(j) === "feature-article" ? (y(), A("div", Fy, [
        l("div", Wy, [
          l("div", By, [
            b(Ce, {
              "image-name": T(c),
              "image-alt": t.imageAlt,
              width: T(s),
              height: T(u),
              class: "object-cover w-full h-full",
              objectFit: T(I)
            }, null, 8, ["image-name", "image-alt", "width", "height", "objectFit"])
          ]),
          l("section", Vy, [
            l("div", {
              class: P(["flex flex-col w-full", [T(d)]])
            }, [
              l("div", Gy, [
                l("h2", {
                  class: P([T(g)])
                }, m(T(r)), 3)
              ]),
              l("p", {
                class: "mt-2 text-body1 leading-[133%]",
                innerHTML: T(o)
              }, null, 8, Zy)
            ], 2),
            l("a", {
              href: t.url,
              class: "flex gap-2 items-center lg:mt-6 mt-2 w-full text-center"
            }, [
              x[3] || (x[3] = l("span", { class: "self-stretch my-auto text-subtitle1 text-primary" }, "About us", -1)),
              b(ie, {
                icon: "arrow-right",
                "icon-color": "primary",
                width: "13",
                height: "13"
              })
            ], 8, $y)
          ])
        ])
      ])) : k("", !0)
    ], 64));
  }
}), Jy = { class: "background" }, Hy = { class: "flex flex-col text-center items-center max-w-full" }, Xy = { class: "text-h1 text-white sm:mt-4 mt-8 pt-8" }, Ky = {
  key: 0,
  class: "flex flex-wrap justify-center my-2 max-w-screen-lg md:gap-2"
}, qy = ["innerHTML"], e4 = { class: "text-h6 self-stretch text-white text-center max-md:max-w-full" }, t4 = {
  key: 0,
  class: "justify-center items-center mt-2 max-w-full"
}, i4 = {
  key: 1,
  class: "flex gap-2 justify-center self-center px-6 py-2 mt-2 text-l grounded-md max-md:px-5 cursor-pointer"
}, M4 = {
  key: 2,
  class: "justify-center py-2 max-w-full text-center text-white w-[350px]"
}, n4 = ["innerHTML"], a4 = {
  key: 3,
  class: "flex flex-col items-center mt-5"
}, r4 = {
  key: 0,
  class: "flex justify-center max-w-full absolute w-full",
  style: { bottom: "-80px" }
}, l4 = {
  key: 0,
  style: { width: "354px", "z-index": "5" }
}, o4 = {
  key: 1,
  style: { width: "354px", "z-index": "5" },
  class: "flex flex-col items-center"
}, s4 = /* @__PURE__ */ ne({
  __name: "GenericButtonBanner",
  props: {
    header: {
      type: String
    },
    subHeader: {
      type: String,
      default: "Apply with us today"
    },
    showTickMessage: {
      type: [Boolean, String]
    },
    tickItem1: String,
    tickItem2: String,
    tickItem3: String,
    wrapperClass: {
      type: String
    },
    footerText: {
      type: String
    },
    btnText: {
      type: String
    },
    showButton: {
      type: [Boolean, String]
    },
    showFooterText: {
      type: [Boolean, String]
    },
    showTrustPilotWidget: {
      type: [Boolean, String]
    },
    buttonLink: {
      type: String
    },
    paddingBottom: {
      type: String
    },
    showCarImage: {
      type: [Boolean, String]
    },
    imaginMake: {
      type: String
    },
    imaginModelFamily: {
      type: String
    },
    imaginModelTrim: {
      type: String
    },
    imaginModelRange: {
      type: String
    },
    imaginModelYear: {
      type: String
    },
    imaginModelPowerTrain: {
      type: String
    },
    imaginModelDoors: {
      type: String
    },
    imaginAngle: {
      type: String
    },
    imaginPaintId: {
      type: String
    },
    imaginWidth: {
      type: String
    },
    imaginPosition: {
      type: String
    },
    overrideCurrentImage: {
      type: String
    },
    carImage: {
      type: String
    },
    carImageAlt: {
      type: String
    },
    carImageWidth: {
      type: String
    },
    carImageHeight: {
      type: String
    },
    aprType: String,
    showInput: {
      type: [Boolean, String],
      default: !1
    },
    inputType: {
      type: String,
      default: "number"
    },
    placeholder: {
      type: String
    },
    showPoundSign: {
      type: [Boolean, String],
      default: !0
    }
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const i = t, {
      header: M,
      wrapperClass: n,
      imaginMake: a,
      imaginModelFamily: r,
      imaginAngle: o,
      imaginPaintId: s,
      imaginWidth: u,
      imaginModelDoors: c,
      imaginModelTrim: g,
      imaginPosition: d,
      overrideCurrentImage: j,
      carImage: D,
      carImageWidth: I,
      carImageHeight: N,
      imaginModelPowerTrain: x
    } = at(i), f = J(() => [i.tickItem1, i.tickItem2, i.tickItem3].filter((q) => q && q.trim() !== "")), L = J(() => i.showButton == !0 || i.showButton == "true"), p = C(""), h = J(() => i.placeholder || "Enter input"), w = J(() => i.showInput == !0 || i.showInput == "true"), O = J(() => i.showPoundSign == !0 || i.showPoundSign == "true"), S = J(() => i.showFooterText == !0 || i.showFooterText == "true"), Y = J(() => i.showTrustPilotWidget == !0 || i.showTrustPilotWidget == "true"), H = J(() => i.showTickMessage == !0 || i.showTickMessage == "true"), B = J(() => i.showCarImage == !0 || i.showCarImage == "true"), ae = J(() => {
      var le;
      if (!i.aprType || i.aprType === "none")
        return (le = i.footerText) == null ? void 0 : le.replace(/<br\/?>/gi, "");
      if (window.APR_RATES !== void 0) {
        const Me = window.APR_RATES[i.aprType] || window.APR_RATES.default;
        return `Rates from ${Me.from}% APR. Representative ${Me.representative}% APR.<br>Car Finance 247 Limited is a credit broker, not a lender.`;
      }
      const q = Bi[i.aprType] || Bi.default;
      return `Rates from ${q.from}% APR. Representative APR ${q.representative}%.<br>Car Finance 247 Limited is a credit broker, not a lender.`;
    }), te = () => {
      let q = i.buttonLink || "";
      /\{\{value\}\}/.test(q) && (p.value = p.value.replace(/\s+/g, ""), q = q.replace(/\{\{value\}\}/g, p.value.trim())), window.open(q, "_self");
    };
    return (q, le) => (y(), A("div", {
      class: P(T(n))
    }, [
      l("div", Jy, [
        le[1] || (le[1] = l("div", { class: "small-circle" }, null, -1)),
        le[2] || (le[2] = l("div", { class: "medium-circle" }, null, -1)),
        l("main", {
          class: "flex flex-col items-center self-stretch px-16 max-md:px-5 top-0 left-0 w-full pt-20 relative z-20",
          style: R([{ paddingBottom: t.paddingBottom || "80px" }])
        }, [
          l("section", Hy, [
            l("header", null, [
              l("h1", Xy, m(T(M)), 1),
              H.value && f.value.length ? (y(), A("ul", Ky, [
                (y(!0), A(ge, null, ye(f.value, (Me, oe) => (y(), A("li", {
                  key: oe,
                  class: "flex gap-2 py-0.5 px-2 max-md:py-2"
                }, [
                  b(ie, {
                    icon: "tick-circle",
                    stroke: "black",
                    width: "20",
                    height: "20",
                    "icon-color": "secondary"
                  }),
                  l("span", {
                    class: "text-body1 text-white text-left tick-item",
                    innerHTML: Me
                  }, null, 8, qy)
                ]))), 128))
              ])) : k("", !0),
              l("p", e4, m(t.subHeader), 1)
            ]),
            w.value ? (y(), A("div", t4, [
              b(Ba, {
                id: "monthly-budget",
                value: p.value,
                "onUpdate:value": le[0] || (le[0] = (Me) => p.value = Me),
                type: t.inputType,
                class: "responsive-width",
                height: "4rem",
                "background-color": "bg-white",
                placeholder: h.value,
                "show-pound-sign": O.value,
                currency: "£",
                "aria-label": "Enter your monthly budget",
                icon: "pound",
                max: 15,
                width: "330px"
              }, null, 8, ["value", "type", "placeholder", "show-pound-sign"])
            ])) : k("", !0),
            L.value ? (y(), A("div", i4, [
              b(Ke, {
                "text-size": "text-button-large",
                "text-color": "text-dark-1",
                label: t.btnText,
                "icon-after": !0,
                color: "bg-secondary",
                "hover-color": "bg-secondary hover:brightness-110",
                width: "330px",
                height: "65px",
                "icon-color": "dark-1",
                "show-button-sub-text": !0,
                "aria-label": t.btnText,
                onClick: te
              }, null, 8, ["label", "aria-label"])
            ])) : k("", !0),
            S.value ? (y(), A("div", M4, [
              l("span", {
                "data-nosnippet": "",
                class: "text-body2 text-white",
                innerHTML: ae.value
              }, null, 8, n4)
            ])) : k("", !0),
            Y.value ? (y(), A("div", a4, [
              b(rn, { widget: "mini-carousel" })
            ])) : k("", !0)
          ])
        ], 4)
      ]),
      B.value ? (y(), A("div", r4, [
        T(j) == "true" ? (y(), A("div", l4, [
          b(oM, {
            make: T(a),
            "model-family": T(r),
            "model-range": t.imaginModelRange,
            "model-year": t.imaginModelYear,
            "model-trim": T(g),
            "model-power-train": T(x),
            "model-doors": T(c),
            angle: T(o),
            "paint-id": T(s),
            width: T(u),
            position: T(d),
            height: "221px"
          }, null, 8, ["make", "model-family", "model-range", "model-year", "model-trim", "model-power-train", "model-doors", "angle", "paint-id", "width", "position"])
        ])) : (y(), A("div", o4, [
          b(Ce, {
            "image-name": T(D),
            "image-alt": t.carImageAlt,
            width: T(I),
            height: T(N)
          }, null, 8, ["image-name", "image-alt", "width", "height"])
        ]))
      ])) : k("", !0)
    ], 2));
  }
}), Rh = /* @__PURE__ */ fe(s4, [["__scopeId", "data-v-3ba38c5f"]]), u4 = {
  id: "how-it-works-container",
  class: "justify-center w-full"
}, c4 = { class: "flex overflow-hidden flex-col gap-8 justify-center items-center self-stretch px-4 py-8 text-center bg-white sm:py-12" }, g4 = { class: "flex flex-col justify-center text-center" }, N4 = {
  key: 0,
  class: "flex flex-col text-center w-full max-md:max-w-full"
}, I4 = { class: "text-h2 leading-none max-md:max-w-full" }, D4 = {
  key: 0,
  class: "text-h6 mt-2 tracking-normal max-md:max-w-full"
}, d4 = { class: "grid grid-cols-1 md:grid-cols-1 lg:grid-cols-3 w-full flex-wrap gap-6 max-w-screen-full xs:max-w-screen-xs md:max-w-screen-md lg:max-w-screen-lg max-md:max-w-full" }, j4 = { class: "flex flex-col md:flex-row lg:flex-col items-center gap-4 gap-x-6" }, y4 = { class: "flex flex-col w-full md:w-1/2 lg:w-full" }, A4 = { class: "gap-2 self-start px-3 py-0.5 text-sm text-white bg-primary rounded-full font-bold" }, T4 = { class: "mt-1 text-h6 text-left" }, x4 = { class: "text-body1 leading-6 text-left" }, Fh = /* @__PURE__ */ ne({
  __name: "HowItWorks",
  props: {
    title: { type: String },
    subTitle: { type: String },
    buttonTitle: { type: String },
    buttonUrl: { type: String },
    step1Image: { type: String },
    step1Title: { type: String },
    step1Description: { type: String },
    step2Image: { type: String },
    step2Title: { type: String },
    step2Description: { type: String },
    step3Image: { type: String },
    step3Title: { type: String },
    step3Description: { type: String },
    buttonSocialUrl: {
      type: String,
      default: "https://social.carfinance247.co.uk/"
    },
    checkIsSocialPage: {
      type: String,
      default: "false"
    }
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const i = t, M = J(() => [
      {
        id: "step1",
        friendlyName: "Step 1",
        title: i.step1Title,
        description: i.step1Description,
        image: i.step1Image
      },
      {
        id: "step2",
        friendlyName: "Step 2",
        title: i.step2Title,
        description: i.step2Description,
        image: i.step2Image
      },
      {
        id: "step3",
        friendlyName: "Step 3",
        title: i.step3Title,
        description: i.step3Description,
        image: i.step3Image
      }
    ]), n = e, a = C(window.innerWidth), r = () => {
      a.value = window.innerWidth;
    };
    we(() => {
      window.addEventListener("resize", r);
    }), _t(() => {
      window.removeEventListener("resize", r);
    });
    const o = J(() => a.value >= 1024 ? "312" : a.value >= 768 ? "333" : "451.2"), s = () => {
      i.buttonUrl ? i.checkIsSocialPage && i.checkIsSocialPage == "true" && La() ? window.open(i.buttonSocialUrl, "_self") : window.open(i.buttonUrl, "_self") : n("click");
    };
    return (u, c) => (y(), A("div", u4, [
      l("section", null, [
        l("div", c4, [
          l("div", g4, [
            i.title ? (y(), A("header", N4, [
              l("h2", I4, m(i.title), 1),
              i.subTitle ? (y(), A("h3", D4, m(i.subTitle), 1)) : k("", !0)
            ])) : k("", !0),
            i.buttonTitle ? (y(), _e(Ke, {
              key: 1,
              class: "justify-center items-center self-center mt-4",
              color: "bg-secondary",
              "text-size": "text-button-large",
              "text-color": "text-dark-1",
              label: t.buttonTitle,
              "icon-after": !0,
              width: "168px",
              height: "44px",
              "icon-color": "dark-1",
              "aria-label": t.buttonTitle,
              onClick: s
            }, null, 8, ["label", "aria-label"])) : k("", !0)
          ]),
          l("div", d4, [
            (y(!0), A(ge, null, ye(M.value, (g, d) => (y(), A("div", {
              key: d,
              class: "flex flex-col w-full md:mt-2"
            }, [
              l("div", j4, [
                b(Ce, {
                  "image-name": g.image,
                  width: o.value,
                  class: "object-contain w-full h-auto rounded-lg md:w-1/2 lg:w-full"
                }, null, 8, ["image-name", "width"]),
                l("div", y4, [
                  l("span", A4, m(g.friendlyName), 1),
                  l("span", T4, m(g.title), 1),
                  l("span", x4, m(g.description), 1)
                ])
              ])
            ]))), 128))
          ])
        ])
      ])
    ]));
  }
}), z4 = { class: "relative" }, f4 = ["href"], m4 = { class: "max-w-screen-lg w-full" }, L4 = ["src"], p4 = { key: 0 }, w4 = { class: "text-h2 text-center py-12" }, C4 = ["onClick"], h4 = { class: "absolute inset-0 flex items-center justify-center" }, O4 = {
  class: "h-20 w-20 text-white z-20 transition-opacity duration-200 hover:opacity-50",
  "aria-label": "Play video"
}, E4 = { class: "flex flex-col justify-end absolute bottom-0 left-0 right-0 p-6 w-full z-20 pointer-events-none" }, S4 = { class: "flex flex-col gap-1 text-white" }, k4 = { class: "text-subtitle2" }, v4 = { class: "text-body2" }, b4 = {
  key: 0,
  class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
}, Q4 = { class: "max-w-3xl w-full relative rounded-xl" }, U4 = { class: "absolute top-4 right-4 flex justify-center items-center bg-white rounded-full p-3" }, Y4 = ["src"], _4 = /* @__PURE__ */ ne({
  name: "VideoComponent",
  __name: "Video",
  props: {
    title: {
      type: String
    },
    videoUrl: {
      type: String,
      required: !0
    },
    thumbnailImage: {
      type: String
    },
    type: {
      type: String
    },
    backgroundColor: {
      type: String
    },
    aspectRatio: {
      type: String,
      default: "16/9"
    },
    videos: {
      type: String,
      default: "[]"
    },
    autoplay: {
      type: Boolean,
      default: !1
    },
    muted: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, i = C([]);
    try {
      i.value = JSON.parse(e.videos);
    } catch (j) {
      console.error("Error parsing videos prop:", j);
    }
    C(null);
    const M = C(!1), n = C(!1), a = C(""), r = C(!1), o = J(() => {
      let j = "";
      return e.videoUrl.includes("watch?v=") ? j = e.videoUrl.split("v=")[1].split("&")[0] : e.videoUrl.includes("youtu.be/") ? j = e.videoUrl.split("youtu.be/")[1].split("?")[0] : e.videoUrl.includes("/embed/") && (j = e.videoUrl.split("/embed/")[1].split("?")[0]), j ? `https://www.youtube.com/embed/${j}` : e.videoUrl;
    }), s = () => e.type === "inline" ? "?enablejsapi=1&autoplay=1&mute=1" : "";
    we(() => {
      u(), window.addEventListener("resize", u);
    }), _t(() => {
      window.removeEventListener("resize", u);
    });
    function u() {
      r.value = window.innerWidth < 768;
    }
    const c = () => {
      let j = "";
      if (e.videoUrl.includes("watch?v=") ? j = e.videoUrl.split("v=")[1].split("&")[0] : e.videoUrl.includes("youtu.be/") ? j = e.videoUrl.split("youtu.be/")[1].split("?")[0] : e.videoUrl.includes("/embed/") && (j = e.videoUrl.split("/embed/")[1].split("?")[0]), j) {
        const D = document.getElementById("youtube-lightbox");
        D instanceof HTMLElement && (D.style.display = "block");
        const I = document.getElementById("youtube-area-desktop");
        if (I && window.getComputedStyle(I, null).display == "flex") {
          const N = document.querySelector("#youtube-area-desktop iframe");
          N && (N.src = `https://www.youtube.com/embed/${j}?autoplay=1&rel=0`);
        } else {
          const N = document.querySelector("#youtube-area-mobile iframe");
          N && (window.matchMedia("(orientation: landscape)").matches ? (N.style.width = "70%", N.style.height = "70%") : (N.style.width = "100%", N.style.height = "30%"), N.src = `https://www.youtube.com/embed/${j}?autoplay=1&rel=0`);
          const x = window;
          x.videoOrientation && clearInterval(x.videoOrientation), x.videoOrientation = setInterval(() => {
            N && (window.matchMedia("(orientation: landscape)").matches ? (N.style.width = "70%", N.style.height = "70%") : (N.style.width = "100%", N.style.height = "30%"));
          }, 400);
        }
      }
    }, g = (j) => {
      let D = "";
      j.includes("watch?v=") ? D = j.split("v=")[1].split("&")[0] : j.includes("youtu.be/") ? D = j.split("youtu.be/")[1].split("?")[0] : j.includes("/embed/") && (D = j.split("/embed/")[1].split("?")[0]), D && (a.value = D, n.value = !0);
    }, d = () => {
      n.value = !1, a.value = "";
    };
    return _t(() => {
    }), (j, D) => (y(), A("div", z4, [
      t.type == "popup" ? (y(), A("div", {
        key: 0,
        class: "absolute inset-0 flex items-center justify-center cursor-pointer bg-opacity-50 rounded-full",
        onClick: c
      }, [
        e.thumbnailImage ? (y(), _e(Ce, {
          key: 0,
          class: "absolute inset-0 w-full h-full object-cover rounded-lg z-10",
          "image-name": e.thumbnailImage,
          "image-alt": "Video Thumbnail",
          width: "100%",
          height: "100%"
        }, null, 8, ["image-name"])) : k("", !0),
        l("a", {
          href: e.videoUrl,
          class: "h-20 w-20 text-white z-20 transition-opacity duration-200 hover:opacity-50",
          "aria-label": "Play video",
          onClick: Pt(c, ["prevent"])
        }, [
          M.value ? k("", !0) : (y(), _e(ie, {
            key: 0,
            id: "play-btn",
            icon: "play",
            width: "80",
            height: "80"
          }))
        ], 8, f4),
        D[0] || (D[0] = l("div", { class: "absolute top-0 left-0 w-full h-1/6 bg-gradient-to-b from-[rgba(0,0,0,0.5)] to-transparent rounded-t-lg z-20" }, null, -1)),
        D[1] || (D[1] = l("div", { class: "absolute bottom-0 left-0 w-full h-1/6 bg-gradient-to-t from-[rgba(0,0,0,0.5)] to-transparent rounded-b-lg z-20" }, null, -1))
      ])) : t.type == "inline" ? (y(), A("div", {
        key: 1,
        class: "w-full h-full py-8 px-4 lg:px-0 max-md:p-4 flex justify-center",
        style: R({ backgroundColor: t.backgroundColor })
      }, [
        l("div", m4, [
          l("iframe", {
            width: "100%",
            src: `${o.value}${s()}`,
            style: R({ "aspect-ratio": t.aspectRatio }),
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
            allowfullscreen: "",
            frameborder: "0",
            loading: "lazy",
            autoplay: !0
          }, null, 12, L4)
        ])
      ], 4)) : t.type === "popup-multiple" ? (y(), A(ge, { key: 2 }, [
        l("div", {
          class: "flex flex-col justify-center items-center max-md:px-4",
          style: R({ backgroundColor: t.backgroundColor })
        }, [
          t.title ? (y(), A("div", p4, [
            l("h2", w4, m(t.title), 1)
          ])) : k("", !0),
          l("div", {
            class: P([{ "overflow-x-auto": r.value }, "w-full lg:px-0"])
          }, [
            l("div", {
              class: P([
                r.value ? "flex space-x-4 pb-4 max-md:px-2" : "grid grid-cols-3 gap-6",
                "max-w-screen-lg mx-auto pb-12"
              ])
            }, [
              (y(!0), A(ge, null, ye(i.value, (I, N) => (y(), A("div", {
                key: N,
                class: P(["relative cursor-pointer h-[485px]", { "flex-shrink-0": r.value }]),
                style: { "aspect-ratio": "5/8" },
                onClick: (x) => g(I.url)
              }, [
                I.thumbnail ? (y(), _e(Ce, {
                  key: 0,
                  "image-name": I.thumbnail,
                  "image-alt": I.title,
                  width: "312px",
                  class: "w-full h-full object-cover rounded-lg"
                }, null, 8, ["image-name", "image-alt"])) : k("", !0),
                l("div", h4, [
                  l("div", O4, [
                    b(ie, {
                      id: "play-btn",
                      icon: "play",
                      width: "80",
                      height: "80"
                    })
                  ])
                ]),
                l("div", E4, [
                  l("div", S4, [
                    l("span", k4, m(I.title), 1),
                    l("span", v4, m(I.description), 1)
                  ])
                ])
              ], 10, C4))), 128))
            ], 2)
          ], 2)
        ], 4),
        n.value ? (y(), A("div", b4, [
          l("div", Q4, [
            l("div", U4, [
              l("button", {
                class: "close-btn",
                onClick: d
              }, [
                b(ie, {
                  id: "close-btn",
                  icon: "close",
                  "icon-color": "primary",
                  width: "24",
                  height: "24"
                })
              ])
            ]),
            l("iframe", {
              src: `https://www.youtube.com/embed/${a.value}?autoplay=1`,
              class: "w-full popup-video",
              style: { "aspect-ratio": "16/9" },
              allowfullscreen: ""
            }, null, 8, Y4)
          ])
        ])) : k("", !0)
      ], 64)) : k("", !0)
    ]));
  }
}), pi = /* @__PURE__ */ fe(_4, [["__scopeId", "data-v-ea5a6a33"]]), P4 = {
  id: "testimonials-container",
  class: "justify-center w-full"
}, R4 = { class: "flex overflow-hidden flex-col gap-8 justify-center items-center self-stretch px-4 py-8 md:py-12 text-center bg-white" }, F4 = { class: "flex flex-col justify-center text-center" }, W4 = {
  key: 0,
  class: "flex flex-col text-center w-full max-md:max-w-full"
}, B4 = { class: "text-h2 leading-none max-md:max-w-full md:mb-8" }, V4 = {
  key: 0,
  class: "text-h6 mt-2 tracking-normal max-md:max-w-full"
}, G4 = {
  id: "youtube-lightbox",
  class: "hidden target:block fixed inset-0 bg-black/75 overflow-auto",
  style: { "z-index": "99" }
}, Z4 = {
  key: 0,
  id: "youtube-area-desktop",
  class: "h-full flex items-center justify-center relative md:flex",
  style: { "margin-left": "10%", "margin-right": "10%" }
}, $4 = ["title"], J4 = {
  key: 1,
  id: "youtube-area-mobile",
  class: "h-full flex items-center justify-center relative",
  style: { "margin-left": "0%", "margin-right": "0%" }
}, H4 = ["title"], X4 = { class: "customer-testimonials-desktop hidden md:block" }, K4 = { class: "flex flex-col gap-6" }, q4 = { class: "lg:row-span-2" }, e0 = {
  key: 0,
  class: "flex overflow-hidden relative flex-col w-full rounded-lg aspect-[0.67] max-h-[485px]"
}, t0 = { class: "flex flex-col justify-end absolute bottom-0 left-0 right-0 p-6 w-full z-20 pointer-events-none" }, i0 = {
  key: 0,
  class: "flex flex-col gap-6 h-full"
}, M0 = { class: "flex flex-col justify-end p-6 flex-grow" }, n0 = { class: "flex flex-col gap-6" }, a0 = {
  key: 0,
  class: "flex flex-col gap-6 h-full"
}, r0 = { class: "flex flex-col justify-end p-6 flex-grow" }, l0 = { class: "lg:row-span-2" }, o0 = {
  key: 0,
  class: "flex overflow-hidden relative flex-col w-full rounded-lg aspect-[0.67] max-h-[485px]"
}, s0 = { class: "flex flex-col justify-end absolute bottom-0 left-0 right-0 p-6 w-full z-20 pointer-events-none" }, u0 = { class: "flex flex-col gap-6" }, c0 = { class: "lg:row-span-2" }, g0 = {
  key: 0,
  class: "flex overflow-hidden relative flex-col w-full rounded-lg aspect-[0.67] max-h-[485px]"
}, N0 = { class: "flex flex-col justify-end absolute bottom-0 left-0 right-0 p-6 w-full z-20 pointer-events-none" }, I0 = {
  key: 0,
  class: "flex flex-col gap-6 h-full hidden lg:block"
}, D0 = { class: "flex flex-col justify-end p-6 flex-grow" }, d0 = {
  key: 0,
  class: "flex flex-col gap-6 md:block lg:hidden"
}, j0 = { class: "h-full" }, y0 = { class: "flex flex-col justify-end p-6 flex-grow h-full" }, A0 = { class: "customer-testimonials-mobile block md:hidden" }, T0 = { key: 0 }, x0 = { class: "lg:row-span-2" }, z0 = { class: "flex overflow-hidden relative flex-col w-full rounded-lg aspect-[0.67] max-h-[485px]" }, f0 = { class: "flex flex-col justify-end absolute bottom-0 left-0 right-0 p-6 w-full z-20 pointer-events-none" }, m0 = {
  key: 0,
  class: "inline-block w-72",
  style: { "white-space": "normal", height: "420px" }
}, L0 = { class: "flex flex-col gap-6" }, p0 = { class: "flex flex-col justify-end absolute bottom-0 left-0 right-0 p-6 w-full z-20" }, w0 = { key: 0 }, C0 = { class: "lg:row-span-2" }, h0 = { class: "flex overflow-hidden relative flex-col w-full rounded-lg aspect-[0.67] max-h-[485px]" }, O0 = { class: "flex flex-col justify-end absolute bottom-0 left-0 right-0 p-6 w-full z-20 pointer-events-none" }, E0 = {
  key: 1,
  class: "inline-block w-72",
  style: { "white-space": "normal", height: "420px" }
}, S0 = { class: "flex flex-col gap-6" }, k0 = { class: "flex flex-col justify-end absolute bottom-0 left-0 right-0 p-6 w-full z-20" }, v0 = { key: 0 }, b0 = { class: "lg:row-span-2" }, Q0 = { class: "flex overflow-hidden relative flex-col w-full rounded-lg aspect-[0.67] max-h-[485px]" }, U0 = { class: "flex flex-col justify-end absolute bottom-0 left-0 right-0 p-6 w-full z-20 pointer-events-none" }, Y0 = {
  key: 2,
  class: "inline-block w-72 mr-4",
  style: { "white-space": "normal", height: "420px" }
}, _0 = { class: "flex flex-col gap-6" }, P0 = { class: "flex flex-col justify-end absolute bottom-0 left-0 right-0 p-6 w-full z-20" }, Wh = {
  __name: "Testimonials",
  props: {
    title: { type: String },
    subTitle: { type: String },
    starImage: { type: String },
    hideText: {
      type: [Boolean, String]
    },
    // Video 1
    video1Url: { type: String },
    video1Quote: { type: String },
    video1Title: { type: String },
    video1Description: { type: String },
    video1Thumbnail: { type: String },
    // Text 1
    text1BackgroundColor: { type: String },
    text1Image: { type: String },
    text1Quote: { type: String },
    text1Title: { type: String },
    text1Description: { type: String },
    text1TrustpilotLink: { type: String },
    // Text 2
    text2BackgroundColor: { type: String },
    text2Image: { type: String },
    text2Quote: { type: String },
    text2Title: { type: String },
    text2Description: { type: String },
    text2TrustpilotLink: { type: String },
    // Video 2
    video2Url: { type: String },
    video2Quote: { type: String },
    video2Title: { type: String },
    video2Description: { type: String },
    video2Thumbnail: { type: String },
    // Video 3
    video3Url: { type: String },
    video3Quote: { type: String },
    video3Title: { type: String },
    video3Description: { type: String },
    video3Thumbnail: { type: String },
    // Text 3
    text3BackgroundColor: { type: String },
    text3Image: { type: String },
    text3Quote: { type: String },
    text3Title: { type: String },
    text3Description: { type: String },
    text3TrustpilotLink: { type: String }
  },
  setup(t) {
    const e = t, i = J(() => e.hideText == !0 || e.hideText == "true"), M = C(!1), n = C(0), a = C(0), r = (d) => {
      M.value = !0, n.value = d.pageX - d.currentTarget.offsetLeft, a.value = d.currentTarget.scrollLeft;
    }, o = (d) => {
      if (!M.value) return;
      d.preventDefault();
      const D = (d.pageX - d.currentTarget.offsetLeft - n.value) * 1.5;
      d.currentTarget.scrollLeft = a.value - D;
    }, s = () => {
      M.value = !1;
    }, u = () => {
      document.getElementById("youtube-lightbox").style.display = "none", document.getElementById("youtube-area-desktop") && window.getComputedStyle(document.getElementById("youtube-area-desktop"), null).display == "flex" ? document.querySelector("#youtube-area-desktop iframe").src = "" : document.querySelector("#youtube-area-mobile iframe").src = "", window.videoOrientation && clearInterval(window.videoOrientation);
    }, c = J(() => /android.+mobile|ip(hone|[oa]d)/i.test(navigator.userAgent)), g = () => window.matchMedia("(orientation: landscape)").matches;
    return (d, j) => (y(), A("div", P4, [
      l("div", R4, [
        l("section", {
          class: "md:max-w-screen-md lg:max-w-screen-lg",
          style: R({ width: i.value ? "100%" : "" })
        }, [
          l("div", F4, [
            t.title ? (y(), A("header", W4, [
              l("h2", B4, m(t.title), 1),
              t.subTitle ? (y(), A("h3", V4, m(t.subTitle), 1)) : k("", !0)
            ])) : k("", !0)
          ]),
          l("div", G4, [
            c.value ? (y(), A("div", J4, [
              l("a", {
                href: "#",
                class: "bg-white px-3 py-1 text-black absolute cursor-pointer",
                style: {
                  zIndex: 99,
                  right: "2%",
                  top: "3%",
                  borderRadius: "50%",
                  width: "56px",
                  height: "56px",
                  paddingTop: "17px",
                  paddingLeft: "17px",
                  color: "hsl(var(--twc-primary))"
                },
                onClick: Pt(u, ["prevent"])
              }, [
                b(ie, {
                  icon: "close",
                  "icon-color": T(Rt).primary,
                  width: "24",
                  height: "24"
                }, null, 8, ["icon-color"])
              ]),
              l("iframe", {
                class: "absolute sm:rounded-xl xs:rounded-xl xxs:rounded-xl xxxs:rounded-xl md:rounded-3xl lg:rounded-3xl",
                style: R(`width: 100%;  ${g() ? "height: 70%" : "height: 30%;"}`),
                title: t.title,
                frameborder: "0",
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                referrerpolicy: "strict-origin-when-cross-origin",
                allowfullscreen: ""
              }, null, 12, H4)
            ])) : (y(), A("div", Z4, [
              l("a", {
                href: "#",
                class: "bg-white text-black absolute cursor-pointer flex justify-center items-center",
                style: {
                  zIndex: 99,
                  right: "1%",
                  top: "12%",
                  borderRadius: "50%",
                  width: "56px",
                  height: "56px",
                  color: "hsl(var(--twc-primary))"
                },
                onClick: Pt(u, ["prevent"])
              }, [
                b(ie, {
                  icon: "close",
                  "icon-color": T(Rt).primary,
                  width: "24",
                  height: "24"
                }, null, 8, ["icon-color"])
              ]),
              l("iframe", {
                class: "absolute",
                style: { "border-radius": "25px", width: "100%", height: "80%" },
                title: t.title,
                frameborder: "0",
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                referrerpolicy: "strict-origin-when-cross-origin",
                allowfullscreen: ""
              }, null, 8, $4)
            ]))
          ]),
          l("div", X4, [
            l("div", {
              class: P([
                "grid grid-cols-1 gap-6 max-w-screen-lg max-md:max-w-full",
                i.value ? "md:grid-cols-3" : "md:grid-cols-2",
                "lg:grid-cols-3"
              ])
            }, [
              l("div", K4, [
                l("div", q4, [
                  t.video1Url ? (y(), A("div", e0, [
                    b(pi, {
                      "video-url": t.video1Url,
                      "thumbnail-image": t.video1Thumbnail,
                      class: "object-cover absolute inset-0 w-full h-full z-10",
                      type: "popup"
                    }, null, 8, ["video-url", "thumbnail-image"]),
                    l("div", t0, [
                      b(qe, {
                        type: "trustpilot",
                        title: t.video1Title,
                        description: t.video1Description,
                        "text-color": "text-white",
                        "background-color": "transparent",
                        quote: i.value ? void 0 : t.video1Quote
                      }, null, 8, ["title", "description", "quote"])
                    ])
                  ])) : k("", !0)
                ]),
                i.value ? k("", !0) : (y(), A("div", i0, [
                  l("div", {
                    class: "flex flex-col w-full rounded-md h-full",
                    style: R({ backgroundColor: t.text1BackgroundColor })
                  }, [
                    l("div", M0, [
                      b(qe, {
                        type: "trustpilot",
                        title: t.text1Title,
                        description: t.text1Description,
                        "text-color": "text-dark",
                        "background-color": "transparent",
                        quote: t.text1Quote,
                        width: "48",
                        height: "48",
                        image: t.text1Image,
                        "star-image": "trustpilot-star",
                        "trustpilot-link": t.text1TrustpilotLink
                      }, null, 8, ["title", "description", "quote", "image", "trustpilot-link"])
                    ])
                  ], 4)
                ]))
              ]),
              l("div", n0, [
                i.value ? k("", !0) : (y(), A("div", a0, [
                  l("div", {
                    class: "flex flex-col w-full rounded-md h-full",
                    style: R({ backgroundColor: t.text2BackgroundColor })
                  }, [
                    l("div", r0, [
                      b(qe, {
                        type: "trustpilot",
                        title: t.text2Title,
                        description: t.text2Description,
                        "text-color": "text-dark",
                        "background-color": "transparent",
                        quote: t.text2Quote,
                        width: "48",
                        height: "48",
                        image: t.text2Image,
                        "star-image": "trustpilot-star",
                        "trustpilot-link": t.text2TrustpilotLink
                      }, null, 8, ["title", "description", "quote", "image", "trustpilot-link"])
                    ])
                  ], 4)
                ])),
                l("div", l0, [
                  t.video2Url ? (y(), A("div", o0, [
                    b(pi, {
                      "video-url": t.video2Url,
                      "thumbnail-image": t.video2Thumbnail,
                      class: "object-cover absolute inset-0 w-full h-full z-10",
                      type: "popup"
                    }, null, 8, ["video-url", "thumbnail-image"]),
                    l("div", s0, [
                      b(qe, {
                        type: "trustpilot",
                        title: t.video2Title,
                        description: t.video2Description,
                        "text-color": "text-white",
                        "background-color": "transparent",
                        quote: i.value ? void 0 : t.video2Quote
                      }, null, 8, ["title", "description", "quote"])
                    ])
                  ])) : k("", !0)
                ])
              ]),
              l("div", u0, [
                l("div", c0, [
                  t.video3Url ? (y(), A("div", g0, [
                    b(pi, {
                      "video-url": t.video3Url,
                      "thumbnail-image": t.video3Thumbnail,
                      class: "object-cover absolute inset-0 w-full h-full z-10",
                      type: "popup"
                    }, null, 8, ["video-url", "thumbnail-image"]),
                    l("div", N0, [
                      b(qe, {
                        type: "trustpilot",
                        title: t.video3Title,
                        description: t.video3Description,
                        "text-color": "text-white",
                        "background-color": "transparent",
                        quote: i.value ? void 0 : t.video3Quote
                      }, null, 8, ["title", "description", "quote"])
                    ])
                  ])) : k("", !0)
                ]),
                i.value ? k("", !0) : (y(), A("div", I0, [
                  l("div", {
                    class: "flex flex-col w-full rounded-md h-full",
                    style: R({ backgroundColor: t.text3BackgroundColor })
                  }, [
                    l("div", D0, [
                      b(qe, {
                        type: "trustpilot",
                        title: t.text3Title,
                        description: t.text3Description,
                        "text-color": "text-dark",
                        "background-color": "transparent",
                        quote: t.text3Quote,
                        width: "48",
                        height: "48",
                        image: t.text3Image,
                        "star-image": "trustpilot-star",
                        "trustpilot-link": t.text3TrustpilotLink
                      }, null, 8, ["title", "description", "quote", "image", "trustpilot-link"])
                    ])
                  ], 4)
                ]))
              ]),
              i.value ? k("", !0) : (y(), A("div", d0, [
                l("div", j0, [
                  l("div", {
                    class: "flex flex-col h-full w-full rounded-md",
                    style: R({ backgroundColor: t.text3BackgroundColor })
                  }, [
                    l("div", y0, [
                      b(qe, {
                        type: "trustpilot",
                        title: t.text3Title,
                        description: t.text3Description,
                        "text-color": "text-dark",
                        "background-color": "transparent",
                        quote: t.text3Quote,
                        width: "48",
                        height: "48",
                        image: t.text3Image,
                        "star-image": "trustpilot-star",
                        "trustpilot-link": t.text3TrustpilotLink
                      }, null, 8, ["title", "description", "quote", "image", "trustpilot-link"])
                    ])
                  ], 4)
                ])
              ]))
            ], 2)
          ])
        ], 4),
        l("div", A0, [
          l("section", null, [
            l("div", {
              id: "swipe-container",
              class: "w-screen overflow-x-auto cursor-grab active:cursor-grabbing hide-scrollbar snap-x",
              style: { "white-space": "nowrap" },
              onMousedown: r,
              onMousemove: o,
              onMouseup: s,
              onMouseleave: s
            }, [
              l("div", {
                class: P([
                  "inline-block w-72 snap-center",
                  i.value ? "" : "mx-4"
                ]),
                style: { "white-space": "normal", height: "420px" }
              }, [
                t.video1Url ? (y(), A("div", T0, [
                  l("div", {
                    class: P([
                      "flex flex-col",
                      i.value ? "ml-4" : "gap-6"
                    ])
                  }, [
                    l("div", x0, [
                      l("div", z0, [
                        b(pi, {
                          "video-url": t.video1Url,
                          "thumbnail-image": t.video1Thumbnail,
                          class: "object-cover absolute inset-0 w-full h-full z-10",
                          type: "popup"
                        }, null, 8, ["video-url", "thumbnail-image"]),
                        l("div", f0, [
                          b(qe, {
                            type: "trustpilot",
                            title: t.video1Title,
                            description: t.video1Description,
                            "text-color": "text-white",
                            "background-color": "transparent",
                            quote: i.value ? void 0 : t.video1Quote
                          }, null, 8, ["title", "description", "quote"])
                        ])
                      ])
                    ])
                  ], 2)
                ])) : k("", !0)
              ], 2),
              i.value ? k("", !0) : (y(), A("div", m0, [
                l("div", L0, [
                  l("div", {
                    class: "flex overflow-hidden relative flex-col w-full rounded-lg aspect-[0.67] max-h-[485px]",
                    style: R({ backgroundColor: t.text1BackgroundColor })
                  }, [
                    l("div", p0, [
                      b(qe, {
                        type: "trustpilot",
                        title: t.text1Title,
                        description: t.text1Description,
                        "text-color": "text-dark",
                        "background-color": "transparent",
                        quote: t.text1Quote,
                        width: "48",
                        height: "48",
                        image: t.text1Image,
                        "star-image": "trustpilot-star",
                        "trustpilot-link": t.text1TrustpilotLink
                      }, null, 8, ["title", "description", "quote", "image", "trustpilot-link"])
                    ])
                  ], 4)
                ])
              ])),
              l("div", {
                class: P([
                  "inline-block w-72 snap-center",
                  i.value ? "" : "mx-4"
                ]),
                style: { "white-space": "normal", height: "420px" }
              }, [
                t.video2Url ? (y(), A("div", w0, [
                  l("div", {
                    class: P([
                      "flex flex-col",
                      i.value ? "ml-4" : "gap-6"
                    ])
                  }, [
                    l("div", C0, [
                      l("div", h0, [
                        b(pi, {
                          "video-url": t.video2Url,
                          "thumbnail-image": t.video2Thumbnail,
                          class: "object-cover absolute inset-0 w-full h-full z-10",
                          type: "popup"
                        }, null, 8, ["video-url", "thumbnail-image"]),
                        l("div", O0, [
                          b(qe, {
                            type: "trustpilot",
                            title: t.video2Title,
                            description: t.video2Description,
                            "text-color": "text-white",
                            "background-color": "transparent",
                            quote: i.value ? void 0 : t.video2Quote
                          }, null, 8, ["title", "description", "quote"])
                        ])
                      ])
                    ])
                  ], 2)
                ])) : k("", !0)
              ], 2),
              i.value ? k("", !0) : (y(), A("div", E0, [
                l("div", S0, [
                  l("div", {
                    class: "flex overflow-hidden relative flex-col w-full rounded-lg aspect-[0.67] max-h-[485px]",
                    style: R({ backgroundColor: t.text2BackgroundColor })
                  }, [
                    l("div", k0, [
                      b(qe, {
                        type: "trustpilot",
                        title: t.text2Title,
                        description: t.text2Description,
                        "text-color": "text-dark",
                        "background-color": "transparent",
                        quote: t.text2Quote,
                        width: "48",
                        height: "48",
                        image: t.text2Image,
                        "star-image": "trustpilot-star",
                        "trustpilot-link": t.text1TrustpilotLink
                      }, null, 8, ["title", "description", "quote", "image", "trustpilot-link"])
                    ])
                  ], 4)
                ])
              ])),
              l("div", {
                class: P([
                  "inline-block w-72 snap-center",
                  i.value ? "mr-4" : "mx-4"
                ]),
                style: { "white-space": "normal", height: "420px" }
              }, [
                t.video3Url ? (y(), A("div", v0, [
                  l("div", {
                    class: P([
                      "flex flex-col",
                      i.value ? "ml-4" : "gap-6"
                    ])
                  }, [
                    l("div", b0, [
                      l("div", Q0, [
                        b(pi, {
                          "video-url": t.video3Url,
                          "thumbnail-image": t.video3Thumbnail,
                          class: "object-cover absolute inset-0 w-full h-full z-10",
                          type: "popup"
                        }, null, 8, ["video-url", "thumbnail-image"]),
                        l("div", U0, [
                          b(qe, {
                            type: "trustpilot",
                            title: t.video3Title,
                            description: t.video3Description,
                            "text-color": "text-white",
                            "background-color": "transparent",
                            quote: i.value ? void 0 : t.video3Quote
                          }, null, 8, ["title", "description", "quote"])
                        ])
                      ])
                    ])
                  ], 2)
                ])) : k("", !0)
              ], 2),
              i.value ? k("", !0) : (y(), A("div", Y0, [
                l("div", _0, [
                  l("div", {
                    class: "flex overflow-hidden relative flex-col w-full rounded-lg aspect-[0.67] max-h-[485px]",
                    style: R({ backgroundColor: t.text3BackgroundColor })
                  }, [
                    l("div", P0, [
                      b(qe, {
                        type: "trustpilot",
                        title: t.text3Title,
                        description: t.text3Description,
                        "text-color": "text-dark",
                        "background-color": "transparent",
                        quote: t.text3Quote,
                        width: "48",
                        height: "48",
                        image: t.text3Image,
                        "star-image": "trustpilot-star",
                        "trustpilot-link": t.text1TrustpilotLink
                      }, null, 8, ["title", "description", "quote", "image", "trustpilot-link"])
                    ])
                  ], 4)
                ])
              ]))
            ], 32)
          ])
        ])
      ])
    ]));
  }
}, R0 = { class: "flex overflow-hidden flex-col gap-8 justify-center items-center self-stretch px-4 py-8 md:py-12" }, F0 = { class: "flex flex-col justify-center text-center" }, W0 = {
  key: 0,
  class: "flex flex-col text-center w-full max-md:max-w-full"
}, B0 = { class: "text-h2 leading-none max-md:max-w-full" }, V0 = {
  key: 0,
  class: "flex gap-2 py-2.5 justify-center text-center"
}, G0 = ["href"], Z0 = { class: "my-auto cursor-pointer" }, $0 = {
  key: 0,
  class: "featured-guides-desktop"
}, J0 = { class: "grid grid-cols-3 gap-6 max-w-screen-lg max-md:max-w-full" }, H0 = {
  key: 1,
  class: "featured-guides-mobile"
}, X0 = { class: "flex flex-col gap-6 ml-4 h-full" }, Bh = /* @__PURE__ */ ne({
  __name: "FeaturedGuides",
  props: {
    title: { type: String },
    subTitle: { type: String },
    subTitleUrl: { type: String },
    guideObj: { type: Array, default: () => [] },
    backgroundColor: { type: String },
    readMoreText: { type: String, default: "Read guide" }
  },
  setup(t) {
    const e = t, i = C(window.innerWidth >= 883), M = () => {
      i.value = window.innerWidth >= 883;
    }, n = J(() => Array.isArray(e.guideObj) ? e.guideObj : JSON.parse(String(e.guideObj))), a = C(!1), r = C(0), o = C(0), s = (g) => {
      a.value = !0, r.value = g.pageX - g.currentTarget.offsetLeft, o.value = g.currentTarget.scrollLeft;
    }, u = (g) => {
      if (!a.value) return;
      g.preventDefault();
      const j = (g.pageX - g.currentTarget.offsetLeft - r.value) * 1.5;
      g.currentTarget.scrollLeft = o.value - j;
    }, c = () => {
      a.value = !1;
    };
    return we(() => {
      window.addEventListener("resize", M);
      const g = document.getElementsByClassName("featuredGuideContentArea");
      let d = 0;
      for (let j = 0; j < g.length; j++)
        d < g[j].clientHeight && (d = g[j].clientHeight);
      for (let j = 0; j < g.length; j++)
        g[j].style.height = d + "px";
    }), _t(() => {
      window.removeEventListener("resize", M);
    }), (g, d) => (y(), A("div", {
      id: "testimonials-container",
      class: "justify-center w-full",
      style: R({ backgroundColor: e.backgroundColor })
    }, [
      l("div", R0, [
        l("section", F0, [
          t.title ? (y(), A("header", W0, [
            l("h2", B0, m(t.title), 1),
            t.subTitle ? (y(), A("div", V0, [
              l("a", {
                class: "text-subtitle1 tracking-normal max-md:max-w-full text-primary",
                href: t.subTitleUrl
              }, m(t.subTitle), 9, G0),
              l("div", Z0, [
                b(ie, {
                  icon: "arrow-right",
                  "icon-color": "primary",
                  width: "13",
                  height: "13"
                })
              ])
            ])) : k("", !0)
          ])) : k("", !0)
        ]),
        i.value ? (y(), A("div", $0, [
          l("div", J0, [
            (y(!0), A(ge, null, ye(n.value, (j, D) => (y(), A("div", {
              key: D,
              class: "flex flex-col gap-6"
            }, [
              i.value ? (y(), _e(bn, {
                key: 0,
                title: j.title,
                image: j.image,
                link: j.link,
                "show-description": "false",
                width: "323px",
                height: "238px",
                "show-outer-background-color": !0,
                "show-outer-radius": !0,
                "show-outer-border": !0,
                "show-outer-shadow": !0,
                "show-read-more": "true",
                "show-image-radius": !0,
                "top-image-object-fit": "cover",
                "is-mobile": "false",
                "show-read-more-text": t.readMoreText,
                "icon-color": "primary",
                "whole-card-clickable": "true"
              }, null, 8, ["title", "image", "link", "show-read-more-text"])) : (y(), _e(bn, {
                key: 1,
                title: j.title,
                image: j.image,
                link: j.link,
                "show-description": "false",
                width: "286px",
                height: "238px",
                "show-outer-background-color": !0,
                "show-outer-radius": !0,
                "show-outer-border": !0,
                "show-outer-shadow": !0,
                "show-read-more": "true",
                "show-image-radius": !0,
                "top-image-object-fit": "cover",
                "show-read-more-text": t.readMoreText,
                "icon-color": "primary",
                "content-class-name": "featuredGuideContentArea",
                "whole-card-clickable": "true"
              }, null, 8, ["title", "image", "link", "show-read-more-text"]))
            ]))), 128))
          ])
        ])) : k("", !0),
        i.value ? k("", !0) : (y(), A("div", H0, [
          l("div", {
            id: "swipe-container",
            class: "w-screen overflow-x-auto cursor-grab active:cursor-grabbing hide-scrollbar snap-x pb-2.5",
            style: { "white-space": "nowrap", height: "450px" },
            onMousedown: s,
            onMousemove: u,
            onMouseup: c,
            onMouseleave: c
          }, [
            (y(!0), A(ge, null, ye(n.value, (j, D) => (y(), A("div", {
              key: D,
              class: P(`inline-block w-72 snap-center h-full ${D == n.value.length - 1 ? " mr-4 " : ""}`),
              style: { "white-space": "normal" }
            }, [
              l("div", X0, [
                b(bn, {
                  "is-mobile": "true",
                  "mobile-without-desc-min-height": "165",
                  title: j.title,
                  image: j.image,
                  link: j.link,
                  "show-description": "false",
                  width: "286px",
                  height: "238px",
                  "show-outer-background-color": !0,
                  "show-outer-radius": !0,
                  "show-outer-border": !0,
                  "show-outer-shadow": !0,
                  "show-read-more": "true",
                  "show-image-radius": !0,
                  "top-image-object-fit": "cover",
                  "show-read-more-text": "Read guide",
                  "icon-color": "primary",
                  "content-class-name": "featuredGuideContentArea",
                  "whole-card-clickable": "true"
                }, null, 8, ["title", "image", "link"])
              ])
            ], 2))), 128))
          ], 32)
        ]))
      ])
    ], 4));
  }
}), K0 = { class: "flex flex-wrap shadow-md max-w-screen-full xs:max-w-screen-xs md:max-w-screen-md lg:max-w-screen-lg max-md:max-w-full" }, Vh = /* @__PURE__ */ ne({
  __name: "FeatureArticleContainer",
  props: {
    title: {
      type: String
    },
    description: {
      type: String
    },
    image: {
      type: String
    },
    imageAlt: {
      type: String
    },
    height: {
      type: String
    },
    textSize: {
      type: String
    },
    textColor: {
      type: String
    },
    backgroundColor: {
      type: String
    },
    url: {
      type: String
    }
  },
  setup(t) {
    return (e, i) => (y(), A("div", {
      class: "flex gap-2 justify-center items-center py-6 px-4 lg:py-12",
      style: R({ backgroundColor: t.backgroundColor })
    }, [
      l("div", K0, [
        b(qe, {
          type: "feature-article",
          title: t.title,
          description: t.description,
          "text-size": "text-h3",
          "text-color": "text-dark-1",
          image: t.image,
          width: "",
          height: "364",
          "background-color": t.backgroundColor,
          quote: "",
          url: t.url,
          "image-alt": t.imageAlt
        }, null, 8, ["title", "description", "image", "background-color", "url", "image-alt"])
      ])
    ], 4));
  }
}), q0 = {
  key: 0,
  class: "flex justify-center w-full"
}, eA = { class: "faq-items p-4 flex flex-col w-full max-w-screen-lg py-8 md:py-12" }, tA = { class: "text-center mb-8" }, iA = { class: "text-h2" }, MA = { key: 1 }, Gh = /* @__PURE__ */ ne({
  __name: "FAQContainer",
  props: {
    title: {
      type: String,
      default: "Frequently Asked Questions"
    },
    data: {
      type: Array,
      default: () => []
    },
    windowObjectName: {
      type: String
    }
  },
  setup(t) {
    const e = t, i = J(() => e.windowObjectName && e.windowObjectName != "" ? window[e.windowObjectName] ? window[e.windowObjectName] : [] : e.data);
    return (M, n) => i.value.length > 0 ? (y(), A("section", q0, [
      l("div", eA, [
        l("div", tA, [
          l("h2", iA, m(e.title), 1)
        ]),
        l("ul", null, [
          (y(!0), A(ge, null, ye(i.value, (a, r) => (y(), A("li", {
            key: r,
            class: "faq-item flex justify-center"
          }, [
            b(cj, {
              title: a.title,
              description: a.description
            }, null, 8, ["title", "description"])
          ]))), 128))
        ])
      ])
    ])) : (y(), A("p", MA, " No FAQ items found. "));
  }
}), nA = ["id"], aA = { class: "flex flex-col justify-center items-start w-full max-w-screen-sm relative" }, rA = { class: "text-left w-full text-subtitle1 mb-4" }, lA = { class: "text-quote text-left w-full" }, oA = { class: "flex justify-center items-center md:pt-6 pt-3" }, sA = ["href"], uA = { class: "flex flex-col flex-1 px-4 py-2" }, cA = ["href"], gA = { class: "text-sm font-bold" }, NA = {
  key: 1,
  class: "text-sm font-bold"
}, IA = { class: "flex gap-1 tracking-normal" }, DA = ["href"], dA = ["innerHTML"], jA = ["innerHTML"], Zh = /* @__PURE__ */ ne({
  name: "PullQuoteComponent",
  __name: "PullQuote",
  props: {
    id: {
      type: String
    },
    title: {
      type: String
    },
    link: {
      type: String
    },
    description: {
      type: String
    },
    image: {
      type: String
    },
    imageAlt: {
      type: String
    },
    backgroundColor: {
      type: String
    },
    quote: {
      type: String
    },
    markerTopText: {
      type: String
    }
  },
  setup(t) {
    const e = t, {
      title: i,
      description: M,
      image: n,
      backgroundColor: a
    } = at(e);
    return (r, o) => (y(), A("div", {
      id: t.id,
      class: "flex justify-center items-center self-stretch py-12 max-md:px-4",
      style: R({ backgroundColor: T(a) })
    }, [
      l("div", aA, [
        b(ie, {
          class: "absolute md:-top-5 md:-left-8 left-0 -top-6",
          icon: "pull-quote-marker-top",
          width: "103",
          height: "65"
        }),
        l("div", rA, m(t.markerTopText && t.markerTopText != "" ? t.markerTopText : "From our expert"), 1),
        l("blockquote", lA, " “" + m(t.quote) + "” ", 1),
        l("div", oA, [
          t.link ? (y(), A("a", {
            key: 0,
            href: t.link,
            target: "_self"
          }, [
            b(Ce, {
              class: "w-14 h-14 rounded-full object-cover",
              "image-name": T(n),
              "image-alt": t.imageAlt,
              width: "56px",
              height: "56px"
            }, null, 8, ["image-name", "image-alt"])
          ], 8, sA)) : (y(), _e(Ce, {
            key: 1,
            class: "w-14 h-14 rounded-full object-cover",
            "image-name": T(n),
            "image-alt": t.imageAlt,
            width: "56px",
            height: "56px"
          }, null, 8, ["image-name", "image-alt"])),
          l("div", uA, [
            t.link ? (y(), A("a", {
              key: 0,
              href: t.link,
              target: "_self"
            }, [
              l("span", gA, m(T(i)), 1)
            ], 8, cA)) : (y(), A("span", NA, m(T(i)), 1)),
            l("div", IA, [
              t.link ? (y(), A("a", {
                key: 0,
                href: t.link,
                target: "_self"
              }, [
                l("span", {
                  class: "leading-[133%] text-sm",
                  innerHTML: T(M)
                }, null, 8, dA)
              ], 8, DA)) : (y(), A("span", {
                key: 1,
                class: "leading-[133%] text-sm",
                innerHTML: T(M)
              }, null, 8, jA))
            ])
          ])
        ]),
        b(ie, {
          class: "absolute bottom-5 right-0",
          icon: "pull-quote-marker-bottom",
          width: "102",
          height: "65"
        })
      ])
    ], 12, nA));
  }
}), yA = ["id"], AA = { class: "flex flex-col items-start pr-5" }, TA = { class: "text-h6" }, xA = { class: "text" }, zA = { class: "cta-button-wrapper" }, fA = /* @__PURE__ */ ne({
  name: "CtaButtonComponent",
  __name: "CTAButton",
  props: {
    id: {
      type: String
    },
    title: {
      type: String
    },
    description: {
      type: String
    },
    link: {
      type: String
    },
    btnText: {
      type: String
    },
    btnColor: {
      type: String
    },
    ctaBackground: {
      type: String
    },
    backgroundColor: {
      type: String
    }
  },
  setup(t) {
    const e = t, i = () => {
      e.link && window.open(e.link, "_self");
    };
    return (M, n) => (y(), A("div", {
      id: t.id,
      class: "flex justify-center items-center self-stretch pt-4 md:pt-0 pb-8 md:pb-12",
      style: R({ backgroundColor: t.backgroundColor })
    }, [
      l("div", {
        class: "flex md:flex-row flex-col justify-between md:items-center items-start gap-y-4 w-full max-w-screen-sm md:p-4 md:px-6 p-4 !py-5 relative shadow-md rounded-md max-md:mx-4",
        style: R({ backgroundColor: t.ctaBackground })
      }, [
        l("div", AA, [
          l("div", TA, m(t.title), 1),
          l("div", xA, m(t.description), 1)
        ]),
        l("div", zA, [
          b(Ke, {
            color: t.btnColor,
            "hover-color": "bg-secondary hover:brightness-110",
            "text-size": "text-subtitle1",
            "text-color": "text-dark-1",
            label: t.btnText,
            "icon-after": !0,
            class: "cta-button",
            onClick: i
          }, null, 8, ["color", "label"])
        ])
      ], 4)
    ], 12, yA));
  }
}), $h = /* @__PURE__ */ fe(fA, [["__scopeId", "data-v-1ee4b585"]]), mA = { class: "grid grid-rows-subgrid row-span-5 gap-1 rounded-lg border p-6 bg-white shadow-md" }, LA = { class: "mb-3" }, pA = { class: "text-h4" }, wA = {
  key: 0,
  href: "/car-finance-eligibility"
}, CA = { class: "text-body1 pb-3 mb-3" }, hA = { class: "content-2" }, OA = ["href"], EA = ["href"], SA = { class: "self-stretch my-auto text-subtitle1 text-primary" }, kA = /* @__PURE__ */ ne({
  __name: "GuideCard",
  props: {
    id: {
      type: String
    },
    title: {
      type: String
    },
    description: {
      type: String
    },
    guideCount: {
      type: String
    },
    guideUrl: {
      type: String
    },
    guideObj: { type: Array, default: () => [] },
    guideIndex: {
      type: String,
      default: "1"
    }
  },
  setup(t) {
    const e = t, i = J(() => typeof e.guideObj == "object" ? e.guideObj : JSON.parse(e.guideObj)), M = J(() => {
      const n = Number.parseInt(e.guideIndex);
      return {
        1: "eligibility",
        2: "vehicle",
        3: "finance-options",
        4: "upgrade",
        5: "credit"
      }[n];
    });
    return (n, a) => (y(), A("div", mA, [
      l("div", LA, [
        b(ie, {
          icon: M.value,
          "icon-color": "primary",
          width: "48",
          height: "48"
        }, null, 8, ["icon"])
      ]),
      l("div", pA, [
        t.title === "Am I Eligible" ? (y(), A("a", wA, m(t.title), 1)) : (y(), A(ge, { key: 1 }, [
          G(m(t.title), 1)
        ], 64))
      ]),
      l("div", CA, m(t.description), 1),
      l("div", hA, [
        a[0] || (a[0] = l("div", { class: "text-subtitle1 mb-4" }, " Featured guides ", -1)),
        (y(!0), A(ge, null, ye(i.value, (r, o) => (y(), A("div", {
          key: o,
          class: P(`text-primary pb-3 mb-3 ${o + 1 == i.value.length ? "" : " border-b  border-solid  "} `),
          style: { "border-color": "rgba(245, 238, 254, 1)" }
        }, [
          l("a", {
            href: r.urlTitle
          }, m(r.title), 9, OA)
        ], 2))), 128))
      ]),
      l("a", {
        href: t.guideUrl,
        class: "flex gap-2 items-center lg:mt-6 mt-2 w-full text-center"
      }, [
        l("span", SA, "View all " + m(t.guideCount) + " guides", 1),
        b(ie, {
          icon: "chevron-right",
          class: "cursor-pointer",
          "icon-color": "primary",
          height: "32px",
          width: "32px"
        })
      ], 8, EA)
    ]));
  }
}), vA = { class: "w-full flex justify-center" }, bA = { class: "w-full max-w-screen-lg grid grid-cols-1 md:grid-cols-2 sm:grid-cols-1 gap-6" }, Jh = /* @__PURE__ */ ne({
  __name: "GuideContainer",
  props: {
    guideObj: {
      type: [Array, String],
      required: !0,
      validator(t) {
        if (Array.isArray(t)) return !0;
        if (typeof t == "string")
          try {
            const e = JSON.parse(t);
            return Array.isArray(e);
          } catch {
            return !1;
          }
        return !1;
      }
    }
  },
  setup(t) {
    const e = t, i = J(() => {
      try {
        if (!e.guideObj)
          return [];
        if (Array.isArray(e.guideObj))
          return e.guideObj;
        if (typeof e.guideObj == "string") {
          const M = JSON.parse(e.guideObj);
          return Array.isArray(M) ? M : [];
        }
        return console.error("Unexpected guide object type:", typeof e.guideObj), [];
      } catch (M) {
        return console.error("Error processing guide object:", M), [];
      }
    });
    return (M, n) => (y(), A("div", vA, [
      l("section", bA, [
        (y(!0), A(ge, null, ye(i.value, (a, r) => (y(), _e(kA, {
          key: a.guideUrl || r,
          title: a.title,
          description: a.description,
          "guide-count": a.guideCount,
          "guide-url": a.guideUrl,
          "guide-obj": a.guideObj,
          "guide-index": String(r + 1)
        }, null, 8, ["title", "description", "guide-count", "guide-url", "guide-obj", "guide-index"]))), 128))
      ])
    ]));
  }
}), QA = { class: "max-w-screen-md max-sm:max-w-screen-xs flex flex-col gap-0 md:gap-8 justify-center items-center self-stretch md:px-4 py-8 text-center sm:pt-12" }, UA = { class: "flex flex-col justify-center" }, YA = {
  key: 0,
  class: "flex flex-col text-center w-full max-md:max-w-full"
}, _A = { class: "text-h2 leading-none max-md:max-w-full" }, PA = {
  key: 0,
  class: "text-h6 mt-2 tracking-normal max-md:max-w-full"
}, RA = { class: "flex gap-x-4 mt-12 mb-6 max-md:hidden" }, FA = ["onClick"], WA = {
  key: 1,
  class: "w-screen overflow-hidden mt-12 mb-6"
}, BA = ["id", "onClick"], VA = { class: "flex flex-col justify-center items-center p-6 max-md:py-6 max-md:bg-white max-md:order-2 max-md:mb-24 max-md:h-fit" }, GA = { class: "text-primary font-bold outlined-number" }, ZA = { class: "text-h5 mb-2" }, $A = ["innerHTML"], JA = { class: "progress-container" }, HA = { class: "w-full flex justify-center my-12 max-md:mt-20 max-md:mb-4" }, Br = 150, XA = /* @__PURE__ */ ne({
  name: "FiveStepHowItWorksContainer",
  __name: "FiveStepHowItWorks",
  props: {
    title: { type: String },
    subTitle: { type: String },
    buttonTitle: { type: String },
    buttonUrl: { type: String }
  },
  setup(t) {
    const e = t, i = {
      looking: [
        {
          id: "looking-step1",
          title: "Get approved",
          description: "Complete our online application form and we will search our wide panel of lenders to get your approval in principle in minutes.",
          image: "https://carfinance247.co.uk/dA/900c3ad3f1/fileAsset/HIW_P_01_01x2.png"
        },
        {
          id: "looking-step2",
          title: "Choose your car",
          description: "Browse personalised quotes on 100,000+ cars in our exclusive members area, or simply enter the reg of the car you've found and get an instant quote. <br><br>Can't find what you're looking for? Your personal account manager is on hand to help you find the perfect car!",
          image: "https://carfinance247.co.uk/dA/6045a6f55a/fileAsset/HIW_P_01_02_New.png"
        },
        {
          id: "looking-step3",
          title: "Customise your quote",
          description: "Add an optional deposit and part exchange, and adjust your loan duration, to find the perfect deal to fit your monthly budget.",
          image: "https://carfinance247.co.uk/dA/a3411414fe/fileAsset/HIW_P_01_03_New.png"
        },
        {
          id: "looking-step4",
          title: "Sign your agreement",
          description: "When you're happy with your quote, all you need to do is sign your agreement online. We'll take care of the rest.",
          image: "https://carfinance247.co.uk/dA/0b6ba95265/fileAsset/HIW_P_01_04_New.png"
        },
        {
          id: "looking-step5",
          title: "Collect your car",
          description: "We will arrange a time to collect your car that suits you, and ensure your car is ready and waiting. Just turn up and drive away.",
          image: "https://carfinance247.co.uk/dA/548e319a23/fileAsset/HIW_P_01_05_New.png"
        }
      ],
      found: [
        {
          id: "found-step1",
          title: "Get approved",
          description: "Complete our online application form and we will search our wide panel of lenders to get your approval in principle in minutes.",
          image: "https://carfinance247.co.uk/dA/0fd88a3d5f/fileAsset/HIW_P_02_01x2.png"
        },
        {
          id: "found-step2",
          title: "Tell us about the car",
          description: "Enter the reg of any cars you've found to get your personalised quote. If you're out visiting dealers or shopping online, download our app for quick quotes on the go.",
          image: "https://carfinance247.co.uk/dA/715dedeab6/fileAsset/HIW_P_02_02_New.png"
        },
        {
          id: "found-step3",
          title: "Customise your quote",
          description: "Add an optional deposit and part exchange, and adjust your loan duration, to find the perfect deal to fit your monthly budget.",
          image: "https://carfinance247.co.uk/dA/2db472a22f/fileAsset/HIW_P_02_03_New.png"
        },
        {
          id: "found-step4",
          title: "Sign your agreement",
          description: "When you're happy with your quote, all you need to do is sign your agreement online. We'll take care of the rest.",
          image: "https://carfinance247.co.uk/dA/cc258bbb42/fileAsset/HIW_P_02_04_New.png"
        },
        {
          id: "found-step5",
          title: "Collect your car",
          description: "We will arrange a time to collect your car that suits you, and ensure your car is ready and waiting. Just turn up and drive away.",
          image: "https://carfinance247.co.uk/dA/8a1083dbea/fileAsset/HIW_P_02_05_New.png"
        }
      ],
      refinance: [
        {
          id: "refinance-step1",
          title: "Get approved",
          description: "Complete our online application form and we will search our wide panel of lenders to get you your personalised refinance quote and approval in principle in minutes.",
          image: "https://carfinance247.co.uk/dA/675854499f/fileAsset/HIW_P_03_01x2.png"
        },
        {
          id: "refinance-step2",
          title: "Get your settlement figure",
          description: "It's easy, just call your existing finance provider to request a settlement figure. Don't worry, you won't need their permission to refinance your car.<br><br>Don't have a settlement figure? You can still use an estimate to get a quote.",
          image: "https://carfinance247.co.uk/dA/fb756897f0/fileAsset/HIW_P_03_02_New.png"
        },
        {
          id: "refinance-step3",
          title: "Customise your quote",
          description: "Add an optional deposit and adjust your loan duration, to find the perfect deal to fit your monthly budget.",
          image: "https://carfinance247.co.uk/dA/bd451c3133/fileAsset/HIW_P_03_03_New.png"
        },
        {
          id: "refinance-step4",
          title: "Sign your agreement",
          description: "When you're happy with your quote, all you need to do is sign your agreement online. We'll take care of the rest.",
          image: "https://carfinance247.co.uk/dA/5c9ca988cd/fileAsset/HIW_P_03_04_New.png"
        },
        {
          id: "refinance-step5",
          title: "Complete the switch",
          description: "We settle your existing finance and set up your repayments with your new lender. There's nothing left for you to do.",
          image: "https://carfinance247.co.uk/dA/cb4c0f2ff4/fileAsset/HIW_P_03_05_New.png"
        }
      ]
    }, M = C(null), n = C("looking"), a = J(() => i[n.value]), r = C(null), o = C(!1), s = C(null), u = C(!1), c = C(null), g = C(!1), d = C(!1);
    let j = null;
    const I = ((w, O) => (...S) => {
      j && clearTimeout(j), j = setTimeout(() => {
        w(...S);
      }, O);
    })(() => {
      if (d.value) {
        d.value = !1;
        return;
      }
      if (!c.value) return;
      const w = c.value.getBoundingClientRect(), O = w.left + w.width / 2, S = c.value.querySelectorAll("button");
      let Y = null, H = 1 / 0;
      if (S.forEach((B) => {
        const ae = B.getBoundingClientRect(), te = ae.left + ae.width / 2, q = Math.abs(te - O);
        q < H && (H = q, Y = B);
      }), Y && Y.id) {
        const B = Y.id.split("-")[0];
        B !== n.value && N(B);
      }
    }, Br), N = async (w) => {
      if (!u.value) {
        if (u.value = !0, d.value = !0, s.value && await x(s.value, "out"), n.value = w, await Tt(), s.value && await x(s.value, "in"), u.value = !1, c.value) {
          const O = c.value.querySelectorAll("button"), S = ["looking", "found", "refinance"].indexOf(w), Y = O[S];
          if (Y) {
            const H = c.value.getBoundingClientRect(), B = Y.getBoundingClientRect(), ae = H.width / 2, q = B.left - H.left - ae + B.width / 2;
            c.value.scrollTo({
              left: c.value.scrollLeft + q,
              behavior: "smooth"
            });
          }
        }
        setTimeout(() => {
          d.value = !1;
        }, Br + 50);
      }
    }, x = (w, O) => new Promise((S) => {
      let ae = O === "in" ? 0 : 1;
      const te = setInterval(() => {
        ae += O === "in" ? 1 / 10 : -1 / 10, w.style.opacity = ae.toString(), (O === "in" && ae >= 1 || O === "out" && ae <= 0) && (clearInterval(te), S(!0));
      }, 10);
    }), f = () => {
      if (M.value) {
        const w = document.documentElement.scrollTop || document.body.scrollTop, O = M.value.offsetTop, S = M.value.offsetHeight, H = window.innerHeight / 2 + (w + 100) - O, B = Math.min(Math.max(H / S * 100, 0), 100);
        r.value && (r.value.style.height = B + "%", B >= 100 ? o.value = !0 : o.value = !1);
      }
    };
    function L() {
      g.value = window.innerWidth < 768;
    }
    xe(g, (w) => {
      w ? Tt(() => {
        p();
      }) : h();
    });
    const p = () => {
      c.value && c.value.addEventListener("scroll", I);
    }, h = () => {
      c.value && c.value.removeEventListener("scroll", I);
    };
    return we(() => {
      L(), window.addEventListener("resize", L), window.addEventListener("scroll", f);
    }), Aa(() => {
      window.removeEventListener("resize", L), window.removeEventListener("scroll", f), h(), j && clearTimeout(j);
    }), (w, O) => (y(), A("div", {
      ref_key: "scrollContainer",
      ref: M,
      class: "flex justify-center"
    }, [
      l("div", QA, [
        l("section", UA, [
          e.title ? (y(), A("header", YA, [
            l("span", _A, m(e.title), 1),
            e.subTitle ? (y(), A("span", PA, m(e.subTitle), 1)) : k("", !0)
          ])) : k("", !0),
          l("div", RA, [
            (y(), A(ge, null, ye(["looking", "found", "refinance"], (S) => l("button", {
              key: S,
              class: P(["rounded-full py-3 px-6 font-bold w-[201px]", `${n.value === S ? "bg-primary text-white" : "bg-purple-1 text-primary"}`]),
              onClick: (Y) => N(S)
            }, m(S === "looking" ? "I'm looking for a car" : S === "found" ? "I've found a car" : "I want to refinance"), 11, FA)), 64))
          ]),
          g.value ? ht((y(), A("div", WA, [
            l("div", {
              ref_key: "draggableContainer",
              ref: c,
              class: "flex space-x-4 md:hidden overflow-x-auto hide-scrollbar snap-x snap-mandatory touch-pan-x px-[50%]"
            }, [
              (y(), A(ge, null, ye(["looking", "found", "refinance"], (S) => l("div", {
                key: S,
                class: "flex-shrink-0 snap-center"
              }, [
                l("button", {
                  id: `${S}-button`,
                  class: P(["rounded-full py-3 px-6 font-bold w-[201px] whitespace-nowrap", `${n.value === S ? "bg-primary text-white" : "bg-purple-1 text-primary"}`]),
                  onClick: (Y) => N(S)
                }, m(S === "looking" ? "I'm looking for a car" : S === "found" ? "I've found a car" : "I want to refinance"), 11, BA)
              ])), 64))
            ], 512)
          ], 512)), [
            [xa, g.value]
          ]) : k("", !0)
        ]),
        l("section", null, [
          l("div", {
            ref_key: "currentContent",
            ref: s,
            class: "current-content w-full grid grid-cols-1 grid-rows-5 gap-8 relative max-md:mt-10"
          }, [
            (y(!0), A(ge, null, ye(a.value, (S, Y) => (y(), A("div", {
              key: S.id,
              class: "grid md:grid-cols-2 grid-cols-1 gap-14 max-md:relative max-md:z-10 max-md:gap-y-0",
              style: { "min-height": "400px" }
            }, [
              l("div", {
                class: P([{ "order-2": (Y + 1) % 2 == 0 }, "bg-white flex justify-center p-2 max-md:pt-6"])
              }, [
                b(Ce, {
                  "image-name": S.image,
                  width: "400px",
                  height: "440px",
                  class: "w-full object-cover rounded-lg max-md:max-w-[480px]"
                }, null, 8, ["image-name"])
              ], 2),
              l("div", VA, [
                l("div", null, [
                  l("span", GA, " 0" + m(Y + 1), 1)
                ]),
                l("div", ZA, m(S.title), 1),
                l("p", {
                  class: "pb-2",
                  innerHTML: S.description
                }, null, 8, $A)
              ])
            ]))), 128)),
            l("div", JA, [
              O[0] || (O[0] = l("div", { class: "circle" }, null, -1)),
              l("div", {
                ref_key: "myBar",
                ref: r,
                class: "progress-bar"
              }, null, 512),
              l("div", {
                class: P(["end-circle", o.value ? "!bg-primary" : ""])
              }, [
                b(ie, {
                  icon: "flag",
                  "icon-color": o.value ? "white" : "primary",
                  stroke: o.value ? "white" : "primary",
                  opacity: o.value ? 1 : 0.1,
                  width: "32",
                  height: "32"
                }, null, 8, ["icon-color", "stroke", "opacity"])
              ], 2)
            ])
          ], 512)
        ]),
        l("section", HA, [
          b(Ke, {
            class: "justify-center items-center self-center mt-12 mb-8 md:mb-0 max-md:mb-0 max-md:mt-0",
            color: "bg-secondary",
            "hover-color": "bg-secondary hover:brightness-110",
            "text-size": "text-button-large",
            "text-color": "text-dark-1",
            label: t.buttonTitle,
            "icon-after": !0,
            width: "240px",
            height: "65px",
            "icon-color": "dark-1",
            "aria-label": t.buttonTitle,
            link: t.buttonUrl,
            "show-button-sub-text": !0
          }, null, 8, ["label", "aria-label", "link"])
        ])
      ])
    ], 512));
  }
}), Hh = /* @__PURE__ */ fe(XA, [["__scopeId", "data-v-36d5a8b9"]]), KA = { class: "background" }, qA = { class: "flex flex-col items-center self-stretch px-16 max-md:px-5 top-0 left-0 w-full pt-20 max-md:pb-28 pb-32" }, eT = { class: "flex flex-col text-center text-white items-center w-full relative z-20" }, tT = { class: "text-h1 sm:mt-4 mt-8" }, iT = { class: "text-h6 self-stretch mt-1" }, MT = { class: "flex justify-center gap-x-4" }, nT = ["href"], aT = ["href"], rT = ["href"], lT = {
  key: 0,
  class: "relative",
  style: { top: "90px" }
}, oT = { class: "author-image" }, sT = /* @__PURE__ */ ne({
  name: "author-banner-component",
  __name: "AuthorBanner",
  props: {
    header: String,
    subHeader: String,
    wrapperClass: String,
    linkedinUrl: String,
    instaUrl: String,
    youtubeUrl: String,
    image: String
  },
  setup(t) {
    return (e, i) => (y(), A("div", {
      class: P(t.wrapperClass)
    }, [
      l("div", KA, [
        i[3] || (i[3] = l("div", { class: "small-circle" }, null, -1)),
        i[4] || (i[4] = l("div", { class: "medium-circle" }, null, -1)),
        l("main", qA, [
          l("section", eT, [
            l("header", null, [
              l("h1", tT, m(t.header), 1),
              l("h2", iT, m(t.subHeader), 1),
              l("div", MT, [
                t.linkedinUrl && t.linkedinUrl != "" ? (y(), A("a", {
                  key: 0,
                  href: t.linkedinUrl,
                  target: "_self",
                  class: "text-body2 font-bold flex justify-center items-center gap-x-2 mt-6"
                }, [
                  b(ie, {
                    id: "author-linkedin-icon",
                    icon: "linkedin",
                    "icon-color": "white",
                    width: "20",
                    height: "20"
                  }),
                  i[0] || (i[0] = G(" LinkedIn "))
                ], 8, nT)) : k("", !0),
                t.instaUrl && t.instaUrl != "" ? (y(), A("a", {
                  key: 1,
                  href: t.instaUrl,
                  target: "_self",
                  class: "text-body2 font-bold flex justify-center items-center gap-x-2 mt-6"
                }, [
                  b(ie, {
                    id: "author-insta-icon",
                    icon: "instagram",
                    "icon-color": "white",
                    width: "20",
                    height: "20"
                  }),
                  i[1] || (i[1] = G(" Instagram "))
                ], 8, aT)) : k("", !0),
                t.youtubeUrl && t.youtubeUrl != "" ? (y(), A("a", {
                  key: 2,
                  href: t.youtubeUrl,
                  target: "_self",
                  class: "text-body2 font-bold flex justify-center items-center gap-x-2 mt-6"
                }, [
                  b(ie, {
                    id: "author-insta-icon",
                    icon: "youtube",
                    "icon-color": "white",
                    width: "20",
                    height: "20"
                  }),
                  i[2] || (i[2] = G(" Youtube "))
                ], 8, rT)) : k("", !0)
              ])
            ])
          ])
        ])
      ]),
      t.image ? (y(), A("div", lT, [
        l("div", oT, [
          b(Ce, {
            class: "w-40 h-40 rounded-full object-cover",
            "image-name": t.image,
            "image-alt": t.header,
            width: "200px",
            height: "200px"
          }, null, 8, ["image-name", "image-alt"])
        ])
      ])) : k("", !0)
    ], 2));
  }
}), Xh = /* @__PURE__ */ fe(sT, [["__scopeId", "data-v-07bb1858"]]), uT = { class: "max-w-screen-md flex flex-col gap-0 md:gap-12 justify-center items-center self-stretch py-8 text-center sm:py-12" }, cT = { class: "flex flex-col justify-center text-center" }, gT = {
  key: 0,
  class: "flex flex-col text-center w-full max-md:max-w-full"
}, NT = { class: "text-h2 leading-none max-md:max-w-full" }, IT = {
  key: 0,
  class: "text-h6 mt-2 tracking-normal max-md:max-w-full"
}, DT = { class: "w-full grid grid-cols-1 grid-rows-4 max-md:mt-10 gap-8 px-4 lg:px-0" }, dT = { class: "flex flex-col justify-center max-md:justify-end items-center max-md:order-2 px-8" }, jT = { class: "text-primary font-bold outlined-number" }, yT = { class: "text-h4 mb-2" }, AT = ["innerHTML"], TT = /* @__PURE__ */ ne({
  name: "FourStepAboutUsContainer",
  __name: "FourStepAboutUs",
  props: {
    title: { type: String },
    subTitle: { type: String },
    backgroundColor: { type: String }
  },
  setup(t) {
    const e = t, i = [
      {
        id: "step-1",
        title: "Passionate",
        description: "We’re never content to settle for second-best. Our shared passion inspires us to live our purpose every day and own the role our individual actions play in the bigger picture.",
        image: "/dA/e7f9616a5d/fileAsset/Passionate.png"
      },
      {
        id: "step-2",
        title: "Efficient",
        description: "We’re never wasteful. In everything we do, we aim to get the most value from our time, money, and effort. Every day makes a difference and streamlining our way of working is second nature.",
        image: "/dA/a5773d12a7/fileAsset/Efficient.png"
      },
      {
        id: "step-3",
        title: "Resilient",
        description: "We face challenges head on. When we do take hits, we keep moving forward, strengthened by the knowledge that we can overcome any issues through innovation, persistence, and teamwork.",
        image: "/dA/c4f260ab7b/fileAsset/Resilient-2.png"
      },
      {
        id: "step-4",
        title: "Bold",
        description: "We aren’t afraid to challenge convention. Taking calculated risks, embracing change, and adopting emerging technologies are the secret to success.",
        image: "/dA/04373acdd9/fileAsset/Bold.png"
      }
    ];
    return (M, n) => (y(), A("div", {
      class: "flex justify-center",
      style: R({ backgroundColor: t.backgroundColor })
    }, [
      l("div", uT, [
        l("section", cT, [
          e.title ? (y(), A("header", gT, [
            l("span", NT, m(e.title), 1),
            e.subTitle ? (y(), A("span", IT, m(e.subTitle), 1)) : k("", !0)
          ])) : k("", !0)
        ]),
        l("section", DT, [
          (y(), A(ge, null, ye(i, (a, r) => l("div", {
            key: r,
            class: "grid md:grid-cols-2 grid-cols-1 max-md:z-10 max-md:gap-y-0 gap-8 sm:max-w-screen-md lg:max-w-screen-lg"
          }, [
            l("div", {
              class: P([{ "order-2": (r + 1) % 2 == 0 }, "flex justify-center"])
            }, [
              b(Ce, {
                class: "w-full object-cover rounded-lg max-md:max-w-[480px] max-md:w-full",
                "image-name": a.image,
                width: "480px",
                height: "480px"
              }, null, 8, ["image-name"])
            ], 2),
            l("div", dT, [
              l("div", null, [
                l("span", jT, " 0" + m(r + 1), 1)
              ]),
              l("div", yT, m(a.title), 1),
              l("div", {
                class: "text-base",
                innerHTML: a.description
              }, null, 8, AT)
            ])
          ])), 64))
        ])
      ])
    ], 4));
  }
}), Kh = /* @__PURE__ */ fe(TT, [["__scopeId", "data-v-68bd974b"]]);
function Qo(t) {
  return {
    make: "BMW",
    trim: "2.0 520d M SPORT 4d AUTO",
    model: "5 SERIES",
    price: t,
    deposit: 0,
    glassesRetailValuation: t,
    glassesRetailTransacted: t,
    glassesTradeValuation: t,
    mileage: 40419,
    registrationDate: new Date((/* @__PURE__ */ new Date()).setFullYear((/* @__PURE__ */ new Date()).getFullYear() - 2))
  };
}
function ee(t, e, i) {
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    maximumFractionDigits: e ?? 0,
    minimumFractionDigits: i ?? 0
  }).format(t);
}
var xT = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function zT(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
const fT = 9, mT = 57, LT = 58, pT = 13, wT = 22, CT = 8, hT = 53, OT = 39, ET = 68, ST = 49, kT = 50, vT = 69, bT = 63, QT = 62, UT = 67, YT = 66, _T = 48, PT = 29, RT = 44, FT = 70, WT = 71, BT = 72, VT = 73, GT = 74, ZT = 75, $T = 76;
var Va = {
  MONEYBARN: fT,
  M247: mT,
  OODLE: LT,
  MARSH: pT,
  MONEYWAY: wT,
  ADVANTAGE: CT,
  SMF: hT,
  STARTLINE: OT,
  LENDABLE: ET,
  CARFINANCE247: ST,
  ALPHERA: kT,
  METROBANK: vT,
  BNP: bT,
  MANNISLAND: QT,
  MOTONOVO: UT,
  V12: YT,
  BLUE: _T,
  BILLING: PT,
  RATESETTER: RT,
  CLOSE: FT,
  AUTOMONEY: WT,
  TANDEM: BT,
  ZOPA: VT,
  CREDITAGRICOLE: GT,
  NORTHRIDGEFINANCE: ZT,
  CAMCO: $T
};
const Se = Va, wi = {
  T1: 504,
  T2: 505,
  T3: 506,
  T4: 507,
  T5: 508,
  TY: 509
}, tM = {
  A1: 397,
  A2: 398,
  A3: 399,
  A4: 400,
  C: 416
}, JT = [
  {
    financeCompanyId: Se.ADVANTAGE,
    tiers: [
      { tierId: 572, simple: 1.15, baseline: 0 },
      //A1
      { tierId: 573, simple: 1.15, baseline: 0 },
      //A2
      { tierId: 574, simple: 1.15, baseline: 0 },
      //A3
      { tierId: 575, simple: 1.15, baseline: 0 },
      //A4
      { tierId: 576, simple: 1.15, baseline: 0 },
      //B1
      { tierId: 577, simple: 1.15, baseline: 0 },
      //B2
      { tierId: 578, simple: 1.15, baseline: 0 },
      //B3
      { tierId: 579, simple: 1.1, baseline: 0 },
      //C1
      { tierId: 580, simple: 1.1, baseline: 0 },
      //C2
      { tierId: 581, simple: 1.1, baseline: 0 },
      //C3
      { tierId: 582, simple: 1.1, baseline: 0 },
      //D1
      { tierId: 583, simple: 1.1, baseline: 0 }
      //E1
    ],
    simple: 1.15,
    baseline: 0
  },
  {
    financeCompanyId: Se.AUTOMONEY,
    tiers: [
      { tierId: wi.T1, simple: 1, baseline: 0 },
      { tierId: wi.T2, simple: 0.95, baseline: 0 },
      { tierId: wi.T3, simple: 0.95, baseline: 0 },
      { tierId: wi.T4, simple: 1, baseline: 0 },
      { tierId: wi.T5, simple: 1, baseline: 0 },
      { tierId: wi.TY, simple: 0.9, baseline: 0 }
    ],
    simple: 1,
    baseline: 0
  },
  {
    financeCompanyId: Se.BILLING,
    simple: 1,
    baseline: 3
  },
  {
    financeCompanyId: Se.MONEYBARN,
    simple: 1.3,
    tiers: [
      {
        tierId: 116,
        //Tier1A
        complex: {
          0: {
            // hp
            0: {
              // used
              0: [
                {
                  //car
                  limit: 0,
                  simple: 1.1,
                  baseline: 0
                }
              ],
              1: [
                {
                  //van
                  limit: 0,
                  simple: 1.1,
                  baseline: 0,
                  vatQualifying: !0
                },
                {
                  //van
                  limit: 0,
                  simple: 1.3,
                  baseline: 0,
                  vatQualifying: !1
                }
              ]
            }
          }
        }
      },
      {
        tierId: 117,
        //Tier1B
        complex: {
          0: {
            // hp
            0: {
              // used
              0: [
                {
                  //car
                  limit: 0,
                  simple: 1.1,
                  baseline: 0
                }
              ],
              1: [
                {
                  //van
                  limit: 0,
                  simple: 1.1,
                  baseline: 0,
                  vatQualifying: !0
                },
                {
                  //van
                  limit: 0,
                  simple: 1.3,
                  baseline: 0,
                  vatQualifying: !1
                }
              ]
            }
          }
        }
      },
      {
        tierId: 118,
        //Tier1C
        complex: {
          0: {
            // hp
            0: {
              // used
              0: [
                {
                  //car
                  limit: 0,
                  simple: 1.1,
                  baseline: 0
                }
              ],
              1: [
                {
                  //van
                  limit: 0,
                  simple: 1.1,
                  baseline: 0,
                  vatQualifying: !0
                },
                {
                  //van
                  limit: 0,
                  simple: 1.3,
                  baseline: 0,
                  vatQualifying: !1
                }
              ]
            }
          }
        }
      },
      {
        tierId: 103,
        // Tier 2A
        complex: {
          0: {
            // hp
            0: {
              // used
              0: [
                {
                  //car
                  limit: 0,
                  simple: 1,
                  baseline: 0
                }
              ],
              1: [
                {
                  //van
                  limit: 0,
                  simple: 1,
                  baseline: 0,
                  vatQualifying: !0
                },
                {
                  //van
                  limit: 0,
                  simple: 1.2,
                  baseline: 0,
                  vatQualifying: !1
                }
              ]
            }
          }
        }
      },
      {
        tierId: 104,
        // Tier 2B
        complex: {
          0: {
            // hp
            0: {
              // used
              0: [
                {
                  //car
                  limit: 0,
                  simple: 1,
                  baseline: 0
                }
              ],
              1: [
                {
                  //van
                  limit: 0,
                  simple: 1,
                  baseline: 0,
                  vatQualifying: !0
                },
                {
                  //van
                  limit: 0,
                  simple: 1.2,
                  baseline: 0,
                  vatQualifying: !1
                }
              ]
            }
          }
        }
      },
      {
        tierId: 105,
        // Tier 2C
        complex: {
          0: {
            // hp
            0: {
              // used
              0: [
                {
                  //car
                  limit: 0,
                  simple: 1,
                  baseline: 0
                }
              ],
              1: [
                {
                  //van
                  limit: 0,
                  simple: 1,
                  baseline: 0,
                  vatQualifying: !0
                },
                {
                  //van
                  limit: 0,
                  simple: 1.2,
                  baseline: 0,
                  vatQualifying: !1
                }
              ]
            }
          }
        }
      },
      {
        tierId: 67,
        //Tier3A
        complex: {
          0: {
            // hp
            0: {
              // used
              0: [
                {
                  //car
                  limit: 0,
                  simple: 1,
                  baseline: 0
                }
              ],
              1: [
                {
                  //van
                  limit: 0,
                  simple: 1,
                  baseline: 2,
                  vatQualifying: !0
                },
                {
                  //van
                  limit: 0,
                  simple: 1.2,
                  baseline: 2,
                  vatQualifying: !1
                }
              ]
            }
          }
        }
      }
    ],
    baseline: 0
  },
  {
    financeCompanyId: Se.MONEYWAY,
    tiers: [
      { tierId: 167, simple: 1.2, baseline: 0 },
      { tierId: 168, simple: 1.2, baseline: 0 },
      { tierId: 169, simple: 1.2, baseline: 0 },
      { tierId: 170, simple: 1.1, baseline: 0 },
      { tierId: 171, simple: 1.1, baseline: 0 },
      { tierId: 172, simple: 1, baseline: 0 },
      { tierId: 173, simple: 1, baseline: 0 },
      { tierId: 174, simple: 1, baseline: 0 }
    ],
    simple: 1.2,
    baseline: 0
  },
  {
    financeCompanyId: Se.OODLE,
    simple: 1.25,
    baseline: 0
  },
  {
    financeCompanyId: Se.TANDEM,
    tiers: [
      { tierId: 516, simple: 1.2, baseline: 0 },
      { tierId: 517, simple: 1.2, baseline: 0 },
      { tierId: 518, simple: 1.2, baseline: 0 },
      { tierId: 519, simple: 1.2, baseline: 0 },
      { tierId: 520, simple: 1.2, baseline: 0 },
      { tierId: 521, simple: 1.2, baseline: 0 },
      { tierId: 522, simple: 1.2, baseline: 0 },
      { tierId: 523, simple: 1.2, baseline: 0 },
      { tierId: 524, simple: 1.2, baseline: 0 },
      { tierId: 525, simple: 1.1, baseline: 0 },
      { tierId: 526, simple: 1.1, baseline: 0 },
      { tierId: 527, simple: 1.1, baseline: 0 },
      { tierId: 528, simple: 1.1, baseline: 0 },
      { tierId: 529, simple: 1.1, baseline: 0 },
      { tierId: 530, simple: 1.1, baseline: 0 }
    ],
    simple: 1.2,
    baseline: 0
  },
  {
    financeCompanyId: Se.ALPHERA,
    complex: {
      0: {
        // hp
        0: {
          // used
          0: [
            //car
            {
              limit: 0,
              simple: 1.35,
              baseline: 4
            }
          ],
          1: [
            //van
            {
              limit: 0,
              simple: 1.15,
              baseline: 4
            }
          ]
        }
      }
    },
    simple: 1.35,
    baseline: 4
  },
  {
    financeCompanyId: Se.BNP,
    simple: 0.97,
    baseline: 3
  },
  {
    financeCompanyId: Se.CLOSE,
    simple: 1.2,
    baseline: 0
  },
  {
    financeCompanyId: Se.CREDITAGRICOLE,
    complex: {
      0: {
        // hp
        0: {
          // used
          0: [
            //car
            {
              limit: 0,
              simple: 1.5,
              baseline: 3
            },
            {
              limit: 35e3,
              simple: 1.25,
              baseline: 3
            }
          ],
          1: [
            //van
            {
              limit: 0,
              simple: 1.1,
              baseline: 3
            }
          ]
        }
      }
    },
    simple: 1.5,
    baseline: 3
  },
  {
    financeCompanyId: Se.MOTONOVO,
    simple: 1.05,
    tiers: [
      {
        tierId: tM.A1,
        //Tier1A
        complex: {
          0: {
            // hp
            0: {
              // used
              0: [
                {
                  //car
                  limit: 0,
                  simple: 1,
                  buffer: 1e3,
                  baseline: 3
                }
              ]
            }
          },
          1: {
            // pcp
            0: {
              // used
              0: [
                {
                  //car
                  limit: 0,
                  simple: 1.1,
                  buffer: 250,
                  baseline: 3
                }
              ]
            }
          }
        }
      },
      {
        tierId: tM.A2,
        //Tier1A
        complex: {
          0: {
            // hp
            0: {
              // used
              0: [
                {
                  //car
                  limit: 0,
                  simple: 1,
                  buffer: 1e3,
                  baseline: 3
                }
              ]
            }
          },
          1: {
            // pcp
            0: {
              // used
              0: [
                {
                  //car
                  limit: 0,
                  simple: 1.1,
                  buffer: 250,
                  baseline: 3
                }
              ]
            }
          }
        }
      },
      {
        tierId: tM.A3,
        //Tier1A
        complex: {
          0: {
            // hp
            0: {
              // used
              0: [
                {
                  //car
                  limit: 0,
                  simple: 1,
                  buffer: 1e3,
                  baseline: 3
                }
              ]
            }
          },
          1: {
            // pcp
            0: {
              // used
              0: [
                {
                  //car
                  limit: 0,
                  simple: 1.1,
                  buffer: 250,
                  baseline: 3
                }
              ]
            }
          }
        }
      },
      {
        tierId: tM.A4,
        //Tiera4
        complex: {
          0: {
            // hp
            0: {
              // used
              0: [
                {
                  //car
                  limit: 0,
                  simple: 1.05,
                  buffer: 0,
                  baseline: 3
                }
              ]
            }
          },
          1: {
            // pcp
            0: {
              // used
              0: [
                {
                  //car
                  limit: 0,
                  simple: 1.05,
                  buffer: 0,
                  baseline: 3
                }
              ]
            }
          }
        }
      },
      {
        tierId: tM.C,
        //Tier C
        complex: {
          0: {
            // hp
            0: {
              // used
              0: [
                {
                  //car
                  limit: 0,
                  simple: 1.02,
                  buffer: 0,
                  baseline: 3
                }
              ]
            }
          },
          1: {
            // pcp
            0: {
              // used
              0: [
                {
                  //car
                  limit: 0,
                  simple: 1.02,
                  buffer: 0,
                  baseline: 3
                }
              ]
            }
          }
        }
      }
    ],
    baseline: 3
  },
  {
    financeCompanyId: Se.NORTHRIDGEFINANCE,
    complex: {
      0: {
        // hp
        0: {
          // used
          0: [
            //car
            {
              limit: 0,
              simple: 1.35,
              baseline: 4
            },
            {
              limit: 2e4,
              simple: 1.25,
              baseline: 4
            }
          ]
        }
      }
    },
    simple: 1.25,
    baseline: 4
  },
  {
    financeCompanyId: Se.ZOPA,
    simple: 1.25,
    complex: {
      0: {
        // hp
        0: {
          // used
          0: [
            //car
            {
              limit: 0,
              simple: 1.25,
              baseline: 3
            },
            {
              limit: 25e3,
              simple: 1.25,
              baseline: 3
            }
          ]
        }
      }
    },
    tiers: [
      {
        tierId: 542,
        // 3c1
        simple: 1.25,
        baseline: 3
      },
      {
        tierId: 543,
        //3d
        simple: 1.25,
        baseline: 3
      },
      {
        tierId: 544,
        //3e
        simple: 1.25,
        baseline: 3
      }
    ],
    baseline: 3
  },
  {
    financeCompanyId: Se.V12,
    simple: 1.2,
    baseline: 3
  },
  {
    financeCompanyId: Se.RATESETTER,
    simple: 1.9,
    baseline: 0
  },
  {
    financeCompanyId: Se.MANNISLAND,
    simple: 1.2,
    baseline: 0
  },
  {
    financeCompanyId: Se.METROBANK,
    simple: 1.2,
    baseline: 0
  },
  {
    financeCompanyId: Se.SMF,
    simple: 1.1,
    baseline: 0
  },
  {
    financeCompanyId: Se.MARSH,
    simple: 1.2,
    baseline: 0
  },
  {
    financeCompanyId: Se.M247,
    simple: 1,
    baseline: 0
  }
];
var HT = {
  LTVS: JT
};
const XT = [
  {
    score: 550,
    rates: [
      { limit: 0, rate: 12.9 },
      { limit: 7500, rate: 12.9 },
      { limit: 1e4, rate: 12.9 },
      { limit: 15e3, rate: 11.9 },
      { limit: 2e4, rate: 10.9 },
      { limit: 3e4, rate: 9.9 },
      { limit: 4e4, rate: 9.9 },
      { limit: 5e4, rate: 8.9 },
      { limit: 1e5, rate: 8.9 }
    ]
  },
  {
    score: 525,
    rates: [
      { limit: 0, rate: 13.9 },
      { limit: 7500, rate: 13.9 },
      { limit: 1e4, rate: 12.9 },
      { limit: 15e3, rate: 11.9 },
      { limit: 2e4, rate: 10.9 },
      { limit: 3e4, rate: 9.9 },
      { limit: 4e4, rate: 9.9 },
      { limit: 5e4, rate: 8.9 },
      { limit: 1e5, rate: 8.9 }
    ]
  },
  {
    score: 500,
    rates: [
      { limit: 0, rate: 14.9 },
      { limit: 7500, rate: 13.9 },
      { limit: 1e4, rate: 12.9 },
      { limit: 15e3, rate: 11.9 },
      { limit: 2e4, rate: 10.9 },
      { limit: 3e4, rate: 9.9 },
      { limit: 4e4, rate: 9.9 },
      { limit: 5e4, rate: 8.9 },
      { limit: 1e5, rate: 8.9 }
    ]
  },
  {
    score: 475,
    rates: [
      { limit: 0, rate: 14.9 },
      { limit: 7500, rate: 14.9 },
      { limit: 1e4, rate: 13.9 },
      { limit: 15e3, rate: 12.9 },
      { limit: 2e4, rate: 11.9 },
      { limit: 3e4, rate: 9.9 },
      { limit: 4e4, rate: 9.9 },
      { limit: 5e4, rate: 9.9 },
      { limit: 1e5, rate: 8.9 }
    ]
  },
  {
    score: 425,
    rates: [
      { limit: 0, rate: 15.9 },
      { limit: 7500, rate: 14.9 },
      { limit: 1e4, rate: 14.9 },
      { limit: 15e3, rate: 13.9 },
      { limit: 2e4, rate: 12.9 },
      { limit: 3e4, rate: 10.9 },
      { limit: 4e4, rate: 10.9 },
      { limit: 5e4, rate: 9.9 },
      { limit: 1e5, rate: 8.9 }
    ]
  },
  {
    score: 350,
    rates: [
      { limit: 0, rate: 15.9 },
      { limit: 7500, rate: 15.9 },
      { limit: 1e4, rate: 15.9 },
      { limit: 15e3, rate: 14.9 },
      { limit: 2e4, rate: 12.9 },
      { limit: 3e4, rate: 10.9 },
      { limit: 4e4, rate: 10.9 },
      { limit: 5e4, rate: 9.9 },
      { limit: 1e5, rate: 8.9 }
    ]
  },
  {
    score: 0,
    rates: [
      { limit: 0, rate: 15.9 },
      { limit: 7500, rate: 15.9 },
      { limit: 1e4, rate: 15.9 },
      { limit: 15e3, rate: 14.9 },
      { limit: 2e4, rate: 12.9 },
      { limit: 3e4, rate: 10.9 },
      { limit: 4e4, rate: 10.9 },
      { limit: 5e4, rate: 9.9 },
      { limit: 1e5, rate: 8.9 }
    ]
  }
], KT = [
  {
    score: 375,
    // and above
    rates: [
      { limit: 0, rate: 12.9 },
      { limit: 7500, rate: 12.9 },
      { limit: 1e4, rate: 11.9 },
      { limit: 15e3, rate: 11.9 },
      { limit: 2e4, rate: 10.9 },
      { limit: 3e4, rate: 9.9 },
      { limit: 4e4, rate: 9.9 },
      { limit: 5e4, rate: 8.9 },
      { limit: 1e5, rate: 8.9 }
    ]
  },
  {
    score: 0,
    rates: [
      { limit: 0, rate: 15.9 },
      { limit: 7500, rate: 15.9 },
      { limit: 1e4, rate: 15.9 },
      { limit: 15e3, rate: 14.9 },
      { limit: 2e4, rate: 12.9 },
      { limit: 3e4, rate: 10.9 },
      { limit: 4e4, rate: 10.9 },
      { limit: 5e4, rate: 9.9 },
      { limit: 1e5, rate: 8.9 }
    ]
  }
];
var qT = {
  primeRates: XT,
  primeRatesCtMandCkDirect: KT
};
const W = Va, ex = [
  {
    duration: 1,
    price: 699,
    limit: 0
  },
  {
    duration: 1,
    price: 799,
    limit: 7500
  },
  {
    duration: 1,
    price: 999,
    limit: 15e3
  },
  {
    duration: 1,
    price: 1099,
    limit: 25e3
  },
  {
    duration: 2,
    price: 999,
    limit: 0
  },
  {
    duration: 2,
    price: 1199,
    limit: 7500
  },
  {
    duration: 2,
    price: 1499,
    limit: 15e3
  },
  {
    duration: 2,
    price: 1699,
    limit: 25e3
  }
], tx = [
  W.OODLE,
  W.MONEYWAY,
  W.BILLING,
  W.LENDABLE,
  W.MOTONOVO,
  W.BNP,
  W.BLUE,
  W.STARTLINE,
  W.V12,
  W.MANNISLAND,
  W.M247,
  W.CREDITAGRICOLE,
  W.NORTHRIDGEFINANCE,
  W.MONEYBARN,
  W.ZOPA
], ix = [
  W.OODLE,
  W.MONEYWAY,
  W.BILLING,
  W.LENDABLE,
  W.MOTONOVO,
  W.BNP,
  W.BLUE,
  W.STARTLINE,
  W.V12,
  W.MANNISLAND,
  W.M247,
  W.CREDITAGRICOLE,
  W.NORTHRIDGEFINANCE,
  W.MONEYBARN
], Mx = [
  W.ADVANTAGE,
  W.CAMCO
], nx = [], ax = [
  349,
  299,
  279,
  249,
  199,
  169
], rx = [
  W.ALPHERA,
  W.ADVANTAGE,
  W.MONEYBARN,
  W.OODLE,
  W.SMF,
  W.MONEYWAY,
  W.BILLING,
  W.LENDABLE,
  W.MOTONOVO,
  W.BNP,
  W.BLUE,
  W.STARTLINE,
  W.V12,
  W.MANNISLAND,
  W.M247,
  W.CREDITAGRICOLE,
  W.AUTOMONEY,
  W.ZOPA,
  W.NORTHRIDGEFINANCE
], lx = [
  W.ALPHERA,
  W.ADVANTAGE,
  W.MONEYBARN,
  W.OODLE,
  W.SMF,
  W.MONEYWAY,
  W.BILLING,
  W.LENDABLE,
  W.MOTONOVO,
  W.BNP,
  W.BLUE,
  W.STARTLINE,
  W.V12,
  W.MANNISLAND,
  W.M247,
  W.CREDITAGRICOLE,
  W.AUTOMONEY,
  W.ZOPA,
  W.NORTHRIDGEFINANCE
], ox = [
  W.CAMCO
], sx = [
  W.CAMCO
], ux = [
  {
    duration: 2,
    price: 399
  },
  {
    duration: 3,
    price: 499
  }
], cx = [
  W.OODLE,
  W.MONEYWAY,
  W.BILLING,
  W.LENDABLE,
  W.MOTONOVO,
  W.BNP,
  W.BLUE,
  W.STARTLINE,
  W.V12,
  W.MANNISLAND,
  W.M247,
  W.CREDITAGRICOLE,
  W.MONEYBARN,
  W.NORTHRIDGEFINANCE
], gx = [
  W.OODLE,
  W.MONEYWAY,
  W.BILLING,
  W.LENDABLE,
  W.MOTONOVO,
  W.BNP,
  W.BLUE,
  W.STARTLINE,
  W.V12,
  W.MANNISLAND,
  W.M247,
  W.CREDITAGRICOLE,
  W.MONEYBARN,
  W.NORTHRIDGEFINANCE
], Nx = [
  W.ADVANTAGE,
  W.AUTOMONEY,
  W.CAMCO
], Ix = [
  W.ADVANTAGE,
  W.AUTOMONEY,
  W.CAMCO
];
var Dx = {
  WARRANTY_PRICES: ex,
  LENDERS_FUNDING_WARRANTY: tx,
  LENDERS_FUNDING_WARRANTY_PCP: ix,
  LENDERS_NO_WARRANTY: Mx,
  LENDERS_NO_WARRANTY_PCP: nx,
  PAINT_PRICES: ax,
  LENDERS_FUNDING_PAINT: rx,
  LENDERS_FUNDING_PAINT_PCP: lx,
  LENDERS_NO_PAINT: ox,
  LENDERS_NO_PAINT_PCP: sx,
  COSMETIC_REPAIR_PRICES: ux,
  LENDERS_FUNDING_COSMETIC_REPAIR: cx,
  LENDERS_FUNDING_COSMETIC_REPAIR_PCP: gx,
  LENDERS_NO_COSMETIC_REPAIR: Nx,
  LENDERS_NO_COSMETIC_REPAIR_PCP: Ix
};
const dx = {
  UNKNOWN: 0,
  CAR: 1,
  CARAVAN: 3,
  MOTORBIKE: 5,
  VAN: 9
};
var Ga = {
  VEHICLE_TYPE_ENUM: dx
};
const jx = {
  HP: 0,
  PCP: 1
};
var Uo = {
  PRODUCT_TYPE_ENUM: jx
};
const yx = {
  USED: 0
};
var Ax = {
  VEHICLE_CONDITION_ENUM: yx
};
function Tx() {
  const t = /* @__PURE__ */ new Date();
  return new Intl.DateTimeFormat("en-GB", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: !1,
    timeZone: "Europe/London"
  }).format(t);
}
function xx() {
  return (/* @__PURE__ */ new Date()).getFullYear();
}
function zx(t, e) {
  const i = new Date(t);
  return new Date(e).getFullYear() - i.getFullYear();
}
function fx(t) {
  const e = new Date(t), i = /* @__PURE__ */ new Date();
  return (i.getFullYear() - e.getFullYear()) * 12 + (i.getMonth() - e.getMonth());
}
function mx(t) {
  if (!t)
    return null;
  const e = /* @__PURE__ */ new Date(), i = new Date(t);
  let M = e.getFullYear() - i.getFullYear();
  const n = e.getMonth() - i.getMonth(), a = e.getDate() - i.getDate();
  return (n < 0 || n === 0 && a < 0) && M--, M;
}
var Yo = {
  getDateTimeUtcNowUkFormat: Tx,
  currentYear: xx,
  getYearsBetween: zx,
  getMonthsSince: fx,
  getAgeFromDob: mx
};
function Lx(t) {
  return {
    proposalId: 10101,
    lenderReference: "ALPHERA_REF",
    isPrime: !0,
    isPreferredAcceptance: !0,
    minVehicleAgeAtStart: null,
    maxVehicleAgeAtStart: null,
    maxVehicleAgeAtEnd: 10,
    minMileage: null,
    maxMileage: 8e4,
    maxLendAmount: 1e6,
    minLendAmount: 3e3,
    minLendAmountPcp: 3e3,
    minTerm: 24,
    maxTerm: 60,
    loanProposalStatus: "ProvisionalAcceptance",
    amountToFinance: Number(t),
    apr: null,
    flatRate: null,
    financeCompany: "Alphera",
    financeCompanyId: 50,
    rank: null
  };
}
var px = {
  mockAlpheraProposal: Lx
};
function wx(t) {
  return {
    proposalId: 10101,
    lenderReference: "BNP_REF",
    isPrime: !0,
    isPreferredAcceptance: !0,
    minVehicleAgeAtStart: null,
    maxVehicleAgeAtStart: 8,
    maxVehicleAgeAtEnd: 12,
    minMileage: null,
    maxMileage: 1e5,
    maxLendAmount: 75e3,
    minLendAmount: 3e3,
    minTerm: 24,
    maxTerm: 60,
    loanProposalStatus: "ProvisionalAcceptance",
    amountToFinance: Number(t),
    apr: null,
    flatRate: null,
    financeCompany: "BNP Paribas",
    financeCompanyId: 63,
    rank: null
  };
}
var Cx = {
  mockBnpProposal: wx
};
function hx(t) {
  return {
    proposalId: 10101,
    lenderReference: "CLOSE_REF",
    isPrime: !0,
    minVehicleAgeAtStart: null,
    maxVehicleAgeAtStart: null,
    maxVehicleAgeAtEnd: 15,
    minMileage: null,
    maxMileage: 12e4,
    maxLendAmount: 2e5,
    minLendAmount: 1e3,
    minTerm: 36,
    maxTerm: 60,
    loanProposalStatus: "ProvisionalAcceptance",
    amountToFinance: Number(t),
    apr: null,
    flatRate: null,
    financeCompany: "Close Brothers",
    financeCompanyId: 70,
    rank: null
  };
}
var Ox = {
  mockCloseProposal: hx
};
function Ex(t) {
  return {
    proposalId: 10101,
    lenderReference: "DUMMY_REF",
    isPrime: !0,
    isPreferredAcceptance: !0,
    minVehicleAgeAtStart: null,
    maxVehicleAgeAtStart: null,
    maxVehicleAgeAtEnd: 10,
    minMileage: null,
    maxMileage: 125e3,
    maxLendAmount: 5e4,
    minLendAmount: 3e3,
    minTerm: 24,
    maxTerm: 60,
    loanProposalStatus: "ProvisionalAcceptance",
    amountToFinance: Number(t),
    apr: null,
    flatRate: null,
    financeCompany: "Zopa",
    financeCompanyId: 73,
    rank: null
  };
}
var Sx = {
  mockZopaProposal: Ex
};
function kx(t) {
  return {
    proposalId: 10101,
    lenderReference: "MOTONOVO_REF",
    isPrime: !0,
    isPreferredAcceptance: !0,
    minVehicleAgeAtStart: null,
    maxVehicleAgeAtStart: null,
    maxVehicleAgeAtEnd: 15,
    minMileage: null,
    maxMileage: 13e4,
    maxLendAmount: 75e3,
    minLendAmount: 3e3,
    minLendAmountPcp: 3e3,
    minTerm: 36,
    maxTerm: 60,
    loanProposalStatus: "ProvisionalAcceptance",
    amountToFinance: Number(t),
    apr: null,
    flatRate: null,
    financeCompany: "Motonovo",
    financeCompanyId: 67,
    rank: null
  };
}
var vx = {
  mockMotonovoProposal: kx
};
const { mockAlpheraProposal: bx } = px, { mockBnpProposal: Qx } = Cx, { mockCloseProposal: Ux } = Ox, { mockZopaProposal: Yx } = Sx, { mockMotonovoProposal: _x } = vx;
var _o = {
  mockAlpheraProposal: bx,
  mockBnpProposal: Qx,
  mockCloseProposal: Ux,
  mockZopaProposal: Yx,
  mockMotonovoProposal: _x
};
const { VEHICLE_TYPE_ENUM: Px } = Ga, Rx = (t) => t ? t.vehicleType === Px.CAR : !1, Fx = (t) => {
  if (!t)
    return !1;
  const e = (i) => (i = i.toLowerCase(), i.includes("electric") || i.includes("hyb"));
  return t.make && t.make.trim().toLowerCase() === "tesla" ? !0 : t.fuel && t.fuel.trim() !== "" ? e(t.fuel) : t.fuelType && t.fuelType.trim() !== "" ? e(t.fuelType) : !1;
}, Wx = (t) => t ? Rx(t) && Fx(t) : !1;
var Bx = {
  isVehicleElectricOrHybridCar: Wx
};
const { isVehicleElectricOrHybridCar: Po } = Bx, Vx = (t, e) => {
  let i = t.maxMileage ? t.maxMileage : 1 / 0;
  return Po(e) && t.maxMileageAtStartElectricCar > 0 && (i = t.maxMileageAtStartElectricCar), i;
}, Gx = (t, e) => {
  let i = t.maxVehicleAgeAtEnd ? t.maxVehicleAgeAtEnd : 1 / 0;
  return Po(e) && t.maxVehicleAgeAtEndElectricCarMonths > 0 && (i = t.maxVehicleAgeAtEndElectricCarMonths), i;
};
var Ro = {
  getPropMaxMileage: Vx,
  getPropMaxVehicleAgeAtEnd: Gx
};
const { LTVS: Zx } = HT, { primeRates: $x, primeRatesCtMandCkDirect: Jx } = qT, {
  WARRANTY_PRICES: Vr,
  LENDERS_FUNDING_WARRANTY: Hx,
  LENDERS_NO_WARRANTY: Xx,
  PAINT_PRICES: Gr,
  LENDERS_FUNDING_PAINT: Kx,
  LENDERS_NO_PAINT: qx,
  COSMETIC_REPAIR_PRICES: ez,
  LENDERS_FUNDING_COSMETIC_REPAIR: tz,
  LENDERS_NO_COSMETIC_REPAIR: iz,
  LENDERS_NO_WARRANTY_PCP: Mz,
  LENDERS_FUNDING_WARRANTY_PCP: nz,
  LENDERS_FUNDING_PAINT_PCP: az,
  LENDERS_NO_PAINT_PCP: rz,
  LENDERS_FUNDING_COSMETIC_REPAIR_PCP: lz,
  LENDERS_NO_COSMETIC_REPAIR_PCP: oz
} = Dx, {
  MONEYBARN: ln,
  M247: sz,
  OODLE: on,
  MARSH: uz,
  MONEYWAY: sn,
  ADVANTAGE: Gi,
  SMF: Fo,
  STARTLINE: Za,
  LENDABLE: yM,
  CARFINANCE247: AM,
  ALPHERA: ii,
  METROBANK: $a,
  BNP: At,
  MANNISLAND: qt,
  MOTONOVO: Vt,
  V12: xt,
  BLUE: Wo,
  BILLING: Bo,
  CLOSE: TM,
  AUTOMONEY: xM,
  TANDEM: Zi,
  ZOPA: zM,
  CREDITAGRICOLE: fi,
  NORTHRIDGEFINANCE: Bt,
  CAMCO: cz
} = Va, { VEHICLE_TYPE_ENUM: Ni } = Ga, { PRODUCT_TYPE_ENUM: gz } = Uo, { VEHICLE_CONDITION_ENUM: Nz } = Ax, Iz = Yo, { mockAlpheraProposal: Dz, mockBnpProposal: dz, mockCloseProposal: jz, mockZopaProposal: yz } = _o, Zr = Ro, Az = 42416, Tz = 21746, xz = 2655, zz = 43118, fz = 21617;
function mz(t, e, i, M = gz.HP, n = Nz.USED, a = Ni.CAR) {
  let r = 1.25, o = 0;
  const s = Zx.find((c) => c.financeCompanyId === e);
  if (!s)
    return t * r;
  const u = i && s.tiers ? s.tiers.find((c) => c.tierId === i) : null;
  if (u)
    if (u.complex) {
      const c = u.complex[M] ? u.complex[M] : u.complex[0], g = c[n] ? c[n] : c[0], d = g[a] ? g[a] : g[0];
      if (d.length > 0) {
        const j = d.reduce((D, I) => t > I.limit ? I : D, null);
        r = j.simple, o = j.buffer;
      } else
        r = u.simple, o = u.buffer ? u.buffer : 0;
    } else
      r = u.simple, o = u.buffer ? u.buffer : 0;
  else if (s.complex) {
    const c = s.complex[M] ? s.complex[M] : s.complex[0], g = c[n] ? c[n] : c[0], d = g[a] ? g[a] : g[0];
    if (d.length > 0) {
      const j = d.reduce((D, I) => t > I.limit ? I : D, null);
      r = j.simple, o = j.buffer ? j.buffer : 0;
    } else
      r = u.simple, o = u.buffer ? u.buffer : 0;
  } else
    r = s.simple, o = s.buffer ? s.buffer : 0;
  return r < 0.9 && (r = 0.9), r * t + o;
}
const Lz = [
  {
    name: "Glasses Retail",
    id: 0,
    financeCompanies: [
      ln,
      on,
      sn,
      Gi,
      Za,
      yM,
      $a,
      Wo,
      xM,
      Zi
    ]
  },
  {
    name: "Glasses Transacted",
    id: 1,
    financeCompanies: [
      Fo
    ]
  },
  {
    name: "Glasses Trade",
    id: 2,
    financeCompanies: []
  },
  {
    name: "CAP Retail",
    id: 3,
    financeCompanies: [
      Vt,
      At,
      xt,
      qt,
      TM,
      Bt,
      Bo,
      zM
    ]
  },
  {
    name: "CAP Clean",
    id: 4,
    financeCompanies: [
      ii,
      Bt
    ]
  }
];
function pz(t, e) {
  if (e.oldWarrantyPrice)
    return Vr[0].price;
  const i = Vr.filter((M) => M.duration === (e.twoYearWarranty ? 2 : 1)).reduce((M, n) => t > n.limit ? n : M, null);
  return i ? i.price : 0;
}
function wz(t) {
  return Gr.find((e) => e === t.oldPaintPrice) || Gr[0];
}
function Cz(t) {
  return ez.find((e) => t.threeYearCosmeticRepair ? e.duration === 3 : e.duration === 2).price;
}
function Vo(t, e, i, M) {
  const n = {
    totalLoanAmount: e,
    totalLoanAmountPCP: e,
    warrantyPrice: 0,
    paintPrice: 0,
    extrasInPrice: 0,
    extrasInPricePCP: 0,
    extrasOutPrice: 0,
    extrasOutPricePCP: 0,
    extrasCashRequired: 0,
    extrasCashRequiredPCP: 0
  };
  M.includesWarranty && (n.warrantyPrice = pz(t.price, M), Hx.includes(i) ? n.extrasInPrice += n.warrantyPrice : Xx.includes(i) ? n.extrasCashRequired += n.warrantyPrice : n.extrasOutPrice += n.warrantyPrice, nz.includes(i) ? n.extrasInPricePCP += n.warrantyPrice : Mz.includes(i) ? n.extrasCashRequiredPCP += n.warrantyPrice : n.extrasOutPricePCP += n.warrantyPrice), M.includesPaint && (n.paintPrice = wz(M), Kx.includes(i) ? n.extrasInPrice += n.paintPrice : qx.includes(i) ? n.extrasCashRequired += n.paintPrice : n.extrasOutPrice += n.paintPrice, az.includes(i) ? n.extrasInPricePCP += n.paintPrice : rz.includes(i) ? n.extrasCashRequiredPCP += n.paintPrice : n.extrasOutPricePCP += n.paintPrice);
  const a = Ha(t) / 12;
  return M.includesCosmeticRepair && a <= 7 && (n.cosmeticRepairPrice = Cz(M), tz.includes(i) ? n.extrasInPrice += n.cosmeticRepairPrice : iz.includes(i) ? n.extrasCashRequired += n.cosmeticRepairPrice : n.extrasOutPrice += n.cosmeticRepairPrice, lz.includes(i) ? n.extrasInPricePCP += n.cosmeticRepairPrice : oz.includes(i) ? n.extrasCashRequiredPCP += n.cosmeticRepairPrice : n.extrasOutPricePCP += n.cosmeticRepairPrice), n.totalLoanAmount += n.extrasInPrice, n.totalLoanAmountPCP += n.extrasInPricePCP, n;
}
const Ja = [
  ii,
  zM,
  TM,
  Vt,
  Bt,
  fi,
  xt,
  AM
];
function hz(t) {
  return Ja.includes(t);
}
const Oz = [
  Zi
], Ez = [
  Zi
], Go = [
  yM,
  on,
  sn,
  Zi,
  Gi,
  Vt,
  Bt
], Sz = [
  Vt,
  fi,
  xt
], kz = [
  xM
], vz = [
  { financeCompanyId: Gi, dp: 2 },
  { financeCompanyId: xM, dp: 6 }
], ra = [
  { financeCompanyId: ln, adjust: 1, hp: !0, pcp: !0 },
  { financeCompanyId: Bt, adjust: 1, hp: !1, pcp: !0 },
  { financeCompanyId: Vt, adjust: 1, hp: !1, pcp: !0 }
], bz = [
  fi,
  xt,
  Bt
], Zo = [
  sz,
  //used as default lender for some tests
  yM,
  Vt,
  xt,
  fi,
  Bt,
  AM
], $o = [
  ln
];
function Qz(t, e) {
  const i = (a, r) => (a = Yt(a) ? "" : a, r = Yt(r) ? "" : r, a.trim().toLowerCase() === r.trim().toLowerCase()), M = e.vehicleType == null ? Ni.UNKNOWN : e.vehicleType;
  let n = !0;
  if (t.excludedVehicles)
    for (const a of t.excludedVehicles)
      a.make && i(a.make, e.make) && (!a.model || i(a.model, e.model)) && (!a.derivative || i(a.derivative, e.derivative)) && (Yt(a.vehicleType) || a.vehicleType === Ni.UNKNOWN || a.vehicleType === M) && (n = !1);
  return t.supportedVehicleTypeIds && M != Ni.UNKNOWN && !t.supportedVehicleTypeIds.includes(M) ? (t.vehicleRuleResults.push({
    id: t.financeCompanyId,
    displayPriority: 1,
    vehicleId: e.vehicleId,
    resultType: "VehicleFailRule",
    message: `Vehicle type ${Object.keys(Ni).find((a) => Ni[a] === e.vehicleType)} is excluded`
  }), !1) : n ? !0 : (t.vehicleRuleResults.push({
    id: t.financeCompanyId,
    displayPriority: 1,
    vehicleId: e.vehicleId,
    resultType: "VehicleFailRule",
    message: "Vehicle is excluded"
  }), !1);
}
function Uz(t, e) {
  const i = t.dealerId ? t.dealerId : t.dealer && t.dealer.dealerId ? t.dealer.dealerId : null;
  if (!i || !e.bannedDealerIds || e.bannedDealerIds.length === 0)
    return !0;
  const M = !e.bannedDealerIds.find((n) => n === i);
  return M || e.vehicleRuleResults.push({
    id: e.financeCompanyId,
    displayPriority: 1,
    vehicleId: t.vehicleId,
    resultType: "VehicleFailRule",
    rule: "Dealer",
    message: "Dealer is banned with lender"
  }), M;
}
const Yz = 0.432, Qn = [
  0.144,
  0.1386,
  0.1494,
  0.1593,
  0.1512,
  0.162,
  0.1764,
  0.1845,
  0.1917,
  0.2079,
  0.2079,
  0.207,
  0.2025,
  0.015255,
  0.015516,
  0.015786,
  0.016074,
  0.016362,
  0.016668,
  0.016983,
  0.017307,
  0.017649,
  0.018,
  0.018369,
  0.018747,
  0.019152
], $r = {
  ABARTH: 25,
  "ALFA ROMEO": 55,
  ARIEL: 5,
  "ASTON MARTIN": 35,
  AUDI: 40,
  AUSTIN: 100,
  BENTLEY: 35,
  BMW: 35,
  BUGATTI: 45,
  CADILLAC: 65,
  CATERHAM: 20,
  CHEVROLET: 55,
  CHRYSLER: 50,
  CITROEN: 45,
  DACIA: 25,
  DAEWOO: 40,
  DAIHATSU: 55,
  DODGE: 45,
  "DS AUTOMOBILES": 50,
  FERRARI: 15,
  FIAT: 40,
  FORD: 40,
  "GREAT WALL": 50,
  HONDA: 50,
  HUMMER: 35,
  HYUNDAI: 45,
  INFINITI: 45,
  ISUZU: 35,
  JAGUAR: 50,
  JEEP: 35,
  KIA: 50,
  LAMBORGHINI: 10,
  "LAND ROVER": 30,
  LEXUS: 40,
  "LONDON TAXIS INTERNATIONAL": 65,
  LOTUS: 20,
  MASERATI: 45,
  MAYBACH: 75,
  MAZDA: 40,
  MCLAREN: 25,
  "MERCEDES-BENZ": 40,
  MG: 50,
  MINI: 25,
  MITSUBISHI: 40,
  MORGAN: 40,
  NISSAN: 35,
  OPEL: 90,
  PERODUA: 95,
  PEUGEOT: 40,
  PORSCHE: 25,
  PROTON: 35,
  RENAULT: 45,
  "ROLLS-ROYCE": 30,
  ROVER: 55,
  SAAB: 65,
  SEAT: 60,
  SKODA: 45,
  SMART: 40,
  SSANGYONG: 40,
  SUBARU: 30,
  SUZUKI: 25,
  TESLA: 45,
  TOYOTA: 35,
  TVR: 35,
  VAUXHALL: 40,
  VOLKSWAGEN: 40,
  VOLVO: 35,
  WESTFIELD: 60
};
function _z(t, e, i, M, n, a = 8e3) {
  let r = 1;
  const o = Math.floor(M);
  t && (t = t.toUpperCase()), t in $r && (r = 1 - $r[t] / 100, r = Math.pow(r, 1 / 3), r = 1 - r, r /= Yz / 3, r = Math.pow(r, 1 / 3));
  const s = Math.floor(n / 12), u = n === 54 || n === 42 || n === 30 || n === 18;
  let c = i;
  const g = 1;
  try {
    for (let D = 0; D <= s; D++) {
      let I = o + D;
      I >= Qn.length && (I = Qn.length - 1);
      let N = g * r * Qn[I];
      N > 0.5 && (N = 0.5), N < 1e-4 && (N = 1e-4);
      const x = c * N;
      c -= x;
    }
  } catch {
    c = i - i * 0.15 * s;
  }
  u && (c -= c * 0.075);
  const d = -175e-7, j = a - 11900;
  return c += d * j * c, c;
}
const Pz = {
  maxVehicleAgeAtEnd: 12,
  minVehicleAgeAtStart: null,
  maxVehicleAgeAtStart: 8,
  maxMileage: 1e5,
  maxLendAmount: 75e3,
  minLendAmount: 2500,
  maxCustomerAgeAtEnd: null,
  minTerm: 12,
  maxTerm: 60,
  apr: 9.9,
  financeCompany: "BNP",
  financeCompanyId: At,
  tierId: 0
};
function Rz() {
  const t = [
    //            apr  minT, maxT, maxAtStart, maxAtEnd, minLen, maxLend
    [At, "BNP", 10.9, 12, 60, 8, 12, 5e4, 75e3],
    [At, "BNP", 10.9, 12, 60, 8, 12, 3e4, 5e4],
    [At, "BNP", 11.9, 12, 60, 8, 12, 2e4, 3e4],
    [At, "BNP", 12.9, 12, 60, 8, 12, 15e3, 2e4],
    [At, "BNP", 13.9, 12, 60, 8, 12, 1e4, 15e3],
    [At, "BNP", 14.9, 12, 60, 8, 12, 2500, 1e4],
    /* Alphera
    New – 2 years old: 11.9% APR
    2 years old – 5 years old: 12.4% APR
    5+ years old: 12.9% APR
    */
    // The one Alphera rate
    [ii, "Alphera", 11.9, 24, 60, 2, 12, 2e4, 5e5],
    [ii, "Alphera", 12.4, 24, 60, 5, 12, 2e4, 5e5],
    [ii, "Alphera", 12.9, 24, 60, 10, 12, 2e4, 5e5],
    /** V12
    16.9% Min Lend £5k
    15.9% (up to £25k)
    13.9% (£25-£55k)
     */
    [xt, "V12", 16.9, 24, 60, 10, 15, 5e3, 1e4],
    [xt, "V12", 15.9, 24, 60, 10, 15, 1e4, 25e3],
    [xt, "V12", 13.9, 24, 60, 10, 15, 25e3, 55e3],
    [qt, "Mann Island", 13.9, 24, 60, 10, 15, 2e4, 2e5],
    [qt, "Mann Island", 14.9, 24, 60, 10, 15, 15e3, 2e4],
    [qt, "Mann Island", 15.9, 24, 60, 10, 15, 1e4, 15e3],
    [qt, "Mann Island", 16.9, 24, 60, 10, 15, 0, 1e4]
  ], e = [];
  for (const i of t) {
    const M = { ...Pz };
    M.financeCompanyId = i[0], M.financeCompany = i[1], M.apr = i[2], M.minTerm = i[3], M.maxTerm = i[4], M.maxVehicleAgeAtStart = i[5], M.maxVehicleAgeAtEnd = i[6], M.minLendAmount = i[7], M.maxLendAmount = i[8], e.push(M);
  }
  return e;
}
function Yt(t) {
  return typeof t > "u" || t === null;
}
function ke(t) {
  return Yt(t) ? 0 : Number(t);
}
function Fz(t, e) {
  return Yt(e) ? ke(t) : ke(e);
}
function Wz(t, e) {
  return Yt(e) ? ke(t) : Number(e);
}
function Bz(t) {
  return Math.round(t * 1e5) / 1e5;
}
function la(t, e, i, M = "unknown") {
  return Wz(i, t) <= Number(i) && Number(i) <= Fz(i, e);
}
function Vz(t, e = -1, i = null, M = null, n = null, a = !1) {
  let r = [
    { rate: 12.9, limit: 0 },
    { rate: 11.9, limit: 1e4 },
    { rate: 11.9, limit: 15e3 },
    { rate: 10.9, limit: 2e4 },
    { rate: 9.9, limit: 3e4 },
    { rate: 9.9, limit: 5e4 },
    { rate: 8.9, limit: 75e3 }
  ];
  if (M && Array.isArray(M) && M.length > 0) {
    const s = M.find((u) => u.financeCompanyId === n);
    if (s && s.rate)
      return s.rate;
  }
  if (i) {
    i.creditCheckScore || (i.creditCheckScore = 1);
    let s = null;
    i.affiliateUserId && [Tz, Az, fz, zz, xz].includes(i.affiliateUserId) ? s = Jx.find((u) => i.creditCheckScore >= u.score) : s = $x.find((u) => i.creditCheckScore >= u.score), s && (r = s.rates);
  }
  let { rate: o } = r[0];
  for (const s of r)
    t >= s.limit && (o = s.rate);
  return o;
}
function Jr(t, e) {
  let i = 0;
  for (let M = 0; M < t.length; M += 1)
    i += t[M] / Math.pow(1 + e, M / 12);
  return i;
}
function Gz(t, e, i = 2) {
  let M = 0, n = 1e3, a, r = 0;
  const o = 1e3;
  do {
    a = M + (n - M) / 2;
    let s = Jr(t, a);
    if (Jr(e, a) > s ? M = a : n = a, r++, r > o)
      break;
  } while (!(n - M < 1e-7));
  return a.toFixed(i + 2);
}
function Zz(t, e, i = 0, M = 0) {
  let n = [];
  n.push(0);
  for (var a = 0; a < e; a++)
    a == 0 ? i ? n.push(i) : n.push(t) : a == e - 1 && M ? n.push(M) : n.push(t);
  return n;
}
function $z(t, e, i, M) {
  let n = e * 1.83, a = 0, r = 100, o = 1.7;
  const s = 2.2;
  for (; a < 16 && r > 5e-3; ) {
    const u = e * o, c = e * s, g = oa(t, u, M), d = oa(t, c, M), j = g.monthlyPayment, D = d.monthlyPayment;
    o += 1 * (s - o) * (i - j) / (D - j), r = Math.abs(i - j), n = u, a += 1;
  }
  return n;
}
function Jo(t) {
  return t === Gi ? 325 : 0;
}
function Ho(t) {
  switch (t) {
    case Gi:
      return 200;
    case AM:
    case sn:
    case Za:
    case Fo:
    case uz:
    case xt:
    case At:
    case TM:
    case fi:
    case Zi:
    case Bt:
      return 10;
    case Wo:
    case Vt:
    case qt:
    case $a:
    case Bo:
      return 1;
    case on:
      return 50;
    case ii:
      return 1;
    case zM:
      return 0;
    case xM:
      return 199;
    case yM:
      return 25;
    case cz:
      return 20;
  }
  return 0;
}
function oa(t, e, i, M = 0, n = null) {
  const a = n ? $o.find((c) => c === n.financeCompanyId) : !1, r = n ? Zo.find((c) => c === n.financeCompanyId) : !1, o = n ? Jo(n.financeCompanyId) : 0, s = n ? Ho(n.financeCompanyId) : 0, u = n && ra.find((c) => c.financeCompanyId === n.financeCompanyId && c.hp === !0) ? ra.find((c) => c.financeCompanyId === n.financeCompanyId && c.hp === !0).adjust : 0;
  if (i -= u, t && e && i) {
    const c = ke(t) - ke(M);
    if (c > 0) {
      const g = Math.pow(ke(e) / 100 + 1, 0.08333333333333333) - 1;
      let d = 0, j = Math.pow(g + 1, i);
      if (n && bz.find((L) => L === n.financeCompanyId)) {
        const L = (j - s / (t - M)) / j, p = c * g * L, h = 1 - Math.pow(1 / (1 + g), i);
        d = p / h;
      } else {
        const L = c * g * j, p = j - 1;
        d = L / p;
      }
      a && (d = Math.trunc(d * 100) / 100), r && (d = _M(d, 2));
      const D = d * i + ke(o), I = ke(s) > 0 ? d + ke(s) : d, N = _M(d * i, 2) + ke(s) + ke(M);
      let x = N - c - ke(M) - s;
      x = _M(x, 2);
      let f = D / ke(i);
      return n && Go.includes(n.financeCompanyId) && (x += s), {
        monthlyPayment: f,
        firstMonthlyPayment: f,
        finalPayment: I,
        totalAmountPayable: N,
        apr: e,
        effectiveRate: e,
        amountToFinance: c,
        costOfCredit: x,
        termDisplay: i,
        lendersPreFees: o,
        lendersPostFees: s,
        commissionAmount: -1
      };
    }
  }
  return null;
}
function _M(t, e = 2) {
  const i = 10 ** e;
  return t ? Math.round(i * t) / i : 0;
}
function ui(t) {
  return t ? t.toFixed(2) : "####";
}
function yt(t, e) {
  let i = ".";
  for (t && t != null && t != "null" && (i = "" + t), i.length > e && (i = i.substring(0, e)); i.length < e; )
    i = " " + i;
  return i;
}
function Hr(t) {
  return `[${yt(t.rank, 2)}] ${yt(t.financeCompany, 20)} (${yt(t.tierId, 3)}) ${yt(ui(t.effectiveRate), 4)}% ${yt(t.term, 3)} @ £${yt(ui(t.monthlyPayment), 7)}} (F: £${yt(ui(t.firstMonthlyPayment), 7)}}, L: £${yt(ui(t.finalPayment), 7)}})   MinDep: £${yt(ui(t.minDeposit), 9)}}   TotPay: £${yt(ui(t.totalAmountPayable), 9)}}   CostCred: £${yt(ui(t.costOfCredit), 9)}} `;
}
function Jz(t) {
  if (!Array.isArray(t.priceMatrix)) {
    console.warn(" [ NO PRICES RETURNED FOR THIS VEHICLE]");
    return;
  }
  for (const e of t.priceMatrix) {
    for (const i of e.otherOptions)
      ;
    for (const i of e.altOptions)
      ;
  }
  if (Array.isArray(t.pcpMatrix)) {
    for (const e of t.pcpMatrix)
      ;
    for (const e of t.priceMatrix) {
      for (const i of e.otherOptions)
        i.pcp && console.log("po-", Hr(i.pcp));
      for (const i of e.altOptions)
        i.pcp && console.log("pa-", Hr(i.pcp));
    }
  }
}
const Hz = (t, e, i = 0) => {
  if (!e) return 0;
  const M = (Array.isArray(e) ? e : e.match(/([^[.\]])+/g)).reduce((n, a) => n && n[a], t);
  return M === void 0 ? i : M;
};
function Xo(t, e, i, M, n, a = 0, r = !0) {
  t.vehicleRuleResults || (t.vehicleRuleResults = []), e.cannotPriceReasons || (e.cannotPriceReasons = []);
  const o = n.annualMileage ? n.annualMileage : 8e3;
  let s = t.minLendAmount, u = t.maxLendAmount, c = Zr.getPropMaxMileage(t, e), g = 2e5, d = null, j = null, D = t.maxVehicleAgeAtStart, I = Zr.getPropMaxVehicleAgeAtEnd(t, e), N = t.minTerm, x = t.maxTerm, f = r ? t.minDepositPcp : t.minDepositHp, L = r ? t.maxDepositPcp : t.maxDepositHp;
  if (t.maxVehicleAgeAtEnd_HP_Electric > 0 && e.fuel == "Electric/Hybrid" && (I = t.maxVehicleAgeAtEnd_HP_Electric), e.vehicleType == Ni.VAN && (I = t.maxVanAgeAtEnd), r)
    switch (s = t.minLendAmount ? t.minLendAmount : 2500, u = t.maxLendAmount ? t.maxLendAmount : 1e6, c = t.maxMileage ? t.maxMileage : 8e4, g = 2e5, I = 999, D = 999, N = 24, x = 60, t.financeCompanyId) {
      case Vt:
        s = t.minLendAmountPcp ? t.minLendAmountPcp : 3e3, u = 5e4, c = 7e4, N = 36, x = 48, D = 5;
        break;
      case ii:
        s = t.minLendAmountPcp ? t.minLendAmountPcp : 12500, u = 5e5, N = 24, x = 60, I = 10, c = 8e4, g = 15e4, j = 5e4;
        break;
      case At:
        s = t.minLendAmountPcp ? t.minLendAmountPcp : 2500, u = 75e3, x = 60, N = 24, D = 5, I = 9, c = 6e4, g = 1e5;
        break;
      case AM:
        s = t.minLendAmountPcp ? t.minLendAmountPcp : 2500, u = 5e5, x = 60, N = 24, D = 5, I = 10, c = 8e4, g = 15e4;
        break;
      case qt:
        s = t.minLendAmountPcp ? t.minLendAmountPcp : 6e3, u = 89999, N = 36, x = 49, I = 5, c = 8e4;
        break;
      case TM:
        s = t.minLendAmountPcp ? t.minLendAmountPcp : 1e3, u = 2e5, c = 5e4, g = null, I = null, D = 5, N = 36, x = 49;
        break;
      case zM:
        s = t.minLendAmountPcp ? t.minLendAmountPcp : 5e3, u = 5e4, N = 24, x = 48, c = 7e4, D = 5, I = null;
        break;
      case fi:
        s = t.minLendAmountPcp ? t.minLendAmountPcp : 1e4, u = 3e5, N = 24, x = 49, c = 7e4, D = null, I = 9, g = 143e3, d = 5e3, j = 35e3;
        break;
      case xt:
        s = t.minLendAmountPcp ? t.minLendAmountPcp : 5e3, u = 2e4, N = 36, x = 48, c = 108e3, D = 5, I = 9;
      case Bt:
        s = t.minLendAmountPcp ? t.minLendAmountPcp : 5e3, u = 9e4, N = 36, x = 49, c = 12e4, g = 12e4, D = 5, I = 9;
        break;
    }
  if (!la(N, x, M, "pcp_term"))
    return t.vehicleRuleResults.push({
      vehicleId: e.vehicleId,
      term: M,
      resultType: "FinanceFailRule",
      displayPriority: 1,
      pcp: r || !1,
      message: "Term " + M + " months not supported"
    }), e.cannotPriceReasons.push({
      financeCompanyId: t.financeCompanyId,
      term: M,
      pcp: r,
      reason: "Not available at term"
    }), !1;
  const p = M / 12;
  if (c && e.mileage > c)
    return t.vehicleRuleResults.push({
      id: t.financeCompanyId,
      vehicleId: e.vehicleId,
      resultType: "VehicleFailRule",
      displayPriority: 2,
      pcp: r || !1,
      message: "Vehicle mileage exceeds " + c.toLocaleString() + " miles"
    }), e.cannotPriceReasons.push({
      financeCompanyId: t.financeCompanyId,
      reason: "Max Mileage"
    }), !1;
  const h = e.mileage + p * (o || 1);
  if (g && h > g)
    return t.vehicleRuleResults.push({
      vehicleId: e.vehicleId,
      term: M,
      pcp: r || !1,
      resultType: "FinanceFailRule",
      displayPriority: 1,
      message: "Vehicle mileage will exceed " + g.toLocaleString() + " miles at end of " + M + " month agreement"
    }), e.cannotPriceReasons.push({
      financeCompanyId: t.financeCompanyId,
      term: M,
      reason: "Max mileage at term"
    }), !1;
  if (j && o > j)
    return t.vehicleRuleResults.push({
      vehicleId: e.vehicleId,
      pcp: r || !1,
      resultType: "FinanceFailRule",
      displayPriority: 1,
      message: "Exceeds max annual mileage"
    }), e.cannotPriceReasons.push({
      financeCompanyId: t.financeCompanyId,
      reason: "Exceeds max annual mileage"
    }), !1;
  if (d && o && o < d)
    return t.vehicleRuleResults.push({
      vehicleId: e.vehicleId,
      pcp: r || !1,
      resultType: "FinanceFailRule",
      displayPriority: 1,
      message: "Does not meet min annual mileage"
    }), e.cannotPriceReasons.push({
      financeCompanyId: t.financeCompanyId,
      reason: "Does not meet min annual mileage"
    }), !1;
  if (L && a > e.price * L)
    return t.vehicleRuleResults.push({
      vehicleId: e.vehicleId,
      pcp: r || !1,
      resultType: "FinanceFailRule",
      rule: "DepositRule",
      displayPriority: 3,
      message: "Deposit + PX is over " + (L * 100).toLocaleString() + "% of vehicle price"
    }), e.cannotPriceReasons.push({
      financeCompanyId: t.financeCompanyId,
      reason: "Deposit + PX is over " + (L * 100).toLocaleString() + "% of vehicle price"
    }), !1;
  if (f && a < e.price * f)
    return t.vehicleRuleResults.push({
      vehicleId: e.vehicleId,
      pcp: r || !1,
      resultType: "FinanceFailRule",
      rule: "DepositRule",
      displayPriority: 3,
      message: "Deposit + PX is under " + (f * 100).toLocaleString() + "% of vehicle price"
    }), e.cannotPriceReasons.push({
      financeCompanyId: t.financeCompanyId,
      reason: "Deposit + PX is under " + (f * 100).toLocaleString() + "% of vehicle price"
    }), !1;
  if (la(s, u + 1e-3, i, "pcp_amount")) {
    const w = Ko(e);
    if (!Yt(D) && w > D)
      return t.vehicleRuleResults.push({
        id: t.financeCompanyId,
        vehicleId: e.vehicleId,
        resultType: "VehicleFailRule",
        pcp: r || !1,
        displayPriority: 3,
        message: "Vehicle age exceeds " + D * 12 + " months"
      }), e.cannotPriceReasons.find((O) => O.financeCompanyId === t.financeCompanyId && O.reason === "Max age at start") || e.cannotPriceReasons.push({
        financeCompanyId: t.financeCompanyId,
        reason: "Max age at start"
      }), !1;
    if (I = I > 15 ? I / 12 : I, Yt(I) || w + p <= I)
      return !0;
    if (w + p > I)
      return t.vehicleRuleResults.push({
        vehicleId: e.vehicleId,
        resultType: "FinanceFailRule",
        displayPriority: 2,
        pcp: r || !1,
        term: M,
        message: "Vehicle age at end of term"
      }), e.cannotPriceReasons.find((O) => O.financeCompanyId === t.financeCompanyId && O.reason === "Max age at term") || e.cannotPriceReasons.push({
        financeCompanyId: t.financeCompanyId,
        reason: "Max age at term"
      }), !1;
  } else
    i > u && (t.vehicleRuleResults.push({
      vehicleId: e.vehicleId,
      resultType: "FinanceFailRule",
      displayPriority: 1,
      pcp: r || !1,
      message: "Loan amount exceeds maximum of £" + u.toLocaleString()
    }), e.cannotPriceReasons.push({
      financeCompanyId: t.financeCompanyId,
      reason: "Loan amount exceeds maximum"
    })), i < s && (t.vehicleRuleResults.push({
      vehicleId: e.vehicleId,
      resultType: "FinanceFailRule",
      displayPriority: 1,
      pcp: r || !1,
      message: "Loan amount does not meet minimim of £" + s.toLocaleString()
    }), e.cannotPriceReasons.push({
      financeCompanyId: t.financeCompanyId,
      reason: "Loan amount below minimum"
    }));
  return !1;
}
function Xz(t, e = null, i = 8e3, M = 0, n = {}) {
  try {
    t.price = ke(t.price), t.mileage = ke(t.mileage), (!e || !Array.isArray(e) || e.length === 0) && (e = [
      Dz(t.price),
      dz(t.price),
      jz(t.price),
      yz(t.price)
    ]);
    const a = e.filter((o) => Ja.includes(o.financeCompanyId));
    let r = !1;
    for (let o of a) {
      const {
        extrasInPrice: s,
        extrasOutPrice: u
      } = Vo(t, t.price - M, o.financeCompanyId, n), c = ke(t.price) + ke(s) + ke(u) - ke(M);
      for (let g of [24, 36, 48, 60])
        Xo(o, t, c, g, n, M, !0) && (r = !0);
    }
    return r;
  } catch (a) {
    return console.error("PRICING ERROR - isVehiclePcpEligible :::", a), !1;
  }
}
function Ha(t) {
  if (t.hasOwnProperty("ageInMonths") && t.ageInMonths > 0)
    return t.ageInMonths;
  let e = null;
  if (t.hasOwnProperty("registrationDate") && (e = t.registrationDate), (e == null || e === void 0 || e === "") && t.hasOwnProperty("dateOfRegistration") && (e = t.dateOfRegistration), (e == null || e === void 0 || e === "") && t.hasOwnProperty("vehicleDateOfFirstReg") && (e = t.vehicleDateOfFirstReg), e == null || e === void 0 || e === "") {
    const { year: M } = t;
    let n = ke(M);
    n > 0 && n < 100 && (n = 2e3 + n), e = /* @__PURE__ */ new Date(), e.setFullYear(n);
  }
  let i = Iz.getMonthsSince(e);
  return i < 0 && (i = 0), t.ageInMonths = i, i;
}
function Ko(t) {
  return Ha(t) / 12;
}
function Kz(t, e, i, M, n) {
  for (const a of t)
    if (a.effectiveRate <= M && a.financeCompanyId !== i) {
      const r = e.find((o) => a.financeCompanyId === o.financeCompanyId);
      if (r) {
        if (Math.abs(n - a.term) <= Math.abs(n - r.term)) {
          e = e.filter((s) => s.financeCompanyId !== a.financeCompanyId);
          let o = Object.assign({}, a);
          o.altOptions = null, e.push(o);
        }
      } else {
        let o = Object.assign({}, a);
        o.altOptions = null, e.push(o);
      }
    }
  return e;
}
function qz(t) {
  const e = /* @__PURE__ */ new Map();
  for (const M of t)
    e.has(M.financeCompanyId) || e.set(M.financeCompanyId, []), e.get(M.financeCompanyId).push(M);
  const i = [];
  return e.forEach((M, n, a) => {
    M.length > 0 && M.sort((r, o) => r.minDeposit != o.minDeposit ? r.minDeposit - o.minDeposit : r.effectiveRate - o.effectiveRate), i.push(M[0]);
  }), i;
}
function ef(t) {
  if (!t.hasPassedCustomerRules && t.customerRuleResults) {
    for (const e of t.customerRuleResults)
      if (e.resultType == "FixedDecline" && t.loanProposalStatus != "Accepted")
        return !1;
  }
  return !(t.loanProposalStatus == "Declined" || t.loanProposalStatus == "Processing" || t.loanProposalStatus == "FailedSendRules" || t.loanProposalStatus == "MoreInfo" || t.loanProposalStatus == "ManualProcessing");
}
var qo = {
  LTV_BASELINES: Lz,
  getMaxLTV: mz,
  vehicleValid: Qz,
  isVehiclePcpEligible: Xz,
  dealerValid: Uz,
  calculateFutureValue: _z,
  supportsPCP: hz,
  getFixedPrimes: Rz,
  getExtrasPricesForLender: Vo,
  insideRange: la,
  getNum: ke,
  dp2: _M,
  isNullOrUndefined: Yt,
  isntDeclined: ef,
  getPrimeRate: Vz,
  calcAPRBisectionMethod: Gz,
  installmentBuilder: Zz,
  calculateEffectiveRate: $z,
  getLendersPreFees: Jo,
  getLendersPostFees: Ho,
  calculateMonthlyPayment: oa,
  p: Bz,
  dumpMatrix: Jz,
  getByPath: Hz,
  vehicleQualifies: Xo,
  vehicleAgeInMonths: Ha,
  vehicleAge: Ko,
  findBetterEffectiveRates: Kz,
  collapse: qz,
  MONEYBARN: ln,
  ADVANTAGE: Gi,
  LENDABLE: yM,
  CARFINANCE247: AM,
  ALPHERA: ii,
  STARTLINE: Za,
  METROBANK: $a,
  OODLE: on,
  MONEYWAY: sn,
  BNP: At,
  CLOSE: TM,
  MANNISLAND: qt,
  MOTONOVO: Vt,
  V12: xt,
  AUTOMONEY: xM,
  TANDEM: Zi,
  ZOPA: zM,
  CREDITAGRICOLE: fi,
  PCP_LENDERS: Ja,
  LENDERS_TERM_ADJUST: ra,
  LENDERS_TRUNCATE_AND_ROUND_MONTHLY_PAYMENT: Zo,
  LENDERS_TRUNCATE_MONTHLY_PAYMENT: $o,
  LENDERS_INCLUDE_POST_FEES_IN_COST_OF_CREDIT: Go,
  LENDERS_EXCLUDE_POST_FEES_FROM_COST_OF_CREDIT_PCP: Sz,
  LENDERS_EXCLUDE_DEPOSIT_FROM_TOTAL_AMOUNT_PAYABLE: Oz,
  LENDERS_NO_MONTHLY_PAYMENT_ROUNDING: Ez,
  LENDERS_EXCLUDE_CHARGES_FROM_COST_OF_CREDIT: kz,
  FLAT_RATE_CALC_ROUNDING: vz
};
function tf(t) {
  return {
    proposalId: 10101,
    lenderReference: "DUMMY_REF",
    isPrime: !0,
    isPreferredAcceptance: !0,
    minVehicleAgeAtStart: null,
    maxVehicleAgeAtStart: null,
    maxVehicleAgeAtEnd: 12,
    minMileage: null,
    maxMileage: 7e4,
    maxLendAmount: 3e5,
    minLendAmount: 1e4,
    minTerm: 24,
    maxTerm: 49,
    loanProposalStatus: "ProvisionalAcceptance",
    amountToFinance: Number(t),
    apr: null,
    flatRate: null,
    financeCompany: "Credit Agricole",
    financeCompanyId: 74,
    rank: null
  };
}
var Mf = {
  mockCaProposal: tf
};
function nf(t) {
  return {
    proposalId: 10101,
    lenderReference: "NORTHRIDGE_REF",
    isPrime: !0,
    isPreferredAcceptance: !0,
    minVehicleAgeAtStart: null,
    maxVehicleAgeAtStart: null,
    maxVehicleAgeAtEnd: 15,
    minMileage: null,
    maxMileage: 9e4,
    maxLendAmount: 15e4,
    minLendAmount: 2500,
    minLendAmountPcp: 5e3,
    minTerm: 24,
    maxTerm: 60,
    loanProposalStatus: "ProvisionalAcceptance",
    maxVehicleAgeAtEnd: 156,
    maxVanAgeAtEnd: 10,
    maxVehicleAgeAtEnd_HP_Electric: 9,
    excludedVehicles: [
      {
        make: "Make",
        model: "Model",
        derivative: "Derivative"
      },
      {
        make: "Ferrari",
        model: "",
        derivative: ""
      },
      {
        make: "Lamborghini",
        model: "",
        derivative: ""
      },
      {
        make: "Maserati",
        model: "",
        derivative: ""
      },
      {
        make: "Fisker",
        model: "",
        derivative: ""
      }
    ],
    amountToFinance: Number(t),
    apr: null,
    flatRate: null,
    financeCompany: "Northridge",
    financeCompanyId: 75,
    rank: null
  };
}
var af = {
  mockNorthridgeProposal: nf
};
function rf(t) {
  return {
    proposalId: 10101,
    lenderReference: "DUMMY_REF",
    isPrime: !0,
    isPreferredAcceptance: !0,
    minVehicleAgeAtStart: null,
    maxVehicleAgeAtStart: null,
    maxVehicleAgeAtEnd: 15,
    minMileage: null,
    maxMileage: 125e3,
    maxLendAmount: 2e4,
    minLendAmount: 5e3,
    minTerm: 36,
    maxTerm: 60,
    loanProposalStatus: "ProvisionalAcceptance",
    amountToFinance: Number(t),
    apr: null,
    flatRate: null,
    financeCompany: "V12",
    financeCompanyId: 66,
    rank: null
  };
}
var lf = {
  mockV12Proposal: rf
};
function es(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: of } = Object.prototype, { getPrototypeOf: Xa } = Object, un = /* @__PURE__ */ ((t) => (e) => {
  const i = of.call(e);
  return t[i] || (t[i] = i.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), ft = (t) => (t = t.toLowerCase(), (e) => un(e) === t), cn = (t) => (e) => typeof e === t, { isArray: $i } = Array, dM = cn("undefined");
function sf(t) {
  return t !== null && !dM(t) && t.constructor !== null && !dM(t.constructor) && ut(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const ts = ft("ArrayBuffer");
function uf(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && ts(t.buffer), e;
}
const cf = cn("string"), ut = cn("function"), is = cn("number"), gn = (t) => t !== null && typeof t == "object", gf = (t) => t === !0 || t === !1, PM = (t) => {
  if (un(t) !== "object")
    return !1;
  const e = Xa(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}, Nf = ft("Date"), If = ft("File"), Df = ft("Blob"), df = ft("FileList"), jf = (t) => gn(t) && ut(t.pipe), yf = (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || ut(t.append) && ((e = un(t)) === "formdata" || // detect form-data instance
  e === "object" && ut(t.toString) && t.toString() === "[object FormData]"));
}, Af = ft("URLSearchParams"), [Tf, xf, zf, ff] = ["ReadableStream", "Request", "Response", "Headers"].map(ft), mf = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function fM(t, e, { allOwnKeys: i = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let M, n;
  if (typeof t != "object" && (t = [t]), $i(t))
    for (M = 0, n = t.length; M < n; M++)
      e.call(null, t[M], M, t);
  else {
    const a = i ? Object.getOwnPropertyNames(t) : Object.keys(t), r = a.length;
    let o;
    for (M = 0; M < r; M++)
      o = a[M], e.call(null, t[o], o, t);
  }
}
function Ms(t, e) {
  e = e.toLowerCase();
  const i = Object.keys(t);
  let M = i.length, n;
  for (; M-- > 0; )
    if (n = i[M], e === n.toLowerCase())
      return n;
  return null;
}
const Di = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : xT, ns = (t) => !dM(t) && t !== Di;
function sa() {
  const { caseless: t } = ns(this) && this || {}, e = {}, i = (M, n) => {
    const a = t && Ms(e, n) || n;
    PM(e[a]) && PM(M) ? e[a] = sa(e[a], M) : PM(M) ? e[a] = sa({}, M) : $i(M) ? e[a] = M.slice() : e[a] = M;
  };
  for (let M = 0, n = arguments.length; M < n; M++)
    arguments[M] && fM(arguments[M], i);
  return e;
}
const Lf = (t, e, i, { allOwnKeys: M } = {}) => (fM(e, (n, a) => {
  i && ut(n) ? t[a] = es(n, i) : t[a] = n;
}, { allOwnKeys: M }), t), pf = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), wf = (t, e, i, M) => {
  t.prototype = Object.create(e.prototype, M), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), i && Object.assign(t.prototype, i);
}, Cf = (t, e, i, M) => {
  let n, a, r;
  const o = {};
  if (e = e || {}, t == null) return e;
  do {
    for (n = Object.getOwnPropertyNames(t), a = n.length; a-- > 0; )
      r = n[a], (!M || M(r, t, e)) && !o[r] && (e[r] = t[r], o[r] = !0);
    t = i !== !1 && Xa(t);
  } while (t && (!i || i(t, e)) && t !== Object.prototype);
  return e;
}, hf = (t, e, i) => {
  t = String(t), (i === void 0 || i > t.length) && (i = t.length), i -= e.length;
  const M = t.indexOf(e, i);
  return M !== -1 && M === i;
}, Of = (t) => {
  if (!t) return null;
  if ($i(t)) return t;
  let e = t.length;
  if (!is(e)) return null;
  const i = new Array(e);
  for (; e-- > 0; )
    i[e] = t[e];
  return i;
}, Ef = /* @__PURE__ */ ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && Xa(Uint8Array)), Sf = (t, e) => {
  const i = (t && t[Symbol.iterator]).call(t);
  let M;
  for (; (M = i.next()) && !M.done; ) {
    const n = M.value;
    e.call(t, n[0], n[1]);
  }
}, kf = (t, e) => {
  let i;
  const M = [];
  for (; (i = t.exec(e)) !== null; )
    M.push(i);
  return M;
}, vf = ft("HTMLFormElement"), bf = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(e, i, M) {
    return i.toUpperCase() + M;
  }
), Xr = (({ hasOwnProperty: t }) => (e, i) => t.call(e, i))(Object.prototype), Qf = ft("RegExp"), as = (t, e) => {
  const i = Object.getOwnPropertyDescriptors(t), M = {};
  fM(i, (n, a) => {
    let r;
    (r = e(n, a, t)) !== !1 && (M[a] = r || n);
  }), Object.defineProperties(t, M);
}, Uf = (t) => {
  as(t, (e, i) => {
    if (ut(t) && ["arguments", "caller", "callee"].indexOf(i) !== -1)
      return !1;
    const M = t[i];
    if (ut(M)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + i + "'");
      });
    }
  });
}, Yf = (t, e) => {
  const i = {}, M = (n) => {
    n.forEach((a) => {
      i[a] = !0;
    });
  };
  return $i(t) ? M(t) : M(String(t).split(e)), i;
}, _f = () => {
}, Pf = (t, e) => t != null && Number.isFinite(t = +t) ? t : e, Un = "abcdefghijklmnopqrstuvwxyz", Kr = "0123456789", rs = {
  DIGIT: Kr,
  ALPHA: Un,
  ALPHA_DIGIT: Un + Un.toUpperCase() + Kr
}, Rf = (t = 16, e = rs.ALPHA_DIGIT) => {
  let i = "";
  const { length: M } = e;
  for (; t--; )
    i += e[Math.random() * M | 0];
  return i;
};
function Ff(t) {
  return !!(t && ut(t.append) && t[Symbol.toStringTag] === "FormData" && t[Symbol.iterator]);
}
const Wf = (t) => {
  const e = new Array(10), i = (M, n) => {
    if (gn(M)) {
      if (e.indexOf(M) >= 0)
        return;
      if (!("toJSON" in M)) {
        e[n] = M;
        const a = $i(M) ? [] : {};
        return fM(M, (r, o) => {
          const s = i(r, n + 1);
          !dM(s) && (a[o] = s);
        }), e[n] = void 0, a;
      }
    }
    return M;
  };
  return i(t, 0);
}, Bf = ft("AsyncFunction"), Vf = (t) => t && (gn(t) || ut(t)) && ut(t.then) && ut(t.catch), ls = ((t, e) => t ? setImmediate : e ? ((i, M) => (Di.addEventListener("message", ({ source: n, data: a }) => {
  n === Di && a === i && M.length && M.shift()();
}, !1), (n) => {
  M.push(n), Di.postMessage(i, "*");
}))(`axios@${Math.random()}`, []) : (i) => setTimeout(i))(
  typeof setImmediate == "function",
  ut(Di.postMessage)
), Gf = typeof queueMicrotask < "u" ? queueMicrotask.bind(Di) : typeof process < "u" && process.nextTick || ls;
var U = {
  isArray: $i,
  isArrayBuffer: ts,
  isBuffer: sf,
  isFormData: yf,
  isArrayBufferView: uf,
  isString: cf,
  isNumber: is,
  isBoolean: gf,
  isObject: gn,
  isPlainObject: PM,
  isReadableStream: Tf,
  isRequest: xf,
  isResponse: zf,
  isHeaders: ff,
  isUndefined: dM,
  isDate: Nf,
  isFile: If,
  isBlob: Df,
  isRegExp: Qf,
  isFunction: ut,
  isStream: jf,
  isURLSearchParams: Af,
  isTypedArray: Ef,
  isFileList: df,
  forEach: fM,
  merge: sa,
  extend: Lf,
  trim: mf,
  stripBOM: pf,
  inherits: wf,
  toFlatObject: Cf,
  kindOf: un,
  kindOfTest: ft,
  endsWith: hf,
  toArray: Of,
  forEachEntry: Sf,
  matchAll: kf,
  isHTMLForm: vf,
  hasOwnProperty: Xr,
  hasOwnProp: Xr,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: as,
  freezeMethods: Uf,
  toObjectSet: Yf,
  toCamelCase: bf,
  noop: _f,
  toFiniteNumber: Pf,
  findKey: Ms,
  global: Di,
  isContextDefined: ns,
  ALPHABET: rs,
  generateString: Rf,
  isSpecCompliantForm: Ff,
  toJSONObject: Wf,
  isAsyncFn: Bf,
  isThenable: Vf,
  setImmediate: ls,
  asap: Gf
};
function ce(t, e, i, M, n) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), i && (this.config = i), M && (this.request = M), n && (this.response = n, this.status = n.status ? n.status : null);
}
U.inherits(ce, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: U.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const os = ce.prototype, ss = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  ss[t] = { value: t };
});
Object.defineProperties(ce, ss);
Object.defineProperty(os, "isAxiosError", { value: !0 });
ce.from = (t, e, i, M, n, a) => {
  const r = Object.create(os);
  return U.toFlatObject(t, r, function(o) {
    return o !== Error.prototype;
  }, (o) => o !== "isAxiosError"), ce.call(r, t.message, e, i, M, n), r.cause = t, r.name = t.name, a && Object.assign(r, a), r;
};
var Zf = null;
function ua(t) {
  return U.isPlainObject(t) || U.isArray(t);
}
function us(t) {
  return U.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function qr(t, e, i) {
  return t ? t.concat(e).map(function(M, n) {
    return M = us(M), !i && n ? "[" + M + "]" : M;
  }).join(i ? "." : "") : e;
}
function $f(t) {
  return U.isArray(t) && !t.some(ua);
}
const Jf = U.toFlatObject(U, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Nn(t, e, i) {
  if (!U.isObject(t))
    throw new TypeError("target must be an object");
  e = e || new FormData(), i = U.toFlatObject(i, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(j, D) {
    return !U.isUndefined(D[j]);
  });
  const M = i.metaTokens, n = i.visitor || u, a = i.dots, r = i.indexes, o = (i.Blob || typeof Blob < "u" && Blob) && U.isSpecCompliantForm(e);
  if (!U.isFunction(n))
    throw new TypeError("visitor must be a function");
  function s(j) {
    if (j === null) return "";
    if (U.isDate(j))
      return j.toISOString();
    if (!o && U.isBlob(j))
      throw new ce("Blob is not supported. Use a Buffer instead.");
    return U.isArrayBuffer(j) || U.isTypedArray(j) ? o && typeof Blob == "function" ? new Blob([j]) : Buffer.from(j) : j;
  }
  function u(j, D, I) {
    let N = j;
    if (j && !I && typeof j == "object") {
      if (U.endsWith(D, "{}"))
        D = M ? D : D.slice(0, -2), j = JSON.stringify(j);
      else if (U.isArray(j) && $f(j) || (U.isFileList(j) || U.endsWith(D, "[]")) && (N = U.toArray(j)))
        return D = us(D), N.forEach(function(x, f) {
          !(U.isUndefined(x) || x === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            r === !0 ? qr([D], f, a) : r === null ? D : D + "[]",
            s(x)
          );
        }), !1;
    }
    return ua(j) ? !0 : (e.append(qr(I, D, a), s(j)), !1);
  }
  const c = [], g = Object.assign(Jf, {
    defaultVisitor: u,
    convertValue: s,
    isVisitable: ua
  });
  function d(j, D) {
    if (!U.isUndefined(j)) {
      if (c.indexOf(j) !== -1)
        throw Error("Circular reference detected in " + D.join("."));
      c.push(j), U.forEach(j, function(I, N) {
        (!(U.isUndefined(I) || I === null) && n.call(
          e,
          I,
          U.isString(N) ? N.trim() : N,
          D,
          g
        )) === !0 && d(I, D ? D.concat(N) : [N]);
      }), c.pop();
    }
  }
  if (!U.isObject(t))
    throw new TypeError("data must be an object");
  return d(t), e;
}
function el(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(i) {
    return e[i];
  });
}
function Ka(t, e) {
  this._pairs = [], t && Nn(t, this, e);
}
const cs = Ka.prototype;
cs.append = function(t, e) {
  this._pairs.push([t, e]);
};
cs.toString = function(t) {
  const e = t ? function(i) {
    return t.call(this, i, el);
  } : el;
  return this._pairs.map(function(i) {
    return e(i[0]) + "=" + e(i[1]);
  }, "").join("&");
};
function Hf(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function gs(t, e, i) {
  if (!e)
    return t;
  const M = i && i.encode || Hf;
  U.isFunction(i) && (i = {
    serialize: i
  });
  const n = i && i.serialize;
  let a;
  if (n ? a = n(e, i) : a = U.isURLSearchParams(e) ? e.toString() : new Ka(e, i).toString(M), a) {
    const r = t.indexOf("#");
    r !== -1 && (t = t.slice(0, r)), t += (t.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return t;
}
class Xf {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, i, M) {
    return this.handlers.push({
      fulfilled: e,
      rejected: i,
      synchronous: M ? M.synchronous : !1,
      runWhen: M ? M.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    U.forEach(this.handlers, function(i) {
      i !== null && e(i);
    });
  }
}
var tl = Xf, Ns = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Kf = typeof URLSearchParams < "u" ? URLSearchParams : Ka, qf = typeof FormData < "u" ? FormData : null, em = typeof Blob < "u" ? Blob : null, tm = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Kf,
    FormData: qf,
    Blob: em
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
const qa = typeof window < "u" && typeof document < "u", ca = typeof navigator == "object" && navigator || void 0, im = qa && (!ca || ["ReactNative", "NativeScript", "NS"].indexOf(ca.product) < 0), Mm = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", nm = qa && window.location.href || "http://localhost";
var am = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  hasBrowserEnv: qa,
  hasStandardBrowserWebWorkerEnv: Mm,
  hasStandardBrowserEnv: im,
  navigator: ca,
  origin: nm
}), $e = {
  ...am,
  ...tm
};
function rm(t, e) {
  return Nn(t, new $e.classes.URLSearchParams(), Object.assign({
    visitor: function(i, M, n, a) {
      return $e.isNode && U.isBuffer(i) ? (this.append(M, i.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function lm(t) {
  return U.matchAll(/\w+|\[(\w*)]/g, t).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function om(t) {
  const e = {}, i = Object.keys(t);
  let M;
  const n = i.length;
  let a;
  for (M = 0; M < n; M++)
    a = i[M], e[a] = t[a];
  return e;
}
function Is(t) {
  function e(i, M, n, a) {
    let r = i[a++];
    if (r === "__proto__") return !0;
    const o = Number.isFinite(+r), s = a >= i.length;
    return r = !r && U.isArray(n) ? n.length : r, s ? (U.hasOwnProp(n, r) ? n[r] = [n[r], M] : n[r] = M, !o) : ((!n[r] || !U.isObject(n[r])) && (n[r] = []), e(i, M, n[r], a) && U.isArray(n[r]) && (n[r] = om(n[r])), !o);
  }
  if (U.isFormData(t) && U.isFunction(t.entries)) {
    const i = {};
    return U.forEachEntry(t, (M, n) => {
      e(lm(M), n, i, 0);
    }), i;
  }
  return null;
}
function sm(t, e, i) {
  if (U.isString(t))
    try {
      return (e || JSON.parse)(t), U.trim(t);
    } catch (M) {
      if (M.name !== "SyntaxError")
        throw M;
    }
  return (i || JSON.stringify)(t);
}
const er = {
  transitional: Ns,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, e) {
    const i = e.getContentType() || "", M = i.indexOf("application/json") > -1, n = U.isObject(t);
    if (n && U.isHTMLForm(t) && (t = new FormData(t)), U.isFormData(t))
      return M ? JSON.stringify(Is(t)) : t;
    if (U.isArrayBuffer(t) || U.isBuffer(t) || U.isStream(t) || U.isFile(t) || U.isBlob(t) || U.isReadableStream(t))
      return t;
    if (U.isArrayBufferView(t))
      return t.buffer;
    if (U.isURLSearchParams(t))
      return e.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let a;
    if (n) {
      if (i.indexOf("application/x-www-form-urlencoded") > -1)
        return rm(t, this.formSerializer).toString();
      if ((a = U.isFileList(t)) || i.indexOf("multipart/form-data") > -1) {
        const r = this.env && this.env.FormData;
        return Nn(
          a ? { "files[]": t } : t,
          r && new r(),
          this.formSerializer
        );
      }
    }
    return n || M ? (e.setContentType("application/json", !1), sm(t)) : t;
  }],
  transformResponse: [function(t) {
    const e = this.transitional || er.transitional, i = e && e.forcedJSONParsing, M = this.responseType === "json";
    if (U.isResponse(t) || U.isReadableStream(t))
      return t;
    if (t && U.isString(t) && (i && !this.responseType || M)) {
      const n = !(e && e.silentJSONParsing) && M;
      try {
        return JSON.parse(t);
      } catch (a) {
        if (n)
          throw a.name === "SyntaxError" ? ce.from(a, ce.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: $e.classes.FormData,
    Blob: $e.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
U.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  er.headers[t] = {};
});
var tr = er;
const um = U.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]);
var cm = (t) => {
  const e = {};
  let i, M, n;
  return t && t.split(`
`).forEach(function(a) {
    n = a.indexOf(":"), i = a.substring(0, n).trim().toLowerCase(), M = a.substring(n + 1).trim(), !(!i || e[i] && um[i]) && (i === "set-cookie" ? e[i] ? e[i].push(M) : e[i] = [M] : e[i] = e[i] ? e[i] + ", " + M : M);
  }), e;
};
const il = Symbol("internals");
function iM(t) {
  return t && String(t).trim().toLowerCase();
}
function RM(t) {
  return t === !1 || t == null ? t : U.isArray(t) ? t.map(RM) : String(t);
}
function gm(t) {
  const e = /* @__PURE__ */ Object.create(null), i = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let M;
  for (; M = i.exec(t); )
    e[M[1]] = M[2];
  return e;
}
const Nm = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function Yn(t, e, i, M, n) {
  if (U.isFunction(M))
    return M.call(this, e, i);
  if (n && (e = i), !!U.isString(e)) {
    if (U.isString(M))
      return e.indexOf(M) !== -1;
    if (U.isRegExp(M))
      return M.test(e);
  }
}
function Im(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, i, M) => i.toUpperCase() + M);
}
function Dm(t, e) {
  const i = U.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((M) => {
    Object.defineProperty(t, M + i, {
      value: function(n, a, r) {
        return this[M].call(this, e, n, a, r);
      },
      configurable: !0
    });
  });
}
class In {
  constructor(e) {
    e && this.set(e);
  }
  set(e, i, M) {
    const n = this;
    function a(o, s, u) {
      const c = iM(s);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const g = U.findKey(n, c);
      (!g || n[g] === void 0 || u === !0 || u === void 0 && n[g] !== !1) && (n[g || s] = RM(o));
    }
    const r = (o, s) => U.forEach(o, (u, c) => a(u, c, s));
    if (U.isPlainObject(e) || e instanceof this.constructor)
      r(e, i);
    else if (U.isString(e) && (e = e.trim()) && !Nm(e))
      r(cm(e), i);
    else if (U.isHeaders(e))
      for (const [o, s] of e.entries())
        a(s, o, M);
    else
      e != null && a(i, e, M);
    return this;
  }
  get(e, i) {
    if (e = iM(e), e) {
      const M = U.findKey(this, e);
      if (M) {
        const n = this[M];
        if (!i)
          return n;
        if (i === !0)
          return gm(n);
        if (U.isFunction(i))
          return i.call(this, n, M);
        if (U.isRegExp(i))
          return i.exec(n);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, i) {
    if (e = iM(e), e) {
      const M = U.findKey(this, e);
      return !!(M && this[M] !== void 0 && (!i || Yn(this, this[M], M, i)));
    }
    return !1;
  }
  delete(e, i) {
    const M = this;
    let n = !1;
    function a(r) {
      if (r = iM(r), r) {
        const o = U.findKey(M, r);
        o && (!i || Yn(M, M[o], o, i)) && (delete M[o], n = !0);
      }
    }
    return U.isArray(e) ? e.forEach(a) : a(e), n;
  }
  clear(e) {
    const i = Object.keys(this);
    let M = i.length, n = !1;
    for (; M--; ) {
      const a = i[M];
      (!e || Yn(this, this[a], a, e, !0)) && (delete this[a], n = !0);
    }
    return n;
  }
  normalize(e) {
    const i = this, M = {};
    return U.forEach(this, (n, a) => {
      const r = U.findKey(M, a);
      if (r) {
        i[r] = RM(n), delete i[a];
        return;
      }
      const o = e ? Im(a) : String(a).trim();
      o !== a && delete i[a], i[o] = RM(n), M[o] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const i = /* @__PURE__ */ Object.create(null);
    return U.forEach(this, (M, n) => {
      M != null && M !== !1 && (i[n] = e && U.isArray(M) ? M.join(", ") : M);
    }), i;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, i]) => e + ": " + i).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...i) {
    const M = new this(e);
    return i.forEach((n) => M.set(n)), M;
  }
  static accessor(e) {
    const i = (this[il] = this[il] = {
      accessors: {}
    }).accessors, M = this.prototype;
    function n(a) {
      const r = iM(a);
      i[r] || (Dm(M, a), i[r] = !0);
    }
    return U.isArray(e) ? e.forEach(n) : n(e), this;
  }
}
In.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
U.reduceDescriptors(In.prototype, ({ value: t }, e) => {
  let i = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t,
    set(M) {
      this[i] = M;
    }
  };
});
U.freezeMethods(In);
var zt = In;
function _n(t, e) {
  const i = this || tr, M = e || i, n = zt.from(M.headers);
  let a = M.data;
  return U.forEach(t, function(r) {
    a = r.call(i, a, n.normalize(), e ? e.status : void 0);
  }), n.normalize(), a;
}
function Ds(t) {
  return !!(t && t.__CANCEL__);
}
function Ji(t, e, i) {
  ce.call(this, t ?? "canceled", ce.ERR_CANCELED, e, i), this.name = "CanceledError";
}
U.inherits(Ji, ce, {
  __CANCEL__: !0
});
function ds(t, e, i) {
  const M = i.config.validateStatus;
  !i.status || !M || M(i.status) ? t(i) : e(new ce(
    "Request failed with status code " + i.status,
    [ce.ERR_BAD_REQUEST, ce.ERR_BAD_RESPONSE][Math.floor(i.status / 100) - 4],
    i.config,
    i.request,
    i
  ));
}
function dm(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
function jm(t, e) {
  t = t || 10;
  const i = new Array(t), M = new Array(t);
  let n = 0, a = 0, r;
  return e = e !== void 0 ? e : 1e3, function(o) {
    const s = Date.now(), u = M[a];
    r || (r = s), i[n] = o, M[n] = s;
    let c = a, g = 0;
    for (; c !== n; )
      g += i[c++], c = c % t;
    if (n = (n + 1) % t, n === a && (a = (a + 1) % t), s - r < e)
      return;
    const d = u && s - u;
    return d ? Math.round(g * 1e3 / d) : void 0;
  };
}
function ym(t, e) {
  let i = 0, M = 1e3 / e, n, a;
  const r = (o, s = Date.now()) => {
    i = s, n = null, a && (clearTimeout(a), a = null), t.apply(null, o);
  };
  return [(...o) => {
    const s = Date.now(), u = s - i;
    u >= M ? r(o, s) : (n = o, a || (a = setTimeout(() => {
      a = null, r(n);
    }, M - u)));
  }, () => n && r(n)];
}
const KM = (t, e, i = 3) => {
  let M = 0;
  const n = jm(50, 250);
  return ym((a) => {
    const r = a.loaded, o = a.lengthComputable ? a.total : void 0, s = r - M, u = n(s), c = r <= o;
    M = r;
    const g = {
      loaded: r,
      total: o,
      progress: o ? r / o : void 0,
      bytes: s,
      rate: u || void 0,
      estimated: u && o && c ? (o - r) / u : void 0,
      event: a,
      lengthComputable: o != null,
      [e ? "download" : "upload"]: !0
    };
    t(g);
  }, i);
}, Ml = (t, e) => {
  const i = t != null;
  return [(M) => e[0]({
    lengthComputable: i,
    total: t,
    loaded: M
  }), e[1]];
}, nl = (t) => (...e) => U.asap(() => t(...e));
var Am = $e.hasStandardBrowserEnv ? /* @__PURE__ */ ((t, e) => (i) => (i = new URL(i, $e.origin), t.protocol === i.protocol && t.host === i.host && (e || t.port === i.port)))(
  new URL($e.origin),
  $e.navigator && /(msie|trident)/i.test($e.navigator.userAgent)
) : () => !0, Tm = $e.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(t, e, i, M, n, a) {
      const r = [t + "=" + encodeURIComponent(e)];
      U.isNumber(i) && r.push("expires=" + new Date(i).toGMTString()), U.isString(M) && r.push("path=" + M), U.isString(n) && r.push("domain=" + n), a === !0 && r.push("secure"), document.cookie = r.join("; ");
    },
    read(t) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(t) {
      this.write(t, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function xm(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function zm(t, e) {
  return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function js(t, e) {
  return t && !xm(e) ? zm(t, e) : e;
}
const al = (t) => t instanceof zt ? { ...t } : t;
function xi(t, e) {
  e = e || {};
  const i = {};
  function M(u, c, g, d) {
    return U.isPlainObject(u) && U.isPlainObject(c) ? U.merge.call({ caseless: d }, u, c) : U.isPlainObject(c) ? U.merge({}, c) : U.isArray(c) ? c.slice() : c;
  }
  function n(u, c, g, d) {
    if (U.isUndefined(c)) {
      if (!U.isUndefined(u))
        return M(void 0, u, g, d);
    } else return M(u, c, g, d);
  }
  function a(u, c) {
    if (!U.isUndefined(c))
      return M(void 0, c);
  }
  function r(u, c) {
    if (U.isUndefined(c)) {
      if (!U.isUndefined(u))
        return M(void 0, u);
    } else return M(void 0, c);
  }
  function o(u, c, g) {
    if (g in e)
      return M(u, c);
    if (g in t)
      return M(void 0, u);
  }
  const s = {
    url: a,
    method: a,
    data: a,
    baseURL: r,
    transformRequest: r,
    transformResponse: r,
    paramsSerializer: r,
    timeout: r,
    timeoutMessage: r,
    withCredentials: r,
    withXSRFToken: r,
    adapter: r,
    responseType: r,
    xsrfCookieName: r,
    xsrfHeaderName: r,
    onUploadProgress: r,
    onDownloadProgress: r,
    decompress: r,
    maxContentLength: r,
    maxBodyLength: r,
    beforeRedirect: r,
    transport: r,
    httpAgent: r,
    httpsAgent: r,
    cancelToken: r,
    socketPath: r,
    responseEncoding: r,
    validateStatus: o,
    headers: (u, c, g) => n(al(u), al(c), g, !0)
  };
  return U.forEach(Object.keys(Object.assign({}, t, e)), function(u) {
    const c = s[u] || n, g = c(t[u], e[u], u);
    U.isUndefined(g) && c !== o || (i[u] = g);
  }), i;
}
var ys = (t) => {
  const e = xi({}, t);
  let { data: i, withXSRFToken: M, xsrfHeaderName: n, xsrfCookieName: a, headers: r, auth: o } = e;
  e.headers = r = zt.from(r), e.url = gs(js(e.baseURL, e.url), t.params, t.paramsSerializer), o && r.set(
    "Authorization",
    "Basic " + btoa((o.username || "") + ":" + (o.password ? unescape(encodeURIComponent(o.password)) : ""))
  );
  let s;
  if (U.isFormData(i)) {
    if ($e.hasStandardBrowserEnv || $e.hasStandardBrowserWebWorkerEnv)
      r.setContentType(void 0);
    else if ((s = r.getContentType()) !== !1) {
      const [u, ...c] = s ? s.split(";").map((g) => g.trim()).filter(Boolean) : [];
      r.setContentType([u || "multipart/form-data", ...c].join("; "));
    }
  }
  if ($e.hasStandardBrowserEnv && (M && U.isFunction(M) && (M = M(e)), M || M !== !1 && Am(e.url))) {
    const u = n && a && Tm.read(a);
    u && r.set(n, u);
  }
  return e;
};
const fm = typeof XMLHttpRequest < "u";
var mm = fm && function(t) {
  return new Promise(function(e, i) {
    const M = ys(t);
    let n = M.data;
    const a = zt.from(M.headers).normalize();
    let { responseType: r, onUploadProgress: o, onDownloadProgress: s } = M, u, c, g, d, j;
    function D() {
      d && d(), j && j(), M.cancelToken && M.cancelToken.unsubscribe(u), M.signal && M.signal.removeEventListener("abort", u);
    }
    let I = new XMLHttpRequest();
    I.open(M.method.toUpperCase(), M.url, !0), I.timeout = M.timeout;
    function N() {
      if (!I)
        return;
      const f = zt.from(
        "getAllResponseHeaders" in I && I.getAllResponseHeaders()
      ), L = {
        data: !r || r === "text" || r === "json" ? I.responseText : I.response,
        status: I.status,
        statusText: I.statusText,
        headers: f,
        config: t,
        request: I
      };
      ds(function(p) {
        e(p), D();
      }, function(p) {
        i(p), D();
      }, L), I = null;
    }
    "onloadend" in I ? I.onloadend = N : I.onreadystatechange = function() {
      !I || I.readyState !== 4 || I.status === 0 && !(I.responseURL && I.responseURL.indexOf("file:") === 0) || setTimeout(N);
    }, I.onabort = function() {
      I && (i(new ce("Request aborted", ce.ECONNABORTED, t, I)), I = null);
    }, I.onerror = function() {
      i(new ce("Network Error", ce.ERR_NETWORK, t, I)), I = null;
    }, I.ontimeout = function() {
      let f = M.timeout ? "timeout of " + M.timeout + "ms exceeded" : "timeout exceeded";
      const L = M.transitional || Ns;
      M.timeoutErrorMessage && (f = M.timeoutErrorMessage), i(new ce(
        f,
        L.clarifyTimeoutError ? ce.ETIMEDOUT : ce.ECONNABORTED,
        t,
        I
      )), I = null;
    }, n === void 0 && a.setContentType(null), "setRequestHeader" in I && U.forEach(a.toJSON(), function(f, L) {
      I.setRequestHeader(L, f);
    }), U.isUndefined(M.withCredentials) || (I.withCredentials = !!M.withCredentials), r && r !== "json" && (I.responseType = M.responseType), s && ([g, j] = KM(s, !0), I.addEventListener("progress", g)), o && I.upload && ([c, d] = KM(o), I.upload.addEventListener("progress", c), I.upload.addEventListener("loadend", d)), (M.cancelToken || M.signal) && (u = (f) => {
      I && (i(!f || f.type ? new Ji(null, t, I) : f), I.abort(), I = null);
    }, M.cancelToken && M.cancelToken.subscribe(u), M.signal && (M.signal.aborted ? u() : M.signal.addEventListener("abort", u)));
    const x = dm(M.url);
    if (x && $e.protocols.indexOf(x) === -1) {
      i(new ce("Unsupported protocol " + x + ":", ce.ERR_BAD_REQUEST, t));
      return;
    }
    I.send(n || null);
  });
};
const Lm = (t, e) => {
  const { length: i } = t = t ? t.filter(Boolean) : [];
  if (e || i) {
    let M = new AbortController(), n;
    const a = function(u) {
      if (!n) {
        n = !0, o();
        const c = u instanceof Error ? u : this.reason;
        M.abort(c instanceof ce ? c : new Ji(c instanceof Error ? c.message : c));
      }
    };
    let r = e && setTimeout(() => {
      r = null, a(new ce(`timeout ${e} of ms exceeded`, ce.ETIMEDOUT));
    }, e);
    const o = () => {
      t && (r && clearTimeout(r), r = null, t.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(a) : u.removeEventListener("abort", a);
      }), t = null);
    };
    t.forEach((u) => u.addEventListener("abort", a));
    const { signal: s } = M;
    return s.unsubscribe = () => U.asap(o), s;
  }
};
var pm = Lm;
const wm = function* (t, e) {
  let i = t.byteLength;
  if (i < e) {
    yield t;
    return;
  }
  let M = 0, n;
  for (; M < i; )
    n = M + e, yield t.slice(M, n), M = n;
}, Cm = async function* (t, e) {
  for await (const i of hm(t))
    yield* wm(i, e);
}, hm = async function* (t) {
  if (t[Symbol.asyncIterator]) {
    yield* t;
    return;
  }
  const e = t.getReader();
  try {
    for (; ; ) {
      const { done: i, value: M } = await e.read();
      if (i)
        break;
      yield M;
    }
  } finally {
    await e.cancel();
  }
}, rl = (t, e, i, M) => {
  const n = Cm(t, e);
  let a = 0, r, o = (s) => {
    r || (r = !0, M && M(s));
  };
  return new ReadableStream({
    async pull(s) {
      try {
        const { done: u, value: c } = await n.next();
        if (u) {
          o(), s.close();
          return;
        }
        let g = c.byteLength;
        if (i) {
          let d = a += g;
          i(d);
        }
        s.enqueue(new Uint8Array(c));
      } catch (u) {
        throw o(u), u;
      }
    },
    cancel(s) {
      return o(s), n.return();
    }
  }, {
    highWaterMark: 2
  });
}, Dn = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", As = Dn && typeof ReadableStream == "function", Om = Dn && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((t) => (e) => t.encode(e))(new TextEncoder()) : async (t) => new Uint8Array(await new Response(t).arrayBuffer())), Ts = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, Em = As && Ts(() => {
  let t = !1;
  const e = new Request($e.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return t = !0, "half";
    }
  }).headers.has("Content-Type");
  return t && !e;
}), ll = 64 * 1024, ga = As && Ts(() => U.isReadableStream(new Response("").body)), qM = {
  stream: ga && ((t) => t.body)
};
Dn && ((t) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
    !qM[e] && (qM[e] = U.isFunction(t[e]) ? (i) => i[e]() : (i, M) => {
      throw new ce(`Response type '${e}' is not supported`, ce.ERR_NOT_SUPPORT, M);
    });
  });
})(new Response());
const Sm = async (t) => {
  if (t == null)
    return 0;
  if (U.isBlob(t))
    return t.size;
  if (U.isSpecCompliantForm(t))
    return (await new Request($e.origin, {
      method: "POST",
      body: t
    }).arrayBuffer()).byteLength;
  if (U.isArrayBufferView(t) || U.isArrayBuffer(t))
    return t.byteLength;
  if (U.isURLSearchParams(t) && (t = t + ""), U.isString(t))
    return (await Om(t)).byteLength;
}, km = async (t, e) => U.toFiniteNumber(t.getContentLength()) ?? Sm(e);
var vm = Dn && (async (t) => {
  let {
    url: e,
    method: i,
    data: M,
    signal: n,
    cancelToken: a,
    timeout: r,
    onDownloadProgress: o,
    onUploadProgress: s,
    responseType: u,
    headers: c,
    withCredentials: g = "same-origin",
    fetchOptions: d
  } = ys(t);
  u = u ? (u + "").toLowerCase() : "text";
  let j = pm([n, a && a.toAbortSignal()], r), D;
  const I = j && j.unsubscribe && (() => {
    j.unsubscribe();
  });
  let N;
  try {
    if (s && Em && i !== "get" && i !== "head" && (N = await km(c, M)) !== 0) {
      let h = new Request(e, {
        method: "POST",
        body: M,
        duplex: "half"
      }), w;
      if (U.isFormData(M) && (w = h.headers.get("content-type")) && c.setContentType(w), h.body) {
        const [O, S] = Ml(
          N,
          KM(nl(s))
        );
        M = rl(h.body, ll, O, S);
      }
    }
    U.isString(g) || (g = g ? "include" : "omit");
    const x = "credentials" in Request.prototype;
    D = new Request(e, {
      ...d,
      signal: j,
      method: i.toUpperCase(),
      headers: c.normalize().toJSON(),
      body: M,
      duplex: "half",
      credentials: x ? g : void 0
    });
    let f = await fetch(D);
    const L = ga && (u === "stream" || u === "response");
    if (ga && (o || L && I)) {
      const h = {};
      ["status", "statusText", "headers"].forEach((Y) => {
        h[Y] = f[Y];
      });
      const w = U.toFiniteNumber(f.headers.get("content-length")), [O, S] = o && Ml(
        w,
        KM(nl(o), !0)
      ) || [];
      f = new Response(
        rl(f.body, ll, O, () => {
          S && S(), I && I();
        }),
        h
      );
    }
    u = u || "text";
    let p = await qM[U.findKey(qM, u) || "text"](f, t);
    return !L && I && I(), await new Promise((h, w) => {
      ds(h, w, {
        data: p,
        headers: zt.from(f.headers),
        status: f.status,
        statusText: f.statusText,
        config: t,
        request: D
      });
    });
  } catch (x) {
    throw I && I(), x && x.name === "TypeError" && /fetch/i.test(x.message) ? Object.assign(
      new ce("Network Error", ce.ERR_NETWORK, t, D),
      {
        cause: x.cause || x
      }
    ) : ce.from(x, x && x.code, t, D);
  }
});
const Na = {
  http: Zf,
  xhr: mm,
  fetch: vm
};
U.forEach(Na, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const ol = (t) => `- ${t}`, bm = (t) => U.isFunction(t) || t === null || t === !1;
var xs = {
  getAdapter: (t) => {
    t = U.isArray(t) ? t : [t];
    const { length: e } = t;
    let i, M;
    const n = {};
    for (let a = 0; a < e; a++) {
      i = t[a];
      let r;
      if (M = i, !bm(i) && (M = Na[(r = String(i)).toLowerCase()], M === void 0))
        throw new ce(`Unknown adapter '${r}'`);
      if (M)
        break;
      n[r || "#" + a] = M;
    }
    if (!M) {
      const a = Object.entries(n).map(
        ([o, s]) => `adapter ${o} ` + (s === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let r = e ? a.length > 1 ? `since :
` + a.map(ol).join(`
`) : " " + ol(a[0]) : "as no adapter specified";
      throw new ce(
        "There is no suitable adapter to dispatch the request " + r,
        "ERR_NOT_SUPPORT"
      );
    }
    return M;
  },
  adapters: Na
};
function Pn(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new Ji(null, t);
}
function sl(t) {
  return Pn(t), t.headers = zt.from(t.headers), t.data = _n.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), xs.getAdapter(t.adapter || tr.adapter)(t).then(function(e) {
    return Pn(t), e.data = _n.call(
      t,
      t.transformResponse,
      e
    ), e.headers = zt.from(e.headers), e;
  }, function(e) {
    return Ds(e) || (Pn(t), e && e.response && (e.response.data = _n.call(
      t,
      t.transformResponse,
      e.response
    ), e.response.headers = zt.from(e.response.headers))), Promise.reject(e);
  });
}
const zs = "1.7.9", dn = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  dn[t] = function(i) {
    return typeof i === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const ul = {};
dn.transitional = function(t, e, i) {
  function M(n, a) {
    return "[Axios v" + zs + "] Transitional option '" + n + "'" + a + (i ? ". " + i : "");
  }
  return (n, a, r) => {
    if (t === !1)
      throw new ce(
        M(a, " has been removed" + (e ? " in " + e : "")),
        ce.ERR_DEPRECATED
      );
    return e && !ul[a] && (ul[a] = !0, console.warn(
      M(
        a,
        " has been deprecated since v" + e + " and will be removed in the near future"
      )
    )), t ? t(n, a, r) : !0;
  };
};
dn.spelling = function(t) {
  return (e, i) => (console.warn(`${i} is likely a misspelling of ${t}`), !0);
};
function Qm(t, e, i) {
  if (typeof t != "object")
    throw new ce("options must be an object", ce.ERR_BAD_OPTION_VALUE);
  const M = Object.keys(t);
  let n = M.length;
  for (; n-- > 0; ) {
    const a = M[n], r = e[a];
    if (r) {
      const o = t[a], s = o === void 0 || r(o, a, t);
      if (s !== !0)
        throw new ce("option " + a + " must be " + s, ce.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (i !== !0)
      throw new ce("Unknown option " + a, ce.ERR_BAD_OPTION);
  }
}
var FM = {
  assertOptions: Qm,
  validators: dn
};
const Lt = FM.validators;
class en {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new tl(),
      response: new tl()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, i) {
    try {
      return await this._request(e, i);
    } catch (M) {
      if (M instanceof Error) {
        let n = {};
        Error.captureStackTrace ? Error.captureStackTrace(n) : n = new Error();
        const a = n.stack ? n.stack.replace(/^.+\n/, "") : "";
        try {
          M.stack ? a && !String(M.stack).endsWith(a.replace(/^.+\n.+\n/, "")) && (M.stack += `
` + a) : M.stack = a;
        } catch {
        }
      }
      throw M;
    }
  }
  _request(e, i) {
    typeof e == "string" ? (i = i || {}, i.url = e) : i = e || {}, i = xi(this.defaults, i);
    const { transitional: M, paramsSerializer: n, headers: a } = i;
    M !== void 0 && FM.assertOptions(M, {
      silentJSONParsing: Lt.transitional(Lt.boolean),
      forcedJSONParsing: Lt.transitional(Lt.boolean),
      clarifyTimeoutError: Lt.transitional(Lt.boolean)
    }, !1), n != null && (U.isFunction(n) ? i.paramsSerializer = {
      serialize: n
    } : FM.assertOptions(n, {
      encode: Lt.function,
      serialize: Lt.function
    }, !0)), FM.assertOptions(i, {
      baseUrl: Lt.spelling("baseURL"),
      withXsrfToken: Lt.spelling("withXSRFToken")
    }, !0), i.method = (i.method || this.defaults.method || "get").toLowerCase();
    let r = a && U.merge(
      a.common,
      a[i.method]
    );
    a && U.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (D) => {
        delete a[D];
      }
    ), i.headers = zt.concat(r, a);
    const o = [];
    let s = !0;
    this.interceptors.request.forEach(function(D) {
      typeof D.runWhen == "function" && D.runWhen(i) === !1 || (s = s && D.synchronous, o.unshift(D.fulfilled, D.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(D) {
      u.push(D.fulfilled, D.rejected);
    });
    let c, g = 0, d;
    if (!s) {
      const D = [sl.bind(this), void 0];
      for (D.unshift.apply(D, o), D.push.apply(D, u), d = D.length, c = Promise.resolve(i); g < d; )
        c = c.then(D[g++], D[g++]);
      return c;
    }
    d = o.length;
    let j = i;
    for (g = 0; g < d; ) {
      const D = o[g++], I = o[g++];
      try {
        j = D(j);
      } catch (N) {
        I.call(this, N);
        break;
      }
    }
    try {
      c = sl.call(this, j);
    } catch (D) {
      return Promise.reject(D);
    }
    for (g = 0, d = u.length; g < d; )
      c = c.then(u[g++], u[g++]);
    return c;
  }
  getUri(e) {
    e = xi(this.defaults, e);
    const i = js(e.baseURL, e.url);
    return gs(i, e.params, e.paramsSerializer);
  }
}
U.forEach(["delete", "get", "head", "options"], function(t) {
  en.prototype[t] = function(e, i) {
    return this.request(xi(i || {}, {
      method: t,
      url: e,
      data: (i || {}).data
    }));
  };
});
U.forEach(["post", "put", "patch"], function(t) {
  function e(i) {
    return function(M, n, a) {
      return this.request(xi(a || {}, {
        method: t,
        headers: i ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: M,
        data: n
      }));
    };
  }
  en.prototype[t] = e(), en.prototype[t + "Form"] = e(!0);
});
var WM = en;
class ir {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let i;
    this.promise = new Promise(function(n) {
      i = n;
    });
    const M = this;
    this.promise.then((n) => {
      if (!M._listeners) return;
      let a = M._listeners.length;
      for (; a-- > 0; )
        M._listeners[a](n);
      M._listeners = null;
    }), this.promise.then = (n) => {
      let a;
      const r = new Promise((o) => {
        M.subscribe(o), a = o;
      }).then(n);
      return r.cancel = function() {
        M.unsubscribe(a);
      }, r;
    }, e(function(n, a, r) {
      M.reason || (M.reason = new Ji(n, a, r), i(M.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const i = this._listeners.indexOf(e);
    i !== -1 && this._listeners.splice(i, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), i = (M) => {
      e.abort(M);
    };
    return this.subscribe(i), e.signal.unsubscribe = () => this.unsubscribe(i), e.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new ir(function(i) {
        e = i;
      }),
      cancel: e
    };
  }
}
var Um = ir;
function Ym(t) {
  return function(e) {
    return t.apply(null, e);
  };
}
function _m(t) {
  return U.isObject(t) && t.isAxiosError === !0;
}
const Ia = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Ia).forEach(([t, e]) => {
  Ia[e] = t;
});
var Pm = Ia;
function fs(t) {
  const e = new WM(t), i = es(WM.prototype.request, e);
  return U.extend(i, WM.prototype, e, { allOwnKeys: !0 }), U.extend(i, e, null, { allOwnKeys: !0 }), i.create = function(M) {
    return fs(xi(t, M));
  }, i;
}
const Ye = fs(tr);
Ye.Axios = WM;
Ye.CanceledError = Ji;
Ye.CancelToken = Um;
Ye.isCancel = Ds;
Ye.VERSION = zs;
Ye.toFormData = Nn;
Ye.AxiosError = ce;
Ye.Cancel = Ye.CanceledError;
Ye.all = function(t) {
  return Promise.all(t);
};
Ye.spread = Ym;
Ye.isAxiosError = _m;
Ye.mergeConfig = xi;
Ye.AxiosHeaders = zt;
Ye.formToJSON = (t) => Is(U.isHTMLForm(t) ? new FormData(t) : t);
Ye.getAdapter = xs.getAdapter;
Ye.HttpStatusCode = Pm;
Ye.default = Ye;
var ms = Ye;
const cl = /* @__PURE__ */ zT(ms), Rm = ms.default, EM = Rm.create({ baseURL: "https://apim.247prod.io/finance/v1" }), Fm = {
  vehicleLookup(t) {
    return new Promise(async (e, i) => {
      try {
        let M = null;
        await EM.get(
          `/vehicle-search?vrm=${t.toUpperCase().replace(" ", "")}`
        ).then((n) => {
          n.data.vehicleId && (M = {
            vehicleId: n.data.vehicleId,
            make: n.data.make,
            model: n.data.model,
            vehicleDateOfFirstReg: n.data.registrationDate ? new Date(n.data.registrationDate) : null,
            regYear: n.data.regYear,
            vrm: n.data.regNumber,
            fuel: n.data.fuel,
            colour: n.data.colour,
            mileage: n.data.mileage,
            price: n.data.price,
            transmission: n.data.trans,
            isIntranetLoanVehicle: !1,
            year: n.data.registrationDate ? new Date(n.data.registrationDate).getFullYear() : null,
            glassesRetailValuation: n.data.glassesRetailValuation,
            glassesTradeValuation: n.data.glassesTradeValuation,
            glassesRetailTransacted: n.data.glassesRetailTransacted,
            futures: n.data.vehicleResiduals ? JSON.parse(n.data.vehicleResiduals) : null,
            vehicleResiduals: n.data.vehicleResiduals,
            capCode: "",
            //res.data.capCode
            capRetail: n.data.capRetail,
            capAverage: n.data.capAverage,
            capClean: n.data.capClean,
            capCreatedOn: n.data.capCreatedOn,
            capId: n.data.capId,
            image: n.data.image,
            images: n.data.images,
            vin: n.data.vin
          });
        }).catch((n) => {
          M = null;
        }), await EM.get(
          `/vehicle-cap/${t}/true?source=PricingLibrary`
        ).then(async (n) => {
          let a = n.data;
          if (a.capCode === null) {
            const r = (await EM.get(
              `/vehicle-cap/${a.vehicleRegistration}/true?source=PricingLibrary`
            )).data;
            r.capCode && (a = r);
          }
          M ? (M.capCode = a.capCode ? a.capCode : M.capCode, M.capId = a.capId ? a.capId : M.capId, M.make = a.make ? a.make : M.make, M.model = a.model ? a.model : M.model, M.vin = a.vin ? a.vin : M.vin, M.vehicleRegistration = a.vehicleRegistration ? a.vehicleRegistration : M.vehicleRegistration, M.vehicleDateOfFirstReg = a.vehicleDateOfFirstReg ? a.vehicleDateOfFirstReg : M.vehicleDateOfFirstReg) : a.make && (M = {
            vehicleId: a.vehicleId,
            make: a.make,
            model: a.model,
            mileage: 0,
            vrm: a.vehicleRegistration,
            vehicleDateOfFirstReg: a.vehicleDateOfFirstReg ? new Date(a.vehicleDateOfFirstReg) : null,
            price: a.price,
            vehicleCondition: a.vehicleCondition,
            fuel: a.fuelType,
            transmission: a.transmission,
            annualMileage: a.annualMileage,
            capId: a.capId,
            capCode: a.capCode,
            capCreatedOn: a.capCreatedOn ? new Date(a.capCreatedOn) : null,
            capAverage: a.capAverage,
            capClean: a.capClean,
            capRetail: a.capRetail,
            colour: a.colour,
            glassCode: a.glassCode,
            glassesEffectiveFrom: a.glassesEffectiveFrom ? new Date(a.glassesEffectiveFrom) : null,
            glassesRetailTransacted: a.glassesRetailTransacted,
            glassesRetailValuation: a.glassesRetailValuation,
            glassesTradeValuation: a.glassesTradeValuation,
            vin: a.vin
          });
        }).catch((n) => {
        }), M && (M.image = "https://res.cloudinary.com/carfinance247-co-uk/image/upload/q_10/v1/" + M.vehicleId + "/1.webp", e(M)), i(null);
      } catch (M) {
        i(M);
      }
    });
  },
  getResiduals(t) {
    return new Promise((e, i) => {
      EM.post("/vehicle/residuals/multiple", t).then((M) => {
        M.status === 204 && e(null), e(M.data);
      }).catch((M) => {
        i(M);
      });
    });
  }
};
var Ls = { vehicleService: Fm };
const { PCP_LENDERS: Wm, isVehiclePcpEligible: Bm } = qo, { mockAlpheraProposal: Vm, mockCloseProposal: Gm, mockZopaProposal: Zm, mockMotonovoProposal: $m } = _o, { mockCaProposal: Jm } = Mf, { mockNorthridgeProposal: Hm } = af, { mockV12Proposal: Xm } = lf, { vehicleService: Km } = Ls;
async function qm(t, e, i = 0, M = null, n = null, a = 8e3, r = null, o = null, s = null) {
  try {
    if ((!M || !Array.isArray(M) || M.length === 0) && (M = [
      Vm(t.price),
      Gm(t.price),
      Zm(t.price),
      $m(t.price),
      Jm(t.price),
      Xm(t.price),
      Hm(t.price)
    ]), !Bm({ ...t, mileage: r || t.mileage }, M) || !M.find((w) => Wm.includes(w.financeCompanyId) && (!w.customerRuleResults || (w.customerRuleResults.find((O) => O.resultType === "FixedDecline") ? w.loanProposalStatus === "Accepted" : !0)) && (w.loanProposalStatus === "Accepted" || w.loanProposalStatus === "ProvisionalAcceptance" || w.loanProposalStatus == "ConditionallyAccepted")))
      return null;
    const u = t.vrm || t.vehicleRegistration || t.regNumber || t.registration;
    if (!u && !s)
      return null;
    let c;
    if (!s) {
      if (c = await Km.vehicleLookup(u), c.price || (c.price = t.price), !c.capCode)
        return null;
      c.mileage = r || t.mileage || 0;
    }
    const g = !!M.find((w) => w.financeCompanyId === 50 && Jt(w)), d = !!M.find((w) => w.financeCompanyId === 70 && Jt(w)), j = !!M.find((w) => w.financeCompanyId === 73 && Jt(w)), D = !!M.find((w) => w.financeCompanyId === 63 && Jt(w)), I = !!M.find((w) => w.financeCompanyId === 67 && Jt(w)), N = !!M.find((w) => w.financeCompanyId === 74 && Jt(w)), x = !!M.find((w) => w.financeCompanyId === 66 && Jt(w)), f = !!M.find((w) => w.financeCompanyId === 75 && Jt(w)), L = [];
    D && L.push(63), g && L.push(50), d && L.push(70), j && L.push(73), I && L.push(67), N && L.push(74), x && L.push(66), f && L.push(75);
    const p = c ? c.mileage : r || t.mileage, h = c ? c.vehicleDateOfFirstReg : t.registrationDate || t.vehicleDateOfFirstReg;
    return {
      applicationId: e || 13917939,
      // use example app id if none passed in
      financeCompanyIds: L,
      deposit: i,
      annualMileage: a,
      capCode: c ? c.capCode : s,
      isNew: !1,
      mileage: parseInt(p),
      registrationDate: new Date(h).toJSON(),
      registration: c ? c.vrm : u,
      price: c ? c.price : parseInt(t.price),
      minTerm: 24,
      maxTerm: 60,
      termInterval: 12,
      make: c ? c.make : t.make,
      model: c ? c.model : t.model,
      vin: c ? c.vin : t.vin,
      vehicleType: 1,
      //remove this once fully switched over to using vehicleTypeId
      capId: c ? c.capId : t.capId,
      terms: n || [24, 36, 48, 60],
      vehicleTypeId: o
    };
  } catch {
    return null;
  }
}
function Jt(t) {
  return t.loanProposalStatus === "Accepted" || (t.loanProposalStatus === "ProvisionalAcceptance" || t.loanProposalStatus === "ConditionallyAccepted") && (!t.customerRuleResults || !t.customerRuleResults.find((e) => e.resultType === "FixedDecline"));
}
var ps = {
  constructResidualsRequest: qm
};
const { vehicleService: e1 } = Ls, { constructResidualsRequest: t1 } = ps;
async function i1(t, e, i = 0, M = null, n = null, a = 8e3, r = null, o = !1, s = null, u = null, c = null) {
  try {
    n && Array.isArray(n) && (n = n.map((I) => Number(I)));
    const g = t.vehicleResiduals && (!r || r === t.mileage) ? typeof t.vehicleResiduals == "string" || t.vehicleResiduals instanceof String ? JSON.parse(t.vehicleResiduals) : t.vehicleResiduals : null, d = [];
    g && o && Object.keys(g).forEach((I) => {
      const N = Object.keys(g[I]).map((x) => Number(x));
      n.filter((x) => !N.includes(x)).length === 0 && (console.log("Already has all terms for lender", I), d.push(Number(I)));
    });
    const j = await t1(t, e, i, M, n, a, r, u, c);
    if (!j)
      return g;
    if (s && Array.isArray(s) && (j.financeCompanyIds = j.financeCompanyIds.filter((I) => !s.includes(I))), o && d.length > 0 && (j.financeCompanyIds = j.financeCompanyIds.filter((I) => !d.includes(I))), j.financeCompanyIds.length === 0)
      return o && console.log("Already has all residuals for proposals"), o ? g : null;
    const D = await e1.getResiduals(j);
    return D ? !o || !g ? D : (Object.keys(g).forEach((I) => {
      const N = Object.keys(D).find((x) => x === I);
      N && (g[I] = { ...D[N], ...g[I] });
    }), Object.keys(D).forEach((I) => {
      g[I] || (g[I] = D[I]);
    }), g) : g;
  } catch (g) {
    return console.log("Pricing Library Error - getResiduals", g), null;
  }
}
var M1 = {
  getResiduals: i1
};
const n1 = 12500, a1 = 1e4;
var r1 = {
  STARTLINE_MAX_LEND_UNDER_21: n1,
  STARTLINE_MAX_LEND_NOT_EMPLOYED: a1
};
const l1 = {
  NOT_EMPLOYED: 5
};
var o1 = {
  EMPLOYMENT_STATUS_ENUM: l1
};
const s1 = {
  PROVISIONAL_UK: 6
};
var u1 = {
  DRIVING_LICENCE_ENUM: s1
};
const {
  calculateFutureValue: c1,
  supportsPCP: g1,
  isVehiclePcpEligible: N1,
  getExtrasPricesForLender: gl,
  MONEYBARN: I1,
  ADVANTAGE: BM,
  LENDABLE: D1,
  ALPHERA: d1,
  METROBANK: ws,
  TANDEM: j1,
  BNP: Cs,
  CLOSE: y1,
  MANNISLAND: A1,
  MOTONOVO: T1,
  V12: x1,
  OODLE: z1,
  CARFINANCE247: Qt,
  LTV_BASELINES: f1,
  CREDITAGRICOLE: m1,
  PCP_LENDERS: hs,
  LENDERS_TRUNCATE_AND_ROUND_MONTHLY_PAYMENT: L1,
  LENDERS_INCLUDE_POST_FEES_IN_COST_OF_CREDIT: p1,
  LENDERS_EXCLUDE_DEPOSIT_FROM_TOTAL_AMOUNT_PAYABLE: w1,
  LENDERS_NO_MONTHLY_PAYMENT_ROUNDING: C1,
  getFixedPrimes: h1,
  insideRange: Os,
  getNum: Z,
  isNullOrUndefined: Oi,
  getPrimeRate: Mr,
  calcAPRBisectionMethod: O1,
  installmentBuilder: E1,
  calculateEffectiveRate: Es,
  getLendersPreFees: S1,
  getLendersPostFees: Ss,
  collapse: SM,
  isntDeclined: k1,
  calculateMonthlyPayment: Da,
  p: v1,
  dumpMatrix: b1,
  vehicleValid: ks,
  getMaxLTV: Nl,
  getByPath: Q1,
  vehicleQualifies: kM,
  vehicleAgeInMonths: Vi,
  vehicleAge: U1,
  findBetterEffectiveRates: Il,
  dp2: Ut,
  MONEYWAY: vs,
  dealerValid: Y1,
  AUTOMONEY: Rn,
  ZOPA: _1,
  LENDERS_EXCLUDE_CHARGES_FROM_COST_OF_CREDIT: P1,
  LENDERS_TRUNCATE_MONTHLY_PAYMENT: R1,
  FLAT_RATE_CALC_ROUNDING: F1,
  LENDERS_EXCLUDE_POST_FEES_FROM_COST_OF_CREDIT_PCP: W1,
  LENDERS_TERM_ADJUST: B1,
  STARTLINE: V1
} = qo, { constructResidualsRequest: G1 } = ps, { getResiduals: Z1 } = M1, ki = Ro, da = Yo, { STARTLINE_MAX_LEND_UNDER_21: Dl, STARTLINE_MAX_LEND_NOT_EMPLOYED: dl } = r1, { EMPLOYMENT_STATUS_ENUM: $1 } = o1, { DRIVING_LICENCE_ENUM: J1 } = u1, { VEHICLE_TYPE_ENUM: jl } = Ga, { PRODUCT_TYPE_ENUM: yl } = Uo;
function Fn(t) {
  return t > 23 ? t : t * 12;
}
function H1(t, e) {
  let i = ki.getPropMaxMileage(t, e), M = t.minMileage ? t.minMileage : 0;
  if (!i)
    return !0;
  const n = e.mileage <= i && e.mileage >= M;
  return !n && !t.vehicleRuleResults.find((a) => a.rule === "MaxMileage") && t.vehicleRuleResults.push({
    id: t.financeCompanyId,
    displayPriority: 1,
    vehicleId: e.vehicleId,
    resultType: "VehicleFailRule",
    rule: e.mileage > i ? "MaxMileage" : "MinMileage",
    message: e.mileage > i ? `Vehicle exceeds max mileage of ${i.toLocaleString()} miles` : `Vehicle below min mileage of ${M.toLocaleString()} miles`
  }), n;
}
function X1(t, e, i) {
  return Number(i) < Number(e.minTerm) ? (e.vehicleRuleResults.push(
    {
      displayPriority: 1,
      vehicleId: t.vehicleId,
      resultType: "FinanceFailRule",
      term: i,
      rule: "Term",
      message: `Term ${i} months not supported`
    }
  ), !1) : Number(i) > Number(e.maxTerm) ? (e.vehicleRuleResults.push(
    {
      displayPriority: 1,
      vehicleId: t.vehicleId,
      resultType: "FinanceFailRule",
      term: i,
      rule: "Term",
      message: `Term ${i} months not supported`
    }
  ), !1) : !0;
}
function K1(t, e, i) {
  let { totalLoanAmount: M, extrasOutPrice: n } = e;
  M += n;
  const a = M >= t.minLendAmount && M <= 1e6;
  return !a && t.vehicleRuleResults && !t.vehicleRuleResults.find((r) => r.rule === "LoanAmount") && t.vehicleRuleResults.push({
    displayPriority: 3,
    vehicleId: i.vehicleId,
    resultType: "FinanceFailRule",
    rule: "LoanAmount",
    message: M < t.minLendAmount ? "Does not meet min lend of &pound;" + t.minLendAmount.toLocaleString() : M > 1e6 ? "Exceeds max lend of &pound;1,000,000" : ""
  }), a;
}
function bs(t, e, i, M = !1) {
  const n = Vi(e), a = n + Z(i);
  if (n > 0) {
    let r = ki.getPropMaxVehicleAgeAtEnd(t, e);
    if (Z(r) > 0 && a >= Fn(Z(r)))
      return M && t.vehicleRuleResults && t.vehicleRuleResults.push({
        displayPriority: 2,
        vehicleId: e.vehicleId,
        resultType: "FinanceFailRule",
        term: i,
        message: "Vehicle age at end of term"
      }), !1;
    let o = t.minVehicleAgeAtStart, s = t.maxVehicleAgeAtStart;
    o != null && (o = Fn(Z(o))), s != null && (s = Fn(Z(s)));
    const u = Os(o, s, n, "age of vehicle at start");
    return !u && M && t.vehicleRuleResults && t.vehicleRuleResults.push({
      id: t.financeCompanyId,
      displayPriority: 2,
      vehicleId: e.vehicleId,
      resultType: "VehicleFailRule",
      message: "Vehicle age"
    }), u;
  }
  return !0;
}
function q1(t, e, i) {
  if (e != null && e.hasOwnProperty("dateOfBirth") && t.hasOwnProperty("maxCustomerAgeAtEnd")) {
    const M = e.dateOfBirth;
    if (!Oi(M) && Z(t.maxCustomerAgeAtEnd) > 0) {
      const n = /* @__PURE__ */ new Date();
      return n.setMonth(n.getMonth() + i), da.getYearsBetween(n, M) <= t.maxCustomerAgeAtEnd;
    }
  }
  return !0;
}
function Qs(t, e, i) {
  return t.financeCompanyId !== m1 ? !0 : i && i.drivingLicenseType != null && i.drivingLicenseType.drivingLicenseTypeId === J1.PROVISIONAL_UK && (e.vehicleType == jl.CAR || e.vehicleType == jl.VAN) ? (console.error("Excluding Credit Agricole proposal when buying a car or van when customer licence type is Provisional UK Driving Licence."), !1) : !0;
}
function Us(t, e, i, M) {
  if (e > 0) {
    if (t.futureValueAtThisTerm && t.futureValueAtThisTerm > 0)
      return t.futureValueAtThisTerm;
    if (t.futures && t.futures[e]) {
      const n = Q1(t.futures, [e, i]);
      if (n > 0)
        return n;
    }
  }
  return e === Qt ? c1(t.make, t.model, t.price, U1(t), i, M) : null;
}
function Al(t, e, i, M = 0, n = 0, a = null, r = 8e3, o = null, s = null) {
  if (!a)
    return null;
  const u = Us(t, a.financeCompanyId, i, r);
  if (!u)
    return a.vehicleRuleResults.push(
      {
        displayPriority: 5,
        vehicleId: t.vehicleId,
        resultType: "FinanceFailRule",
        pcp: !0,
        term: i,
        rule: "Term",
        message: `Unable to get residual value for ${i} months`
      }
    ), null;
  const c = Math.round(100 * u) / 100, g = e - M, d = Ss(a.financeCompanyId), j = (c + d) / g, D = n > 0 ? n : Mr(g, Vi(t), o, s, a.financeCompanyId, !0), I = Z(D) / 100 + 1;
  let N = 0, x = 1, f = B1.find((te) => te.financeCompanyId === a.financeCompanyId && te.pcp === !0);
  f && (N = f.adjust, x = f.adjust - 1);
  let L = Math.pow(I, 1 / 12) - 1;
  const p = Math.pow(1 + L, i + N), h = (p - j) / p;
  let w = L * (g * h), O = 1 - Math.pow(1 / (1 + L), i - x), S = Math.round(100 * w / O) / 100;
  a && R1.find((te) => te === a.financeCompanyId);
  const Y = a ? L1.find((te) => te === a.financeCompanyId) : !1;
  let H = Ut(Z(v1(S)) * Z(i - x), 2) + Z(c) + Z(M) + d, B = Math.round(100 * (H - M - g)) / 100;
  Y && (S = Ut(S, 2), H = Ut(H, 2)), W1.includes(a.financeCompanyId) && (B -= d);
  const ae = {
    monthlyPayment: S,
    firstMonthlyPayment: S,
    minDeposit: M,
    deposit: M,
    depositRequired: !0,
    finalPayment: c + d,
    totalAmountPayable: H,
    apr: D,
    effectiveRate: D,
    lendersPreFees: 0,
    isPCP: !0,
    amountToFinance: g,
    costOfCredit: B,
    futureValue: c,
    termDisplay: i - x,
    lendersPostFees: d,
    commissionAmount: -1
  };
  return ae.monthlyPayment <= 0 ? null : ae;
}
function Ys(t, e, i, M = 0, n) {
  if (t && e && i) {
    const a = S1(n.financeCompanyId), r = Ss(n.financeCompanyId);
    let o = 0;
    const s = n ? n.financeCompanyId : null;
    s === z1 && (o = 50), s === Rn && (o = 199);
    const u = 2, c = Z(t) - Z(M);
    if (c > 0) {
      const g = c + e * c * i / 1200 + Z(a);
      let d = C1.includes(s) ? g / Z(i) : Ut(g / Z(i), 2);
      s === BM && (d = Math.ceil(100 * (g / i)) / 100), (s === vs || s === Rn) && (d = Math.floor(100 * (g / i)) / 100);
      const j = Z(r) > 0 ? Ut(d + Z(r)) : d;
      let D = Ut(d * i + Z(r) + Z(M) + o, u), I = D - c - Z(M) - r;
      P1.includes(s) && (I -= o), p1.includes(s) && (I += r), w1.includes(s) && (D -= Z(M));
      let N = 0;
      if ([BM, Rn].includes(s)) {
        const f = F1.find((h) => h.financeCompanyId === s), L = f ? f.dp : 2, p = E1(d, i, d + Z(o), d + Z(r));
        N = Number((100 * O1([c], p, L)).toFixed(L));
      } else {
        const f = (i * d + r + o) / i;
        N = Es(Z(t) - Z(M) + a, e, f, i);
      }
      let x = 1;
      return [BM, D1, j1].includes(s) && (x = 2), N = Ut(N, x), {
        monthlyPayment: d,
        firstMonthlyPayment: Ut(d + o, u),
        finalPayment: j,
        totalAmountPayable: D,
        flatRate: e,
        effectiveRate: N,
        amountToFinance: c,
        costOfCredit: Ut(I, u),
        lendersPreFees: a,
        lendersPostFees: r,
        lendersCharges: o,
        loanAmount: c,
        tot: D,
        total: g,
        termDisplay: i,
        commissionAmount: -1
      };
    }
  }
  return null;
}
function _s(t, e) {
  const i = {};
  for (let M = 60; M > 12; M -= 1)
    for (const n of e)
      Os(n.minTerm, n.maxTerm, M, "term") && bs(n, t, M) && (i.hasOwnProperty(n.financeCompanyId) || (i[n.financeCompanyId] = M));
  return i;
}
function pt(t, e) {
  const i = [Qt, d1, A1, ws, x1, y1, Cs, T1], M = [247, 167, 168];
  return t.effectiveRate > 0 && e.effectiveRate > 0 ? t.effectiveRate != e.effectiveRate ? t.effectiveRate - e.effectiveRate : t.commissionAmount > 0 && e.commissionAmount > 0 && e.commissionAmount != t.commissionAmount ? e.commissionAmount - t.commissionAmount : t.affiliateCommissionAmount > 0 && e.affiliateCommissionAmount > 0 && e.affiliateCommissionAmount != t.affiliateCommissionAmount ? e.affiliateCommissionAmount - t.affiliateCommissionAmount : t.monthlyPayment - e.monthlyPayment : i.includes(t.financeCompanyId) && i.includes(e.financeCompanyId) ? t.rank > 0 && e.rank > 0 && t.rank !== e.rank ? t.rank - e.rank : t.deposit !== e.deposit ? t.effectiveRate - e.effectiveRate : t.monthlyPayment - e.monthlyPayment : i.includes(t.financeCompanyId) ? -5e-3 : i.includes(e.financeCompanyId) ? 5e-3 : M.includes(t.tierId) && M.includes(e.tierId) ? t.monthlyPayment - e.monthlyPayment : M.includes(t.tierId) ? -0.01 : M.includes(e.tierId) ? 0.01 : t.deposit !== e.deposit ? t.effectiveRate - e.effectiveRate : t.monthlyPayment - e.monthlyPayment;
}
function Ps(t, e, i = 0, M = 0, n = null, a = {}) {
  const r = a.pxSettlement ? a.pxSettlement : 0;
  t.price = Z(t.price), t.mileage = Z(t.mileage), t.noMatchingProposal = !0, t.displayPrices = !1, t.monthlyPayment = 0, t.deposit = 0, t.pxValue = M, t.pxSettlement = r, t.minDeposit = 0, t.maxDeposit = t.price - 2500, t.totalAmountPayable = 0, t.effectiveDeposit = 0, t.depositRequired = !1, t.handlingFee = 0, t.pcpMatrix = [], t.pcp = null, t.priceMatrix = [], t.cannotPrice = !1, t.cannotPriceReason = null, t.cannotPricePCP = !1, t.cannotPriceReasonPCP = null, t.cannotPriceReasons = [], t.lenderDecisions = [], e.forEach((u) => {
    u.vehicleRuleResults = [];
  });
  const o = Z(i) + Z(M) - Z(r);
  for (const u of e)
    Oi(u.financeCompanyId) && !Oi(u.lenderId) && (u.financeCompanyId = u.lenderId, u.financeCompany = u.lenderName);
  const s = _s(t, e);
  if (t && e && e.length > 0) {
    let u = [
      12,
      18,
      24,
      30,
      36,
      42,
      48,
      54,
      60
    ];
    if (a.terms)
      u = a.terms;
    else
      for (const d of Object.values(s))
        u.includes(d) || u.push(d);
    u.sort();
    let c = [];
    const g = [];
    for (const d of u) {
      const j = [];
      let D = e;
      a && a.explodePrime && (D = D.filter((N) => N.financeCompanyId !== Qt), D.push(...h1()));
      const I = Number(t.price) + t.handlingFee - Z(o);
      D = D.filter((N) => N.financeCompanyId === Qt || X1(t, N, d) && H1(N, t) && K1(N, gl(t, I, N.financeCompanyId, a), t) && bs(N, t, d, !0) && ks(N, t) && q1(N, n, d) && Qs(N, t, n) && k1(N) && Y1(t, N)), D.forEach((N) => {
        N.vehicleRuleResults || (N.vehicleRuleResults = []);
      });
      for (const N of D) {
        let x = Number(t.price) + t.handlingFee - Z(o), f = Number(t.price) + t.handlingFee - Z(o);
        N.financeCompanyId === Qt && (N.maxLendAmount = N.maxLendAmount ? N.maxLendAmount : 2e5, N.minLendAmount = N.minLendAmount ? N.minLendAmount : 2500, N.maxTerm = 60, N.minTerm = 12);
        const L = {
          proposalId: N.proposalId,
          noMatchingProposal: !1,
          displayPrices: !0,
          term: d,
          financeCompany: N.financeCompany,
          financeCompanyId: N.financeCompanyId,
          tierId: N.tierId,
          tierName: N.tierName,
          minDeposit: 0,
          maxDeposit: t.price - N.minLendAmount,
          isPCP: !1,
          pcpMileage: a.pcpMileage ? a.pcpMileage : 0,
          excessMilage: 6.9,
          rank: 0,
          loanProposalStatus: N.loanProposalStatus,
          cashRequired: 0
          // to account for out of 'agreement entirely' warranty and or paint
        }, p = {
          proposalId: N.proposalId,
          noMatchingProposal: !1,
          displayPrices: !0,
          term: d,
          financeCompany: N.financeCompany,
          financeCompanyId: N.financeCompanyId,
          tierId: N.tierId,
          tierName: N.tierName,
          minDeposit: 0,
          maxDeposit: t.price - N.minLendAmount,
          isPCP: !0,
          pcpMileage: a.pcpMileage ? a.pcpMileage : 0,
          excessMilage: 6.9,
          rank: 0,
          loanProposalStatus: N.loanProposalStatus,
          cashRequired: 0,
          // to account for out of 'agreement entirely' warranty and or paint
          annualMileageLimit: a.annualMileage ? a.annualMileage : 8e3
        };
        let {
          warrantyPrice: h,
          paintPrice: w,
          cosmeticRepairPrice: O,
          extrasInPrice: S,
          extrasInPricePCP: Y,
          extrasOutPrice: H,
          extrasOutPricePCP: B,
          extrasCashRequired: ae,
          extrasCashRequiredPCP: te,
          totalLoanAmount: q,
          totalLoanAmountPCP: le
        } = gl(t, x, N.financeCompanyId, a);
        h && (L.warrantyPrice = h, p.warrantyPrice = h), w && (L.paintPrice = w, p.paintPrice = w), O && (L.cosmeticRepairPrice = O, p.cosmeticRepairPrice = O), L.cashRequired += ae, p.cashRequired += te, x = q, f = le;
        let Me = t.price + S, oe = t.price + Y, $ = null, E = null, be = !1, V = !1;
        if (a.ignoreLTV === void 0 || a.ignoreLTV === null || a.ignoreLTV === !1) {
          let je = t.glassesRetailValuation, We = f1.find((Re) => Re.financeCompanies.find((Be) => Be === N.financeCompanyId));
          switch (We = We || { id: 0 }, We.id) {
            case 1:
              t.glassesRetailTransacted > 0 && (je = t.glassesRetailTransacted);
              break;
            case 2:
              t.glassesTradeValuation > 0 && (je = t.glassesTradeValuation);
              break;
            case 3:
              t.capRetail > 0 && (je = t.capRetail);
              break;
            case 4:
              t.capClear > 0 && (je = t.capClear);
              break;
          }
          !Oi(je) && je > 0 && ($ = Nl(
            je,
            N.financeCompanyId,
            N.tierId,
            yl.HP,
            t.condition ? t.condition : 0,
            t.vehicleType ? t.vehicleType : 0
          ), Me = Math.round(100 * $) / 100, E = Nl(
            je,
            N.financeCompanyId,
            N.tierId,
            yl.PCP,
            t.condition ? t.condition : 0,
            t.vehicleType ? t.vehicleType : 0
          ), oe = Math.round(100 * E) / 100);
        }
        if (N.financeCompanyId === _1 && ((Vi(t) > N.maxVehicleAgeMaxLendReducedHp || t.mileage > N.maxMileageMaxLendReducedHp) && (Me = N.maxLendMileage100KVehicleAge8Hp, oe = N.maxLendMileage100KVehicleAge8Pcp), n != null && n.hasOwnProperty("dateOfBirth"))) {
          const je = da.getAgeFromDob(n.dateOfBirth);
          Oi(je) || je < N.minAgeMaxLendReduced && (Me = N.maxLendCustomerUnder26, oe = N.maxLendCustomerUnder26);
        }
        if (N.financeCompanyId === V1) {
          if (n != null && n.hasOwnProperty("dateOfBirth")) {
            const je = da.getAgeFromDob(n.dateOfBirth);
            !Oi(je) && je < 21 && (Me = Dl, oe = Dl);
          }
          a != null && a.hasOwnProperty("occupationStatusId") && a.occupationStatusId === $1.NOT_EMPLOYED && (Me = dl, oe = dl);
        }
        N.maxLendAmount < Me && (Me = N.maxLendAmount), N.maxLendAmount < oe && (oe = N.maxLendAmount), L.maxDeposit = Me - N.minLendAmount, p.maxDeposit = oe - N.minLendAmount, t.price + S > Me && (L.minDeposit = t.price + S - Me), t.price + Y > oe && (p.minDeposit = t.price + Y - oe), N.financeCompanyId === I1 && (N.tierId === 67 || N.tierId === 119) && L.minDeposit < 400 && (L.minDeposit = 400), L.minDeposit < H && (L.minDeposit = H), p.minDeposit < B && (p.minDeposit = B);
        let Q = o, F = o;
        L.minDeposit > 0 && (be = !0), p.minDeposit > 0 && (V = !0), o < 0 || (o < L.minDeposit && (Q = L.minDeposit), o < p.minDeposit && (F = p.minDeposit));
        const Ne = Z(N.apr) > 0 || Z(N.flatRate) > 0;
        let se = Z(d) > 0;
        N.financeCompanyId === BM && x < 6e3 && d > 54 && (se = !1), N.financeCompanyId === ws && Z(d) % 6 !== 0 && (se = !1);
        const Nt = g1(N.financeCompanyId);
        if (Ne && se) {
          const je = t.price + Z(S) + Z(H) - Z(Q), We = t.price + Z(Y) + Z(B) - Z(F), Re = kM(N, t, je, d, a, Q, !1), Be = Nt && kM(N, t, We, d, a, F, !0);
          if (Nt || N.vehicleRuleResults.push({
            vehicleId: t.vehicleId,
            term: d,
            resultType: "FinanceFailRule",
            displayPriority: 1,
            pcp: !0,
            message: "PCP not supported"
          }), N.hpAprRangesV4 && Array.isArray(N.hpAprRangesV4) && N.hpAprRangesV4.length > 0) {
            const Ie = N.hpAprRangesV4.find((K) => K.minFinanceAmount <= je && K.maxFinanceAmount >= je);
            Ie && (Ie.apr || Ie.flatRate) && (Ie.apr && (N.apr = Number(Ie.apr)), Ie.flatRate && (N.flatRate = Number(Ie.flatRate)), Ie.commissionPercentage && (N.commissionInfo == null && (N.commissionInfo = {}), N.commissionInfo.commissionPercentage = Number(Ie.commissionPercentage)), Ie.commissionFixed && (N.commissionInfo == null && (N.commissionInfo = {}), N.commissionInfo.commissionFixed = Number(Ie.commissionFixed)), Ie.affiliateCommissionPercentage && (N.affiliateCommissionInfo == null && (N.affiliateCommissionInfo = {}), N.affiliateCommissionInfo.commissionPercentage = Number(Ie.affiliateCommissionPercentage)), Ie.affiliateCommissionFixed && (N.affiliateCommissionInfo == null && (N.affiliateCommissionInfo = {}), N.affiliateCommissionInfo.commissionFixed = Number(Ie.affiliateCommissionFixed)));
          }
          if (N.financeCompanyId === vs && N.flatRateByDepositPercentage && (Z(Q) / (t.price + S + H) * 100 >= N.flatRateByDepositPercentage.minDepositPercentage ? N.flatRate = N.flatRateByDepositPercentage.reducedFlatRate : N.flatRate = N.flatRateByDepositPercentage.originalFlatRate), a.bespokeRates && Array.isArray(a.bespokeRates) && a.bespokeRates.length > 0) {
            const Ie = a.bespokeRates.find((K) => K.financeCompanyId === N.financeCompanyId);
            Ie && Ie.rate && (N.apr = Number(Ie.rate));
          }
          if (Re || Be) {
            if (Z(N.apr) > 0 ? Object.assign(L, Da(t.price + S + H, Z(N.apr), Z(d), Z(Q), N)) : Object.assign(
              L,
              Ys(
                t.price + S + H,
                Z(N.flatRate),
                Z(d),
                Z(Q),
                N
              )
            ), L.deposit = Z(Q), L.depositDisplay = Z(Q) - Z(M) + Z(r), L.pxValue = M, L.pxSettlement = r, L.effectiveDeposit = o, L.depositRequired = be, L.maxLTV = $, N.commissionInfo) {
              if (Z(N.commissionInfo.commissionFixed) > 0)
                L.commissionAmount = Z(N.commissionInfo.commissionFixed);
              else if (Z(N.commissionInfo.commissionPercentage) > 0) {
                let Ie = Z(N.commissionInfo.commissionCap) > 0 ? Z(N.commissionInfo.commissionCap) : 999999, K = Z(N.commissionInfo.commissionPercentageCapOfTotalInterestCharges) > 0 ? (L.totalAmountPayable - L.amountToFinance) * Z(N.commissionInfo.commissionPercentageCapOfTotalInterestCharges) / 100 : 999999, X = Z(N.commissionInfo.commissionPercentage) / 100 * L.amountToFinance;
                L.commissionAmount = Math.min(X, Ie, K), L.commissionAmount = Math.round(L.commissionAmount * 100) / 100;
              }
            }
            if (N.affiliateCommissionInfo) {
              if (Z(N.affiliateCommissionInfo.commissionFixed) > 0)
                L.affiliateCommissionAmount = Z(N.affiliateCommissionInfo.commissionFixed);
              else if (Z(N.affiliateCommissionInfo.commissionPercentage) > 0) {
                let Ie = Z(N.affiliateCommissionInfo.commissionCap) > 0 ? Z(N.affiliateCommissionInfo.commissionCap) : 999999, K = Z(N.affiliateCommissionInfo.commissionPercentage) / 100 * L.amountToFinance;
                L.affiliateCommissionAmount = Math.min(K, Ie), L.affiliateCommissionAmount = Math.round(L.affiliateCommissionAmount * 100) / 100;
              }
            }
            if (Be && Nt && (!a.ignorePcpLender || !a.ignorePcpLender.find((Ie) => Ie === N.financeCompanyId))) {
              p.deposit = Z(F), p.depositDisplay = Z(F) - Z(M) + Z(r), p.pxValue = M, p.pxSettlement = r, p.effectiveDeposit = o, p.depositRequired = V, p.maxLTV = E;
              let Ie = oe || Me;
              p.maxDeposit = Ie - N.minLendAmount, t.price + Y > Ie && (p.minDeposit = t.price + Y - Ie), p.minDeposit > 0 && (p.depositRequired = !0), o < p.minDeposit && (p.deposit = p.minDeposit), Object.assign(p, Al(t, t.price + Y + B, d, p.deposit, N.apr, N, 8e3, n)), p && p.monthlyPayment > 0 && (L.pcp = p);
            }
            L.rank = Wn(x + H, N), j.push(L);
          } else
            N.financeCompanyId == Cs;
        } else if (N.financeCompanyId === Qt || Nt) {
          const je = Mr(x, Vi(t), n, a.bespokeRates, N.financeCompanyId, !1);
          L.rank = Wn(x + H, N), L.rank = Wn(x + H, N);
          const We = kM(N, t, x, d, a, Q, !1), Re = kM(N, t, f, d, a, Q, !0);
          if (We) {
            if (Object.assign(L, Da(t.price + S, Z(je), Z(d), Z(Q), N)), L.deposit = Z(Q), L.depositDisplay = Z(Q) - Z(M) + Z(r), L.pxValue = M, L.pxSettlement = r, L.effectiveDeposit = o, L.depositRequired = be, L.maxLTV = $, Re && (!a.ignorePcpLender || !a.ignorePcpLender.find((Be) => Be === N.financeCompanyId))) {
              p.deposit = Z(F), p.depositDisplay = Z(F) - Z(M) + Z(r), p.pxValue = M, p.pxSettlement = r, p.effectiveDeposit = o, p.depositRequired = V, p.maxLTV = E;
              let Be = oe || Me;
              p.maxDeposit = Be - N.minLendAmount, t.price + S > Be && (p.minDeposit = t.price + S - Be), p.minDeposit > 0 && (p.depositRequired = !0), o < p.minDeposit && (p.deposit = p.minDeposit);
              const Ie = N.financeCompanyId === Qt, K = e.find((X) => X.financeCompanyId !== Qt);
              (!Ie || Ie && !K) && Object.assign(p, Al(t, t.price + S + H, d, p.deposit, 0, N, 8e3, n, a.bespokeRates)), p && p.monthlyPayment > 0 && (L.pcp = p);
            }
            j.push(L);
          }
        }
      }
      if (j.length > 0) {
        const N = j.filter((p) => p.pcp && p.pcp !== null).map((p) => p.pcp).sort((p, h) => p.effectiveRate - h.effectiveRate).sort(pt);
        let x = j.filter((p) => p.minDeposit <= o).sort(pt);
        const f = j.sort((p, h) => p.effectiveRate - h.effectiveRate).sort(pt);
        x.length === 0 && (x = j.sort((p, h) => p.minDeposit - h.minDeposit).sort(pt));
        const L = x[0];
        if (L.altOptions = SM(f.filter((p) => p.financeCompanyId !== L.financeCompanyId && p.effectiveRate <= L.effectiveRate)), L.otherOptions = SM(f.filter((p) => p.financeCompanyId !== L.financeCompanyId)), L.otherOptions.sort(pt), c.push(L), N.length > 0) {
          let p = N.filter((O) => O.minDeposit <= o).sort(pt);
          const h = N.sort((O, S) => O.effectiveRate - S.effectiveRate).sort(pt);
          p.length === 0 && (p = N.sort((O, S) => O.minDeposit - S.minDeposit).sort(pt));
          const w = p[0];
          w.altOptions = SM(h.filter((O) => O.financeCompanyId !== w.financeCompanyId && O.effectiveRate <= w.effectiveRate)), w.otherOptions = SM(h.filter((O) => O.financeCompanyId !== w.financeCompanyId)), w.otherOptions.sort(pt), g.push(w);
        }
      }
    }
    if (c.length > 0) {
      c = c.sort((d, j) => d.monthlyPayment - j.monthlyPayment), t = Object.assign(t, c[0]), t.priceMatrix = c.sort((d, j) => d.term - j.term), t.pcpMatrix = g.sort((d, j) => d.term - j.term);
      for (const d of t.priceMatrix)
        for (const j of t.priceMatrix)
          j.term !== d.term && (d.altOptions = Il([j], d.altOptions, d.financeCompanyId, d.effectiveRate, d.term), d.altOptions = Il(j.altOptions, d.altOptions, d.financeCompanyId, d.effectiveRate, d.term), d.altOptions.sort((D, I) => D.effectiveRate - I.effectiveRate));
    } else
      t.cannotPrice = !0;
  } else
    t.cannotPrice = !0;
  return t.cannotPrice && (t.cannotPriceReason = eL(t, e), t.cannotPriceReasonPcp = t.cannotPriceReason), !t.cannotPrice && (!t.pcpMatrix || t.pcpMatrix.length === 0) && (t.cannotPricePCP = !0, t.cannotPriceReasonPCP = tL(t, e, a.annualMileage)), t.lenderDecisions = iL(t, e, a.bespokeRates), t;
}
function eL(t, e, i = !1) {
  let M = Object.assign({}, e);
  if (i && (M = M.filter((c) => hs.includes(c.financeCompanyId)), M.length === 0))
    return "No PCP approvals";
  const n = e.filter((c) => c.maxVehicleAgeAtStart).sort((c, g) => (c.maxVehicleAgeAtStart > 15 ? c.maxVehicleAgeAtStart : c.maxVehicleAgeAtStart * 12) < (g.maxVehicleAgeAtStart > 15 ? g.maxVehicleAgeAtStart : g.maxVehicleAgeAtStart * 12) ? 1 : -1);
  if (n.length > 0 && Vi(t) > (n[0].maxVehicleAgeAtStart > 15 ? n[0].maxVehicleAgeAtStart : n[0].maxVehicleAgeAtStart * 12))
    return "Max Age";
  if (e.find((c) => c.vehicleRuleResults && c.vehicleRuleResults.find((g) => g.message === "Vehicle age at end of term")))
    return "Max age at end";
  const a = e.filter((c) => ki.getPropMaxMileage(c, t)).sort((c, g) => ki.getPropMaxMileage(c, t) < ki.getPropMaxMileage(g, t) ? 1 : -1);
  if (a.length > 0 && t.mileage > ki.getPropMaxMileage(a[0], t))
    return "Max Mileage";
  const r = e.filter((c) => c.minLendAmount).sort((c, g) => c.minLendAmount < g.minLendAmount ? -1 : 1);
  if (r.length > 0 && t.price < r[0].minLendAmount)
    return "Min Lend";
  const o = e.filter((c) => c.maxLendAmount).sort((c, g) => c.maxLendAmount < g.maxLendAmount ? 1 : -1);
  if (o.length > 0 && t.price > o[0].maxLendAmount)
    return "Max Lend";
  if (e.find((c) => c.vehicleRuleResults && c.vehicleRuleResults.find((g) => g.message === "Vehicle is excluded")))
    return "Vehicle is excluded";
  const s = e.find((c) => c.vehicleRuleResults && c.vehicleRuleResults.find((g) => g.message.includes("Vehicle type")));
  if (s)
    return s.vehicleRuleResults.find((c) => c.message.includes("Vehicle type")).message;
  const u = e.find((c) => c.vehicleRuleResults && c.vehicleRuleResults.find((g) => g.rule === "DepositRule"));
  return u ? u.vehicleRuleResults.find((c) => c.rule === "DepositRule").message : "Failed Rule";
}
function tL(t, e) {
  if (Vi(t) > 96)
    return "Max Age";
  if (t.mileage > 8e4)
    return "Max Mileage";
  if (t.price < 2500)
    return "Min Lend";
  if (t.price > 1e6)
    return "Max Lend";
  if (!e.find((M) => hs.includes(M.financeCompanyId)))
    return "No PCP approvals";
  if (t.cannotPriceReasons && t.cannotPriceReasons.find((M) => M.reason === "Exceeds max annual mileage"))
    return "Exceeds max annual mileage";
  if (!t.futures && !e.find((M) => M.financeCompanyId === Qt))
    return "No residual values";
  const i = e.find((M) => M.vehicleRuleResults && M.vehicleRuleResults.find((n) => n.rule === "DepositRule"));
  return i ? i.vehicleRuleResults.find((M) => M.rule === "DepositRule").message : "Failed Rule";
}
function iL(t, e, i) {
  const M = [], n = ML(t, i), a = aL(e), r = rL(e), o = nL(e), s = lL(e, t, n, r, o, a), u = oL(e, t, n, r, o, a, s);
  return M.push({
    name: "Approved",
    rows: n && n.length > 0 ? n.sort((c, g) => c.rate < g.rate ? -1 : 1) : n,
    defaultOpened: !0
  }), M.push({
    name: "Awaiting Decision",
    rows: a,
    defaultOpened: !0,
    loading: !0
  }), M.push({
    name: "Failed Lender Vehicle Rules",
    rows: s,
    defaultOpened: !1
  }), M.push({
    name: "Failed Lender Customer Rules",
    rows: r,
    defaultOpened: !1
  }), M.push({
    name: "Declined",
    rows: o,
    defaultOpened: !1
  }), M.push({
    name: "Failed Lender Finance Rules",
    rows: u,
    defaultOpened: !1
  }), M;
}
function ML(t, e) {
  const i = [];
  return t.priceMatrix && t.priceMatrix.forEach((M) => {
    i.findIndex((n) => n.id === M.financeCompanyId) === -1 && i.push({
      id: M.financeCompanyId,
      icon: "mdi-check-bold",
      iconColour: "positive",
      title: M.financeCompany + (M.loanProposalStatus && M.loanProposalStatus === "ProvisionalAcceptance" ? " (Predicted)" : ""),
      subtext: Ci(e, M.financeCompanyId, M.effectiveRate),
      rate: hi(e, M.financeCompanyId, M.effectiveRate)
    });
  }), t.pcpMatrix && t.pcpMatrix.forEach((M) => {
    i.findIndex((n) => n.id === M.financeCompanyId) === -1 && i.push({
      id: M.financeCompanyId,
      icon: "mdi-check-bold",
      iconColour: "positive",
      title: M.financeCompany + (M.loanProposalStatus && M.loanProposalStatus === "ProvisionalAcceptance" ? " (Predicted)" : ""),
      subtext: Ci(e, M.financeCompanyId, M.effectiveRate),
      rate: hi(e, M.financeCompanyId, M.effectiveRate)
    });
  }), t.priceMatrix && t.priceMatrix.forEach((M) => {
    M.altOptions.forEach((n) => {
      i.findIndex((a) => a.id === n.financeCompanyId) === -1 && i.push({
        id: n.financeCompanyId,
        icon: "mdi-check-bold",
        iconColour: "positive",
        title: n.financeCompany + (n.loanProposalStatus && n.loanProposalStatus === "ProvisionalAcceptance" ? " (Predicted)" : ""),
        subtext: Ci(e, n.financeCompanyId, n.effectiveRate),
        rate: hi(e, n.financeCompanyId, n.effectiveRate)
      });
    }), M.otherOptions.forEach((n) => {
      i.findIndex((a) => a.id === n.financeCompanyId) === -1 && i.push({
        id: n.financeCompanyId,
        icon: "mdi-check-bold",
        iconColour: "positive",
        title: n.financeCompany + (n.loanProposalStatus && n.loanProposalStatus === "ProvisionalAcceptance" ? " (Predicted)" : ""),
        subtext: Ci(e, n.financeCompanyId, n.effectiveRate),
        rate: hi(e, n.financeCompanyId, n.effectiveRate)
      });
    });
  }), t.pcpMatrix && t.pcpMatrix.forEach((M) => {
    M.altOptions.forEach((n) => {
      i.findIndex((a) => a.id === n.financeCompanyId) === -1 && i.push({
        id: n.financeCompanyId,
        icon: "mdi-check-bold",
        iconColour: "positive",
        title: n.financeCompany + (n.loanProposalStatus && n.loanProposalStatus === "ProvisionalAcceptance" ? " (Predicted)" : ""),
        subtext: Ci(e, n.financeCompanyId, n.effectiveRate),
        rate: hi(e, n.financeCompanyId, n.effectiveRate)
      });
    }), M.otherOptions.forEach((n) => {
      i.findIndex((a) => a.id === n.financeCompanyId) === -1 && i.push({
        id: n.financeCompanyId,
        icon: "mdi-check-bold",
        iconColour: "positive",
        title: n.financeCompany + (n.loanProposalStatus && n.loanProposalStatus === "ProvisionalAcceptance" ? " (Predicted)" : ""),
        subtext: Ci(e, n.financeCompanyId, n.effectiveRate),
        rate: hi(e, n.financeCompanyId, n.effectiveRate)
      });
    });
  }), i;
}
function nL(t) {
  const e = [];
  return t.forEach((i) => {
    i.loanProposalStatus && i.loanProposalStatus.toString() === "Declined" && !e.find((M) => M.id === i.financeCompanyId) && e.push({
      id: i.financeCompanyId,
      title: i.financeCompany,
      icon: "mdi-close-thick",
      iconColour: "negative",
      subtext: null
    });
  }), e;
}
function aL(t) {
  const e = [];
  return t.forEach((i) => {
    i.loanProposalStatus && i.loanProposalStatus.toString() === "Processing" && !e.find((M) => M.id === i.financeCompanyId) && e.push({
      id: i.financeCompanyId,
      title: i.financeCompany,
      icon: "mdi-loading",
      iconColour: "warning",
      subtext: null
    });
  }), e;
}
function rL(t) {
  const e = [];
  return t.forEach((i) => {
    (!e.find((M) => M.id === i.financeCompanyId) && i.loanProposalStatus && i.loanProposalStatus.toString() !== "Accepted" && i.customerRuleResults && i.customerRuleResults.find((M) => M.resultType === "FixedDecline") || i.loanProposalStatus && i.loanProposalStatus === "FailedSendRules") && e.push({
      id: i.financeCompanyId,
      title: i.financeCompany,
      icon: "mdi-exclamation-thick",
      iconColour: "negative",
      subtext: i.loanProposalStatus && i.loanProposalStatus === "FailedSendRules" ? "Failed send rules" : i.customerRuleResults.find((M) => M.resultType === "FixedDecline").message
    });
  }), e;
}
function lL(t, e, i, M, n, a) {
  const r = [];
  return t.filter((o) => !a.find((s) => s.id === o.financeCompanyId)).forEach((o) => {
    let s = t.filter((u) => u.financeCompanyId === o.financeCompanyId).sort((u, c) => u.minLendAmount - c.minLendAmount);
    if (s.find((u) => u.vehicleRuleResults.filter((c) => c.resultType === "VehicleFailRule" && c.vehicleId === e.vehicleId)) && !r.find((u) => u.id === o.financeCompanyId)) {
      const u = s.map((g) => [...new Set(g.vehicleRuleResults.filter((d) => d.resultType === "VehicleFailRule"))]);
      let c = [];
      u.forEach((g) => c.push(...g)), c = c.sort((g, d) => g.displayPriority - d.displayPriority), c.forEach((g) => {
        r.find((d) => d.id === g.id) || r.push({
          id: o.financeCompanyId,
          title: o.financeCompany,
          pcp: g.pcp,
          icon: "mdi-exclamation-thick",
          iconColour: "warning",
          subtext: g.message
        });
      });
    }
  }), r;
}
function oL(t, e, i, M, n, a, r) {
  const o = [];
  return t.filter((s) => !M.find((u) => u.id === s.financeCompanyId) && !r.find((u) => u.id === s.financeCompanyId) && !n.find((u) => u.id === s.financeCompanyId) && !a.find((u) => u.id === s.financeCompanyId)).forEach((s) => {
    let u = t.filter((c) => c.financeCompanyId === s.financeCompanyId).sort((c, g) => c.minLendAmount - g.minLendAmount);
    if (!u.find((c) => c.vehicleRuleResults.filter((g) => g.resultType === "FinanceFailRule" && g.vehicleId === e.vehicleId).length === 0)) {
      const c = u.map((d) => [...new Set(d.vehicleRuleResults.filter((j) => j.resultType === "FinanceFailRule"))]);
      let g = [];
      c.forEach((d) => g.push(...d)), g = g.sort((d, j) => d.displayPriority - j.displayPriority), g.forEach((d) => {
        o.find((j) => j.term === d.term && j.pcp === d.pcp && j.id === s.financeCompanyId) || o.push({
          id: s.financeCompanyId,
          title: s.financeCompany,
          term: d.term,
          pcp: d.pcp,
          icon: "mdi-exclamation-thick",
          iconColour: "warning",
          subtext: d.message
        });
      });
    }
  }), o;
}
function Ci(t, e, i) {
  return t && t.find((M) => M.financeCompanyId === e) ? t.find((M) => M.financeCompanyId === e).rate + "% APR (Bespoke)" : i + "% APR";
}
function hi(t, e, i) {
  return t && t.find((M) => M.financeCompanyId === e) ? t.find((M) => M.financeCompanyId === e).rate : i;
}
function Wn(t, e) {
  if (e.hpRank && e.hpRank.length > 0) {
    const i = e.hpRank.find((M) => M.minFinanceAmount <= t && M.maxFinanceAmount >= t);
    return i ? i.rank : e.rank ? e.rank : 0;
  }
  return e.rank ? e.rank : 0;
}
function Rs(t, e, i) {
  const M = {};
  return M.applicationId = 100101010, M.proposalKey = null, M.proposalId = 10101, M.lenderReference = "DUMMY_REF", M.isPrime = !1, M.isPreferredAcceptance = !0, M.minVehicleAgeAtStart = null, M.maxVehicleAgeAtStart = null, M.minMileage = null, M.maxMileage = 12e4, M.maxLendAmount = 5e4, M.minLendAmount = 2500, M.minTerm = 24, M.maxTerm = 60, M.customerUserId = 101010, M.amountToFinance = Number(t), M.term = Number(i), M.apr = Number(e), M.flatRate = null, M.monthlyPayment = null, M.totalAmountPayable = null, M.financeCompany = "247 Money", M.financeCompanyId = 57, M.tierId = 0, M.createdUtc = /* @__PURE__ */ new Date(), M;
}
function sL(t, e, i) {
  const M = {};
  return M.applicationId = 100101010, M.proposalKey = null, M.proposalId = 10101, M.lenderReference = "DUMMY_REF", M.isPrime = !0, M.isPreferredAcceptance = !0, M.minVehicleAgeAtStart = null, M.maxVehicleAgeAtStart = null, M.maxVehicleAgeAtEnd = 15, M.minMileage = null, M.maxMileage = 14e4, M.maxLendAmount = 1e5, M.minLendAmount = 2e3, M.minTerm = 12, M.maxTerm = 60, M.customerUserId = 101010, M.amountToFinance = Number(t), M.term = Number(i), M.apr = null, M.flatRate = null, M.monthlyPayment = null, M.totalAmountPayable = null, M.financeCompany = "Carfinance247", M.financeCompanyId = 49, M.createdUtc = /* @__PURE__ */ new Date(), M;
}
function uL(t, e = 0, i = 2e4) {
  const M = Rs(t.price, 19.9, 60), n = sL(t.price, 12.9, 60);
  return Ps(t, [t.price >= i ? n : M], e, 0);
}
var tn = {
  calculateMonthlyPayment: Da,
  calculateMonthlyPaymentForVehicle: Ps,
  priceSortingFunction: pt,
  calculateMonthlyPaymentFlat: Ys,
  vehicleValid: ks,
  getFutureValue: Us,
  getPrimeRate: Mr,
  dumpMatrix: b1,
  calculateEffectiveRate: Es,
  findMaxTerms: _s,
  generateRepApr: uL,
  mockProposal: Rs,
  isVehiclePcpEligible: N1,
  constructResidualsRequest: G1,
  getResiduals: Z1,
  isVehicleSupportedforProvisionalLicence: Qs
};
function cL(t, e) {
  const i = {};
  return i.proposalId = 10101, i.lenderReference = "ALPHERA_REF", i.isPrime = !0, i.isPreferredAcceptance = !0, i.minVehicleAgeAtStart = null, i.maxVehicleAgeAtStart = null, i.maxVehicleAgeAtEnd = 144, i.minMileage = null, i.maxMileage = 8e4, i.maxLendAmount = 1e6, i.minLendAmount = 3e3, i.minLendAmountPcp = 3e3, i.minTerm = 24, i.maxTerm = 60, i.loanProposalStatus = "ProvisionalAcceptance", i.amountToFinance = Number(t), i.apr = e ?? null, i.flatRate = null, i.financeCompany = "Alphera", i.financeCompanyId = 50, i.rank = null, i;
}
function gL(t, e) {
  const i = {};
  return i.proposalId = 10101, i.lenderReference = "BNP_REF", i.isPrime = !0, i.isPreferredAcceptance = !0, i.minVehicleAgeAtStart = null, i.maxVehicleAgeAtStart = 96, i.maxVehicleAgeAtEnd = 144, i.minMileage = null, i.maxMileage = 1e5, i.maxLendAmount = 75e3, i.minLendAmount = 3e3, i.minTerm = 24, i.maxTerm = 60, i.loanProposalStatus = "ProvisionalAcceptance", i.amountToFinance = Number(t), i.apr = e ?? null, i.flatRate = null, i.financeCompany = "BNP Paribas", i.financeCompanyId = 63, i.rank = null, i;
}
function NL(t, e) {
  const i = {};
  return i.proposalId = 10101, i.lenderReference = "DUMMY_REF", i.isPrime = !0, i.isPreferredAcceptance = !0, i.minVehicleAgeAtStart = null, i.maxVehicleAgeAtStart = null, i.maxVehicleAgeAtEnd = 12, i.minMileage = null, i.maxMileage = 7e4, i.maxLendAmount = 3e5, i.minLendAmount = 1e4, i.minTerm = 24, i.maxTerm = 49, i.loanProposalStatus = "ProvisionalAcceptance", i.amountToFinance = Number(t), i.apr = e ?? null, i.flatRate = null, i.financeCompany = "Credit Agricole", i.financeCompanyId = 74, i.rank = null, i;
}
function IL(t, e) {
  const i = {};
  return i.proposalId = 10101, i.lenderReference = "CLOSE_REF", i.isPrime = !0, i.minVehicleAgeAtStart = null, i.maxVehicleAgeAtStart = null, i.maxVehicleAgeAtEnd = 180, i.minMileage = null, i.maxMileage = 12e4, i.maxLendAmount = 2e5, i.minLendAmount = 1e3, i.minTerm = 36, i.maxTerm = 60, i.loanProposalStatus = "ProvisionalAcceptance", i.amountToFinance = Number(t), i.apr = e ?? null, i.flatRate = null, i.financeCompany = "Close Brothers", i.financeCompanyId = 70, i.rank = null, i;
}
function DL(t, e) {
  const i = {};
  return i.proposalId = 10101, i.lenderReference = "MOTONOVO_REF", i.isPrime = !0, i.isPreferredAcceptance = !0, i.minVehicleAgeAtStart = null, i.maxVehicleAgeAtStart = null, i.maxVehicleAgeAtEnd = 180, i.minMileage = null, i.maxMileage = 13e4, i.maxLendAmount = 75e3, i.minLendAmount = 3e3, i.minLendAmountPcp = 3e3, i.minTerm = 36, i.maxTerm = 60, i.loanProposalStatus = "ProvisionalAcceptance", i.amountToFinance = Number(t), i.apr = e ?? null, i.flatRate = null, i.financeCompany = "Motonovo", i.financeCompanyId = 67, i.rank = null, i;
}
function dL(t, e) {
  const i = {};
  return i.proposalId = 10101, i.lenderReference = "NORTHRIDGE_REF", i.isPrime = !0, i.isPreferredAcceptance = !0, i.minVehicleAgeAtStart = null, i.maxVehicleAgeAtStart = null, i.maxVehicleAgeAtEnd = 15, i.minMileage = null, i.maxMileage = 9e4, i.maxLendAmount = 15e4, i.minLendAmount = 2500, i.minLendAmountPcp = 5e3, i.minTerm = 24, i.maxTerm = 60, i.loanProposalStatus = "ProvisionalAcceptance", i.amountToFinance = Number(t), i.apr = e ?? null, i.flatRate = null, i.financeCompany = "Northridge", i.financeCompanyId = 75, i.rank = null, i;
}
function jL(t, e) {
  const i = {};
  return i.proposalId = 10101, i.lenderReference = "V12_REF", i.isPrime = !0, i.isPreferredAcceptance = !0, i.minVehicleAgeAtStart = null, i.maxVehicleAgeAtStart = null, i.maxVehicleAgeAtEnd = 15, i.minMileage = null, i.maxMileage = 125e3, i.maxLendAmount = 2e4, i.minLendAmount = 5e3, i.minLendAmountPcp = 5e3, i.minTerm = 36, i.maxTerm = 60, i.loanProposalStatus = "ProvisionalAcceptance", i.amountToFinance = Number(t), i.apr = e ?? null, i.flatRate = null, i.financeCompany = "V12", i.financeCompanyId = 66, i.rank = null, i;
}
function yL(t, e) {
  const i = {};
  return i.proposalId = 10101, i.lenderReference = "ZOPA_REF", i.isPrime = !0, i.isPreferredAcceptance = !0, i.minVehicleAgeAtStart = null, i.maxVehicleAgeAtStart = null, i.maxVehicleAgeAtEnd = 10, i.minMileage = null, i.maxMileage = 125e3, i.maxLendAmount = 5e4, i.minLendAmount = 3e3, i.minLendAmountPcp = 3e3, i.minTerm = 24, i.maxTerm = 60, i.loanProposalStatus = "ProvisionalAcceptance", i.amountToFinance = Number(t), i.apr = e ?? null, i.flatRate = null, i.financeCompany = "Zopa", i.financeCompanyId = 73, i.rank = null, i;
}
function Fs(t, e) {
  const i = {};
  return i.proposalId = 10101, i.lenderReference = "HP_REF", i.isPrime = !1, i.isPreferredAcceptance = !0, i.minVehicleAgeAtStart = null, i.maxVehicleAgeAtStart = 145, i.maxVehicleAgeAtEnd = 181, i.minMileage = null, i.maxMileage = 12e4, i.maxLendAmount = 1e6, i.minLendAmount = 2e3, i.minLendAmountPcp = 2e3, i.minTerm = 24, i.maxTerm = 60, i.loanProposalStatus = "ProvisionalAcceptance", i.amountToFinance = Number(t), i.apr = null, i.flatRate = null, i.financeCompany = "Carfinance247", i.financeCompanyId = 49, i.rank = null, i;
}
function Tl(t, e) {
  const i = [];
  return i.push(cL(t, e)), i.push(gL(t, e)), i.push(NL(t, e)), i.push(IL(t, e)), i.push(DL(t, e)), i.push(dL(t, e)), i.push(jL(t, e)), i.push(yL(t, e)), i.push(Fs(t)), i;
}
function Ws(t) {
  const e = new Intl.NumberFormat("en-GB", {
    maximumFractionDigits: 1,
    minimumFractionDigits: 0
  });
  return t.effectiveRate > 0 ? e.format(t.effectiveRate) + "%" : t.apr ? e.format(t.apr) + "%" : t.flatRate ? e.format(t.flatRate) + "% flat" : "";
}
const nr = (t, e) => {
  const i = t.__vccOpts || t;
  for (const [M, n] of e)
    i[M] = n;
  return i;
}, AL = {}, TL = {
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 904.000000 251.000000",
  preserveAspectRatio: "xMidYMid meet"
};
function xL(t, e) {
  return y(), A("svg", TL, e[0] || (e[0] = [
    za(`<g transform="translate(0.000000,251.000000) scale(0.100000,-0.100000)" fill="var(--q-brand-logo-colour)" stroke="none"><path d="M4970 2025 l0 -265 35 0 35 0 0 110 0 110 106 0 c121 0 165 14 195
64 27 44 26 140 -1 184 -32 52 -69 62 -230 62 l-140 0 0 -265z m282 194 c32
-17 51 -74 38 -115 -18 -54 -41 -64 -152 -64 l-98 0 0 95 0 95 96 0 c52 0 104
-5 116 -11z"></path><path d="M7710 2195 l0 -94 -36 24 c-50 34 -136 35 -185 2 -104 -69 -105 -274
-2 -343 63 -42 159 -38 204 7 19 19 19 19 19 -6 0 -21 5 -25 30 -25 l30 0 0
265 0 265 -30 0 -30 0 0 -95z m-59 -112 c37 -22 59 -69 59 -127 0 -94 -42
-146 -116 -146 -87 0 -138 83 -114 187 20 91 97 129 171 86z"></path><path d="M8070 2025 l0 -265 30 0 c25 0 30 4 30 25 0 25 0 25 19 6 45 -45 142
-49 203 -7 53 36 73 80 73 166 0 133 -49 192 -165 198 -60 4 -69 2 -98 -23
l-32 -27 0 96 0 96 -30 0 -30 0 0 -265z m230 60 c76 -40 88 -192 18 -250 -55
-47 -140 -30 -173 35 -19 37 -19 133 0 170 28 55 98 75 155 45z"></path><path d="M5512 2133 c-72 -35 -110 -129 -91 -226 11 -60 21 -78 59 -111 89
-74 232 -48 284 52 52 102 13 242 -81 291 -32 16 -133 13 -171 -6z m138 -46
c64 -32 90 -137 54 -213 -31 -65 -118 -85 -172 -39 -40 34 -55 75 -50 136 10
100 90 155 168 116z"></path><path d="M5824 2133 c4 -9 32 -97 64 -195 l57 -179 34 3 35 3 35 142 c20 78
38 144 42 147 3 3 18 -47 34 -112 47 -195 41 -182 79 -182 l33 0 58 183 c32
100 60 188 63 195 3 10 -4 13 -29 10 l-34 -3 -40 -147 c-22 -80 -43 -149 -46
-153 -3 -3 -24 63 -45 147 l-39 153 -32 3 c-36 4 -30 19 -79 -183 -15 -60 -30
-113 -34 -118 -3 -4 -21 48 -40 115 -18 68 -37 138 -42 156 -8 28 -13 32 -45
32 -29 0 -34 -3 -29 -17z"></path><path d="M6478 2125 c-80 -55 -106 -180 -59 -278 31 -64 76 -90 155 -91 88 0
138 31 160 102 7 19 4 22 -23 22 -17 0 -31 -5 -31 -10 0 -6 -11 -22 -25 -35
-19 -20 -34 -25 -74 -25 -64 0 -109 35 -118 93 l-6 37 148 0 147 0 -7 43 c-10
61 -28 98 -64 132 -27 25 -41 30 -99 33 -59 3 -71 0 -104 -23z m168 -57 c12
-13 26 -35 29 -50 l7 -28 -112 0 -112 0 7 28 c8 32 32 61 60 73 33 14 96 3
121 -23z"></path><path d="M6810 1955 l0 -195 29 0 29 0 4 129 c3 128 3 130 33 161 18 19 43 33
67 36 34 6 38 10 38 35 0 26 -3 29 -35 29 -27 0 -44 -9 -75 -40 l-40 -40 0 40
c0 36 -2 40 -25 40 l-25 0 0 -195z"></path><path d="M7130 2143 c-35 -13 -72 -47 -90 -83 -24 -47 -27 -154 -6 -203 51
-120 241 -141 306 -34 27 44 25 57 -10 57 -16 0 -30 -5 -30 -10 0 -6 -11 -22
-25 -35 -19 -20 -34 -25 -72 -25 -28 0 -58 7 -71 16 -26 18 -52 65 -52 94 0
19 5 20 146 20 l146 0 -7 48 c-9 61 -41 118 -81 142 -31 20 -118 26 -154 13z
m136 -77 c19 -19 34 -43 34 -55 0 -20 -5 -21 -110 -21 -121 0 -124 2 -90 58
38 62 113 71 166 18z"></path><path d="M8460 2145 c0 -3 34 -90 76 -194 l76 -190 -21 -45 c-19 -45 -55 -67
-80 -51 -7 4 -11 -5 -11 -24 0 -29 3 -31 36 -31 48 0 70 14 93 58 24 48 181
455 181 470 0 7 -13 12 -29 12 -29 0 -30 -2 -81 -155 -28 -85 -55 -153 -60
-150 -4 2 -31 72 -60 155 l-52 150 -34 0 c-19 0 -34 -2 -34 -5z"></path><path d="M343 1296 c-146 -48 -237 -159 -264 -323 -31 -190 55 -375 209 -450
52 -25 68 -28 167 -28 101 0 115 2 167 28 32 16 75 48 97 74 43 48 81 135 81
183 l0 30 -78 0 -79 0 -12 -42 c-27 -89 -87 -138 -171 -138 -112 0 -190 78
-211 212 -24 150 42 289 153 319 88 23 193 -23 219 -95 l13 -36 84 0 84 0 -7
33 c-20 91 -95 180 -184 220 -59 26 -207 33 -268 13z"></path><path d="M2070 900 l0 -390 85 0 85 0 0 160 0 160 165 0 165 0 0 65 0 65 -162
2 -163 3 0 90 0 90 193 3 192 2 0 70 0 70 -280 0 -280 0 0 -390z"></path><path d="M2710 1220 l0 -70 80 0 80 0 0 70 0 70 -80 0 -80 0 0 -70z"></path><path d="M6390 1269 c-89 -40 -145 -122 -157 -229 l-6 -61 74 3 74 3 7 43 c14
85 58 132 123 132 101 0 149 -126 79 -209 -14 -17 -74 -64 -134 -106 -165
-113 -219 -180 -235 -288 l-7 -47 286 0 286 0 0 65 0 65 -180 0 c-99 0 -180 4
-180 9 0 14 63 66 158 130 95 64 156 124 178 177 8 18 14 61 14 96 0 146 -104
238 -269 238 -45 0 -81 -7 -111 -21z"></path><path d="M6987 1056 l-167 -223 0 -77 0 -76 160 0 160 0 0 -85 0 -85 75 0 75
0 0 85 0 85 50 0 50 0 0 65 0 65 -50 0 -50 0 0 235 0 235 -68 0 -67 0 -168
-224z m150 -243 c-3 -2 -48 -2 -101 -1 l-96 3 98 131 97 132 3 -130 c1 -72 1
-133 -1 -135z"></path><path d="M7400 1205 l0 -75 180 0 180 0 -54 -77 c-62 -89 -114 -190 -145 -282
-26 -74 -51 -190 -51 -232 l0 -29 78 0 78 0 12 89 c25 189 105 389 195 487 47
52 47 52 47 123 l0 71 -260 0 -260 0 0 -75z"></path><path d="M1047 1080 c-21 -6 -50 -16 -66 -24 -32 -17 -91 -81 -91 -99 0 -7 -3
-22 -6 -34 -6 -22 -4 -23 75 -23 72 0 81 2 81 18 0 10 12 29 26 43 21 19 36
24 79 23 66 0 95 -22 95 -70 0 -45 -28 -62 -126 -74 -159 -20 -222 -54 -244
-131 -12 -41 -4 -103 19 -142 47 -83 225 -100 325 -32 l34 23 6 -24 c6 -23 11
-24 79 -24 l72 0 -3 227 c-4 265 -8 282 -86 322 -37 19 -65 24 -139 27 -50 2
-109 -1 -130 -6z m178 -430 c-21 -41 -75 -64 -129 -55 -51 8 -76 30 -76 67 0
61 27 80 139 97 35 6 66 13 70 17 15 15 11 -97 -4 -126z"></path><path d="M1755 1072 c-22 -11 -55 -35 -73 -56 l-32 -37 0 46 0 45 -75 0 -75 0
0 -280 0 -280 80 0 80 0 0 163 c0 192 8 218 80 255 34 18 55 22 88 18 l43 -6
-3 73 -3 72 -35 3 c-19 1 -53 -6 -75 -16z"></path><path d="M3194 1072 c-23 -11 -53 -33 -68 -48 l-26 -29 0 38 0 37 -75 0 -75 0
0 -280 0 -280 80 0 80 0 0 180 c0 202 8 238 59 264 57 30 120 15 146 -33 12
-24 15 -68 15 -221 l0 -190 81 0 81 0 -4 218 c-3 208 -4 219 -28 267 -32 64
-71 87 -158 92 -52 3 -77 -1 -108 -15z"></path><path d="M3733 1076 c-68 -22 -110 -54 -132 -100 -35 -72 -32 -76 58 -76 l79
0 6 30 c8 40 62 65 120 55 53 -8 76 -30 76 -71 0 -45 -26 -60 -127 -74 -161
-21 -219 -52 -244 -127 -14 -42 -5 -108 20 -149 49 -81 225 -97 326 -29 l34
24 3 -22 c3 -20 10 -22 78 -25 l75 -3 -3 203 c-1 112 -4 221 -7 243 -7 48 -42
90 -94 113 -50 21 -214 26 -268 8z m190 -429 c-11 -19 -33 -37 -53 -44 -42
-15 -108 -8 -132 14 -24 22 -23 78 2 103 21 21 28 23 130 43 l65 12 3 -48 c2
-33 -3 -58 -15 -80z"></path><path d="M4453 1079 c-18 -5 -48 -24 -67 -43 l-36 -33 0 33 0 34 -75 0 -75 0
0 -280 0 -280 75 0 75 0 0 155 c0 175 11 243 44 274 29 27 87 37 125 21 51
-21 61 -65 61 -270 l0 -180 75 0 75 0 0 211 c0 235 -6 272 -54 317 -52 49
-140 65 -223 41z"></path><path d="M5014 1079 c-59 -17 -126 -71 -158 -128 -25 -46 -31 -68 -34 -142 -7
-144 33 -226 139 -284 48 -26 64 -30 139 -30 144 0 228 56 265 179 l14 46 -74
0 -75 0 -14 -33 c-21 -51 -60 -77 -117 -77 -40 0 -52 5 -78 30 -74 74 -66 245
14 308 19 15 42 22 74 22 54 0 83 -17 101 -60 12 -30 13 -30 86 -30 68 0 74 2
74 21 0 64 -79 149 -161 173 -57 17 -146 19 -195 5z"></path><path d="M5626 1074 c-72 -23 -150 -104 -172 -179 -38 -132 1 -282 90 -347
101 -73 260 -76 356 -8 33 24 90 104 90 127 0 9 -18 13 -61 13 -56 0 -65 -3
-100 -35 -35 -32 -45 -35 -98 -35 -49 0 -65 4 -90 26 -25 21 -51 74 -51 106 0
4 93 9 208 10 l207 3 -3 50 c-7 112 -54 199 -135 249 -59 36 -163 45 -241 20z
m165 -114 c19 -11 40 -46 53 -87 l7 -23 -130 0 c-72 0 -131 2 -131 5 0 21 32
75 55 93 30 24 111 30 146 12z"></path><path d="M2710 790 l0 -280 80 0 80 0 0 280 0 280 -80 0 -80 0 0 -280z"></path><path d="M8294 1045 c-214 -46 -364 -234 -364 -455 0 -263 205 -470 465 -470
182 0 339 99 421 265 34 70 39 87 42 172 5 117 -14 199 -68 281 -72 111 -172
181 -299 208 -80 17 -117 17 -197 -1z m421 -488 c-11 -84 -42 -142 -105 -200
-72 -67 -141 -92 -239 -85 -85 6 -154 41 -214 108 -42 47 -76 114 -64 127 3 2
22 8 42 13 33 7 37 6 46 -17 30 -80 124 -143 214 -143 68 0 147 40 185 92 26
36 53 122 47 150 -1 6 16 17 38 23 51 15 59 4 50 -68z"></path></g>`, 1)
  ]));
}
const zL = /* @__PURE__ */ nr(AL, [["render", xL]]), ja = [
  {
    affiliateUserId: 19773,
    displayName: "Admiral"
  },
  {
    affiliateUserId: 1664,
    displayName: "AutoVillage"
  },
  {
    affiliateUserId: 16588,
    displayName: "Autovolo"
  },
  {
    affiliateUserId: 21723,
    displayName: "AllPurposeLoans"
  },
  {
    affiliateUserId: -1,
    displayName: "Aspire Money"
  },
  {
    affiliateUserId: 2655,
    displayName: "CarCraft",
    brand: "Carcraft",
    brandCar: "silver-mercedes",
    host: "carcraft-carsearch",
    brandOnTransition: !0,
    applyPage: "https://carcraft.carfinance247.co.uk"
  },
  {
    affiliateUserId: 0,
    displayName: "CarFinance247",
    brand: "CarFinance247",
    brandCar: "silver-mercedes",
    host: "cf247",
    applyPage: "https://apply.carfinance247.co.uk"
  },
  {
    affiliateUserId: 1977,
    displayName: "Carwow",
    brand: "Carwow",
    brandCar: "silver-mercedes",
    host: "carwow-carsearch",
    applyPage: "https://apply.carfinance247.co.uk"
  },
  {
    affiliateUserId: 41183,
    displayName: "Credit Karma"
  },
  {
    affiliateUserId: 20676,
    displayName: "Credit Karma"
  },
  {
    affiliateUserId: 21746,
    displayName: "Credit Karma",
    brand: "CreditKarma",
    brandCar: "green-mercedes",
    host: "ckdirect-carsearch",
    applyPage: "https://ckdirect.carfinance247.co.uk"
  },
  {
    affiliateUserId: 21174,
    displayName: "Compare The Market"
  },
  {
    affiliateUserId: 42416,
    displayName: "CompareTheMarket",
    brand: "CompareTheMarket",
    brandCar: "silver-mercedes",
    host: "comparethemarket-carsearch",
    applyPage: "https://apply.carfinance247.co.uk",
    brandOnTransition: !0,
    hideRefinance: !0
  },
  {
    affiliateUserId: 43118,
    displayName: "PistonHeads",
    brand: "PistonHeads",
    brandOnTransition: !0,
    applyPage: "https://pistonheads.carfinance247.co.uk"
  },
  {
    affiliateUserId: 43745,
    displayName: "Regit",
    brand: "Regit",
    brandOnTransition: !0,
    applyPage: "https://regit.carfinance247.co.uk"
  },
  {
    affiliateUserId: 16568,
    displayName: "Car Finder Scotland"
  },
  {
    affiliateUserId: 21617,
    displayName: "CarGurus",
    isAllowedSetPreferences: !1,
    isAllowedReturnToSite: !0,
    isClassifiedPartner: !0,
    returnUrl: "https://www.cargurus.co.uk/Cars/forsale?utm_source=CF247&utm_medium=members_area_button",
    host: "cargurus"
  },
  {
    affiliateUserId: 2515,
    displayName: "CarSite"
  },
  {
    affiliateUserId: 18796,
    displayName: "cazana"
  },
  {
    affiliateUserId: 17253,
    displayName: "ClearScore",
    brand: "Clearscore",
    brandCar: "silver-mercedes",
    host: "clearscore-carsearch",
    brandOnTransition: !0,
    applyPage: "https://apply.carfinance247.co.uk"
  },
  {
    affiliateUserId: 19249,
    displayName: "Confused",
    brand: "Confused",
    brandCar: "silver-mercedes",
    brandOnTransition: !0,
    host: "confused-carsearch",
    applyPage: "https://confused.carfinance247.co.uk"
  },
  {
    companyName: "test-Confused.com",
    affiliateUserId: 19240,
    displayName: "Confused"
  },
  {
    affiliateUserId: 20123,
    displayName: "CredAbility"
  },
  {
    affiliateUserId: 21737,
    displayName: "CredApp",
    brand: "CredApp",
    brandCar: "silver-mercedes",
    host: "credapp-carsearch",
    brandOnTransition: !0,
    applyPage: "https://apply.carfinance247.co.uk"
  },
  {
    affiliateUserId: 18782,
    displayName: "DesperateSeller"
  },
  {
    displayName: "DriveScore",
    brand: "DriveScore",
    brandCar: "silver-mercedes",
    affiliateUserId: 42294,
    brandOnTransition: !0,
    host: "drivescore-carsearch",
    applyPage: "https://drivescore.carfinance247.co.uk"
  },
  {
    affiliateUserId: 41999,
    displayName: "Equifax",
    brand: "Equifax",
    brandCar: "silver-mercedes",
    host: "equifax",
    applyPage: "https://apply.carfinance247.co.uk"
  },
  {
    affiliateUserId: 1798,
    displayName: "Experian",
    brand: "Experian",
    brandCar: "silver-mercedes",
    host: "experian",
    brandOnTransition: !0,
    applyPage: "https://apply.carfinance247.co.uk"
  },
  {
    affiliateUserId: null,
    displayName: "facebook"
  },
  {
    affiliateUserId: 3550,
    displayName: "Freedom Finance"
  },
  {
    affiliateUserId: 21175,
    displayName: "Go Compare"
  },
  {
    affiliateUserId: null,
    displayName: "GoWizard"
  },
  {
    affiliateUserId: 17094,
    displayName: "Honest John"
  },
  {
    affiliateUserId: 18781,
    displayName: "knowyourmoney"
  },
  {
    affiliateUserId: 2428,
    displayName: "money"
  },
  {
    affiliateUserId: 16758,
    displayName: "Money Guru"
  },
  {
    affiliateUserId: 20351,
    displayName: "MoneySuperMarket"
  },
  {
    affiliateUserId: 20564,
    displayName: "MoneySavingExpert"
  },
  {
    affiliateUserId: 17137,
    displayName: "Monevo"
  },
  {
    affiliateUserId: 21430,
    displayName: "Motiv"
  },
  {
    affiliateUserId: 2775,
    displayName: "Motors"
  },
  {
    affiliateUserId: 42399,
    displayName: "MyCarCheck",
    brand: "MyCarCheck",
    brandCar: "silver-mercedes",
    host: "mycarcheck-carsearch",
    brandOnTransition: !0,
    applyPage: "https://apply.carfinance247.co.uk"
  },
  {
    affiliateUserId: 21884,
    displayName: "OceanCar",
    brand: "OceanFinance",
    brandCar: "silver-mercedes",
    host: "ocean-carsearch",
    brandOnTransition: !0,
    applyPage: "https://oceancar.carfinance247.co.uk"
  },
  {
    affiliateUserId: 20124,
    displayName: "Ocean Finance"
  },
  {
    affiliateUserId: 17447,
    displayName: "Parkers",
    modalShowLogo: !0,
    brand: "Parkers",
    brandCar: "silver-mercedes",
    brandOnTransition: !0,
    host: "parkers-carsearch"
  },
  {
    affiliateUserId: 17177,
    displayName: "RAC Cars"
  },
  {
    affiliateUserId: 1327,
    displayName: "Used Card NI"
  },
  {
    affiliateUserId: 2411,
    displayName: "uSwitch"
  },
  {
    affiliateUserId: null,
    // TODO - set
    displayName: "Time4Leasing"
  },
  {
    affiliateUserId: 2319,
    displayName: "Think Money"
  },
  {
    affiliateUserId: 21886,
    displayName: "thinkmoneycar",
    brand: "ThinkMoney",
    brandCar: "silver-mercedes",
    host: "thinkmoney-carsearch",
    brandOnTransition: !0,
    applyPage: "https://thinkmoney.carfinance247.co.uk"
  },
  {
    affiliateUserId: 2439,
    displayName: "Totally Money",
    brand: "TotallyMoney",
    brandCar: "silver-mercedes",
    host: "totallymoney-carsearch",
    brandOnTransition: !0,
    applyPage: "https://apply.carfinance247.co.uk"
  },
  {
    affiliateUserId: 2400,
    displayName: "Young Car Driver"
  }
];
function z(t, e, i) {
  if (typeof document > "u") return;
  const M = document.body;
  M && M.style.setProperty(`--q-${t}`, e);
}
let xl = !1;
var zl;
typeof document < "u" && ((zl = document.querySelector("body")) == null || zl.style.setProperty("--border-radius", "15px"), z("brand-brand-text-light", "#fff"));
function ya(t) {
  xl || (xl = !0, z("primary", "#6905F2"), z("brand-background", "#6905F2"), z("brand-background-border", "#6905F2"), z("brand-text-light", "#ffffff"), z("brand-text-dark", "#1d1d1d"), z("brand-button-background", "#ffffff"), z("brand-button-text", "#1d1d1d"), z("brand-button-active-background", "#ffffff"), z("brand-button-active-text", "#6905F2"), z("brand-cta-background", "#ffffff"), z("brand-cta-text", "#6905F2"), z("brand-link-colour", "#6905F2"), z("brand-logo-colour", "#000000"), z("brand-rep-text", "#000000"), t === "Carcraft" && (z("primary", "#ff916f"), z("brand-background", "#ff916f"), z("brand-background-border", "#ff916f"), z("brand-text-light", "#ffffff"), z("brand-text-dark", "#1d1d1d"), z("brand-button-background", "#ffffff"), z("brand-button-text", "#1d1d1d"), z("brand-button-active-background", "#ffffff"), z("brand-button-active-text", "#ff916f"), z("brand-cta-background", "#ffffff"), z("brand-cta-text", "#ff916f"), z("brand-link-colour", "#ff916f"), z("brand-logo-colour", "#000000"), z("brand-rep-text", "#000000")), t === "PistonHeads" && (z("primary", "#1c2527"), z("brand-background", "#1c2527"), z("brand-background-border", "#1c2527"), z("brand-text-light", "#ffffff"), z("brand-text-dark", "#1d1d1d"), z("brand-button-background", "#ffffff"), z("brand-button-text", "#1d1d1d"), z("brand-button-active-background", "#ffffff"), z("brand-button-active-text", "#1c2527"), z("brand-cta-background", "#5d8200"), z("brand-cta-text", "#ffffff"), z("brand-link-colour", "#000000"), z("brand-logo-colour", "#000000"), z("brand-rep-text", "#000000")), (t === "CarFinance247" || t === "247Money") && (z("primary", "#604DD5"), z("secondary", "#26a69a"), z("secondary-hover", "#44b0a6")), t === "Carwow" && (z("primary", "#00a4ff"), z("brand-background", "#00a4ff"), z("brand-background-border", "#00a4ff"), z("brand-text-light", "#ffffff"), z("brand-text-dark", "#1d1d1d"), z("brand-button-background", "#ffffff"), z("brand-button-text", "#1d1d1d"), z("brand-button-active-background", "#ffffff"), z("brand-button-active-text", "#00a4ff"), z("brand-cta-background", "#ffffff"), z("brand-cta-text", "#00a4ff"), z("brand-rep-text", "#000000")), t === "Confused" && (z("primary", "#1F1F1F"), z("brand-background", "#1F1F1F"), z("brand-background-border", "#1F1F1F"), z("brand-text-light", "#ffffff"), z("brand-text-dark", "#1d1d1d"), z("brand-button-background", "#ffffff"), z("brand-button-text", "#1d1d1d"), z("brand-button-active-background", "#ffffff"), z("brand-button-active-text", "#1F1F1F"), z("brand-cta-background", "#ffffff"), z("brand-cta-text", "#1F1F1F"), z("brand-rep-text", "#000000")), t === "ClearScore" && (z("primary", "#233143"), z("brand-background", "#233143"), z("brand-background-border", "#233143"), z("brand-text-light", "#ffffff"), z("brand-text-dark", "#1d1d1d"), z("brand-button-background", "#ffffff"), z("brand-button-text", "#1d1d1d"), z("brand-button-active-background", "#ffffff"), z("brand-button-active-text", "#233143"), z("brand-cta-background", "#ffffff"), z("brand-cta-text", "#233143"), z("brand-rep-text", "#000000")), t === "CreditKarma" && (z("primary", "#008600"), z("brand-background", "#008600"), z("brand-background-border", "#008600"), z("brand-text-light", "#ffffff"), z("brand-text-dark", "#1d1d1d"), z("brand-button-background", "#ffffff"), z("brand-button-text", "#1d1d1d"), z("brand-button-active-background", "#ffffff"), z("brand-button-active-text", "#008600"), z("brand-cta-background", "#ffffff"), z("brand-cta-text", "#008600"), z("brand-rep-text", "#000000")), t === "CompareTheMarket" && (z("primary", "#2843D0"), z("brand-background", "#2843D0"), z("brand-background-border", "#2843D0"), z("brand-text-light", "#ffffff"), z("brand-text-dark", "#1d1d1d"), z("brand-button-background", "#ffffff"), z("brand-button-text", "#1d1d1d"), z("brand-button-active-background", "#ffffff"), z("brand-button-active-text", "#2843D0"), z("brand-cta-background", "#ffffff"), z("brand-cta-text", "#2843D0"), z("brand-rep-text", "#000000")), t === "Clearscore" && (z("primary", "#233143"), z("brand-background", "#233143"), z("brand-background-border", "#233143"), z("brand-text-light", "#ffffff"), z("brand-text-dark", "#1d1d1d"), z("brand-button-background", "#ffffff"), z("brand-button-text", "#1d1d1d"), z("brand-button-active-background", "#ffffff"), z("brand-button-active-text", "#233143"), z("brand-cta-background", "#ffffff"), z("brand-cta-text", "#233143"), z("brand-rep-text", "#000000")), t === "CredApp" && (z("primary", "#8100ff"), z("brand-background", "#8100ff"), z("brand-background-border", "#8100ff"), z("brand-text-light", "#ffffff"), z("brand-text-dark", "#1d1d1d"), z("brand-button-background", "#ffffff"), z("brand-button-text", "#1d1d1d"), z("brand-button-active-background", "#ffffff"), z("brand-button-active-text", "#8100ff"), z("brand-cta-background", "#ffffff"), z("brand-cta-text", "#8100ff"), z("brand-rep-text", "#000000")), t === "DriveScore" && (z("primary", "#0B132E"), z("brand-background", "#0B132E"), z("brand-background-border", "#0B132E"), z("brand-text-light", "#ffffff"), z("brand-text-dark", "#1d1d1d"), z("brand-button-background", "#ffffff"), z("brand-button-text", "#1d1d1d"), z("brand-button-active-background", "#ffffff"), z("brand-button-active-text", "#0B132E"), z("brand-cta-background", "#ffffff"), z("brand-cta-text", "#0B132E"), z("brand-rep-text", "#000000")), t === "Equifax" && (z("primary", "#29343f"), z("brand-background", "#29343f"), z("brand-background-border", "#29343f"), z("brand-text-light", "#ffffff"), z("brand-text-dark", "#1d1d1d"), z("brand-button-background", "#ffffff"), z("brand-button-text", "#1d1d1d"), z("brand-button-active-background", "#ffffff"), z("brand-button-active-text", "#29343f"), z("brand-cta-background", "#ffffff"), z("brand-cta-text", "#29343f"), z("brand-rep-text", "#000000")), t === "Experian" && (z("primary", "#1D4F91"), z("brand-background", "#1D4F91"), z("brand-background-border", "#1D4F91"), z("brand-text-light", "#ffffff"), z("brand-text-dark", "#1d1d1d"), z("brand-button-background", "#ffffff"), z("brand-button-text", "#1d1d1d"), z("brand-button-active-background", "#ffffff"), z("brand-button-active-text", "#1D4F91"), z("brand-cta-background", "#ffffff"), z("brand-cta-text", "#1D4F91"), z("brand-rep-text", "#000000")), t === "MyCarCheck" && (z("primary", "#12325b"), z("brand-background", "#12325b"), z("brand-background-border", "#12325b"), z("brand-text-light", "#ffffff"), z("brand-text-dark", "#1d1d1d"), z("brand-button-background", "#ffffff"), z("brand-button-text", "#1d1d1d"), z("brand-button-active-background", "#ffffff"), z("brand-button-active-text", "#12325b"), z("brand-cta-background", "#ffffff"), z("brand-cta-text", "#12325b"), z("brand-rep-text", "#000000")), t === "OceanFinance" && (z("primary", "#282d5c"), z("brand-background", "#282d5c"), z("brand-background-border", "#282d5c"), z("brand-text-light", "#ffffff"), z("brand-text-dark", "#1d1d1d"), z("brand-button-background", "#ffffff"), z("brand-button-text", "#1d1d1d"), z("brand-button-active-background", "#ffffff"), z("brand-button-active-text", "#282d5c"), z("brand-cta-background", "#ffffff"), z("brand-cta-text", "#282d5c"), z("brand-rep-text", "#000000")), t === "Parkers" && (z("primary", "#034ea2"), z("brand-background", "#034ea2"), z("brand-background-border", "#034ea2"), z("brand-text-light", "#ffffff"), z("brand-text-dark", "#1d1d1d"), z("brand-button-background", "#ffffff"), z("brand-button-text", "#1d1d1d"), z("brand-button-active-background", "#ffffff"), z("brand-button-active-text", "#034ea2"), z("brand-cta-background", "#ffffff"), z("brand-cta-text", "#034ea2"), z("brand-rep-text", "#000000")), t === "ThinkMoney" && (z("primary", "#0078B2"), z("brand-background", "#0078B2"), z("brand-background-border", "#0078B2"), z("brand-text-light", "#ffffff"), z("brand-text-dark", "#1d1d1d"), z("brand-button-background", "#ffffff"), z("brand-button-text", "#1d1d1d"), z("brand-button-active-background", "#ffffff"), z("brand-button-active-text", "#0078B2"), z("brand-cta-background", "#ffffff"), z("brand-cta-text", "#0078B2"), z("brand-rep-text", "#000000")), t === "TotallyMoney" && (z("primary", "#261a91"), z("brand-background", "#261a91"), z("brand-background-border", "#261a91"), z("brand-text-light", "#ffffff"), z("brand-text-dark", "#1d1d1d"), z("brand-button-background", "#ffffff"), z("brand-button-text", "#1d1d1d"), z("brand-button-active-background", "#ffffff"), z("brand-button-active-text", "#261a91"), z("brand-cta-background", "#ffffff"), z("brand-cta-text", "#261a91"), z("brand-rep-text", "#000000")));
}
function fL() {
  const t = new URLSearchParams(window.location.search);
  t.get("aid"), z("primary", t.get("primary") ?? "#6905F2"), z("brand-background", t.get("brand-background") ?? "#6905F2"), z("brand-background-border", t.get("brand-background-border") ?? "#6905F2"), z("brand-text-light", t.get("brand-text-light") ?? "#ffffff"), z("brand-text-dark", t.get("brand-text-dark") ?? "#1d1d1d"), z("brand-button-background", t.get("brand-button-background") ?? "#ffffff"), z("brand-button-text", t.get("brand-button-text") ?? "#1d1d1d"), z("brand-button-active-background", t.get("brand-button-active-background") ?? "#ffffff"), z("brand-button-active-text", t.get("brand-button-active-text") ?? "#6905F2"), z("brand-cta-background", t.get("brand-cta-background") ?? "#ffffff"), z("brand-cta-text", t.get("brand-cta-text") ?? "#6905F2"), z("brand-link-colour", t.get("brand-link-colour") ?? "#6905F2"), z("brand-logo-colour", t.get("brand-logo-colour") ?? "#000000"), z("brand-rep-text", t.get("brand-rep-text") ?? "#000000");
}
const Bs = {
  affiliate: {},
  brand: "CarFinance247",
  utms: "",
  // actions: {
  setAffiliate(t) {
    this.affiliate = t, this.affiliate.brand && (ya(this.affiliate.brand), this.brand = this.affiliate.brand);
  },
  updateBrand(t) {
    this.brand = t, ya(t);
    const e = ja.find((i) => i.brand === t);
    e && (this.affiliate = e);
  },
  setUtms() {
    this.utms = "";
    const t = new URLSearchParams(window.location.search), e = t.get("aid") ?? t.get("daid") ?? null;
    t.forEach((i, M) => {
      M.startsWith("utm_") && (this.utms += this.utms.length > 0 ? "&" + M + "=" + i : M + "=" + i);
    }), this.utms.indexOf("utm_source") == -1 && (this.utms += this.utms.length > 0 ? "&utm_source=" + (e ?? "Calculator") : "utm_source=" + (e ?? "Calculator"));
  }
};
function mL(t, e) {
  const i = LL.find((M) => M.score === e && M.min <= t && M.max > t);
  return i ? i.apr : 19.9;
}
const LL = [
  { score: "Excellent", min: 0, max: 1e4, apr: 11.9 },
  { score: "Excellent", min: 1e4, max: 15e3, apr: 9.9 },
  { score: "Excellent", min: 15e3, max: 2e4, apr: 9.9 },
  { score: "Excellent", min: 2e4, max: 3e4, apr: 9.9 },
  { score: "Excellent", min: 3e4, max: 75e3, apr: 9.9 },
  { score: "Excellent", min: 75e3, max: 9999999, apr: 9.9 },
  { score: "Good", min: 0, max: 1e4, apr: 12.9 },
  { score: "Good", min: 1e4, max: 15e3, apr: 11.4 },
  { score: "Good", min: 15e3, max: 2e4, apr: 11.4 },
  { score: "Good", min: 2e4, max: 3e4, apr: 11.4 },
  { score: "Good", min: 3e4, max: 75e3, apr: 11.4 },
  { score: "Good", min: 75e3, max: 9999999, apr: 11.4 },
  { score: "Fair", min: 0, max: 1e4, apr: 13.9 },
  { score: "Fair", min: 1e4, max: 15e3, apr: 12.9 },
  { score: "Fair", min: 15e3, max: 2e4, apr: 11.9 },
  { score: "Fair", min: 2e4, max: 3e4, apr: 11.9 },
  { score: "Fair", min: 3e4, max: 75e3, apr: 11.4 },
  { score: "Fair", min: 75e3, max: 9999999, apr: 11.4 },
  { score: "Poor", min: 0, max: 1e4, apr: 19.9 },
  { score: "Poor", min: 1e4, max: 15e3, apr: 18.9 },
  { score: "Poor", min: 15e3, max: 2e4, apr: 15.9 },
  { score: "Poor", min: 2e4, max: 3e4, apr: 15.9 },
  { score: "Poor", min: 3e4, max: 75e3, apr: 13.9 },
  { score: "Poor", min: 75e3, max: 9999999, apr: 12.9 }
], pL = { id: "aprWrapper" }, wL = { key: 0 }, CL = {
  key: 0,
  class: "tw-mx-auto tw-max-w-3xl"
}, hL = { key: 0 }, OL = { class: "tw-font-semibold" }, EL = { class: "tw-font-semibold" }, SL = { class: "tw-font-semibold" }, kL = { class: "tw-font-semibold" }, vL = { class: "tw-font-semibold" }, bL = { class: "tw-font-semibold" }, QL = { class: "tw-font-semibold" }, UL = {
  key: 0,
  class: "tw-pt-2"
}, YL = { key: 1 }, _L = { class: "tw-font-semibold" }, PL = { class: "tw-font-semibold" }, RL = { class: "tw-font-semibold" }, FL = { class: "tw-font-semibold" }, WL = { class: "tw-font-semibold" }, BL = {
  key: 0,
  class: "tw-pt-2"
}, VL = {
  key: 1,
  class: "tw-mx-auto tw-max-w-3xl"
}, GL = { key: 0 }, ZL = { class: "tw-font-semibold" }, $L = { class: "tw-font-semibold" }, JL = { class: "tw-font-semibold" }, HL = { class: "tw-font-semibold" }, XL = { class: "tw-font-semibold" }, KL = { class: "tw-font-semibold" }, qL = { class: "tw-font-semibold" }, ep = { class: "tw-font-semibold" }, tp = { class: "tw-font-semibold" }, ip = { class: "tw-font-semibold" }, Mp = {
  key: 0,
  class: "tw-pt-2"
}, np = { key: 1 }, ap = { class: "tw-font-semibold" }, rp = { class: "tw-font-semibold" }, lp = { class: "tw-font-semibold" }, op = { class: "tw-font-semibold" }, sp = { class: "tw-font-semibold" }, up = { class: "tw-font-semibold" }, cp = { class: "tw-font-semibold" }, gp = { class: "tw-font-semibold" }, Np = { class: "tw-text-center tw-text-md tw-pt-2" }, Ip = {
  key: 0,
  class: "tw-pt-1"
}, Dp = { class: "tw-grid tw-grid-cols-1 tw-gap-2" }, dp = { class: "tw-grid tw-grid-cols-12 tw-gap-2" }, jp = { class: "tw-col-span-12 tw-lg:col-span-6 tw-grid tw-grid-cols-12 tw-gap-2" }, yp = { class: "tw-col-span-12 tw-sm:col-span-3 tw-px-1 tw-mb-2" }, Ap = { class: "tw-col-span-12 tw-sm:col-span-3 tw-px-1 tw-mb-2" }, Tp = { class: "tw-col-span-12 tw-sm:col-span-3 tw-px-1 tw-mb-2" }, xp = { class: "tw-col-span-12 tw-sm:col-span-3 tw-px-1 tw-mb-2" }, zp = { class: "tw-col-span-12 tw-lg:col-span-6 tw-grid tw-grid-cols-12 tw-gap-2" }, fp = { class: "tw-col-span-12 tw-sm:col-span-3 tw-px-1 tw-mb-2" }, mp = { class: "tw-col-span-12 tw-sm:col-span-3 tw-px-1 tw-mb-2" }, Lp = { class: "tw-col-span-12 tw-sm:col-span-3 tw-px-1 tw-mb-2" }, pp = { class: "tw-col-span-12 tw-sm:col-span-3 tw-px-1 tw-mb-2" }, wp = { class: "tw-px-1" }, Cp = { class: "tw-grid tw-grid-cols-1 tw-sm:grid-cols-12 tw-lg:grid-cols-12 tw-gap-2" }, hp = { class: "tw-col-span-1 tw-sm:col-span-12 tw-lg:col-span-6 tw-grid tw-grid-cols-4 tw-gap-2" }, Op = { class: "tw-col-span-4 tw-sm:col-span-1 tw-px-1 tw-mb-2" }, Ep = { class: "tw-col-span-4 tw-sm:col-span-1 tw-px-1 tw-mb-2" }, Sp = { class: "tw-col-span-4 tw-sm:col-span-1 tw-px-1 tw-mb-2" }, kp = { class: "tw-col-span-4 tw-sm:col-span-1 tw-px-1 tw-mb-2" }, vp = { class: "tw-col-span-1 tw-sm:col-span-12 tw-lg:col-span-6 tw-grid tw-grid-cols-4 tw-gap-2" }, bp = { class: "tw-col-span-4 tw-sm:col-span-1 tw-px-1 tw-mb-2" }, Qp = { class: "tw-col-span-4 tw-sm:col-span-1 tw-px-1 tw-mb-2" }, Up = { class: "tw-col-span-4 tw-sm:col-span-1 tw-px-1 tw-mb-2" }, Yp = { class: "tw-col-span-4 tw-sm:col-span-1 tw-px-1 tw-mb-2" }, _p = { class: "tw-px-1" }, Pp = /* @__PURE__ */ ne({
  __name: "RepApr",
  props: {
    product: String,
    term: Number,
    otrPrice: Number,
    deposit: Number,
    apr: Number,
    ratesFrom: Number,
    showCF247: {
      type: Boolean,
      default: !0
    },
    annualMileage: Number,
    theme: String,
    backgroundColour: String,
    textColour: String,
    table: Boolean,
    tableTitle: String,
    titleColour: String,
    fieldHeaderColour: String,
    fieldBackgroundColour: String,
    fieldTextColour: String,
    isUnregulated: {
      type: Boolean,
      default: void 0
    },
    isFinancePage: {
      type: Boolean,
      default: !1
    },
    isCarCraft: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = ($, E) => {
      if (typeof document > "u") return "";
      const be = document.body;
      return be && getComputedStyle(be).getPropertyValue(`--q-${$}`).trim() || "";
    }, i = t, M = C("PCP"), n = C(60), a = C(16e3), r = C(0), o = C(null), s = C(9.9), u = C(!0), c = C(8e3), g = C("light"), d = C(null), j = C(null), D = C("text"), I = C(null), N = C(null), x = C(null), f = C(null), L = C(null), p = C(!1), h = C(!1), w = C(!1), O = Ol(Qo(a.value)), S = C(!1);
    let Y = null;
    const H = C(null);
    we(() => {
      Bs.setUtms();
      const $ = new URLSearchParams(window.location.search);
      M.value = i.product ? i.product : $.get("product") ?? "HP", a.value = i.otrPrice ? Number(i.otrPrice) : $.get("otrPrice") && !isNaN(Number($.get("otrPrice"))) ? Number($.get("otrPrice")) : a.value, o.value = i.apr ? Number(i.apr) : $.get("apr") ? Number($.get("apr")) : null, p.value = o.value === null, s.value = i.ratesFrom ? Number(i.ratesFrom) : $.get("ratesFrom") ? Number($.get("ratesFrom") ?? 9.9) : s.value, n.value = i.term ? Number(i.term) : $.get("term") ? Number($.get("term")) : n.value, r.value = i.deposit ? Number(i.deposit) : $.get("deposit") ? Number($.get("deposit")) : r.value, u.value = i.showCF247 !== null && i.showCF247 === !1 ? !1 : $.get("showCF247") ? $.get("showCF247") === "true" : !0, c.value = i.annualMileage ? Number(i.annualMileage) : $.get("annualMileage") ? Number($.get("annualMileage")) : 8e3, g.value = i.theme ? i.theme : $.get("theme") ? $.get("theme") : g.value, j.value = i.backgroundColour ? i.backgroundColour : $.get("backgroundColour") ? $.get("backgroundColour") : j.value, x.value = i.fieldHeaderColour ? i.fieldHeaderColour : $.get("fieldHeaderColour") ? $.get("fieldHeaderColour") : e("primary"), f.value = i.fieldBackgroundColour ? i.fieldBackgroundColour : $.get("fieldBackgroundColour") ? $.get("fieldBackgroundColour") : f.value, L.value = i.fieldTextColour ? i.fieldTextColour : $.get("fieldTextColour") ? $.get("fieldTextColour") : e("dark"), I.value = i.tableTitle ? i.tableTitle : $.get("tableTitle") ? $.get("tableTitle") : I.value, N.value = i.titleColour ? i.titleColour : $.get("tableTitleColour") ? $.get("tableTitleColour") : N.value, d.value = i.textColour ? i.textColour : $.get("textColour") ? $.get("textColour") : d.value, w.value = !!($.get("vdp") && $.get("vdp") === "true"), D.value = i.table && i.table === !0 || $.get("view") && $.get("view") === "table" ? "table" : D.value, h.value = i.isUnregulated !== null && i.isUnregulated !== void 0 ? i.isUnregulated : !!($.get("isUnregulated") && $.get("isUnregulated") === "true"), Y = setTimeout(B, 1e3), window.self.addEventListener("resize", Me), Me(), te(), H.value = setInterval(() => {
        le();
      }, 1e3);
    }), _t(() => {
      clearTimeout(Y), Y = null, window.self.removeEventListener("resize", Me);
    });
    function B() {
      typeof window < "u" && (S.value = window.self.matchMedia("(max-width: 600px)").matches);
    }
    const ae = J(() => n.value === 24 ? "2 years" : n.value === 36 ? "3 years" : n.value === 48 ? "4 years" : n.value === 60 ? "5 years" : `${n.value} months`);
    function te() {
      O.deposit = r.value, O.price = a.value, O.glassesRetailTransacted = a.value, O.glassesRetailValuation = a.value, O.glassesTradeValuation = a.value;
      const $ = Fs(a.value);
      o.value && ($.apr = o.value), tn.calculateMonthlyPaymentForVehicle(
        O,
        [$],
        r.value,
        // deposit
        0,
        null,
        {
          annualMileage: c.value
        }
      ), (!O.pcpMatrix || O.pcpMatrix.length === 0) && (M.value = "HP");
    }
    const q = J(() => M.value === "HP" ? !O.priceMatrix || O.priceMatrix.length === 0 ? null : O.priceMatrix.find(($) => $.term === n.value) : M.value === "PCP" ? !O.pcpMatrix || O.pcpMatrix.length === 0 ? null : O.pcpMatrix.find(($) => $.term === n.value) : null);
    function le() {
      if (document.getElementById("aprWrapper")) {
        const $ = {
          type: "cf247-rep-apr-height",
          height: document.getElementById("aprWrapper").scrollHeight + 10
        };
        window.parent.postMessage($, "*"), oe();
      }
    }
    function Me() {
      B(), le();
    }
    function oe() {
      var $ = document.getElementById("cf247-widget-body");
      $ ? ($.style.overflow = "visible", setTimeout(() => {
      }, 100)) : setTimeout(() => {
        oe();
      }, 100);
    }
    return te(), ($, E) => (y(), A("div", pL, [
      !h.value || t.isFinancePage || w.value ? (y(), A("div", wL, [
        D.value === "text" ? (y(), A("div", {
          key: 0,
          class: "tw-p-4 tw-text-center tw-text-md",
          style: R({ "background-color": j.value ?? "", color: d.value ?? "black" })
        }, [
          p.value ? (y(), A("div", CL, [
            M.value === "PCP" ? (y(), A("div", hL, [
              E[1] || (E[1] = l("span", { class: "tw-font-semibold" }, "Personal Contract Purchase (PCP) Representative Example", -1)),
              E[2] || (E[2] = G(": Car price ")),
              l("span", OL, m(T(ee)(27500, 2, 2)), 1),
              E[3] || (E[3] = G(", Term ")),
              E[4] || (E[4] = l("span", { class: "tw-font-semibold" }, "4 years", -1)),
              E[5] || (E[5] = G(", Deposit ")),
              l("span", EL, m(T(ee)(2750, 2, 2)), 1),
              E[6] || (E[6] = G(", Total amount of credit ")),
              l("span", SL, m(T(ee)(24750, 2, 2)), 1),
              E[7] || (E[7] = G(", Representative APR ")),
              E[8] || (E[8] = l("span", { class: "tw-font-semibold" }, m(10.9) + "% fixed rate", -1)),
              E[9] || (E[9] = G(", Monthly payment ")),
              l("span", kL, m(T(ee)(392.47, 2, 2)), 1),
              E[10] || (E[10] = G(", Total cost of credit ")),
              l("span", vL, m(T(ee)(8291.09, 2, 2)), 1),
              E[11] || (E[11] = G(", Total amount payable ")),
              l("span", bL, m(T(ee)(35791.09, 2, 2)), 1),
              E[12] || (E[12] = G(", Optional final payment ")),
              l("span", QL, m(T(ee)(14595, 2, 2)), 1),
              G(", Annual mileage " + m(c.value.toLocaleString()) + "pa. ", 1),
              u.value ? (y(), A("div", UL, E[0] || (E[0] = [
                l("a", {
                  href: "https://www.carfinance247.co.uk",
                  "aria-label": "Carfinance247",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  class: "tw-text-blue-600 tw-hover:underline",
                  title: "Carfinance247"
                }, "Car Finance 247", -1),
                l("span", null, " Limited is a credit broker, not a lender.", -1)
              ]))) : k("", !0)
            ])) : (y(), A("div", YL, [
              E[14] || (E[14] = l("span", { class: "tw-font-semibold" }, "Hire Purchase (HP) Representative example", -1)),
              E[15] || (E[15] = G(": Borrow ")),
              l("span", _L, m(T(ee)(1e4, 2, 2)), 1),
              E[16] || (E[16] = G(" over ")),
              E[17] || (E[17] = l("span", { class: "tw-font-semibold" }, "5 years", -1)),
              E[18] || (E[18] = G(", with a ")),
              l("span", PL, m(T(ee)(0)), 1),
              E[19] || (E[19] = G(" deposit. Representative APR ")),
              E[20] || (E[20] = l("span", { class: "tw-font-semibold" }, m(19.9) + "%", -1)),
              E[21] || (E[21] = G(" fixed rate. Monthly payment: ")),
              l("span", RL, m(T(ee)(255.5, 2, 2)), 1),
              E[22] || (E[22] = G(", Total cost of credit: ")),
              l("span", FL, m(T(ee)(5330, 2, 2)), 1),
              E[23] || (E[23] = G(", Total amount repayable: ")),
              l("span", WL, m(T(ee)(15330, 2, 2)), 1),
              E[24] || (E[24] = G(". ")),
              u.value ? (y(), A("div", BL, E[13] || (E[13] = [
                l("a", {
                  href: "https://www.carfinance247.co.uk",
                  "aria-label": "Carfinance247",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  class: "tw-text-blue-600 tw-hover:underline",
                  title: "Carfinance247"
                }, "Car Finance 247", -1),
                l("span", null, " Limited is a credit broker, not a lender.", -1)
              ]))) : k("", !0)
            ]))
          ])) : q.value ? (y(), A("div", VL, [
            M.value === "PCP" ? (y(), A("div", GL, [
              E[26] || (E[26] = l("span", { class: "tw-font-semibold" }, "Personal Contract Purchase (PCP) Representative Example", -1)),
              E[27] || (E[27] = G(": Car price ")),
              l("span", ZL, m(T(ee)(a.value, 2, 2)), 1),
              E[28] || (E[28] = G(", Term ")),
              l("span", $L, m(ae.value), 1),
              E[29] || (E[29] = G(", Deposit ")),
              l("span", JL, m(T(ee)(r.value, 2, 2)), 1),
              E[30] || (E[30] = G(", Total amount of credit ")),
              l("span", HL, m(T(ee)(q.value.amountToFinance, 2, 2)), 1),
              E[31] || (E[31] = G(", Representative APR ")),
              l("span", XL, m(o.value) + "% fixed rate", 1),
              E[32] || (E[32] = G(", Monthly payment ")),
              l("span", KL, m(T(ee)(q.value.monthlyPayment, 2, 2)), 1),
              E[33] || (E[33] = G(", Option-to-Purchase fee ")),
              l("span", qL, m(T(ee)(q.value.lendersPostFees, 2, 2)), 1),
              E[34] || (E[34] = G(", Total cost of credit ")),
              l("span", ep, m(T(ee)(q.value.costOfCredit, 2, 2)), 1),
              E[35] || (E[35] = G(", Total amount payable ")),
              l("span", tp, m(T(ee)(q.value.totalAmountPayable, 2, 2)), 1),
              E[36] || (E[36] = G(", Optional final payment ")),
              l("span", ip, m(T(ee)(q.value.finalPayment, 2, 2)), 1),
              G(", Annual mileage " + m(c.value.toLocaleString()) + "pa. ", 1),
              u.value ? (y(), A("div", Mp, E[25] || (E[25] = [
                l("a", {
                  href: "https://www.carfinance247.co.uk",
                  "aria-label": "Carfinance247",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  class: "tw-text-blue-600 tw-hover:underline",
                  title: "Carfinance247"
                }, "Car Finance 247", -1),
                l("span", null, " Limited is a credit broker, not a lender.", -1)
              ]))) : k("", !0)
            ])) : (y(), A("div", np, [
              t.isCarCraft ? (y(), A(ge, { key: 0 }, [
                E[37] || (E[37] = l("strong", null, "Representative Example: ", -1)),
                E[38] || (E[38] = G("Borrow £10,000 over 5 years with a £0 deposit. Representative ")),
                E[39] || (E[39] = l("strong", null, "18.9% APR ", -1)),
                E[40] || (E[40] = G("fixed rate. Monthly payment: ")),
                E[41] || (E[41] = l("strong", null, "£250.88. ", -1)),
                E[42] || (E[42] = G("Option to purchase fee £10 payable. Total cost of credit: ")),
                E[43] || (E[43] = l("strong", null, "£5,052.80. ", -1)),
                E[44] || (E[44] = G("Total amount repayable: ")),
                E[45] || (E[45] = l("strong", null, "£15,062.80. ", -1)),
                E[46] || (E[46] = l("br", null, null, -1)),
                E[47] || (E[47] = l("br", null, null, -1)),
                E[48] || (E[48] = G("EGFV Rix Limited, trading as Carcraft.co.uk, is a credit broker, not a lender. "))
              ], 64)) : (y(), A(ge, { key: 1 }, [
                E[50] || (E[50] = l("span", { class: "tw-font-semibold" }, "Hire Purchase (HP) Representative example", -1)),
                E[51] || (E[51] = G(": Borrow ")),
                l("span", ap, m(T(ee)(a.value, 2, 2)), 1),
                E[52] || (E[52] = G(" over ")),
                l("span", rp, m(ae.value), 1),
                E[53] || (E[53] = G(", with a ")),
                l("span", lp, m(T(ee)(r.value, 2, 2)), 1),
                E[54] || (E[54] = G(" deposit. Representative APR ")),
                l("span", op, m(o.value) + "%", 1),
                E[55] || (E[55] = G(", fixed rate. Monthly payment: ")),
                l("span", sp, m(T(ee)(q.value.monthlyPayment, 2, 2)), 1),
                E[56] || (E[56] = G(", Option-to-Purchase fee: ")),
                l("span", up, m(T(ee)(q.value.lendersPostFees, 2, 2)), 1),
                E[57] || (E[57] = G(", Total cost of credit: ")),
                l("span", cp, m(T(ee)(q.value.costOfCredit, 2, 2)), 1),
                E[58] || (E[58] = G(", Total amount repayable: ")),
                l("span", gp, m(T(ee)(q.value.totalAmountPayable, 2, 2)), 1),
                E[59] || (E[59] = G(". ")),
                l("div", Np, " Rates from " + m(s.value) + "% APR. ", 1),
                u.value ? (y(), A("div", Ip, E[49] || (E[49] = [
                  l("a", {
                    href: "https://www.carfinance247.co.uk",
                    "aria-label": "Carfinance247",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    class: "tw-text-blue-600 tw-hover:underline",
                    title: "Carfinance247"
                  }, "Car Finance 247", -1),
                  l("span", null, " Limited is a credit broker, not a lender.", -1)
                ]))) : k("", !0)
              ], 64))
            ]))
          ])) : k("", !0)
        ], 4)) : D.value === "table" && p.value ? (y(), A("div", {
          key: 1,
          style: R({ "background-color": j.value ?? "transparent", color: d.value ?? "black" })
        }, [
          l("div", Dp, [
            l("div", dp, [
              l("div", jp, [
                l("div", yp, [
                  l("div", {
                    class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-1",
                    style: R({ "background-color": g.value === "dark" ? "#5f5f5f" : f.value ?? "#f5f5f5" })
                  }, [
                    l("div", {
                      class: "tw-font-semibold tw-text-sm",
                      style: R({ color: g.value === "dark" ? "white" : x.value ?? "black" })
                    }, "Product", 4),
                    l("div", {
                      class: "tw-text-md",
                      style: R({ color: g.value === "dark" ? "white" : d.value ?? "black" })
                    }, m(M.value), 5)
                  ], 4)
                ]),
                l("div", Ap, [
                  l("div", {
                    class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-1",
                    style: R({ "background-color": g.value === "dark" ? "#5f5f5f" : f.value ?? "#f5f5f5" })
                  }, [
                    l("div", {
                      class: "tw-font-semibold tw-text-sm",
                      style: R({ color: g.value === "dark" ? "white" : x.value ?? "black" })
                    }, "Cash Price", 4),
                    l("div", {
                      class: "tw-text-md",
                      style: R({ color: g.value === "dark" ? "white" : d.value ?? "black" })
                    }, m(T(ee)(M.value === "HP" ? 1e4 : 27500, 2, 2)), 5)
                  ], 4)
                ]),
                l("div", Tp, [
                  l("div", {
                    class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-1",
                    style: R({ "background-color": g.value === "dark" ? "#5f5f5f" : f.value ?? "#f5f5f5" })
                  }, [
                    l("div", {
                      class: "tw-font-semibold tw-text-sm",
                      style: R({ color: g.value === "dark" ? "white" : x.value ?? "black" })
                    }, "Deposit", 4),
                    l("div", {
                      class: "tw-text-md",
                      style: R({ color: g.value === "dark" ? "white" : d.value ?? "black" })
                    }, m(T(ee)(M.value === "HP" ? 0 : 2750, 2, 2)), 5)
                  ], 4)
                ]),
                l("div", xp, [
                  l("div", {
                    class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-1",
                    style: R({ "background-color": g.value === "dark" ? "#5f5f5f" : f.value ?? "#f5f5f5" })
                  }, [
                    l("div", {
                      class: "tw-font-semibold tw-text-sm",
                      style: R({ color: g.value === "dark" ? "white" : x.value ?? "black" })
                    }, "Total Payable", 4),
                    l("div", {
                      class: "tw-text-md",
                      style: R({ color: g.value === "dark" ? "white" : d.value ?? "black" })
                    }, m(T(ee)(M.value === "HP" ? 15329.8 : 35791.09, 2, 2)), 5)
                  ], 4)
                ])
              ]),
              l("div", zp, [
                l("div", fp, [
                  l("div", {
                    class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-1",
                    style: R({ "background-color": g.value === "dark" ? "#5f5f5f" : f.value ?? "#f5f5f5" })
                  }, [
                    l("div", {
                      class: "tw-font-semibold tw-text-sm",
                      style: R({ color: g.value === "dark" ? "white" : x.value ?? "black" })
                    }, "Term", 4),
                    l("div", {
                      class: "tw-text-md",
                      style: R({ color: g.value === "dark" ? "white" : d.value ?? "black" })
                    }, m(M.value === "HP" ? 60 : 48), 5)
                  ], 4)
                ]),
                l("div", mp, [
                  l("div", {
                    class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-1",
                    style: R({ "background-color": g.value === "dark" ? "#5f5f5f" : f.value ?? "#f5f5f5" })
                  }, [
                    l("div", {
                      class: "tw-font-semibold tw-text-sm",
                      style: R({ color: g.value === "dark" ? "white" : x.value ?? "black" })
                    }, "Cost of Credit", 4),
                    l("div", {
                      class: "tw-text-md",
                      style: R({ color: g.value === "dark" ? "white" : d.value ?? "black" })
                    }, m(T(ee)(M.value === "HP" ? 5329.8 : 8291.09, 2, 2)), 5)
                  ], 4)
                ]),
                l("div", Lp, [
                  l("div", {
                    class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-1",
                    style: R({ "background-color": g.value === "dark" ? "#5f5f5f" : f.value ?? "#f5f5f5" })
                  }, [
                    l("div", {
                      class: "tw-font-semibold tw-text-sm",
                      style: R({ color: g.value === "dark" ? "white" : x.value ?? "black" })
                    }, "Monthly Payment", 4),
                    l("div", {
                      class: "tw-text-md",
                      style: R({ color: g.value === "dark" ? "white" : d.value ?? "black" })
                    }, m(T(ee)(M.value === "HP" ? 255.5 : 392.47)), 5)
                  ], 4)
                ]),
                l("div", pp, [
                  l("div", {
                    class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-1",
                    style: R({ "background-color": g.value === "dark" ? "#5f5f5f" : f.value ?? "#f5f5f5" })
                  }, [
                    l("div", {
                      class: "tw-font-semibold tw-text-sm",
                      style: R({ color: g.value === "dark" ? "white" : x.value ?? "black" })
                    }, "Final Payment", 4),
                    l("div", {
                      class: "tw-text-md",
                      style: R({ color: g.value === "dark" ? "white" : d.value ?? "black" })
                    }, m(T(ee)(M.value === "HP" ? 255.5 : 14595, 2, 2)), 5)
                  ], 4)
                ])
              ])
            ])
          ]),
          l("div", wp, [
            l("div", {
              class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-1",
              style: R({ "background-color": g.value === "dark" ? "#5f5f5f" : f.value ?? "#f5f5f5" })
            }, [
              l("div", {
                class: "tw-font-semibold tw-text-sm",
                style: R({ color: g.value === "dark" ? "white" : x.value ?? "black" })
              }, "Representative APR", 4),
              l("div", {
                class: "tw-text-md",
                style: R({ color: g.value === "dark" ? "white" : d.value ?? "black" })
              }, m(M.value === "HP" ? 19.9 : 10.9) + "%", 5)
            ], 4)
          ]),
          l("div", {
            class: "tw-text-center tw-text-md tw-pt-2",
            style: R({ color: g.value === "dark" ? "white" : d.value ?? "black" })
          }, " Rates from " + m(s.value) + "% APR. ", 5),
          u.value ? (y(), A("div", {
            key: 0,
            class: "tw-text-center tw-text-md tw-pt-1",
            style: R({ color: g.value === "dark" ? "white" : d.value ?? "black" })
          }, E[60] || (E[60] = [
            l("a", {
              href: "https://www.carfinance247.co.uk",
              "aria-label": "Carfinance247",
              target: "_blank",
              rel: "noopener noreferrer",
              class: "tw-text-blue-600 tw-hover:underline",
              title: "Carfinance247"
            }, "Car Finance 247", -1),
            l("span", null, " Limited is a credit broker, not a lender.", -1)
          ]), 4)) : k("", !0)
        ], 4)) : D.value === "table" && !p.value && q.value ? (y(), A("div", {
          key: 2,
          style: R({ "background-color": j.value ?? "transparent" })
        }, [
          l("div", Cp, [
            l("div", hp, [
              l("div", Op, [
                l("div", {
                  class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-1",
                  style: R({ "background-color": g.value === "dark" ? "#5f5f5f" : f.value ?? "#f5f5f5" })
                }, [
                  l("div", {
                    class: "tw-font-semibold tw-text-sm",
                    style: R({ color: g.value === "dark" ? "white" : x.value ?? "black" })
                  }, "Product", 4),
                  l("div", {
                    class: "tw-text-md",
                    style: R({ color: g.value === "dark" ? "white" : d.value ?? "black" })
                  }, m(M.value), 5)
                ], 4)
              ]),
              l("div", Ep, [
                l("div", {
                  class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-1",
                  style: R({ "background-color": g.value === "dark" ? "#5f5f5f" : f.value ?? "#f5f5f5" })
                }, [
                  l("div", {
                    class: "tw-font-semibold tw-text-sm",
                    style: R({ color: g.value === "dark" ? "white" : x.value ?? "black" })
                  }, "Cash Price", 4),
                  l("div", {
                    class: "tw-text-md",
                    style: R({ color: g.value === "dark" ? "white" : d.value ?? "black" })
                  }, m(T(ee)(q.value.amountToFinance)), 5)
                ], 4)
              ]),
              l("div", Sp, [
                l("div", {
                  class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-1",
                  style: R({ "background-color": g.value === "dark" ? "#5f5f5f" : f.value ?? "#f5f5f5" })
                }, [
                  l("div", {
                    class: "tw-font-semibold tw-text-sm",
                    style: R({ color: g.value === "dark" ? "white" : x.value ?? "black" })
                  }, "Deposit", 4),
                  l("div", {
                    class: "tw-text-md",
                    style: R({ color: g.value === "dark" ? "white" : d.value ?? "black" })
                  }, m(T(ee)(q.value.deposit)), 5)
                ], 4)
              ]),
              l("div", kp, [
                l("div", {
                  class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-1",
                  style: R({ "background-color": g.value === "dark" ? "#5f5f5f" : f.value ?? "#f5f5f5" })
                }, [
                  l("div", {
                    class: "tw-font-semibold tw-text-sm",
                    style: R({ color: g.value === "dark" ? "white" : x.value ?? "black" })
                  }, "Total Payable", 4),
                  l("div", {
                    class: "tw-text-md",
                    style: R({ color: g.value === "dark" ? "white" : d.value ?? "black" })
                  }, m(T(ee)(q.value.totalAmountPayable, 2, 2)), 5)
                ], 4)
              ])
            ]),
            l("div", vp, [
              l("div", bp, [
                l("div", {
                  class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-1",
                  style: R({ "background-color": g.value === "dark" ? "#5f5f5f" : f.value ?? "#f5f5f5" })
                }, [
                  l("div", {
                    class: "tw-font-semibold tw-text-sm",
                    style: R({ color: g.value === "dark" ? "white" : x.value ?? "black" })
                  }, "Term", 4),
                  l("div", {
                    class: "tw-text-md",
                    style: R({ color: g.value === "dark" ? "white" : d.value ?? "black" })
                  }, m(q.value.term), 5)
                ], 4)
              ]),
              l("div", Qp, [
                l("div", {
                  class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-1",
                  style: R({ "background-color": g.value === "dark" ? "#5f5f5f" : f.value ?? "#f5f5f5" })
                }, [
                  l("div", {
                    class: "tw-font-semibold tw-text-sm",
                    style: R({ color: g.value === "dark" ? "white" : x.value ?? "black" })
                  }, "Initial Payment", 4),
                  l("div", {
                    class: "tw-text-md",
                    style: R({ color: g.value === "dark" ? "white" : d.value ?? "black" })
                  }, m(T(ee)(q.value.firstMonthlyPayment, 2, 2)), 5)
                ], 4)
              ]),
              l("div", Up, [
                l("div", {
                  class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-1",
                  style: R({ "background-color": g.value === "dark" ? "#5f5f5f" : f.value ?? "#f5f5f5" })
                }, [
                  l("div", {
                    class: "tw-font-semibold tw-text-sm",
                    style: R({ color: g.value === "dark" ? "white" : x.value ?? "black" })
                  }, "Monthly Payment", 4),
                  l("div", {
                    class: "tw-text-md",
                    style: R({ color: g.value === "dark" ? "white" : d.value ?? "black" })
                  }, m(T(ee)(q.value.monthlyPayment, 2, 2)) + " x " + m(q.value.term - 2), 5)
                ], 4)
              ]),
              l("div", Yp, [
                l("div", {
                  class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-1",
                  style: R({ "background-color": g.value === "dark" ? "#5f5f5f" : f.value ?? "#f5f5f5" })
                }, [
                  l("div", {
                    class: "tw-font-semibold tw-text-sm",
                    style: R({ color: g.value === "dark" ? "white" : x.value ?? "black" })
                  }, "Final Payment", 4),
                  l("div", {
                    class: "tw-text-md",
                    style: R({ color: g.value === "dark" ? "white" : d.value ?? "black" })
                  }, m(T(ee)(q.value.finalPayment, 2, 2)), 5)
                ], 4)
              ])
            ])
          ]),
          l("div", _p, [
            l("div", {
              class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-1",
              style: R({ "background-color": g.value === "dark" ? "#5f5f5f" : f.value ?? "#f5f5f5" })
            }, [
              l("div", {
                class: "tw-font-semibold tw-text-sm",
                style: R({ color: g.value === "dark" ? "white" : x.value ?? "black" })
              }, "Representative APR", 4),
              l("div", {
                class: "tw-text-md",
                style: R({ color: g.value === "dark" ? "white" : d.value ?? "black" })
              }, m(T(Ws)(q.value)), 5)
            ], 4)
          ]),
          l("div", {
            class: "tw-text-center tw-text-md tw-pt-2",
            style: R({ color: g.value === "dark" ? "white" : d.value ?? "black" })
          }, " Rates from " + m(s.value) + "% APR. ", 5),
          u.value ? (y(), A("div", {
            key: 0,
            class: "tw-text-center tw-text-md tw-pt-1",
            style: R({ color: g.value === "dark" ? "white" : d.value ?? "black" })
          }, E[61] || (E[61] = [
            l("a", {
              href: "https://www.carfinance247.co.uk",
              "aria-label": "Carfinance247",
              target: "_blank",
              rel: "noopener noreferrer",
              class: "tw-text-blue-600 tw-hover:underline",
              title: "Carfinance247"
            }, "Car Finance 247", -1),
            l("span", null, " Limited is a credit broker, not a lender.", -1)
          ]), 4)) : k("", !0)
        ], 4)) : k("", !0)
      ])) : k("", !0)
    ]));
  }
}), Bn = /* @__PURE__ */ nr(Pp, [["__scopeId", "data-v-96c4f8e5"]]);
function fl(t) {
  const e = Rp(t);
  return e && e.r * 0.299 + e.g * 0.587 + e.b * 0.114 > 186 ? "black" : "white";
}
function Rp(t) {
  var e = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
  return e ? {
    r: parseInt(e[1], 16),
    g: parseInt(e[2], 16),
    b: parseInt(e[3], 16)
  } : null;
}
const ml = {
  getResiduals(t) {
    return new Promise((e, i) => {
      cl.post("https://apim.247prod.io/api/dealer/v1/vehicle/residuals/multiple", t).then((M) => {
        M.status === 204 && e(null), e(M.data);
      }).catch((M) => {
        i(M);
      });
    });
  },
  vehicleSearch(t, e) {
    return new Promise((i, M) => {
      cl.get(`https://apim.247prod.io/api/calculator/v1/vehicle-search?vrm=${t}&mileage=${e}`).then((n) => {
        if (n.status === 200) {
          i(n.data);
          return;
        }
        i(null), i(n.data);
      }).catch((n) => {
        M(n);
      });
    });
  }
};
function Fp(t, e, i = 0) {
  return new Promise(async (M, n) => {
    if (t.futuresMileage && t.futuresMileage === t.annualMileage || t.futuresRequestFailed) {
      M(t.futures ? { futures: t.futures, regDate: t.vehicleDateOfFirstReg } : null);
      return;
    }
    if (!t.capId) {
      const r = await ml.vehicleSearch(t.vrm, t.mileage);
      if (!r) {
        M(null);
        return;
      }
      r.price = t.price, r.mileage = t.mileage, r.vrm = t.vehicleRegistration, t = r;
    }
    const a = await tn.constructResidualsRequest(
      t,
      16374719,
      // needs any app id
      i,
      e,
      [24, 36, 48, 60],
      8e3,
      null,
      null,
      t.capCode
    );
    if (!a) {
      t.futuresMileage = 8e3, M({ futures: null, regDate: t.vehicleDateOfFirstReg });
      return;
    }
    a.financeCompanyIds = [75], ml.getResiduals(a).then((r) => {
      if (!r) {
        t.futuresMileage = 8e3, t.futuresRequestFailed = !0, M({ futures: null, regDate: t.vehicleDateOfFirstReg });
        return;
      }
      r[75] && (r[50] = r[75], r[66] = r[75], r[67] = r[75], r[70] = r[75], r[73] = r[75], r[74] = r[75]), M({ futures: r, regDate: t.vehicleDateOfFirstReg });
    }).catch((r) => {
      t.futuresRequestFailed = !0, t.futures = null, M(null);
    });
  });
}
const Wp = {
  id: "calcWrapper",
  style: {}
}, Bp = { class: "tw-flex tw-flex-row" }, Vp = {
  class: "brand-text-dark shadow-3 tw-h-full tw-bg-white tw-border tw-rounded-lg tw-shadow",
  style: { "border-radius": "var(--q-border-radius)", overflow: "visible", height: "100%" }
}, Gp = {
  key: 0,
  class: "text-h5 tw-mb-4"
}, Zp = {
  key: 1,
  class: "text-subtitle1 tw-pb-2"
}, $p = {
  key: 2,
  id: "amountToFinance",
  class: "text-subtitle1 tw-mb-1 q-field-border !tw-px-0"
}, Jp = { class: "tw-w-full input-icons" }, Hp = { key: 3 }, Xp = { class: "text-body1 tw-pb-1" }, Kp = {
  key: 0,
  class: "text-body2 tw-pb-1"
}, qp = ["min", "step", "max"], ew = {
  key: 5,
  class: "tw-flex tw-w-full tw-justify-between tw-text-grey-8 text-body2",
  style: { "margin-top": "-5px !important" }
}, tw = {
  key: 7,
  id: "amountOfDeposit",
  class: "text-subtitle1 tw-mb-1 q-field-border !tw-px-0"
}, iw = { class: "wt-w-full input-icons" }, Mw = { class: "tw-flex tw-gap-1" }, nw = { class: "tw-flex-1" }, aw = ["id"], rw = { class: "tw-flex-1" }, lw = ["id"], ow = { class: "tw-flex-1" }, sw = ["id"], uw = { class: "tw-flex-1" }, cw = ["id"], gw = {
  key: 8,
  class: "tw-flex tw-items-center text-subtitle1 tw-pt-4 tw-pb-2"
}, Nw = {
  style: { fill: "var(--q-brand-button-active-text)" },
  xmlns: "http://www.w3.org/2000/svg",
  height: "17.5px",
  viewBox: "0 -960 960 960",
  width: "17.5px",
  fill: "#e8eaed"
}, Iw = {
  key: 0,
  class: "tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-black tw-bg-opacity-50 tw-p-6 tw-z-10"
}, Dw = { class: "tw-bg-white tw-rounded-lg tw-max-w-[560px]" }, dw = { class: "tw-flex tw-items-center tw-justify-between tw-p-4" }, jw = ["value"], yw = {
  key: 10,
  class: "tw-flex tw-items-center text-subtitle1 tw-pt-4 tw-pb-2"
}, Aw = {
  style: { fill: "var(--q-brand-button-active-text)" },
  xmlns: "http://www.w3.org/2000/svg",
  height: "17.5px",
  viewBox: "0 -960 960 960",
  width: "17.5px",
  fill: "#e8eaed"
}, Tw = {
  key: 0,
  class: "tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-black tw-bg-opacity-50 tw-p-6 tw-z-10"
}, xw = { class: "tw-bg-white tw-rounded-lg tw-max-w-[560px]" }, zw = { class: "tw-flex tw-items-center tw-justify-between tw-p-4" }, fw = {
  key: 11,
  class: "tw-flex tw-gap-1 tw-py-1"
}, mw = { class: "tw-flex-1" }, Lw = ["id", "disabled"], pw = { class: "tw-flex-1" }, ww = {
  key: 12,
  class: "tw-flex tw-w-full tw-justify-end tw-pt-4"
}, Cw = {
  style: { width: "150px", "max-width": "150px" },
  class: "cursor-pointer"
}, hw = {
  href: "https://www.carfinance247.co.uk",
  "aria-label": "Carfinance247",
  target: "_blank",
  rel: "noopener noreferrer",
  title: "Carfinance247"
}, Ow = {
  key: 0,
  class: "tw-w-full"
}, Ew = { class: "tw-flex tw-w-full tw-justify-between tw-py-2" }, Sw = { class: "text-body1" }, kw = { class: "text-body2" }, vw = {
  key: 0,
  class: "tw-flex tw-w-full tw-justify-between tw-py-2"
}, bw = { class: "text-body1" }, Qw = { class: "text-body2" }, Uw = {
  key: 1,
  class: "tw-flex tw-w-full tw-justify-between tw-py-2"
}, Yw = { class: "text-body1" }, _w = { class: "text-body2" }, Pw = { class: "tw-flex tw-w-full tw-justify-between text-body1 tw-py-2" }, Rw = { class: "text-body1 tw-flex tw-items-center" }, Fw = {
  key: 0,
  class: "tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-black tw-bg-opacity-50 tw-p-6 tw-z-10"
}, Ww = { class: "tw-bg-white tw-rounded-lg tw-max-w-[560px] tw-text-black" }, Bw = { class: "tw-flex tw-items-center tw-justify-between tw-p-4" }, Vw = { class: "text-body1" }, Gw = {
  key: 2,
  class: "tw-flex tw-w-full tw-justify-between tw-py-2"
}, Zw = { class: "text-body1" }, $w = { class: "text-body2" }, Jw = { class: "tw-flex tw-w-full tw-justify-between tw-py-2" }, Hw = { class: "text-body1" }, Xw = { class: "tw-flex tw-w-full tw-justify-between tw-py-2" }, Kw = { class: "text-body1" }, qw = { class: "text-body2" }, eC = { class: "tw-flex tw-w-full tw-justify-between tw-py-2" }, tC = { class: "text-body1" }, iC = { class: "text-body2" }, MC = { class: "tw-flex tw-w-full tw-justify-between text-body1 tw-py-2" }, nC = { class: "text-h6" }, aC = { class: "text-h4" }, rC = { class: "text-h6" }, lC = { class: "text-body2 tw-py-2" }, oC = { key: 0 }, sC = { class: "tw-pt-4" }, uC = { class: "tw-flex tw-justify-center text-h6" }, cC = { class: "tw-flex" }, gC = {
  key: 0,
  class: "tw-pl-2",
  style: { fill: "var(--q-brand-cta-text)" },
  xmlns: "http://www.w3.org/2000/svg",
  height: "27.44px",
  viewBox: "0 -960 960 960",
  width: "38px"
}, NC = {
  key: 0,
  class: "text-body2"
}, IC = {
  key: 1,
  class: "tw-flex tw-w-full tw-h-full tw-justify-center tw-items-center tw-text-center column"
}, DC = { class: "tw-mt-4 text-h6 text-weight-regular" }, dC = { class: "tw-pt-4" }, jC = {
  key: 1,
  class: "tw-flex tw-w-full tw-h-full tw-justify-center tw-items-center column"
}, yC = { class: "tw-mt-4 text-h6 text-weight-regular" }, AC = { class: "rep-example" }, TC = { key: 0 }, xC = { key: 1 }, zC = { key: 0 }, fC = { key: 1 }, mC = /* @__PURE__ */ ne({
  __name: "Calculator",
  props: {
    aid: {
      type: Number,
      default: null
    },
    daid: {
      type: Number,
      default: null
    },
    dealerName: {
      type: String,
      default: null
    },
    ctaText: {
      type: String,
      default: null
    },
    defaultAmount: {
      type: Number,
      default: null
    },
    defaultAmountTitle: {
      type: String,
      default: null
    },
    defaultTerm: {
      type: Number,
      default: null
    },
    defaultScore: {
      type: String,
      default: null
    },
    hideRepApr: {
      type: Boolean,
      default: !1
    },
    repApr: {
      type: Number,
      default: null
    },
    defaultRatesFrom: {
      type: Number,
      default: null
    },
    hideSlider: {
      type: Boolean,
      default: !1
    },
    radius: {
      type: Number,
      default: null
    },
    showDeposit: {
      type: Boolean,
      default: !1
    },
    brandPrimary: {
      type: String,
      default: null
    },
    brandSecondary: {
      type: String,
      default: null
    },
    repAprFieldBackgroundColour: {
      type: String,
      default: null
    },
    repAprBackgroundColour: {
      type: String,
      default: null
    },
    repAprTextColour: {
      type: String,
      default: null
    },
    isUnregulated: {
      type: Boolean,
      default: !1
    },
    isRegulated: {
      type: Boolean,
      default: !1
    },
    hidePcp: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = C(null), i = (v) => {
      window.open(v);
    }, M = (v, _) => {
      var Ee;
      (Ee = document.querySelector("body")) == null || Ee.style.setProperty(`--q-${v}`, _);
    }, n = t, a = Bs, r = C(["Excellent", "Good", "Fair", "Poor"]), o = C("HP"), s = C(3e3), u = C(8e3), c = C(2e5), g = C(!1), d = C(!1), j = C(!1), D = C(!1), I = C(!1), N = C(!1), x = C(!1), f = C(!0), L = C(!1), p = C("Car Finance Calculator"), h = C(!1), w = C(null), O = C(!1), S = C(null), Y = C(null), H = C(!1), B = C(1e4), ae = C(1e3), te = C("What is the price of the car?"), q = C(!1), le = C(!1), Me = C(!1), oe = C(!1), $ = C(48), E = C(61), be = C("How many months do you want to borrow for?"), V = C(!1), Q = C(0), F = C(0), Ne = C("Do you have a deposit?"), se = C("Good"), Nt = C("My credit score is"), je = C(null), We = C(null), Re = C(9.9), Be = C(!1), Ie = C(null), K = C(null), X = C(null), De = C(null), Ae = C("Start Your Application"), mt = C(null), Gt = C(!1), jn = C(!1), ar = C(0), mi = C("text"), Hi = C("Representative Example"), Ve = C(null), St = C(null), mM = C(null), LM = C(null), pM = C(null), Zt = C(null), ri = C(null), yn = C(!1), wM = C(!1), rr = C(!1), lr = C(!1), ue = Ol(Qo(B.value)), An = C(null), Xi = C(!1);
    we(() => {
      a.setUtms();
      const v = new URLSearchParams(window.location.search);
      if (x.value = !!(v.get("isClassified") && v.get("isClassified") === "true"), Gt.value = !!(v.get("removeBackground") && v.get("removeBackground") === "true"), p.value = v.get("title") ?? p.value, h.value = !!(v.get("hideTitle") && v.get("hideTitle") === "true"), D.value = !!(v.get("overrideApply") && v.get("overrideApply") === "true"), I.value = !!(v.get("overrideCredScore") && v.get("overrideCredScore") === "true"), B.value = n.defaultAmount ? n.defaultAmount : v.get("amount") && !isNaN(Number(v.get("amount"))) ? Number(v.get("amount")) : B.value, te.value = n.defaultAmountTitle ? n.defaultAmountTitle : v.get("amountTitle") ?? te.value, q.value = !!(v.get("hideAmountInput") && v.get("hideAmountInput") === "true"), le.value = !!(v.get("staticAmount") && v.get("staticAmount") === "true"), Me.value = n.hideSlider && n.hideSlider === !0 ? !0 : !!(v.get("hideSlider") && v.get("hideSlider") === "true"), Q.value = v.get("deposit") && !isNaN(Number(v.get("deposit"))) ? Number(v.get("deposit")) : Q.value, F.value = v.get("minDeposit") && !isNaN(Number(v.get("minDeposit"))) ? Number(v.get("minDeposit")) : F.value, V.value = n.showDeposit ? n.showDeposit : !!(v.get("showDeposit") && v.get("showDeposit") === "true"), Ne.value = v.get("depositTitle") ?? Ne.value, w.value = n.aid ? Number(n.aid) : v.get("aid") ? Number(v.get("aid")) : null, S.value = n.daid ? Number(n.daid) : v.get("daid") ? Number(v.get("daid")) : null, Y.value = n.dealerName ? n.dealerName : v.get("dname") ?? null, lr.value = !!(v.get("isV3") && v.get("isV3") === "true"), Ie.value = v.get("excellentApr") ? Number(v.get("excellentApr")) : null, K.value = v.get("goodApr") ? Number(v.get("goodApr")) : null, X.value = v.get("fairApr") ? Number(v.get("fairApr")) : null, De.value = v.get("poorApr") ? Number(v.get("poorApr")) : null, N.value = !!(v.get("isCF247") && v.get("isCF247") === "true"), jn.value = !!(v.get("hidePoweredBy") && v.get("hidePoweredBy") === "true"), mi.value = v.get("repView") ? v.get("repView") : mi.value, Hi.value = v.get("repTableTitle") ?? Hi.value, yn.value = !!(v.get("noTransition") && v.get("noTransition") === "true"), wM.value = n.isUnregulated && n.isUnregulated === !0 ? !0 : !!(v.get("isUnregulated") && v.get("isUnregulated") === "true"), rr.value = n.isRegulated && n.isRegulated === !0 ? !0 : !!(v.get("isRegulated") && v.get("isRegulated") === "true"), O.value = !!(S.value || rr.value || wM.value), H.value = n.hidePcp && n.hidePcp === !0 ? !0 : !!(v.get("hidePcp") && v.get("hidePcp") === "true"), H.value && (o.value = "HP"), f.value = !N.value && !jn.value, f.value && w.value && Number(w.value) === 2655 && (f.value = !1), se.value = n.defaultScore ? n.defaultScore : v.get("defaultScore") ?? "Good", Nt.value = v.get("scoreTitle") ?? Nt.value, $.value = n.defaultTerm ? n.defaultTerm : v.get("defaultTerm") ? Number(v.get("defaultTerm")) : 48, be.value = v.get("termTitle") ?? be.value, Ae.value = n.ctaText ? n.ctaText : v.get("defaultButtonText") ?? "Start Your Application", mt.value = v.get("subButtonText") ?? null, je.value = v.get("customApr") ? Number(v.get("customApr")) : null, We.value = n.repApr ? n.repApr : Number(v.get("defaultRepAPR") ?? We.value), Be.value = n.hideRepApr && n.hideRepApr === !0 ? !0 : !!(v.get("hideRepApr") && v.get("hideRepApr") === "true"), Re.value = n.defaultRatesFrom ? n.defaultRatesFrom : Number(v.get("ratesFrom") ?? Re.value), Ve.value = n.brandPrimary ? n.brandPrimary : v.get("brandPrimary") ?? null, St.value = n.brandSecondary ? n.brandSecondary : v.get("brandSecondary") ?? null, LM.value = n.repAprFieldBackgroundColour ? n.repAprFieldBackgroundColour : v.get("repAprFieldBackgroundColour") ?? null, mM.value = n.repAprBackgroundColour ? n.repAprBackgroundColour : v.get("repAprBackgroundColour") ?? null, pM.value = n.repAprTextColour ? n.repAprTextColour : v.get("repAprTextColour") ?? null, Ve.value && (M("primary", Ve.value), M("brand-background", Ve.value), M("brand-background-border", Ve.value), M("brand-button-active-text", Ve.value), M("brand-cta-text", Ve.value), M("brand-link-colour", Ve.value)), !w.value && !S.value && !Ve.value && ya("CarFinance247"), St.value) {
        M("secondary", St.value), M("brand-cta-background", St.value);
        const Ee = fl(St.value);
        M("brand-cta-text", Ee);
      }
      ar.value = n.radius ? Number(n.radius) : v.get("radius") ? Number(v.get("radius")) : 15, Zt.value = v.get("vrm") ?? null, ri.value = v.get("mileage") ? Number(v.get("mileage")) : null, An.value = v.get("advertId") ? v.get("advertId") : null, oe.value = !!(v.get("vdp") && v.get("vdp") === "true" || Zt.value), oe.value && (te.value = "Vehicle price", le.value = !0, Me.value = !0), M("border-radius", ar.value + "px");
      const _ = w.value ? ja.find((Ee) => Ee.affiliateUserId === Number(w.value)) : null;
      if (_)
        a.setAffiliate(_), _.displayName === "CarCraft" && (L.value = !0, Re.value = 8.9, We.value = 18.9, jn.value = !0, f.value = !1);
      else if (w.value || S.value)
        if (Ve.value && (M("primary", Ve.value), M("brand-background", Ve.value), M("brand-background-border", Ve.value), M("brand-button-active-text", Ve.value), M("brand-cta-text", Ve.value), M("brand-link-colour", Ve.value)), St.value) {
          M("secondary", St.value), M("brand-cta-background", St.value);
          const Ee = fl(St.value);
          M("brand-cta-text", Ee);
        } else
          fL();
      wM.value && oe.value && (p.value = "Finance Calculator provided by Car Finance 247"), Xi.value = !0, zn();
    }), xe([() => se.value, () => B.value, () => x.value, () => Q.value, () => Xi.value], () => {
      Xi.value && ur();
    });
    const or = J(
      () => {
        let v = B.value - Q.value;
        return o.value === "HP" && (v < s.value || v > c.value) || o.value === "PCP" && (v < u.value || v > c.value);
      }
    ), Vs = J(() => {
      let v = B.value - Q.value;
      if (o.value === "PCP" && v < u.value)
        return `We are unable to offer PCP finance on amounts lower than ${ee(u.value)}. Try switching to finance type 'HP' `;
      if (o.value === "HP" && v < s.value)
        return `We are unable to offer finance below ${ee(s.value)}`;
      if (v > c.value)
        return `We are unable to offer finance above ${ee(c.value)}`;
    }), Ki = C(!1), sr = C(!1);
    async function ur() {
      if (!Xi.value || Q.value < F.value || Q.value > B.value || or.value)
        return;
      ue.deposit = Q.value, ue.price = B.value, ue.glassesRetailTransacted = B.value, ue.glassesRetailValuation = B.value, ue.glassesTradeValuation = B.value, ue.ageInMonths = 0;
      let v = je.value ? je.value : x.value ? 9.9 : mL(ue.price - (Q.value ? Q.value : 0), se.value);
      se.value === "Excellent" && Ie.value ? v = Ie.value : se.value === "Good" && K.value ? v = K.value : se.value === "Fair" && X.value ? v = X.value : se.value === "Poor" && De.value && (v = De.value);
      let _ = Tl(ue.price, v), Ee = Tl(ue.price, v).filter((re) => re.financeCompanyId === 49);
      if (O.value ? (_ = _.filter((re) => re.financeCompanyId != 49), Ee[0].apr = v) : (_ = _.filter((re) => re.financeCompanyId === 49), _[0].apr = v), !Ki.value && O.value && !H.value && B.value && Zt.value && ri.value) {
        Ki.value = !0, ue.price = B.value, ue.vrm = Zt.value, ue.mileage = ri.value;
        const re = await Fp(ue, _, Q.value);
        re && (ue.futures = re.futures, ue.ageInMonths = null, ue.registrationDate = re.regDate ? re.regDate : ue.registrationDate), ue.futuresMileage = 8e3, ue.annualMileage = 8e3, Ki.value = !1;
      }
      if (tn.calculateMonthlyPaymentForVehicle(
        ue,
        _,
        Q.value,
        // deposit
        0,
        null,
        {
          annualMileage: 8e3,
          terms: [24, 36, 48, 60]
        }
      ), O.value) {
        const re = JSON.parse(JSON.stringify(ue));
        tn.calculateMonthlyPaymentForVehicle(
          re,
          Ee,
          Q.value,
          // deposit
          0,
          null,
          {
            annualMileage: 8e3,
            terms: [24, 36, 48, 60]
          }
        ), ue.cannotPrice = re.cannotPrice, ue.cannotPriceReason = re.cannotPriceReason, ue.priceMatrix = re.priceMatrix;
      }
      if (!je.value && (se.value === "Poor" || se.value === "Fair") && (ue.pcpMatrix = []), !ue.pcpMatrix || ue.pcpMatrix.length === 0 || B.value - Q.value < u.value ? o.value = "HP" : !sr.value && !L.value && (o.value = "PCP", sr.value = !0), E.value === 61 && (E.value = $.value), o.value === "HP") {
        const re = ue.priceMatrix && ue.priceMatrix.length ? ue.priceMatrix.reduce((Ge, kt) => Ge.term > kt.term ? Ge : kt).term : 0;
        E.value = E.value > re ? re : $.value;
      } else {
        const re = ue.pcpMatrix && ue.pcpMatrix.length ? ue.pcpMatrix.reduce((Ge, kt) => Ge.term > kt.term ? Ge : kt).term : 0;
        E.value = E.value > re ? re : $.value;
      }
    }
    const Oe = J(() => o.value === "HP" ? !ue.priceMatrix || ue.priceMatrix.length === 0 ? null : ue.priceMatrix.find((v) => v.term === E.value) : o.value === "PCP" ? !ue.pcpMatrix || ue.pcpMatrix.length === 0 ? null : ue.pcpMatrix.find((v) => v.term === E.value) : null), cr = J(() => {
      let v = B.value - Q.value;
      return !(!ue.pcpMatrix || ue.pcpMatrix.length === 0 || v < 8e3);
    });
    function qi(v, _, Ee) {
      if (w.value && !isNaN(Number(w.value))) {
        const re = ja.find((Ge) => Ge.affiliateUserId === Number(w.value));
        if (re && re.displayName === "CompareTheMarket")
          return `CarFinance_${_}_${Ee}`;
      }
      return v;
    }
    function gr(v) {
      g.value = v;
    }
    function Gs() {
      if (I.value) {
        const v = {
          type: "cf247-improve-cred-score-click"
        };
        window.parent.postMessage(v, "*");
        return;
      }
      i("https://www.carfinance247.co.uk/improve-your-credit-score");
    }
    function Zs() {
      const v = new URLSearchParams(a.utms);
      for (const [Ge, kt] of v.entries())
        Ge === "amount" && v.delete(Ge);
      let _ = null;
      for (const [Ge, kt] of v.entries())
        _ === null ? _ = `?${Ge}=${encodeURIComponent(kt)}` : _.includes(Ge) || (_ += `&${Ge}=${encodeURIComponent(kt)}`);
      const Ee = `${a.affiliate && a.affiliate.applyPage ? a.affiliate.applyPage : "https://apply.carfinance247.co.uk"}${_ !== null ? _ + "&" : "?"}${"aid=" + w.value}&amount=${B.value ?? 1e4}&deposit=${Q.value}&term=${$.value}${yn.value ? "&noTransition=true" : ""}${Zt.value ? "&vrm=" + Zt.value + "&vehicle_type=car" : ""}${ri.value ? "&mileage=" + ri.value : ""}${An.value ? "&advertId=" + An.value : ""}`, re = O.value ? `https://apply.carfinance247.co.uk${_ !== null ? _ + "&" : "?"}daid=${S.value}&dname=${Y.value}&amount=${B.value ?? 1e4}&deposit=${Q.value}&pxValue=0&pxSettlement=0&annualMileage=8000&term=${$.value}${oe.value ? "&app-type=full&utm_type=dealerFull" : "&noBankDetails=true&app-type=eligibility" + (lr.value ? "&utm_type=dealerEligibility" : "&utm_type=dealerFull")}${yn.value ? "&noTransition=true" : ""}${Zt.value ? "&vrm=" + Zt.value + "&vehicle_type=car" : ""}${ri.value ? "&mileage=" + ri.value : ""}${wM.value ? "&utm_campaign=dealerweb&noPx=true" : ""}` : null;
      if (D.value) {
        const Ge = {
          type: "cf247-apply-click",
          url: re ?? Ee
        };
        window.parent.postMessage(Ge, "*");
        return;
      }
      i(re ?? Ee);
    }
    function CM(v) {
      E.value = v;
      const _ = {
        type: "cf247-change-finance-term",
        val: v
      };
      window.parent.postMessage(_, "*");
    }
    function $s() {
      const v = {
        type: "cf247-change-credit-score",
        val: se.value
      };
      window.parent.postMessage(v, "*");
    }
    function Nr() {
      var v;
      const _ = B.value / Number((v = e.value) == null ? void 0 : v.max) * 100;
      e.value.style.background = `linear-gradient(to right, var(--q-brand-background) ${_}%, #0000001a ${_}%)`;
      const Ee = {
        type: "cf247-change-finance-amount",
        val: B.value
      };
      window.parent.postMessage(Ee, "*");
    }
    function Js() {
      const v = {
        type: "cf247-change-amount-of-deposit"
      };
      window.parent.postMessage(v, "*");
    }
    function Ir(v) {
      o.value = v;
      const _ = {
        type: "cf247-change-finance-product",
        val: v
      };
      window.parent.postMessage(_, "*");
    }
    function Dr() {
      if (o.value === "PCP") {
        B.value < s.value && (o.value = "HP", ur());
        return;
      }
      B.value < s.value ? B.value = s.value : B.value > c.value && (B.value = c.value);
    }
    const Tn = C("");
    xe(o, () => {
      Tn.value = "quote-fade", setTimeout(() => {
        Tn.value = "";
      }, 1e3);
    });
    const He = C(!1);
    let xn = null;
    we(() => {
      xn = setTimeout(dr, 1), window.self.addEventListener("resize", zn), Ar.value = setInterval(jr, 100);
    }), _t(() => {
      clearTimeout(xn), xn = null, window.self.removeEventListener("resize", zn), clearTimeout(Ar.value);
    });
    function dr() {
      typeof window < "u" && (He.value = window.self.matchMedia("(max-width: 600px)").matches);
    }
    function jr() {
      if (document.getElementById("calcWrapper")) {
        const v = {
          type: "cf247-calc-height",
          height: document.getElementById("calcWrapper").scrollHeight + 10
        };
        window.parent.postMessage(v, "*"), yr();
      }
    }
    function yr() {
      var v = document.getElementById("cf247-widget-body");
      v ? (v.style.overflow = "visible", setTimeout(() => {
      }, 100)) : setTimeout(() => {
        yr();
      }, 100);
    }
    function zn() {
      var v;
      dr(), jr(), e.value = document.querySelector("#range");
      const _ = B.value / Number((v = e.value) == null ? void 0 : v.max) * 100;
      e.value.style.background = `linear-gradient(to right, var(--q-brand-background) ${_}%, #0000001a ${_}%)`;
    }
    const Ar = C(null);
    return (v, _) => {
      const Ee = Mu("q-icon");
      return y(), A("div", Wp, [
        l("div", Bp, [
          l("div", {
            class: P(["header brand-background brand-background-border tw-px-4 tw-mt-6 tw-mb-10 pad-left-desktop", He.value && Gt.value ? "bg-transparent" : ""]),
            style: R([{ display: He.value ? "none" : "block" }, { "border-right": "0px solid" }])
          }, null, 6),
          l("div", {
            class: P(`content tw-grid  ${He.value ? " tw-grid-cols-1 " : " tw-grid-cols-2 "} tw-pt-1 tw-pb-4 tw-overflow-visible`)
          }, [
            l("div", {
              class: P(["tw-w-full", He.value ? "tw-px-4 " + (He.value && Gt.value ? N.value && He.value ? "bg-gradient-for-calculator-ui" : "bg-transparent" : "bg-gradient") : ""])
            }, [
              l("div", Vp, [
                l("div", {
                  class: "tw-p-4",
                  style: R({ padding: He.value ? "20px" : "24px" })
                }, [
                  !N.value && !h.value ? (y(), A("div", Gp, m(p.value), 1)) : k("", !0),
                  q.value ? k("", !0) : (y(), A("div", Zp, m(te.value), 1)),
                  !q.value && !le.value ? (y(), A("div", $p, [
                    l("div", Jp, [
                      _[16] || (_[16] = l("div", {
                        class: "tw-icon tw-absolute tw-pl-2.5 tw-text-base tw-font-normal",
                        style: { "padding-top": "7px" }
                      }, " £ ", -1)),
                      ht(l("input", {
                        id: "financeAmount",
                        "onUpdate:modelValue": _[0] || (_[0] = (re) => B.value = re),
                        type: "number",
                        class: "tw-w-full tw-border tw-rounded-md focus:tw-outline-none tw-text-left tw-p-0 tw-pl-6 tw-h-[38px] tw-text-base tw-font-normal",
                        onBlur: Dr,
                        onInput: Nr
                      }, null, 544), [
                        [
                          vM,
                          B.value,
                          void 0,
                          { number: !0 }
                        ]
                      ])
                    ])
                  ])) : le.value ? (y(), A("div", Hp, [
                    l("span", Xp, m(T(ee)(B.value, 2, 2).split(".")[0]), 1),
                    T(ee)(B.value, 2, 2).split(".")[1] !== "00" ? (y(), A("span", Kp, "." + m(T(ee)(B.value, 2, 2).split(".")[1]), 1)) : k("", !0)
                  ])) : k("", !0),
                  !q.value && !le.value && !Me.value ? ht((y(), A("input", {
                    key: 4,
                    id: "range",
                    "onUpdate:modelValue": _[1] || (_[1] = (re) => B.value = re),
                    type: "range",
                    class: "tw-w-full tw-p-0 tw-my-4",
                    min: s.value,
                    step: ae.value,
                    max: c.value,
                    onInput: Nr
                  }, null, 40, qp)), [
                    [
                      vM,
                      B.value,
                      void 0,
                      { number: !0 }
                    ]
                  ]) : k("", !0),
                  !q.value && !le.value && !Me.value ? (y(), A("div", ew, [
                    l("span", null, m(T(ee)(s.value)), 1),
                    l("span", null, m(T(ee)(c.value)), 1)
                  ])) : k("", !0),
                  x.value || V.value ? (y(), A("div", {
                    key: 6,
                    class: P(["text-subtitle1 tw-pb-1", q.value ? "" : "tw-pt-4"])
                  }, m(Ne.value), 3)) : k("", !0),
                  x.value || V.value ? (y(), A("div", tw, [
                    l("div", iw, [
                      _[17] || (_[17] = l("div", {
                        class: "tw-icon tw-absolute tw-pl-2.5 tw-text-base tw-font-normal",
                        style: { "padding-top": "7px" }
                      }, " £ ", -1)),
                      ht(l("input", {
                        id: "depositAmount",
                        "onUpdate:modelValue": _[2] || (_[2] = (re) => Q.value = re),
                        type: "number",
                        class: "tw-w-full tw-border tw-rounded-md focus:tw-outline-none tw-text-left tw-p-0 tw-pl-6 tw-h-[38px] tw-text-base tw-font-normal",
                        onBlur: Dr,
                        onInput: Js
                      }, null, 544), [
                        [
                          vM,
                          Q.value,
                          void 0,
                          { number: !0 }
                        ]
                      ])
                    ])
                  ])) : k("", !0),
                  l("div", {
                    class: P(["text-subtitle1 tw-pb-2", q.value && !(x.value || V.value) ? "" : "tw-pt-4"])
                  }, m(be.value), 3),
                  l("div", Mw, [
                    l("div", nw, [
                      l("button", {
                        class: P(["tw-w-full tw-border tw-rounded-md tw-p-2 tw-text-subtitle1 q-field-border", E.value === 24 ? "brand-button--active" : "brand-button"]),
                        style: R(E.value === 24 ? "border: 2px solid currentColor;" : " border-color: rgba(0, 0, 0, 0.24) !important;"),
                        onClick: _[3] || (_[3] = (re) => CM(24)),
                        id: qi("cf-in-term-24", "Calculator", "Term24Button")
                      }, " 24 ", 14, aw)
                    ]),
                    l("div", rw, [
                      l("button", {
                        class: P(["tw-w-full tw-border tw-rounded-md tw-p-2 tw-text-subtitle1 q-field-border", E.value === 36 ? "brand-button--active" : "brand-button"]),
                        style: R(E.value === 36 ? "border: 2px solid currentColor;" : " border-color: rgba(0, 0, 0, 0.24) !important;"),
                        onClick: _[4] || (_[4] = (re) => CM(36)),
                        id: qi("cf-in-term-36", "Calculator", "Term36Button")
                      }, " 36 ", 14, lw)
                    ]),
                    l("div", ow, [
                      l("button", {
                        class: P(["tw-w-full tw-border tw-rounded-md tw-p-2 tw-text-subtitle1 q-field-border", E.value === 48 ? "brand-button--active" : "brand-button"]),
                        style: R(E.value === 48 ? "border: 2px solid currentColor;" : " border-color: rgba(0, 0, 0, 0.24) !important;"),
                        onClick: _[5] || (_[5] = (re) => CM(48)),
                        id: qi("cf-in-term-48", "Calculator", "Term48Button")
                      }, " 48 ", 14, sw)
                    ]),
                    l("div", uw, [
                      l("button", {
                        class: P(["tw-w-full tw-border tw-rounded-md tw-p-2 tw-text-subtitle1 q-field-border", E.value === 60 ? "brand-button--active" : "brand-button"]),
                        style: R(E.value === 60 ? "border: 2px solid currentColor;" : " border-color: rgba(0, 0, 0, 0.24) !important;"),
                        onClick: _[6] || (_[6] = (re) => CM(60)),
                        id: qi("cf-in-term-60", "Calculator", "Term60Button")
                      }, " 60 ", 14, cw)
                    ])
                  ]),
                  !x.value && !je.value ? (y(), A("div", gw, [
                    G(m(Nt.value) + " ", 1),
                    l("button", {
                      class: "tw-pl-1 brand-link",
                      "aria-label": "Learn more about credit score",
                      onClick: _[7] || (_[7] = (re) => gr(!0))
                    }, [
                      (y(), A("svg", Nw, _[18] || (_[18] = [
                        l("path", { d: "M444-288h72v-240h-72v240Zm35.79-312q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5Zm.49 504Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Zm-.28-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" }, null, -1)
                      ])))
                    ]),
                    g.value ? (y(), A("div", Iw, [
                      l("div", Dw, [
                        l("div", dw, [
                          _[20] || (_[20] = l("h3", { class: "tw-text-h6" }, " What is a Credit Score? ", -1)),
                          l("button", {
                            onClick: _[8] || (_[8] = (re) => gr(!1))
                          }, _[19] || (_[19] = [
                            l("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              height: "24px",
                              viewBox: "0 -960 960 960",
                              width: "24px",
                              fill: "#000"
                            }, [
                              l("path", { d: "m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" })
                            ], -1)
                          ]))
                        ]),
                        _[23] || (_[23] = l("hr", null, null, -1)),
                        l("div", { class: "tw-p-4 tw-font-normal" }, [
                          _[22] || (_[22] = l("p", { class: "!tw-pt-0" }, " Your credit score is based on your payment history (paying bills on time), debt levels, length of credit history, types of credit, and recent credit inquiries. ", -1)),
                          l("button", {
                            class: "tw-flex tw-items-center tw-mt-4 tw-text-white tw-px-4 tw-py-2 tw-rounded",
                            style: { "background-color": "var(--q-brand-background)" },
                            onClick: Gs
                          }, _[21] || (_[21] = [
                            G(" Improve my Credit Score "),
                            l("svg", {
                              class: "tw-ml-2.5",
                              xmlns: "http://www.w3.org/2000/svg",
                              height: "24px",
                              viewBox: "0 -960 960 960",
                              width: "24px",
                              fill: "#fff"
                            }, [
                              l("path", { d: "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z" })
                            ], -1)
                          ]))
                        ])
                      ])
                    ])) : k("", !0)
                  ])) : k("", !0),
                  !x.value && !je.value ? ht((y(), A("select", {
                    key: 9,
                    id: "selectScore",
                    "onUpdate:modelValue": _[9] || (_[9] = (re) => se.value = re),
                    class: "tw-w-full tw-border tw-rounded-md tw-p-2 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 q-field-border",
                    onChange: $s,
                    style: { "background-image": `linear-gradient(45deg, transparent 50%, gray 50%),
                        linear-gradient(135deg, gray 50%, transparent 50%),
                        radial-gradient(#fff 70%, transparent 72%)`, "background-position": `calc(100% - 20px) calc(1em + 2px),
                        calc(100% - 15px) calc(1em + 2px),
                        calc(100% - .5em) .5em`, "background-size": `5px 5px,
                        5px 5px,
                        1.5em 1.5em`, "background-repeat": "no-repeat", margin: "0", "-webkit-box-sizing": "border-box", "-moz-box-sizing": "border-box", "box-sizing": "border-box", "-webkit-appearance": "none", "-moz-appearance": "none" }
                  }, [
                    (y(!0), A(ge, null, ye(r.value, (re) => (y(), A("option", {
                      key: re,
                      value: re
                    }, m(re), 9, jw))), 128))
                  ], 544)), [
                    [hl, se.value]
                  ]) : k("", !0),
                  H.value ? k("", !0) : (y(), A("div", yw, [
                    _[29] || (_[29] = G(" Finance product ")),
                    l("button", {
                      class: "tw-pl-1 brand-link",
                      "aria-label": "Learn more about finance options",
                      onClick: _[10] || (_[10] = (re) => j.value = !0)
                    }, [
                      (y(), A("svg", Aw, _[24] || (_[24] = [
                        l("path", { d: "M444-288h72v-240h-72v240Zm35.79-312q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5Zm.49 504Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Zm-.28-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" }, null, -1)
                      ])))
                    ]),
                    j.value ? (y(), A("div", Tw, [
                      l("div", xw, [
                        l("div", zw, [
                          _[26] || (_[26] = l("h3", { class: "tw-text-h6" }, " What finance options are available? ", -1)),
                          l("button", {
                            onClick: _[11] || (_[11] = (re) => j.value = !1)
                          }, _[25] || (_[25] = [
                            l("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              height: "24px",
                              viewBox: "0 -960 960 960",
                              width: "24px",
                              fill: "#000"
                            }, [
                              l("path", { d: "m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" })
                            ], -1)
                          ]))
                        ]),
                        _[27] || (_[27] = l("hr", null, null, -1)),
                        _[28] || (_[28] = l("div", { class: "tw-p-4 tw-font-normal" }, [
                          l("p", { class: "!tw-pt-0 tw-pb-4" }, [
                            l("strong", null, "HP (Hire Purchase)"),
                            G(": involves making regular monthly payments until you've covered the full cost of the car. Once all payments are made, you own the car outright. ")
                          ]),
                          l("p", { class: "!tw-pt-0" }, [
                            l("strong", null, "PCP (Personal Contract Purchase)"),
                            G(": involves making lower monthly payments compared to HP. At the end of the contract, you have the choice to either buy the car by making a final balloon payment or return it. ")
                          ])
                        ], -1))
                      ])
                    ])) : k("", !0)
                  ])),
                  H.value ? k("", !0) : (y(), A("div", fw, [
                    l("div", mw, [
                      l("button", {
                        class: P(["tw-w-full tw-border tw-rounded-md tw-p-2 tw-text-subtitle1 q-field-border", o.value === "PCP" ? "brand-button--active" : "brand-button"]),
                        style: R(o.value === "PCP" ? "border: 2px solid currentColor;" : " border-color: rgba(0, 0, 0, 0.24) !important;"),
                        id: qi("cf-in-finance-type-pcp", "Calculator", "FinanceTypePCPButton"),
                        onClick: _[12] || (_[12] = (re) => Ir("PCP")),
                        disabled: !cr.value || Ki.value
                      }, m(cr.value && !Ki.value ? "PCP" : "PCP (unavailable)"), 15, Lw)
                    ]),
                    l("div", pw, [
                      l("button", {
                        class: P(["tw-w-full tw-border tw-rounded-md tw-p-2 tw-text-subtitle1 q-field-border", o.value === "HP" ? "brand-button--active" : "brand-button"]),
                        style: R(o.value === "HP" ? "border: 2px solid currentColor;" : " border-color: rgba(0, 0, 0, 0.24) !important;"),
                        onClick: _[13] || (_[13] = (re) => Ir("HP"))
                      }, " HP ", 6)
                    ])
                  ])),
                  f.value && !x.value ? (y(), A("div", ww, [
                    l("div", Cw, [
                      l("a", hw, [
                        b(zL)
                      ])
                    ])
                  ])) : k("", !0)
                ], 4)
              ])
            ], 2),
            l("div", {
              class: P(Gt.value && He.value ? "tw-w-full tw-px-4 tw-py-4 brand-text-light" : `tw-w-full ${He.value ? "tw-my-0" : "tw-my-6"} brand-background brand-background-border tw-p-6 brand-text-light`),
              style: R([{ "border-radius": He.value ? "0 0 0 0" : "0 var(--q-border-radius) var(--q-border-radius) 0", "margin-top": He.value ? "-5px" : "24px", border: He.value ? "none" : "" }, { "border-left": "0px solid" }])
            }, [
              l("div", {
                class: P(["brand-background tw-h-full", He.value && Gt.value ? "tw-shadow-0 tw-p-2 q-card q-card-rounded" : ""]),
                style: R(N.value && He.value ? "background-color: unset; color: #000;" : "")
              }, [
                or.value ? (y(), A("div", jC, [
                  b(Ee, {
                    size: "lg",
                    name: "mdi-information-outline",
                    color: "brand-text-light"
                  }),
                  l("div", yC, m(Vs.value), 1)
                ])) : (y(), A("div", {
                  key: o.value,
                  class: P(["tw-flex tw-items-center tw-h-full", Tn.value])
                }, [
                  Oe.value ? (y(), A("div", Ow, [
                    l("div", Ew, [
                      _[30] || (_[30] = l("span", { class: "text-body1" }, "Vehicle price", -1)),
                      l("span", null, [
                        l("span", Sw, m(T(ee)(Oe.value.amountToFinance + Oe.value.deposit, 2, 2).toString().split(".")[0]), 1),
                        l("span", kw, "." + m(T(ee)(Oe.value.amountToFinance + Oe.value.deposit, 2, 2).toString().split(".")[1]), 1)
                      ])
                    ]),
                    x.value || V.value ? (y(), A("div", vw, [
                      _[31] || (_[31] = l("span", { class: "text-body1" }, "Deposit", -1)),
                      l("span", null, [
                        l("span", bw, m(T(ee)(Oe.value.deposit, 2, 2).toString().split(".")[0]), 1),
                        l("span", Qw, "." + m(T(ee)(Oe.value.deposit, 2, 2).toString().split(".")[1]), 1)
                      ])
                    ])) : k("", !0),
                    x.value || V.value ? (y(), A("div", Uw, [
                      _[32] || (_[32] = l("span", { class: "text-body1" }, "Amount to finance", -1)),
                      l("span", null, [
                        l("span", Yw, m(T(ee)(Oe.value.amountToFinance, 2, 2).toString().split(".")[0]), 1),
                        l("span", _w, "." + m(T(ee)(Oe.value.amountToFinance, 2, 2).toString().split(".")[1]), 1)
                      ])
                    ])) : k("", !0),
                    l("div", Pw, [
                      l("div", Rw, [
                        G(m(x.value ? "Best available rate" : "APR") + " ", 1),
                        l("button", {
                          class: "tw-pl-1 brand-text-light",
                          "aria-label": "Learn more about APR",
                          onClick: _[14] || (_[14] = (re) => d.value = !0)
                        }, _[33] || (_[33] = [
                          l("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            height: "17.5px",
                            viewBox: "0 -960 960 960",
                            width: "17.5px",
                            fill: "#e8eaed"
                          }, [
                            l("path", { d: "M444-288h72v-240h-72v240Zm35.79-312q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5Zm.49 504Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Zm-.28-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" })
                          ], -1)
                        ])),
                        d.value ? (y(), A("div", Fw, [
                          l("div", Ww, [
                            l("div", Bw, [
                              _[35] || (_[35] = l("h3", { class: "tw-text-h6" }, " APR Explained ", -1)),
                              l("button", {
                                onClick: _[15] || (_[15] = (re) => d.value = !1)
                              }, _[34] || (_[34] = [
                                l("svg", {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  height: "24px",
                                  viewBox: "0 -960 960 960",
                                  width: "24px",
                                  fill: "#000"
                                }, [
                                  l("path", { d: "m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" })
                                ], -1)
                              ]))
                            ]),
                            _[36] || (_[36] = l("hr", null, null, -1)),
                            _[37] || (_[37] = l("p", { class: "tw-mt-4 tw-p-4 !tw-pt-0 tw-font-normal" }, " APR (Annual Percentage Rate) is the total cost of borrowing, shown as a percentage. It includes interest and helps you compare and understand how much a loan will cost annually. ", -1))
                          ])
                        ])) : k("", !0)
                      ]),
                      l("span", Vw, m(T(Ws)(Oe.value)), 1)
                    ]),
                    Oe.value.isPCP ? (y(), A("div", Gw, [
                      _[38] || (_[38] = l("span", { class: "text-body1" }, "Optional final payment*", -1)),
                      l("span", null, [
                        l("span", Zw, m(T(ee)(Oe.value.finalPayment, 2, 2).toString().split(".")[0]), 1),
                        l("span", $w, "." + m(T(ee)(Oe.value.finalPayment, 2, 2).toString().split(".")[1]), 1)
                      ])
                    ])) : k("", !0),
                    l("div", Jw, [
                      _[40] || (_[40] = l("span", { class: "text-body1" }, "Option-to-purchase fee", -1)),
                      l("span", null, [
                        l("span", Hw, m(T(ee)(10, 0, 0).toString().split(".")[0]), 1),
                        _[39] || (_[39] = l("span", { class: "text-body2" }, ".00", -1))
                      ])
                    ]),
                    l("div", Xw, [
                      _[41] || (_[41] = l("span", { class: "text-body1" }, "Total cost of credit", -1)),
                      l("span", null, [
                        l("span", Kw, m(T(ee)(Oe.value.costOfCredit, 2, 2).toString().split(".")[0]), 1),
                        l("span", qw, "." + m(T(ee)(Oe.value.costOfCredit, 2, 2).toString().split(".")[1]), 1)
                      ])
                    ]),
                    l("div", eC, [
                      _[42] || (_[42] = l("span", { class: "text-body1" }, "Total amount repayable", -1)),
                      l("span", null, [
                        l("span", tC, m(T(ee)(Oe.value.totalAmountPayable, 2, 2).toString().split(".")[0]), 1),
                        l("span", iC, "." + m(T(ee)(Oe.value.totalAmountPayable, 2, 2).toString().split(".")[1]), 1)
                      ])
                    ]),
                    l("div", MC, [
                      l("span", nC, m(Oe.value.termDisplay) + " monthly payments of", 1),
                      l("span", null, [
                        l("span", aC, m(T(ee)(Oe.value.monthlyPayment, 2, 2).toString().split(".")[0]), 1),
                        l("span", rC, "." + m(T(ee)(Oe.value.monthlyPayment, 2, 2).toString().split(".")[1]), 1)
                      ])
                    ]),
                    l("div", lC, [
                      Oe.value.isPCP ? (y(), A("span", oC, _[43] || (_[43] = [
                        G("*Optional final payment includes a £10 option-to-purchase fee. Annual mileage limit of "),
                        l("strong", null, "8,000", -1),
                        G(" miles, excess mileage fee of "),
                        l("strong", null, "8p/mile", -1),
                        G(". ")
                      ]))) : k("", !0)
                    ]),
                    l("div", sC, [
                      l("button", {
                        class: "tw-w-full brand-background tw-text-white tw-py-3 tw-rounded-md tw-text-h6 brand-cta",
                        onClick: Zs
                      }, [
                        l("div", uC, [
                          l("div", cC, [
                            G(m(Ae.value) + " ", 1),
                            mt.value ? k("", !0) : (y(), A("svg", gC, _[44] || (_[44] = [
                              l("path", { d: "m560-241.33-47.33-47.34L672-448H160v-66.67h512l-160-160L559.33-722 800-481.33l-240 240Z" }, null, -1)
                            ])))
                          ]),
                          mt.value ? (y(), A("div", NC, m(mt.value), 1)) : k("", !0)
                        ])
                      ])
                    ])
                  ])) : ue.cannotPrice ? (y(), A("div", IC, [
                    b(Ee, {
                      size: "lg",
                      name: "mdi-information-outline",
                      color: "brand-text-light"
                    }),
                    l("div", DC, [
                      _[45] || (_[45] = G(" We are unable to provide finance on this vehicle. ")),
                      l("div", dC, " Reason: " + m(ue.cannotPriceReason), 1)
                    ])
                  ])) : k("", !0)
                ], 2))
              ], 6)
            ], 6)
          ], 2)
        ]),
        !Be.value && Xi.value ? (y(), A("div", {
          key: 0,
          class: P(["tw-px-2 text-center brand-rep-text", mi.value === "table" ? "tw-mt-4" : "tw-mt-6"])
        }, [
          l("div", AC, [
            o.value === "PCP" ? (y(), A("div", TC, [
              b(Bn, {
                product: "PCP",
                tableTitle: Hi.value ?? void 0,
                showCF247: f.value && !x.value,
                otrPrice: 27500,
                deposit: 2750,
                term: 48,
                apr: We.value ?? void 0,
                annualMileage: 8e3,
                ratesFrom: Re.value,
                table: mi.value === "table",
                "background-colour": mM.value ?? void 0,
                "text-colour": pM.value ?? void 0,
                "field-background-colour": LM.value ?? void 0
              }, null, 8, ["tableTitle", "showCF247", "apr", "ratesFrom", "table", "background-colour", "text-colour", "field-background-colour"])
            ])) : (y(), A("div", xC, [
              L.value ? (y(), A("div", zC, [
                b(Bn, {
                  product: "HP",
                  tableTitle: Hi.value ?? void 0,
                  showCF247: !1,
                  otrPrice: 1e4,
                  deposit: 0,
                  term: 60,
                  apr: We.value ?? void 0,
                  ratesFrom: Re.value,
                  annualMileage: 8e3,
                  table: mi.value === "table",
                  "background-colour": mM.value ?? void 0,
                  "text-colour": pM.value ?? void 0,
                  "field-background-colour": LM.value ?? void 0,
                  "is-car-craft": !0
                }, null, 8, ["tableTitle", "apr", "ratesFrom", "table", "background-colour", "text-colour", "field-background-colour"])
              ])) : (y(), A("div", fC, [
                b(Bn, {
                  product: "HP",
                  tableTitle: Hi.value ?? void 0,
                  showCF247: f.value && !x.value,
                  otrPrice: 16e3,
                  deposit: 2750,
                  term: 60,
                  apr: We.value ?? void 0,
                  ratesFrom: Re.value,
                  annualMileage: 8e3,
                  table: mi.value === "table",
                  "background-colour": mM.value ?? void 0,
                  "text-colour": pM.value ?? void 0,
                  "field-background-colour": LM.value ?? void 0
                }, null, 8, ["tableTitle", "showCF247", "apr", "ratesFrom", "table", "background-colour", "text-colour", "field-background-colour"])
              ]))
            ]))
          ])
        ], 2)) : k("", !0)
      ]);
    };
  }
}), LC = /* @__PURE__ */ nr(mC, [["__scopeId", "data-v-c4d4779c"]]), pC = { class: "flex flex-col justify-center self-stretch md:py-12 py-8" }, wC = {
  key: 0,
  class: "flex justify-center items-center px-16 w-full max-md:px-5 max-md:max-w-full"
}, CC = { class: "flex flex-col max-w-full w-[975px]" }, hC = { class: "text-h2 text-center text-dark-1 w-full mb-8" }, OC = { class: "flex justify-center items-center" }, EC = { class: "w-full max-w-screen-lg" }, SC = /* @__PURE__ */ ne({
  __name: "Calculator",
  props: {
    topTitle: {
      type: String
    },
    backgroundColor: {
      type: String
    },
    aid: {
      type: String
    },
    isClassified: {
      type: String
    },
    removeBackground: {
      type: String
    },
    title: {
      type: String
    },
    hideTitle: {
      type: String
    },
    overrideApply: {
      type: String
    },
    overrideCredScore: {
      type: String
    },
    amount: {
      type: String
    },
    amountTitle: {
      type: String
    },
    hideAmountInput: {
      type: String
    },
    staticAmount: {
      type: String
    },
    hideSlider: {
      type: String
    },
    deposit: {
      type: String
    },
    minDeposit: {
      type: String
    },
    showDeposit: {
      type: String
    },
    depositTitle: {
      type: String
    },
    daid: {
      type: String
    },
    dname: {
      type: String
    },
    excellentApr: {
      type: String
    },
    goodApr: {
      type: String
    },
    fairApr: {
      type: String
    },
    poorApr: {
      type: String
    },
    isCF247: {
      type: String
    },
    hidePoweredBy: {
      type: String
    },
    defaultScore: {
      type: String
    },
    scoreTitle: {
      type: String
    },
    defaultTerm: {
      type: String
    },
    termTitle: {
      type: String
    },
    defaultButtonText: {
      type: String
    },
    subButtonText: {
      type: String
    },
    customApr: {
      type: String
    },
    defaultRepAPR: {
      type: String
    },
    hideRepApr: {
      type: String
    },
    aprType: String
  },
  setup(t) {
    const e = t, i = C(!0);
    return xe(
      () => ({ ...e }),
      async () => {
        i.value = !1, await Tt(), i.value = !0;
      },
      { deep: !0 }
    ), (M, n) => (y(), A("div", {
      style: R({ backgroundColor: t.backgroundColor })
    }, [
      l("div", pC, [
        t.topTitle ? (y(), A("div", wC, [
          l("div", CC, [
            l("div", hC, [
              l("h2", null, m(t.topTitle), 1)
            ])
          ])
        ])) : k("", !0),
        l("div", OC, [
          l("div", EC, [
            i.value ? (y(), _e(T(LC), nu({ key: 0 }, e, {
              "is-classified": t.isClassified,
              title: t.title,
              "hide-title": t.hideTitle,
              "override-apply": t.overrideApply,
              "override-cred-score": t.overrideCredScore,
              amount: t.amount,
              "amount-title": t.amountTitle,
              "hide-amount-input": t.hideAmountInput,
              "static-amount": t.staticAmount,
              "hide-slider": t.hideSlider,
              deposit: t.deposit,
              "min-deposit": t.minDeposit,
              "show-deposit": t.showDeposit,
              "deposit-title": t.depositTitle,
              daid: t.daid,
              dname: t.dname,
              "excellent-apr": t.excellentApr,
              "good-apr": t.goodApr,
              "fair-apr": t.fairApr,
              "poor-apr": t.poorApr,
              "is-c-f247": t.isCF247,
              "hide-powered-by": t.hidePoweredBy,
              "default-score": t.defaultScore,
              "score-title": t.scoreTitle,
              "default-term": t.defaultTerm ? Number(t.defaultTerm) : 24,
              "term-title": t.termTitle,
              "default-button-text": t.defaultButtonText,
              "sub-button-text": t.subButtonText,
              "custom-apr": t.customApr,
              "default-rep-a-p-r": t.defaultRepAPR,
              "hide-rep-apr": !0,
              "apr-type": t.aprType
            }), null, 16, ["is-classified", "title", "hide-title", "override-apply", "override-cred-score", "amount", "amount-title", "hide-amount-input", "static-amount", "hide-slider", "deposit", "min-deposit", "show-deposit", "deposit-title", "daid", "dname", "excellent-apr", "good-apr", "fair-apr", "poor-apr", "is-c-f247", "hide-powered-by", "default-score", "score-title", "default-term", "term-title", "default-button-text", "sub-button-text", "custom-apr", "default-rep-a-p-r", "apr-type"])) : k("", !0)
          ])
        ])
      ])
    ], 4));
  }
}), qh = /* @__PURE__ */ fe(SC, [["__scopeId", "data-v-f56be66b"]]), kC = ["id", "aria-label"], vC = { class: "relative" }, bC = { key: 2 }, QC = { class: "flex flex-col w-full" }, UC = { key: 0 }, YC = { key: 1 }, _C = { key: 2 }, PC = {
  key: 0,
  class: "text-body4 pt-1"
}, RC = {
  key: 0,
  class: "mx-1"
}, FC = /* @__PURE__ */ ne({
  __name: "VehicleCard",
  props: {
    id: {
      type: String,
      required: !0
    },
    registrationYear: {
      type: String,
      required: !0
    },
    make: {
      type: String,
      required: !0
    },
    model: {
      type: String,
      required: !0
    },
    price: {
      type: Number,
      required: !0
    },
    colour: {
      type: String,
      required: !0
    },
    mileage: {
      type: String,
      required: !0
    },
    transmission: {
      type: String,
      required: !0
    },
    fuelType: {
      type: String,
      required: !0
    },
    imageUrl: {
      type: String,
      required: !0
    },
    vrm: {
      type: String,
      required: !1
    },
    dealerInfoUrl: {
      type: String,
      required: !1
    },
    listItemBackgroundColor: {
      type: String,
      required: !1
    },
    trim: {
      type: String,
      required: !1
    },
    listItemTextColor: {
      type: String,
      default: "text-dark-1"
    },
    showVehicleImage: {
      type: Boolean,
      default: !0
    },
    showVehicleSpecs: {
      type: Boolean,
      default: !0
    },
    showVehicleCardBorder: {
      type: Boolean,
      default: !0
    },
    useVehicleImageRadius: {
      type: Boolean,
      default: !0
    },
    stacked: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, i = C(!1), M = (f) => new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(f), n = (f) => Number(f).toLocaleString("en-GB"), a = J(() => {
      const f = [
        { label: `${n(e.mileage)} miles`, show: !!e.mileage },
        { label: e.transmission, show: !!e.transmission },
        { label: e.fuelType, show: !!e.fuelType },
        { label: e.colour, show: !!e.colour }
      ].filter((L) => L.show);
      return e.stacked ? f.slice(0, 3) : f;
    }), r = J(() => {
      var f;
      return (f = e.imageUrl) == null ? void 0 : f.includes("cdn.imagin.studio/getImage");
    });
    console.log("🔄 isImaginUrl:", r.value);
    const o = J(() => r.value ? new URL(e.imageUrl).searchParams.get("make") : null), s = J(() => {
      var L;
      return r.value ? (L = new URL(e.imageUrl).searchParams.get("modelFamily")) == null ? void 0 : L.replace(/%2B/g, " ") : null;
    }), u = J(() => r.value ? new URL(e.imageUrl).searchParams.get("modelRange") : null), c = J(() => r.value ? new URL(e.imageUrl).searchParams.get("modelYear") : null), g = J(() => r.value ? new URL(e.imageUrl).searchParams.get("modelTrim") : null), d = J(() => r.value ? new URL(e.imageUrl).searchParams.get("modelPowerTrain") : null), j = J(() => r.value ? new URL(e.imageUrl).searchParams.get("modelDoors") : null), D = J(() => r.value ? new URL(e.imageUrl).searchParams.get("angle") : null), I = J(() => r.value ? new URL(e.imageUrl).searchParams.get("paintId") : null), N = J(() => r.value ? new URL(e.imageUrl).searchParams.get("position") : null);
    J(() => r.value ? new URL(e.imageUrl).searchParams.get("width") : null);
    const x = J(() => e.model ? e.stacked && window.innerWidth <= 768 && e.model.length > 8 ? e.model.slice(0, 8) + ".." : e.model : "");
    return (f, L) => (y(), A("article", {
      id: t.id,
      class: P([
        "text-dark-1",
        t.stacked ? "flex flex-row items-center bg-[#f5eefe] rounded-md" : "flex flex-col"
      ]),
      tabindex: "0",
      role: "article",
      "aria-label": `Vehicle listing for ${t.registrationYear ? t.registrationYear : ""} ${t.make ? t.make : ""} ${t.model ? t.model : ""}`
    }, [
      t.showVehicleImage ? (y(), A("div", {
        key: 0,
        class: P(t.stacked ? "w-[90px] h-[70px] flex-shrink-0 mr-3" : "w-full")
      }, [
        l("div", vC, [
          r.value ? (y(), _e(oM, {
            key: 0,
            make: o.value ?? void 0,
            "model-family": s.value ?? void 0,
            "model-range": u.value ?? void 0,
            "model-year": c.value ?? void 0,
            "model-trim": g.value ?? void 0,
            "model-power-train": d.value ?? void 0,
            "model-doors": j.value ?? void 0,
            angle: D.value ?? void 0,
            "paint-id": I.value ?? void 0,
            position: N.value ?? void 0,
            width: t.stacked ? "90px" : "700px",
            height: t.stacked ? "70px" : "auto",
            class: P("!px-0 object-cover " + (t.stacked ? "rounded-md w-[90px] h-[70px]" : "w-full aspect-[16/10] " + (t.useVehicleImageRadius ? "rounded-md" : "")))
          }, null, 8, ["make", "model-family", "model-range", "model-year", "model-trim", "model-power-train", "model-doors", "angle", "paint-id", "position", "width", "height", "class"])) : k("", !0),
          !r.value && !i.value ? (y(), _e(Ce, {
            key: 1,
            "image-name": t.imageUrl,
            "image-alt": `${t.registrationYear ? t.registrationYear : ""} ${t.make ? t.make : ""} ${t.model ? t.model : ""} ${t.colour ? t.colour : ""} exterior view`,
            class: P(t.stacked ? "object-contain rounded-md w-[90px] h-[70px]" : "object-cover w-full aspect-[16/10] " + (t.useVehicleImageRadius ? "rounded-md" : "")),
            width: t.stacked ? "90px" : "100%",
            height: t.stacked ? "70px" : "auto",
            onError: L[0] || (L[0] = (p) => i.value = !0)
          }, null, 8, ["image-name", "image-alt", "class", "width", "height"])) : k("", !0),
          i.value ? (y(), A("div", bC, [
            au(f.$slots, "imageCannotLoad", {}, void 0, !0)
          ])) : k("", !0)
        ])
      ], 2)) : k("", !0),
      l("div", {
        class: P([
          t.stacked ? "flex flex-col justify-center w-full bg-transparent p-0" : "flex flex-col justify-center mt-2 w-full bg-white rounded-md p-4",
          t.showVehicleCardBorder && !t.stacked ? "border border-solid border-[#DDDDDD]" : ""
        ])
      }, [
        l("div", QC, [
          l("div", {
            class: P(t.stacked ? "flex flex-col items-start" : "flex gap-10 justify-between items-center w-full")
          }, [
            t.price ? (y(), A("span", {
              key: 0,
              class: "text-base font-bold self-stretch leading-5 order-1",
              "aria-label": "Price",
              style: R(t.stacked ? "margin-bottom: 2px;" : "")
            }, m(M(t.price)), 5)) : k("", !0),
            l("h2", {
              class: P(t.stacked ? "text-base font-bold leading-5 order-2" : "text-base font-bold self-stretch leading-5")
            }, [
              t.registrationYear ? (y(), A("span", UC, m(t.registrationYear), 1)) : k("", !0),
              L[1] || (L[1] = G(m(" ") + " ")),
              t.make ? (y(), A("span", YC, m(t.make), 1)) : k("", !0),
              L[2] || (L[2] = G(m(" ") + " ")),
              t.model ? (y(), A("span", _C, m(x.value), 1)) : k("", !0)
            ], 2)
          ], 2),
          t.trim && !t.stacked ? (y(), A("p", PC, m(t.trim), 1)) : k("", !0)
        ]),
        t.showVehicleSpecs ? (y(), A("div", {
          key: 0,
          class: P(t.stacked ? "flex items-start mt-1 text-body2" : "flex gap-2 items-start self-start mt-4 text-body3"),
          role: "list",
          "aria-label": "Vehicle specifications"
        }, [
          (y(!0), A(ge, null, ye(a.value, (p, h) => (y(), A("span", {
            key: h,
            class: P([
              "car-spec gap-2 self-stretch rounded whitespace-nowrap",
              !t.stacked && "px-2 py-1"
            ]),
            style: R({ backgroundColor: t.listItemBackgroundColor }),
            role: "listitem"
          }, [
            p.label.toLowerCase() !== "unknown" ? (y(), A("span", {
              key: 0,
              class: P(t.listItemTextColor)
            }, [
              G(m(p.label), 1),
              t.stacked && h !== a.value.length - 1 ? (y(), A("span", RC, "|")) : k("", !0)
            ], 2)) : k("", !0)
          ], 6))), 128))
        ], 2)) : k("", !0)
      ], 2)
    ], 10, kC));
  }
}), eO = /* @__PURE__ */ fe(FC, [["__scopeId", "data-v-e3458a2d"]]), WC = { class: "relative mb-2 w-full" }, BC = ["for"], VC = { class: "text-sm font-bold mb-1 block" }, GC = { class: "relative" }, ZC = {
  key: 0,
  class: "absolute z-10 left-4 flex items-center font-medium text-xl",
  style: { height: "3.6rem" }
}, $C = ["id", "type", "name", "placeholder", "autocomplete", "maxlength", "minlength", "inputmode", "disabled"], JC = {
  class: "absolute right-4 flex items-center",
  style: { top: "0", height: "3.5rem" }
}, HC = {
  key: 0,
  class: "mr-1.5"
}, XC = {
  key: 0,
  class: "error text-body1"
}, KC = {
  key: 1,
  class: "mt-2 text-sm text-dark-1 opacity-80"
}, qC = /* @__PURE__ */ ne({
  __name: "InputComponent",
  props: {
    id: { default: "text" },
    type: { default: "text" },
    inputMode: { default: "text" },
    label: { default: "" },
    name: {},
    placeholder: { default: "" },
    autocomplete: { default: "" },
    maxLength: { default: 50 },
    minLength: { default: 0 },
    uppercase: { type: Boolean, default: !1 },
    smallPrint: { default: "" },
    showPoundSign: { type: Boolean, default: !1 },
    textAlign: { default: "left" },
    modelValue: { default: "" },
    disabled: { type: Boolean, default: !1 },
    error: { default: "" },
    required: { type: Boolean, default: !1 },
    errorMessage: {},
    rightText: { default: "" }
  },
  emits: ["update:modelValue", "blur"],
  setup(t, { expose: e, emit: i }) {
    const M = t, n = i, a = C(), r = C(void 0), o = async (D) => {
      console.log("Validating with:", {
        required: M.required,
        error: M.error,
        errorMessage: M.errorMessage,
        value: s.value
      }), M.required && (D ? r.value = D : M.error || M.errorMessage ? r.value = M.error || M.errorMessage : s.value ? M.minLength && s.value.length < M.minLength ? r.value = `Minimum length is ${M.minLength} characters` : r.value = void 0 : r.value = M.errorMessage || M.error || D);
    };
    e({
      validate: o
    });
    const s = C(M.modelValue);
    xe(() => M.modelValue, (D) => {
      s.value = D;
    });
    const u = J(() => ({
      uppercase: M.uppercase,
      "font-base": !0,
      "px-4": !M.showPoundSign,
      "px-10": M.showPoundSign
    })), c = (D) => D.replace(/[<>]/g, "").replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;"), d = ((D, I) => {
      let N;
      return function(...f) {
        const L = () => {
          clearTimeout(N), D(...f);
        };
        clearTimeout(N), N = setTimeout(L, I);
      };
    })((D) => {
      const I = D.target, N = c(I.value);
      I.value = N, n("update:modelValue", N);
    }, 300), j = async () => {
      await o(), n("blur", s.value);
    };
    return (D, I) => (y(), A("div", WC, [
      l("label", { for: D.name }, [
        l("span", VC, m(D.label), 1)
      ], 8, BC),
      l("div", GC, [
        D.showPoundSign ? (y(), A("div", ZC, " £ ")) : k("", !0),
        ht(l("input", {
          id: D.id,
          ref_key: "inputRef",
          ref: a,
          "onUpdate:modelValue": I[0] || (I[0] = (N) => s.value = N),
          type: D.type,
          name: D.name,
          placeholder: D.placeholder,
          autocomplete: D.autocomplete,
          maxlength: D.maxLength,
          minlength: D.minLength,
          class: P([u.value, r.value ? "input-error" : "", `text-${D.textAlign}`]),
          inputmode: D.inputMode,
          disabled: D.disabled,
          onInput: I[1] || (I[1] = //@ts-ignore
          (...N) => T(d) && T(d)(...N)),
          onBlur: j
        }, null, 42, $C), [
          [
            ru,
            s.value,
            void 0,
            { trim: !0 }
          ]
        ]),
        l("div", JC, [
          D.rightText != "" ? (y(), A("span", HC, m(D.rightText), 1)) : k("", !0),
          !r.value && s.value ? (y(), _e(ie, {
            key: 1,
            icon: "tick-circle",
            "icon-color": "positive",
            stroke: "white",
            width: "20",
            height: "20"
          })) : k("", !0),
          r.value ? (y(), _e(ie, {
            key: 2,
            icon: "error",
            "icon-color": "negative",
            stroke: "none",
            width: "20",
            height: "20"
          })) : k("", !0)
        ])
      ]),
      r.value ? (y(), A("p", XC, m(r.value), 1)) : k("", !0),
      D.smallPrint ? (y(), A("p", KC, m(D.smallPrint), 1)) : k("", !0)
    ]));
  }
}), e2 = /* @__PURE__ */ fe(qC, [["__scopeId", "data-v-a199d0d7"]]), t2 = { key: 0 }, i2 = { class: "text-3xl font-bold mb-6" }, M2 = { class: "mb-8" }, n2 = { class: "max-md:w-full w-1/3" }, a2 = { class: "mb-6" }, r2 = { class: "flex flex-col gap-4 items-start w-full" }, l2 = { class: "flex gap-4 w-full" }, o2 = { class: "w-full" }, s2 = {
  key: 0,
  class: "error text-body1"
}, u2 = { class: "w-full" }, c2 = {
  key: 0,
  class: "error text-body1"
}, g2 = { class: "w-full" }, N2 = {
  key: 0,
  class: "error text-body1"
}, I2 = { class: "w-full" }, D2 = {
  key: 0,
  class: "error text-body1"
}, d2 = { class: "w-full" }, j2 = {
  key: 0,
  class: "error text-body1"
}, y2 = { class: "w-full" }, A2 = {
  key: 0,
  class: "error text-body1"
}, T2 = { class: "w-full" }, x2 = {
  key: 0,
  class: "error text-body1"
}, z2 = { class: "max-md:w-full w-1/3" }, f2 = { key: 1 }, m2 = { class: "border border-1 border-[#CCCCCC] rounded-md shadow-card" }, L2 = { class: "flex justify-center items-center gap-4 px-4 py-6" }, p2 = { class: "text-center" }, w2 = {
  key: 0,
  class: "text-base font-bold bg-yellow-1 !py-0.5 !px-2 text-center rounded mb-4 w-fit mx-auto"
}, C2 = { class: "text-h5" }, h2 = {
  key: 1,
  class: "text-base font-medium"
}, O2 = { class: "flex gap-2 mt-2 justify-center text-sm font-medium" }, E2 = "prod", S2 = /* @__PURE__ */ ne({
  __name: "VehicleSearch",
  props: {
    header: {}
  },
  emits: ["update"],
  setup(t, { emit: e }) {
    const i = e, M = {
      dev: {
        baseUrl: "https://apim.247dev.io/api/apply/v1",
        libraryUrl: "https://apim.247dev.io/api/cf247-library/v1"
      },
      prod: {
        baseUrl: "https://apim.247prod.io/api/apply/v1",
        libraryUrl: "https://apim.247prod.io/api/cf247-library/v1"
      }
    }, { baseUrl: n, libraryUrl: a } = M[E2], r = {
      "Content-Type": "application/json",
      Accept: "application/json"
    };
    async function o(V, Q = {}, F) {
      console.log(`🚀 API Call Started: ${V}`, { options: Q }), N.value = !0;
      try {
        const Ne = await fetch(V, {
          ...Q,
          headers: {
            ...r,
            ...Q.headers
          }
        });
        if (!Ne.ok)
          throw console.error(`❌ API Error: ${V}`, { status: Ne.status, statusText: Ne.statusText }), new Error(Ne.statusText || "API request failed");
        const se = await Ne.json();
        return console.log(`✅ API Response: ${V}`, se), se;
      } catch (Ne) {
        throw console.error(`💥 API Failed: ${V}`, Ne), Ne;
      } finally {
        console.log(`🏁 API Call Completed: ${V}`), N.value = !1;
      }
    }
    const s = async () => (await o(`${a}/client-token`, {
      method: "POST"
    })).authenticationToken ?? null, u = async (V) => {
      console.log(`🚀 Fetching vehicle details for reg: ${V}`), N.value = !0;
      try {
        const Q = await fetch(
          `${a}/vehicle-details/${encodeURIComponent(V)}`,
          {
            headers: r
          }
        );
        if (Q.status === 400)
          return console.error("❌ Invalid registration number"), {
            error: "Registration is not valid",
            data: void 0
          };
        if (!Q.ok)
          throw new Error("Failed to fetch vehicle details");
        const F = await Q.json();
        return i("update", F), console.log("✅ Vehicle details retrieved:", F), !F || !F.make || !F.model || !F.capId ? {
          error: "Vehicle not found",
          data: void 0
        } : {
          error: "",
          data: {
            ...F,
            // Ensure all required fields are present
            id: F.id || "",
            registration: F.registration || V,
            vin: F.vin || "",
            capId: F.capId || 0,
            capCode: F.capCode || "",
            make: F.make || "",
            model: F.model || "",
            colour: F.colour || "",
            year: F.year || 0,
            registrationDate: F.registrationDate || "",
            manufactureDate: F.manufactureDate || null,
            bodyType: F.bodyType || "",
            type: F.type || "",
            fuel: F.fuel || "",
            transmission: F.transmission || "",
            engineCapacity: F.engineCapacity || 0,
            doorplan: F.doorplan || null,
            vrm: F.vrm || V,
            mileage: F.mileage || 0
          }
        };
      } catch (Q) {
        return console.error("💥 Error fetching vehicle details:", Q), {
          error: "Unable to retrieve vehicle details",
          data: void 0
        };
      } finally {
        N.value = !1;
      }
    }, c = async () => o(`${n}/vehicle/makes`), g = async (V) => o(
      `${n}/vehicle/models?${new URLSearchParams({
        manufacturerCode: V.toString()
      })}`
    ), d = async (V) => o(
      `${n}/vehicle/trims?${new URLSearchParams({
        rangeCode: V.toString()
      })}`
    ), j = async () => o(`${n}/vehicle/filters`), D = C({
      regNumber: "",
      vehicle: {
        id: "",
        registration: "",
        vin: "",
        capId: 0,
        capCode: "",
        make: "",
        model: "",
        colour: "",
        year: 0,
        registrationDate: "",
        manufactureDate: null,
        bodyType: "",
        type: "",
        fuel: "",
        transmission: "",
        engineCapacity: 0,
        doorplan: null,
        vrm: "unknown",
        mileage: 0
      }
    }), I = C(!1), N = C(!1), x = C(""), f = C({
      type: "",
      make: "",
      model: "",
      fuel: "",
      year: "",
      colour: "",
      vehicle: "",
      transmission: ""
    }), L = C(!1), p = C(!1), h = J(() => {
      const V = [];
      return D.value.vehicle.colour && V.push(D.value.vehicle.colour), D.value.vehicle.transmission && V.push(D.value.vehicle.transmission), D.value.vehicle.fuel && V.push(D.value.vehicle.fuel), V;
    }), w = C([]), O = C([]), S = C(null), Y = C([]), H = C(), B = async () => {
      var Q, F, Ne;
      console.log("🔄 Starting registration form validation"), x.value = "";
      const V = /^[A-Z0-9]{2,7}$/;
      if (!D.value.regNumber || !V.test(D.value.regNumber.toUpperCase())) {
        x.value = "Please enter a valid registration number", await Tt(), await ((Q = H.value) == null ? void 0 : Q.validate()), console.log("❌ Validation failed: Invalid registration format");
        return;
      }
      N.value = !0;
      try {
        if (L.value = !0, w.value.length === 0) {
          const Nt = await c();
          w.value = Nt.map((je) => ({
            label: je.name.trim(),
            value: je.name.trim(),
            code: je.code.toString()
          }));
        }
        console.log(`🚀 Fetching vehicle details for reg: ${D.value.regNumber}`);
        const se = await u(D.value.regNumber);
        if (console.log("🔍 Vehicle details response:", se), p.value = !se.error, se.error || !se.data || !se.data.capId) {
          x.value = se.error || "Vehicle not found", await Tt(), await ((F = H.value) == null ? void 0 : F.validate());
          return;
        }
        D.value.vehicle = {
          id: "",
          registration: "",
          vin: "",
          capId: 0,
          capCode: "",
          make: "",
          model: "",
          colour: "",
          year: 0,
          registrationDate: "",
          manufactureDate: null,
          bodyType: "",
          type: "",
          fuel: "",
          transmission: "",
          engineCapacity: 0,
          doorplan: null,
          vrm: "unknown",
          mileage: 0
        }, Object.assign(D.value.vehicle, se.data), console.log("✅ Vehicle details retrieved and validated:", se.data), await Tt();
      } catch (se) {
        console.error("💥 Error fetching vehicle details:", se), x.value = "Unable to retrieve vehicle details", await Tt(), await ((Ne = H.value) == null ? void 0 : Ne.validate());
      } finally {
        N.value = !1, L.value = !1;
      }
    }, ae = () => {
      console.log("🔄 Starting manual form validation"), Object.keys(f.value).forEach((F) => {
        f.value[F] = "";
      });
      let V = !1;
      D.value.vehicle.type = "car";
      const Q = [
        // Remove type validation since it's hardcoded
        { field: D.value.vehicle.make, key: "make", name: "Make" },
        { field: D.value.vehicle.model, key: "model", name: "Model" },
        { field: D.value.vehicle.fuel, key: "fuel", name: "Fuel Type" },
        { field: D.value.vehicle.year, key: "year", name: "Year" },
        { field: D.value.vehicle.colour, key: "colour", name: "Colour" },
        { field: D.value.vehicle.transmission, key: "transmission", name: "Transmission" },
        { field: D.value.vehicle, key: "vehicle", name: "Vehicle" }
      ];
      for (const { field: F, key: Ne, name: se } of Q)
        F || (f.value[Ne] = `Please select a ${se}`, console.log(`❌ Validation failed: Missing ${se}`), V = !0);
      V || console.log("✅ Manual form validation passed");
    }, te = () => {
      p.value = !1, I.value = !1, D.value.regNumber = "", D.value.vehicle = {
        id: "",
        registration: "",
        vin: "",
        capId: 0,
        capCode: "",
        make: "",
        model: "",
        colour: "",
        year: 0,
        registrationDate: "",
        manufactureDate: null,
        bodyType: "",
        type: "",
        fuel: "",
        transmission: "",
        engineCapacity: 0,
        doorplan: null,
        vrm: "unknown",
        mileage: 0
      };
    }, q = () => {
      var V, Q;
      return ((Q = (V = S.value) == null ? void 0 : V.fuel) == null ? void 0 : Q.map((F) => ({
        label: F.name,
        value: F.name
      }))) || [];
    }, le = () => {
      var V, Q;
      return ((Q = (V = S.value) == null ? void 0 : V.trans) == null ? void 0 : Q.map((F) => ({
        label: F.name,
        value: F.name
      }))) || [];
    }, Me = () => {
      const V = (/* @__PURE__ */ new Date()).getFullYear(), Q = [];
      for (let F = V; F >= V - 14; F--)
        Q.push({
          label: F.toString(),
          value: F.toString()
        });
      return Q;
    }, oe = () => {
      var V, Q;
      return ((Q = (V = S.value) == null ? void 0 : V.colour) == null ? void 0 : Q.map((F) => ({
        label: F.name,
        value: F.name
      }))) || [];
    }, $ = async () => {
      if (!D.value.vehicle.model || L.value) return [];
      try {
        const V = O.value.find((F) => F.value === D.value.vehicle.model);
        if (!V)
          throw new Error("Selected model not found");
        const Q = await d(Number(V.code));
        Y.value = Q.map((F) => ({
          label: `${D.value.vehicle.make} ${D.value.vehicle.model} ${F.name}`,
          value: F.capId.toString()
        }));
      } catch (V) {
        console.error("Error fetching trims:", V), Y.value = [];
      }
    }, E = () => {
      var V;
      !D.value.regNumber || !D.value.regNumber.trim() ? (x.value = "Enter a valid registration number", (V = H.value) == null || V.validate()) : x.value = "";
    }, be = (V) => {
      const Q = /^[a-zA-Z0-9\s]$/.test(V.key), F = ["Backspace", "Tab", "Enter", "End", "Home", "ArrowLeft", "ArrowRight", "Delete"].includes(V.key);
      !Q && !F && V.preventDefault();
    };
    return xe(I, async (V) => {
      if (V) {
        D.value.regNumber = "", x.value = "", console.log("🔄 Manual entry selected, fetching makes");
        try {
          const Q = await c();
          w.value = Q.map((F) => ({
            label: F.name.trim(),
            value: F.name.trim(),
            code: F.code.toString()
          })), console.log("✅ Makes fetched:", w.value);
        } catch (Q) {
          console.error("❌ Error fetching makes:", Q);
        }
        try {
          S.value = await j();
        } catch (Q) {
          console.error("Error fetching filters:", Q);
        }
      }
    }), xe(() => D.value.vehicle.make, async (V) => {
      if (!L.value && V) {
        console.log("🔄 Make selected, fetching models");
        try {
          const Q = w.value.find((Ne) => Ne.value === V);
          if (!Q)
            throw new Error("Selected make not found");
          const F = await g(Number.parseInt(Q.code));
          O.value = F.map((Ne) => ({
            label: Ne.name.trim(),
            value: Ne.name.trim(),
            code: Ne.code.toString()
          })).sort((Ne, se) => Ne.label.localeCompare(se.label)), console.log("✅ Models fetched:", O.value);
        } catch (Q) {
          console.error("❌ Error fetching models:", Q);
        }
      }
    }), xe(() => D.value.vehicle.model, async () => {
      !L.value && D.value.vehicle.model && await $();
    }), xe(() => D.value.vehicle.year, (V) => {
      V && (D.value.vehicle.registrationDate = `${V}-01-01T00:00:00`);
    }), xe(() => D.value.vehicle.type, () => {
      f.value.type = "";
    }), xe(() => D.value.vehicle.make, () => {
      f.value.make = "";
    }), xe(() => D.value.vehicle.model, () => {
      f.value.model = "", $();
    }), xe(() => D.value.vehicle.fuel, () => {
      f.value.fuel = "";
    }), xe(() => D.value.vehicle.transmission, () => {
      f.value.transmission = "";
    }), xe(() => D.value.vehicle.year, (V) => {
      f.value.year = "", V && (D.value.vehicle.registrationDate = `${V}-01-01T00:00:00`);
    }), xe(() => D.value.vehicle.colour, () => {
      f.value.colour = "";
    }), xe(() => D.value.vehicle.capId, () => {
      f.value.vehicle = "";
    }), xe(() => D.value.regNumber, (V) => {
      !V || !V.trim() ? x.value = "Enter a valid registration number" : x.value = "";
    }, { immediate: !0 }), we(async () => {
      try {
        await s(), S.value = await j();
      } catch (V) {
        console.error("Error fetching filters:", V);
      }
    }), (V, Q) => p.value ? (y(), A("div", f2, [
      Q[24] || (Q[24] = l("h1", { class: "text-3xl font-bold mb-6" }, " Confirm your vehicle details ", -1)),
      l("div", m2, [
        l("div", L2, [
          l("div", p2, [
            D.value.vehicle.registration ? (y(), A("p", w2, m(D.value.vehicle.registration), 1)) : k("", !0),
            l("h3", C2, m(D.value.vehicle.make) + " " + m(D.value.vehicle.model), 1),
            D.value.vehicle.bodyType ? (y(), A("h4", h2, m(D.value.vehicle.bodyType), 1)) : k("", !0),
            l("div", O2, [
              (y(!0), A(ge, null, ye(h.value, (F) => (y(), A("p", {
                key: F,
                class: "bg-purple-1 !px-2 !py-0.5 rounded"
              }, m(F), 1))), 128))
            ]),
            l("p", {
              class: "text-center underline mt-4 text-base font-medium cursor-pointer hover:no-underline",
              "aria-label": "This is not my car",
              tabindex: "0",
              onClick: te,
              onKeydown: [
                ci(te, ["enter"]),
                ci(te, ["space"])
              ]
            }, " This is not my car ", 32)
          ])
        ])
      ])
    ])) : (y(), A("div", t2, [
      l("h1", i2, m(V.header), 1),
      Q[23] || (Q[23] = l("h2", { class: "text-xl font-bold mb-6" }, " Tell us about your current car ", -1)),
      I.value ? (y(), A("form", {
        key: 1,
        id: "manual-form",
        onSubmit: Pt(ae, ["prevent"])
      }, [
        l("div", a2, [
          l("p", {
            class: "text-subtitle1 mt-2 underline cursor-pointer flex gap-2 mb-4 hover:no-underline",
            "aria-label": "Search by Vehicle Registration",
            tabindex: "0",
            onClick: Q[5] || (Q[5] = (F) => I.value = !1),
            onKeydown: [
              Q[6] || (Q[6] = ci((F) => I.value = !1, ["enter"])),
              Q[7] || (Q[7] = ci((F) => I.value = !1, ["space"]))
            ]
          }, [
            b(ie, {
              icon: "search",
              "icon-color": "dark-1",
              stroke: "none",
              width: "20",
              height: "20"
            }),
            Q[15] || (Q[15] = G(" Search by Vehicle Registration "))
          ], 32),
          l("div", r2, [
            l("div", l2, [
              l("div", o2, [
                Q[16] || (Q[16] = l("label", { for: "vehicle-make" }, "Make", -1)),
                b(si, {
                  id: "vehicle-make",
                  modelValue: D.value.vehicle.make,
                  "onUpdate:modelValue": Q[8] || (Q[8] = (F) => D.value.vehicle.make = F),
                  width: "100%",
                  height: "52px",
                  "background-color": "bg-white",
                  placeholder: "Select Make",
                  value: "none",
                  options: w.value
                }, null, 8, ["modelValue", "options"]),
                f.value.make ? (y(), A("p", s2, m(f.value.make), 1)) : k("", !0)
              ]),
              l("div", u2, [
                Q[17] || (Q[17] = l("label", { for: "vehicle-model" }, "Model", -1)),
                b(si, {
                  id: "vehicle-model",
                  modelValue: D.value.vehicle.model,
                  "onUpdate:modelValue": Q[9] || (Q[9] = (F) => D.value.vehicle.model = F),
                  width: "100%",
                  height: "52px",
                  "background-color": "bg-white",
                  placeholder: "Select Model",
                  value: "none",
                  options: O.value,
                  disabled: !D.value.vehicle.make
                }, null, 8, ["modelValue", "options", "disabled"]),
                f.value.model ? (y(), A("p", c2, m(f.value.model), 1)) : k("", !0)
              ])
            ]),
            l("div", g2, [
              Q[18] || (Q[18] = l("label", { for: "vehicle-fuel-type" }, "Fuel Type", -1)),
              b(si, {
                id: "vehicle-fuel-type",
                modelValue: D.value.vehicle.fuel,
                "onUpdate:modelValue": Q[10] || (Q[10] = (F) => D.value.vehicle.fuel = F),
                width: "100%",
                height: "52px",
                "background-color": "bg-white",
                placeholder: "Select Fuel Type",
                value: "none",
                options: q(),
                disabled: !D.value.vehicle.make || !D.value.vehicle.model
              }, null, 8, ["modelValue", "options", "disabled"]),
              f.value.fuel ? (y(), A("p", N2, m(f.value.fuel), 1)) : k("", !0)
            ]),
            l("div", I2, [
              Q[19] || (Q[19] = l("label", { for: "vehicle-transmission" }, "Transmission", -1)),
              b(si, {
                id: "vehicle-transmission",
                modelValue: D.value.vehicle.transmission,
                "onUpdate:modelValue": Q[11] || (Q[11] = (F) => D.value.vehicle.transmission = F),
                width: "100%",
                height: "52px",
                "background-color": "bg-white",
                placeholder: "Select Transmission",
                value: "none",
                options: le(),
                disabled: !D.value.vehicle.make || !D.value.vehicle.model || !D.value.vehicle.fuel
              }, null, 8, ["modelValue", "options", "disabled"]),
              f.value.transmission ? (y(), A("p", D2, m(f.value.transmission), 1)) : k("", !0)
            ]),
            l("div", d2, [
              Q[20] || (Q[20] = l("label", { for: "vehicle-year" }, "Year", -1)),
              b(si, {
                id: "vehicle-year",
                modelValue: D.value.vehicle.year,
                "onUpdate:modelValue": Q[12] || (Q[12] = (F) => D.value.vehicle.year = F),
                width: "100%",
                height: "52px",
                "background-color": "bg-white",
                placeholder: "Select Year",
                value: "none",
                options: Me(),
                disabled: !D.value.vehicle.make || !D.value.vehicle.model || !D.value.vehicle.fuel || !D.value.vehicle.transmission
              }, null, 8, ["modelValue", "options", "disabled"]),
              f.value.year ? (y(), A("p", j2, m(f.value.year), 1)) : k("", !0)
            ]),
            l("div", y2, [
              Q[21] || (Q[21] = l("label", { for: "vehicle-color" }, "Colour", -1)),
              b(si, {
                id: "vehicle-color",
                modelValue: D.value.vehicle.colour,
                "onUpdate:modelValue": Q[13] || (Q[13] = (F) => D.value.vehicle.colour = F),
                width: "100%",
                height: "52px",
                "background-color": "bg-white",
                placeholder: "Select Colour",
                value: "none",
                options: oe(),
                disabled: !D.value.vehicle.make || !D.value.vehicle.model || !D.value.vehicle.fuel || !D.value.vehicle.year || !D.value.vehicle.transmission
              }, null, 8, ["modelValue", "options", "disabled"]),
              f.value.colour ? (y(), A("p", A2, m(f.value.colour), 1)) : k("", !0)
            ]),
            l("div", T2, [
              Q[22] || (Q[22] = l("label", { for: "vehicle-select" }, "Select your vehicle", -1)),
              b(si, {
                id: "vehicle-select",
                modelValue: D.value.vehicle.capId,
                "onUpdate:modelValue": Q[14] || (Q[14] = (F) => D.value.vehicle.capId = F),
                width: "100%",
                height: "52px",
                "background-color": "bg-white",
                placeholder: "Select Vehicle",
                value: "none",
                options: Y.value,
                disabled: !D.value.vehicle.make || !D.value.vehicle.model || !D.value.vehicle.fuel || !D.value.vehicle.year || !D.value.vehicle.colour || !D.value.vehicle.transmission
              }, null, 8, ["modelValue", "options", "disabled"]),
              f.value.vehicle ? (y(), A("p", x2, m(f.value.vehicle), 1)) : k("", !0)
            ])
          ])
        ]),
        l("div", z2, [
          b(Ke, {
            "hover-color": "bg-secondary hover:brightness-110",
            color: "bg-secondary",
            "text-size": "text-button-large",
            label: "Continue",
            "icon-after": !0,
            width: "100%",
            height: "52px",
            "icon-color": "dark-1",
            "aria-label": "Continue",
            type: "submit"
          })
        ])
      ], 32)) : (y(), A("form", {
        key: 0,
        onSubmit: Pt(B, ["prevent"])
      }, [
        l("div", M2, [
          b(e2, {
            id: "reg-number",
            ref_key: "inputRef",
            ref: H,
            modelValue: D.value.regNumber,
            "onUpdate:modelValue": Q[0] || (Q[0] = (F) => D.value.regNumber = F),
            name: "reg-number",
            label: "Vehicle Registration",
            placeholder: "",
            type: "text",
            inputmode: "text",
            width: "100%",
            height: "52px",
            error: x.value,
            "error-message": x.value,
            required: !0,
            "max-length": 10,
            pattern: "[A-Za-z0-9\\s]*",
            onInput: Q[1] || (Q[1] = (F) => D.value.regNumber = F.target.value.toUpperCase()),
            onBlur: E,
            onKeydown: be
          }, null, 8, ["modelValue", "error", "error-message"]),
          l("p", {
            class: "text-base font-medium mt-2 underline cursor-pointer hover:no-underline",
            role: "button",
            "aria-label": "Manually Enter Vehicle Details",
            tabindex: "0",
            onClick: Q[2] || (Q[2] = (F) => I.value = !0),
            onKeydown: [
              Q[3] || (Q[3] = ci((F) => I.value = !0, ["enter"])),
              Q[4] || (Q[4] = ci((F) => I.value = !0, ["space"]))
            ]
          }, " Manually Enter Vehicle Details ", 32)
        ]),
        l("div", n2, [
          b(Ke, {
            "hover-color": "bg-secondary hover:brightness-110",
            color: "bg-secondary",
            "text-size": "text-button-large",
            label: "Continue",
            "icon-after": !0,
            width: "100%",
            height: "52px",
            "icon-color": "dark-1",
            "aria-label": "Continue",
            type: "submit",
            loading: N.value,
            disabled: N.value
          }, null, 8, ["loading", "disabled"])
        ])
      ], 32))
    ]));
  }
}), tO = /* @__PURE__ */ fe(S2, [["__scopeId", "data-v-46b04374"]]), k2 = { class: "card" }, v2 = /* @__PURE__ */ ne({
  __name: "HelloWorld",
  props: {
    msg: {}
  },
  setup(t) {
    const e = C(0);
    return (i, M) => (y(), A(ge, null, [
      l("h1", null, m(i.msg), 1),
      l("div", k2, [
        l("button", {
          type: "button",
          onClick: M[0] || (M[0] = (n) => e.value++)
        }, "count is " + m(e.value), 1),
        M[1] || (M[1] = l("p", null, [
          G(" Edit "),
          l("code", null, "components/HelloWorld.vue"),
          G(" to test HMR ")
        ], -1))
      ]),
      M[2] || (M[2] = l("p", null, [
        G(" Check out "),
        l("a", {
          href: "https://vuejs.org/guide/quick-start.html#local",
          target: "_blank"
        }, "create-vue"),
        G(", the official Vue + Vite starter ")
      ], -1)),
      M[3] || (M[3] = l("p", null, [
        G(" Learn more about IDE Support for Vue in the "),
        l("a", {
          href: "https://vuejs.org/guide/scaling-up/tooling.html#ide-support",
          target: "_blank"
        }, "Vue Docs Scaling up Guide"),
        G(". ")
      ], -1)),
      M[4] || (M[4] = l("p", { class: "read-the-docs" }, "Click on the Vite and Vue logos to learn more", -1))
    ], 64));
  }
}), iO = /* @__PURE__ */ fe(v2, [["__scopeId", "data-v-6bbba2df"]]);
export {
  Xh as AuthorBanner,
  Ke as Button,
  $h as CTAButton,
  mh as CarConverter,
  Ch as CardTrio,
  Ph as ContactCard,
  cj as FAQ,
  Gh as FAQContainer,
  Vh as FeatureArticle,
  Bh as FeaturedGuides,
  Hh as FiveStepHowItWorks,
  ph as Footer,
  Kh as FourStepAboutUs,
  Rh as GenericButtonBanner,
  fh as GenericFooter,
  Jh as GuideContainer,
  Lh as Header,
  iO as HelloWorld,
  Qh as HelpandAdviceBox,
  wh as HeroBanner,
  Fh as HowItWorks,
  ie as Icon,
  kn as IconList,
  qe as ImageText,
  bn as ImageWidget,
  oM as Imagin,
  vh as InfoCard,
  bh as PageComponent,
  Zh as PullQuote,
  kh as QuoteFooter,
  Uh as RowIcon,
  Yh as SearchBar,
  si as SelectInput,
  _h as SolidHeader,
  Sh as SortFinance,
  qh as TailiwindCalculator,
  Wh as Testimonials,
  Eh as ThirdPartyPartners,
  Oh as TrustPilotContainer,
  rn as Trustpilot,
  eO as VehicleCard,
  tO as VehicleSearch,
  pi as Video,
  hh as WhyCF247
};
